import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** 日付 */
  Date: Date;
  /** RFC 3339形式の日時 */
  DateTime: Date;
  /** 画像や外部リンクなどで使用するURI */
  URI: string;
  _Any: any;
  _FieldSet: any;
};











/**  AKB48チャンネル  */
export type G_Akb48Channel = {
  /**  チャンネル名  */
  title: Scalars['String'];
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  LOD/ROD  */
  channelType: G_Akb48ChannelType;
  /**  チャンネル内の作品検索  */
  search: G_Akb48SvodContentConnection;
  /**  チャンネル内の作品リスト  */
  contents: G_Akb48SvodContentConnection;
  /**  作品  */
  content: G_Akb48Content;
};


/**  AKB48チャンネル  */
export type G_Akb48ChannelSearchArgs = {
  device: G_Device;
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  AKB48チャンネル  */
export type G_Akb48ChannelContentsArgs = {
  device: G_Device;
  akb48MemberId?: Maybe<Scalars['ID']>;
  teamId?: Maybe<Scalars['ID']>;
  group?: Maybe<G_Akb48Group>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  AKB48チャンネル  */
export type G_Akb48ChannelContentArgs = {
  id: Scalars['ID'];
};

/**  AKB48チャンネル種別  */
export enum G_Akb48ChannelType {
  /**  LIVE!! ON DEMAND  */
  Lod = 'LOD',
  /**  REVIVAL!! ON DEMAND  */
  Rod = 'ROD'
}

export type G_Akb48Content = {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  作品説明  */
  description: Scalars['String'];
  /**  チーム  */
  team: G_Akb48Team;
  /**  出演メンバー  */
  members: Array<G_Akb48Member>;
  /** レジューム位置 */
  resumePoint: Scalars['Int'];
  /**  視聴期限(配信期限)  */
  viewingExpiresAt?: Maybe<Scalars['DateTime']>;
};


export type G_Akb48ContentDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


export type G_Akb48ContentResumePointArgs = {
  device: G_Device;
};

/**  AKB48グループ  */
export enum G_Akb48Group {
  Akb48 = 'AKB48',
  Ske48 = 'SKE48',
  Stu48 = 'STU48',
  Nmb48 = 'NMB48',
  Hkt48 = 'HKT48',
  Ngt48 = 'NGT48'
}

/**  AKB48メンバー  */
export type G_Akb48Member = {
  /**  メンバーID  */
  id: Scalars['ID'];
  /**  親メンバーID(チームを兼任しているメンバーに設定される)  */
  parentId?: Maybe<Scalars['ID']>;
  /**  メンバー名  */
  name: Scalars['String'];
};

export type G_Akb48PurchasedContentConnection = G_ForwardOnlyConnection & {
  edges: Array<G_Akb48PurchasedContentEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_Akb48PurchasedContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_Akb48PurchasedContentSummary;
};

/**  AKB48購入済み作品概要(リスト表示用)  */
export type G_Akb48PurchasedContentSummary = G_Node & {
  /**  マイライブラリID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  視聴期限  */
  viewingExpiresAt?: Maybe<Scalars['DateTime']>;
};

/**  AKB48購入済み作品リストソート順  */
export enum G_Akb48PurchasedContentsSortOrder {
  /**  購入日の新しい順  */
  NewestToOldest = 'NEWEST_TO_OLDEST',
  /**  購入日の古い順  */
  OldestToNewest = 'OLDEST_TO_NEWEST'
}

export type G_Akb48SvodContentConnection = G_ForwardOnlyConnection & {
  edges: Array<G_Akb48SvodContentEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_Akb48SvodContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_Akb48SvodContentSummary;
};

/**  AKB48月額作品概要(リスト表示用)  */
export type G_Akb48SvodContentSummary = G_Node & {
  /** コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  作品説明  */
  description: Scalars['String'];
  /**  チーム  */
  team: G_Akb48Team;
  /**  出演メンバー  */
  members: Array<G_Akb48Member>;
};


/**  AKB48月額作品概要(リスト表示用)  */
export type G_Akb48SvodContentSummaryDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

/**  AKB48チーム  */
export type G_Akb48Team = {
  /**  チームID  */
  id: Scalars['ID'];
  /**  チーム名  */
  name: Scalars['String'];
};

export type G_AddBookBookmarkInput = {
  /**  対象ブックス作品のシリーズID  */
  seriesId: Scalars['ID'];
};

export type G_AddBookBookmarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_AddFanzaPpvBookmarkInput = {
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  対象作品コンテンツID  */
  contentId: Scalars['ID'];
};

export type G_AddFanzaPpvBookmarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_FanzaPpvBookmarkError>;
};

export type G_AddProfileInput = {
  /**  プロフィール名  */
  name: Scalars['String'];
  /**  プロフィールアイコンID  */
  profileIconId: Scalars['ID'];
  /**  視聴レーティング制限  */
  viewableRating?: Maybe<G_ViewableRating>;
  /**  購入制限  */
  canPurchase?: Maybe<Scalars['Boolean']>;
  /**  セキュリティコード  */
  securityCode?: Maybe<Scalars['String']>;
};

export type G_AddProfilePayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  プロフィール情報  */
  profile?: Maybe<G_Profile>;
};

export type G_AddVideoBookmarkInput = {
  /**  対象作品のシーズンID  */
  seasonId: Scalars['ID'];
};

export type G_AddVideoBookmarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/**
 * PSVRプレイヤー起動パラメータ
 * https://confl.arms.dmm.com/pages/viewpage.action?pageId=974843633
 */
export type G_AppStartParamsForPsvr = {
  /**  再生URL  */
  playUrl: Scalars['URI'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  ショップ  */
  shop: Scalars['String'];
  /**  st品番  */
  productId: Scalars['String'];
  /**  購入品番  */
  parentProductId: Scalars['String'];
  /**  無期限購入判定  */
  isPast: Scalars['Boolean'];
  /**
   * 配信画質
   * Quality.nameと同等の値を返す
   */
  qualityGroup: Scalars['String'];
  /**  商品種類(基本的にmonthly or digital)  */
  type: Scalars['String'];
  /**  全パート  */
  allParts: Scalars['Int'];
  /**  視聴形式  */
  viewingType: Scalars['String'];
};

/** PSVR起動パラメータ取得用の画質パラメータ */
export enum G_AppStartParamsForPsvrQuality {
  High = 'HIGH',
  Normal = 'NORMAL'
}

/** AppStoreのトランザクション */
export type G_AppStoreTransaction = {
  /**  有効化したトランザクションID  */
  id: Scalars['String'];
};

/** オーディオに関するデコード能力を示す */
export type G_AudioProtectionCapability = {
  /** オーディオコーデック */
  codec: G_StreamingAudioCodec;
};

/** 音声情報 */
export type G_AudioRendition = {
  /** RFC5646 言語タグ (ja, en-US, ja-JP-x-1, etc...) */
  lang: Scalars['String'];
  /** チャンネル数 (2 or 6) */
  audioChannels: Scalars['Int'];
  /** チャンネルレイアウト */
  audioChannelLayout: G_StreamingAudioChannelLayout;
};

/**  生年月  */
export type G_BirthdateInput = {
  /**  年  */
  year: Scalars['Int'];
  /**  月  */
  month: Scalars['Int'];
};

/**  シリーズ単位で集約されたキャンペーン情報詳細  */
export type G_BookAggregatedCampaignDetail = {
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  シリーズ内の合計無料作品数  */
  totalFreeVolumes: Scalars['Int'];
  /**  シリーズ内の合計無料話数  */
  totalFreeEpisodes: Scalars['Int'];
  /**  待てば¥0対象の連載話合計  */
  totalStaminaRentalEpisodes: Scalars['Int'];
  /**  ポイント還元率合計の最大値(%)  */
  highestTotalPointRefundRate: Scalars['Int'];
  /**  最も割引率の高い割引きキャンペーン  */
  bestDiscountCampaign?: Maybe<G_BookDiscountCampaign>;
  /**  最も還元率の高いポイント還元キャンペーン  */
  bestPointRefundCampaign?: Maybe<G_BookPointRefundCampaign>;
  /**  最も還元率の高いプレミアム会員限定ポイント還元キャンペーン  */
  bestPremiumPointRefundCampaign?: Maybe<G_BookPremiumPointRefundCampaign>;
  /**  連載キャンペーン一覧  */
  serializationCampaigns?: Maybe<Array<G_BookSerializationCampaign>>;
};

/**  シリーズ単位で集約されたキャンペーン情報概要  */
export type G_BookAggregatedCampaignSummary = {
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  シリーズ内の合計無料作品数  */
  totalFreeVolumes: Scalars['Int'];
  /**  シリーズ内の合計無料話数  */
  totalFreeEpisodes: Scalars['Int'];
  /**  ポイント還元率合計の最大値(%)  */
  highestTotalPointRefundRate: Scalars['Int'];
  /**  最大割引き率(%)  */
  highestDiscountRate: Scalars['Int'];
};

export type G_BookAppliedEpisodeCampaign = {
  campaignId: Scalars['ID'];
  productId: Scalars['ID'];
  productType: G_BooksEpisodeProductType;
};

/**  ブックスのバナー情報  */
export type G_BookBanner = {
  /**  バナーの内容  */
  description: Scalars['String'];
  /**  バナー画像のURL  */
  imageUrl: Scalars['URI'];
  /**  リスト遷移時の絞り込みフィルター  */
  filter?: Maybe<G_BookFilter>;
  /**  リスト遷移時の絞り込みフィルター  */
  order?: Maybe<G_BookOrder>;
  /**  末端遷移用のシリーズID  */
  seriesId?: Maybe<Scalars['ID']>;
  /**  末端遷移用のコンテンツID  */
  contentId?: Maybe<Scalars['ID']>;
  /**  電子書籍遷移用のlink  */
  url: Scalars['URI'];
};

/**  ブックスバナー  */
export type G_BookBanners = {
  /**  ローテーションバナー  */
  link: Array<G_BookBanner>;
  /**  中間バナー  */
  inner: Array<G_BookBanner>;
  /**  まだまだお得なキャンペーンバナー  */
  campaign: Array<G_BookBanner>;
};


/**  ブックスバナー  */
export type G_BookBannersLinkArgs = {
  allowUrlOnly?: Maybe<Scalars['Boolean']>;
};


/**  ブックスバナー  */
export type G_BookBannersInnerArgs = {
  allowUrlOnly?: Maybe<Scalars['Boolean']>;
};


/**  ブックスバナー  */
export type G_BookBannersCampaignArgs = {
  allowUrlOnly?: Maybe<Scalars['Boolean']>;
};

/**  ブックスお気に入り  */
export type G_BookBookmark = G_Node & {
  /**  シリーズID  */
  id: Scalars['ID'];
  /**  シリーズ  */
  series?: Maybe<G_BookSeriesSummary>;
};

export type G_BookBookmarkConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookBookmarkEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookBookmarkEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookBookmark;
};

/**  ブックス お気に入りの並び替え条件  */
export enum G_BookBookmarkOrder {
  /**  登録が新しい順  */
  New = 'NEW',
  /**  登録が古い順  */
  Old = 'OLD'
}

/**  ブックス閲覧履歴  */
export type G_BookBrowseHistory = G_Node & {
  /**  シリーズID  */
  id: Scalars['ID'];
  /**  シリーズ  */
  series?: Maybe<G_BookSeriesSummary>;
  /**  コンテンツID  */
  contentId?: Maybe<Scalars['ID']>;
  /**  出版形式  */
  publishFormat?: Maybe<G_BookPublishFormat>;
};

export type G_BookBrowseHistoryConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookBrowseHistoryEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookBrowseHistoryEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookBrowseHistory;
};

/**  ブックスキャンペーン  */
export type G_BookCampaign = {
  /**  キャンペーンID  */
  id: Scalars['Int'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  終了日時  */
  endAt: Scalars['DateTime'];
};

/**  ブックスコンテンツ  */
export type G_BookContent = {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  シリーズ  */
  series: G_BookMeta;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  作家一覧  */
  authors: Array<G_BookMeta>;
  /**  キーワード一覧  */
  keywords: Array<G_BookMeta>;
  /**  カテゴリー  */
  category: G_BookMeta;
  /**  書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  巻数/話数  */
  number: Scalars['Int'];
  /**  独占であるか  */
  isMonopoly: Scalars['Boolean'];
  /**  先行であるか  */
  isPreSale: Scalars['Boolean'];
  /**  縦読みフラグ  */
  isToon: Scalars['Boolean'];
  /**  作品概要  */
  description: Scalars['String'];
  /**  掲載紙・レーベル  */
  label: G_BookMeta;
  /**  出版社  */
  publisher: G_BookMeta;
  /**  告知  */
  notice: Array<Scalars['String']>;
  /**  既読フラグ  */
  isRead: Scalars['Boolean'];
  /**  最終閲覧フラグ  */
  isLastRead: Scalars['Boolean'];
  /**
   * 代表プロダクト
   * コンテンツ情報に必ずひとつセットされる、閲覧期限無期限(salesType=normal)のプロダクト
   */
  representativeProduct: G_BookProduct;
  /**  販売情報  */
  products: Array<G_BookProduct>;
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
};

/**  割引キャンペーン  */
export type G_BookDiscountCampaign = G_BookCampaign & {
  /**  キャンペーンID  */
  id: Scalars['Int'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  終了日時  */
  endAt: Scalars['DateTime'];
  /**  割引率(%)  */
  rate: Scalars['Int'];
};

/**  ブックス 連載話情報  */
export type G_BookEpisode = G_Node & G_BookContent & {
  /**  BookStoryId  */
  id: Scalars['ID'];
  /**  シリーズ  */
  series: G_BookMeta;
  /**  話数  */
  number: Scalars['Int'];
  /**  話タイトル  */
  title: Scalars['String'];
  /**  話数タイトル  */
  numberTitle: Scalars['String'];
  /**  作家一覧  */
  authors: Array<G_BookMeta>;
  /**  キーワード一覧  */
  keywords: Array<G_BookMeta>;
  /**  カテゴリー  */
  category: G_BookMeta;
  /**  書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  独占であるか  */
  isMonopoly: Scalars['Boolean'];
  /**  先行であるか  */
  isPreSale: Scalars['Boolean'];
  /**  縦読みフラグ  */
  isToon: Scalars['Boolean'];
  /**  作品概要  */
  description: Scalars['String'];
  /**  掲載紙・レーベル  */
  label: G_BookMeta;
  /**  出版社  */
  publisher: G_BookMeta;
  /**  告知  */
  notice: Array<Scalars['String']>;
  /**  既読フラグ(ログインユーザーのみ)  */
  isRead: Scalars['Boolean'];
  /**  最終閲覧フラグ(ログインユーザーのみ)  */
  isLastRead: Scalars['Boolean'];
  /**
   * 代表プロダクト
   * コンテンツ情報に必ずひとつセットされる、閲覧期限無期限(salesType=normal)のプロダクト
   */
  representativeProduct: G_BookEpisodeProduct;
  /**  販売情報  */
  products: Array<G_BookEpisodeProduct>;
  /**  親コンテンツ情報  */
  parentInfo?: Maybe<G_BookParentInfo>;
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
};

/**  ブックス 連載話の視聴情報  */
export type G_BookEpisodeBrowseFree = {
  /**  視聴URL  */
  browseUrl: Scalars['URI'];
};

export type G_BookEpisodeConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookEpisodeEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookEpisodeEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookEpisode;
};

/**  ブックス 連載話販売情報  */
export type G_BookEpisodeProduct = G_BookProduct & {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  販売ステータス  */
  saleStatus: G_BookProductSaleStatus;
  /**  商品形態  */
  productType: G_BooksEpisodeProductType;
  /**  無料ストリーミングURL  */
  freeStreamingUrl?: Maybe<Scalars['URI']>;
  /**  無料開始日  */
  freeBeginAt?: Maybe<Scalars['DateTime']>;
  /**  無料閲覧期限  */
  freeEndAt?: Maybe<Scalars['DateTime']>;
  /**  販売種別(無期限/レンタル)  */
  salesType: G_BookProductSalesType;
  /**  配信形式  */
  distributionMethods: Array<G_BookProductDistributionMethod>;
  /**  提供プラットフォーム  */
  platforms: Array<G_BookPlatform>;
  /**  ユーザーが購入済みであるか  */
  isPurchased: Scalars['Boolean'];
  /**  発売日  */
  releasedAt: Scalars['DateTime'];
  /**  公開日  */
  publishedAt: Scalars['DateTime'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**  定価(税込)  */
  fixedPrice: Scalars['Int'];
  /**  ポイント還元情報  */
  pointRefundDetail: G_PointRefundDetailByProduct;
  /**
   *  適用された連載キャンペーン
   * @deprecated Use appliedEpisodeCampaign
   */
  appliedSerializationCampaign?: Maybe<G_BookSerializationCampaign>;
  /**  エピソードに適用されているキャンペーン  */
  appliedEpisodeCampaign?: Maybe<G_BookAppliedEpisodeCampaign>;
  /**  プレミアム会員限定ポイント還元キャンペーン  */
  premiumPointRefundCampaigns: Array<G_BookPremiumPointRefundCampaign>;
  /**  毎日¥0開始日  */
  staminaRentalBeginAt?: Maybe<Scalars['DateTime']>;
  /**  毎日¥0無料閲覧可能時間  */
  staminaRentalExpireHour?: Maybe<Scalars['Int']>;
  /**  消費体力数  */
  staminaCost?: Maybe<Scalars['Int']>;
  /**  閲覧情報  */
  browsingInfo?: Maybe<G_BookProductBrowsingInfo>;
  /**  毎日¥0閲覧情報  */
  staminaBrowsingInfo?: Maybe<G_BookProductStaminaBrowsingInfo>;
  /**  新着か  */
  isNewEpisode: Scalars['Boolean'];
  /**  還元ポイント */
  issuancePoint: Scalars['Int'];
  /**  合計還元率  */
  totalPointRate: Scalars['Int'];
};

/**  ブックス 連載話一覧の並び替え条件  */
export enum G_BookEpisodeSortOrder {
  /**  最新話から  */
  New = 'NEW',
  /**  最初から  */
  Old = 'OLD'
}

/**  ブtックス 検索時の絞り込み条件を指定される場合の型（プロパティはBookFilterInputと同じ）  */
export type G_BookFilter = {
  /**  検索文字  */
  searchWord?: Maybe<Scalars['String']>;
  /**  シリーズ名  */
  series: Array<Scalars['String']>;
  /**  著者名  */
  authors: Array<Scalars['String']>;
  /**  著者ID  */
  authorIds: Array<Scalars['Int']>;
  /**  レーベル名  */
  labels: Array<Scalars['String']>;
  /**  レーベルID  */
  labelIds: Array<Scalars['Int']>;
  /**  出版社名  */
  publisher: Array<Scalars['String']>;
  /**  出版社ID  */
  publisherIds: Array<Scalars['Int']>;
  /**  俳優名  */
  actors: Array<Scalars['String']>;
  /**  俳優ID  */
  actorIds: Array<Scalars['Int']>;
  /**  女優名  */
  actresses: Array<Scalars['String']>;
  /**  女優ID  */
  actressIds: Array<Scalars['Int']>;
  /**  キーワード名  */
  keywords: Array<Scalars['String']>;
  /**  キーワードID  */
  keywordIds: Array<Scalars['Int']>;
  /**  カテゴリーID  */
  categories: Array<Scalars['Int']>;
  /**  無料商品  */
  isFree?: Maybe<Scalars['Boolean']>;
  /**  プレミアム会員無料作品  */
  isPremiumFree?: Maybe<Scalars['Boolean']>;
  /**  価格の最低値  */
  priceMin?: Maybe<Scalars['Int']>;
  /**  価格の最大値  */
  priceMax?: Maybe<Scalars['Int']>;
  /**  キャンペーン名  */
  campaign?: Maybe<Scalars['String']>;
  /**  値引きキャンペーン  */
  isDiscountCampaign?: Maybe<Scalars['Boolean']>;
  /**  ポイント還元キャンペーン  */
  isPointCampaign?: Maybe<Scalars['Boolean']>;
  /**  セットキャンペーン  */
  isSetCampaign?: Maybe<Scalars['Boolean']>;
  /**  連載商品  */
  isEpisodes?: Maybe<Scalars['Boolean']>;
  /**  巻読み商品  */
  isVolumes?: Maybe<Scalars['Boolean']>;
  /**  毎日¥0作品  */
  isStaminaRental?: Maybe<Scalars['Boolean']>;
  /**  キャンペーンOR検索  */
  appliedCampaigns: Array<G_BookSearchFacetSale>;
};

/**  ブックス 検索時の絞り込み条件  */
export type G_BookFilterInput = {
  /**  検索文字  */
  searchWord?: Maybe<Scalars['String']>;
  /**  シリーズ名  */
  series: Array<Scalars['String']>;
  /**  著者名  */
  authors: Array<Scalars['String']>;
  /**  著者ID  */
  authorIds: Array<Scalars['Int']>;
  /**  レーベル名  */
  labels: Array<Scalars['String']>;
  /**  レーベルID  */
  labelIds: Array<Scalars['Int']>;
  /**  出版社名  */
  publisher: Array<Scalars['String']>;
  /**  出版社ID  */
  publisherIds: Array<Scalars['Int']>;
  /**  俳優名  */
  actors: Array<Scalars['String']>;
  /**  俳優ID  */
  actorIds: Array<Scalars['Int']>;
  /**  女優名  */
  actresses: Array<Scalars['String']>;
  /**  女優ID  */
  actressIds: Array<Scalars['Int']>;
  /**  キーワード名  */
  keywords: Array<Scalars['String']>;
  /**  キーワードID  */
  keywordIds: Array<Scalars['Int']>;
  /**  カテゴリーID  */
  categories: Array<Scalars['Int']>;
  /**  無料商品  */
  isFree?: Maybe<Scalars['Boolean']>;
  /**  プレミアム会員無料作品  */
  isPremiumFree?: Maybe<Scalars['Boolean']>;
  /**  価格の最低値  */
  priceMin?: Maybe<Scalars['Int']>;
  /**  価格の最大値  */
  priceMax?: Maybe<Scalars['Int']>;
  /**  キャンペーン名  */
  campaign?: Maybe<Scalars['String']>;
  /**  値引きキャンペーン  */
  isDiscountCampaign?: Maybe<Scalars['Boolean']>;
  /**  ポイント還元キャンペーン  */
  isPointCampaign?: Maybe<Scalars['Boolean']>;
  /**  セットキャンペーン  */
  isSetCampaign?: Maybe<Scalars['Boolean']>;
  /**  連載商品  */
  isEpisodes?: Maybe<Scalars['Boolean']>;
  /**  巻読み商品  */
  isVolumes?: Maybe<Scalars['Boolean']>;
  /**  毎日¥0作品  */
  isStaminaRental?: Maybe<Scalars['Boolean']>;
  /**  キャンペーンOR検索  */
  appliedCampaigns: Array<G_BookSearchFacetSale>;
};

/**  フロア 例: 男性コミック, 女性コミック  */
export type G_BookFloor = {
  /**  BookFloorId  */
  id: Scalars['ID'];
  /**  タイトル  */
  title: Scalars['String'];
  /**  カテゴリーID  */
  categoryIds: Array<Scalars['Int']>;
};

/**  ブックスホーム  */
export type G_BookHome = {
  /**  バナー情報一覧を取得する  */
  banners?: Maybe<G_BookBanners>;
  /**  トップに表示するランキング種類  */
  rankings: Array<G_BookRankingWithFixedTerm>;
};

/**  ブックス i2iレコメンド表示場所  */
export enum G_BookItemBasedRecommendationDisplayLocation {
  Detail = 'DETAIL',
  ViewerLastPage = 'VIEWER_LAST_PAGE'
}

/**  ブックスキーワードピックアップ  */
export type G_BookKeywordPickup = {
  /**  ピックアップ名称  */
  name: Scalars['String'];
  /**  検索時の絞り込み条件  */
  filter: G_BookFilter;
};

/**  ブックス 蔵書(購入済み書籍)  */
export type G_BookLibrary = G_Node & {
  /**  シリーズID  */
  id: Scalars['ID'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  単行本/連載話  */
  publishFormat: G_BookPublishFormat;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  作家  */
  authors: Array<G_BookMeta>;
  /**  ジャンル  */
  genres: Array<G_BookMeta>;
  /**  カテゴリー  */
  category: G_BookMeta;
  /**  単巻の作品か  */
  isSingle: Scalars['Boolean'];
  /**  毎日¥0フラグ  */
  isStaminaRental: Scalars['Boolean'];
  /**  予約であるか  */
  isPreOrder: Scalars['Boolean'];
  /**  縦読みフラグ  */
  isToon: Scalars['Boolean'];
  /** 廃盤であるか */
  isDiscontinued: Scalars['Boolean'];
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
  /**  最小レーティングレベル  */
  minRatingLevel: Scalars['Int'];
};

export type G_BookLibraryConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookLibraryEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookLibraryEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookLibrary;
};

/**  ブックス ライブラリソート  */
export enum G_BookLibrarySortOrder {
  /**  購入日が新しい順  */
  PurchaseNewest = 'PURCHASE_NEWEST',
  /**  購入日が古い順  */
  PurchaseOldest = 'PURCHASE_OLDEST',
  /**  作家順  */
  Author = 'AUTHOR',
  /**  作品名順  */
  Title = 'TITLE',
  /**  視聴期限の短い順  */
  ExpirationDateNear = 'EXPIRATION_DATE_NEAR'
}

/**  ブックス作品のメタデータ  */
export type G_BookMeta = {
  /**  ID  */
  id: Scalars['Int'];
  /**  名前  */
  name: Scalars['String'];
};

/**  ブックスの並び替え情報  */
export enum G_BookOrder {
  /**  人気順  */
  Popular = 'POPULAR',
  /**  おすすめ順  */
  Recommend = 'RECOMMEND',
  /**  新着順  */
  New = 'NEW',
  /**  閲覧数順  */
  Views = 'VIEWS',
  /**  評価順  */
  ReviewScore = 'REVIEW_SCORE',
  /**  お気に入り数順  */
  Favorite = 'FAVORITE',
  /**  価格の安い順  */
  Price = 'PRICE',
  /**  商品発売日順  */
  Release = 'RELEASE',
  /**  マッチング順  */
  Matching = 'MATCHING'
}

/**  ブックス 親コンテンツ情報  */
export type G_BookParentInfo = {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
};

/**  ブックスピックアップ作品  */
export type G_BookPickup = G_BookSeriesPickup | G_BookKeywordPickup;

/**  ブックスピックアップ種別  */
export enum G_BookPickupTypes {
  /**  新着・話題ピックアップ  */
  NewArrival = 'NEW_ARRIVAL',
  /**  一冊丸ごと無料ピックアップ  */
  Free = 'FREE',
  /**  毎日￥０作品ピックアップ  */
  FreeEpisode = 'FREE_EPISODE',
  /**  プレミアム会員無料ピックアップ  */
  PremiumMemberFree = 'PREMIUM_MEMBER_FREE',
  /**  キーワードピックアップ  */
  Keyword = 'KEYWORD'
}

/**  ブックス 対応プラットフォーム  */
export enum G_BookPlatform {
  /**  Webブラウザ  */
  Browser = 'BROWSER',
  /**  Android  */
  Android = 'ANDROID',
  /**  iOS  */
  Ios = 'IOS',
  /**  PCアプリ Mac  */
  PcMac = 'PC_MAC',
  /**  PCアプリ Windows  */
  PcWindows = 'PC_WINDOWS'
}

/**  ポイント還元キャンペーン  */
export type G_BookPointRefundCampaign = G_BookCampaign & {
  /**  キャンペーンID  */
  id: Scalars['Int'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  終了日時  */
  endAt: Scalars['DateTime'];
  /**  還元率(%)  */
  rate: Scalars['Int'];
};

/**  プレミアムポイント還元キャンペーン  */
export type G_BookPremiumPointRefundCampaign = {
  /**  終了日時  */
  endAt: Scalars['DateTime'];
  /**  還元率(%)  */
  rate: Scalars['Int'];
};

export type G_BookProduct = {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  販売ステータス  */
  saleStatus: G_BookProductSaleStatus;
  /**  販売種別(無期限/レンタル)  */
  salesType: G_BookProductSalesType;
  /**  配信形式  */
  distributionMethods: Array<G_BookProductDistributionMethod>;
  /**  プレミアム会員限定ポイント還元キャンペーン  */
  premiumPointRefundCampaigns: Array<G_BookPremiumPointRefundCampaign>;
  /**  提供プラットフォーム  */
  platforms: Array<G_BookPlatform>;
  /**  ユーザーが購入済みかどうか（購入可能かどうか）  */
  isPurchased: Scalars['Boolean'];
  /**  発売日  */
  releasedAt: Scalars['DateTime'];
  /**  公開日  */
  publishedAt: Scalars['DateTime'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**  定価(税込)  */
  fixedPrice: Scalars['Int'];
  /**  ポイント還元情報  */
  pointRefundDetail: G_PointRefundDetailByProduct;
  /**  無料ストリーミングURL  */
  freeStreamingUrl?: Maybe<Scalars['URI']>;
  /**  無料閲覧期限  */
  freeEndAt?: Maybe<Scalars['DateTime']>;
  /**  閲覧情報  */
  browsingInfo?: Maybe<G_BookProductBrowsingInfo>;
  /**  還元ポイント */
  issuancePoint: Scalars['Int'];
  /**  合計還元率  */
  totalPointRate: Scalars['Int'];
};

/**  ブックス 購入済み書籍閲覧情報  */
export type G_BookProductBrowsingInfo = {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  ストリーミングURL  */
  streamingUrl: Scalars['URI'];
  /**  販売種別  */
  salesType: G_BookProductSalesType;
  /**  閲覧期限(無期限の場合はNull)  */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /**  閲覧可能秒数(無期限の場合はNull)  */
  viewableSeconds?: Maybe<Scalars['Int']>;
};

/**  ブックス 配信形式  */
export enum G_BookProductDistributionMethod {
  /**  ダウンロード  */
  Download = 'DOWNLOAD',
  /**  ストリーミング  */
  Streaming = 'STREAMING'
}

/**  ブックス販売ステータス  */
export enum G_BookProductSaleStatus {
  /**  販売中  */
  OnSale = 'ON_SALE',
  /**  予約受付中  */
  PreOrder = 'PRE_ORDER',
  /**  廃盤(購入不可)  */
  Discontinued = 'DISCONTINUED'
}

/**  ブックス販売種別(無期限/レンタル)  */
export enum G_BookProductSalesType {
  /**  無期限  */
  Normal = 'NORMAL',
  /**  レンタル  */
  Rental = 'RENTAL'
}

/**  ブックス 毎日¥0レンタル済み書籍閲覧情報  */
export type G_BookProductStaminaBrowsingInfo = {
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  ストリーミングURL  */
  streamingUrl: Scalars['URI'];
  /**  閲覧期限(無期限の場合はNull)  */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /**  閲覧可能秒数(無期限の場合はNull)  */
  viewableSeconds?: Maybe<Scalars['Int']>;
};

/**  出版形式  */
export enum G_BookPublishFormat {
  /**  単行本  */
  Volume = 'VOLUME',
  /**  連載話  */
  Episode = 'EPISODE'
}

/**  ブックス 購入方式の種類  */
export enum G_BookPurchaseMethod {
  /**  レンタル  */
  Rental = 'RENTAL',
  /**  購入  */
  Purchase = 'PURCHASE',
  /**  毎日¥0  */
  StaminaRental = 'STAMINA_RENTAL'
}

export type G_BookRanking = {
  /**  BookRankingId  */
  id: Scalars['ID'];
  /**  ランキングタイトル  */
  title: Scalars['String'];
  /**  ランキングで指定可能な期間  */
  terms: Array<G_BookRankingTerm>;
  /**  ランキングのシリーズ取得  */
  items: G_BookRankingItemConnection;
};


export type G_BookRankingItemsArgs = {
  terms: G_BookRankingTerm;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type G_BookRankingItem = G_Node & {
  /**  BookRankingItemId  */
  id: Scalars['ID'];
  /**  ランキング順位  */
  rank: Scalars['Int'];
  /**  ブックスのシリーズ情報  */
  series: G_BookSeriesSummary;
};

export type G_BookRankingItemConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookRankingItemEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookRankingItemEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookRankingItem;
};

/**  ブックス ランキングの集計期間  */
export enum G_BookRankingTerm {
  /**  1日  */
  Daily = 'DAILY',
  /**  1週間  */
  Weekly = 'WEEKLY',
  /**  1ヶ月  */
  Monthly = 'MONTHLY'
}

/**  ブックスホーム画面向けの期間が固定(サーバーサイドで指定)されたランキング  */
export type G_BookRankingWithFixedTerm = {
  /**  BookRankingId  */
  id: Scalars['ID'];
  /**  ランキングタイトル  */
  title: Scalars['String'];
  /**  ランキングのシリーズ取得  */
  items: G_BookRankingItemConnection;
};


/**  ブックスホーム画面向けの期間が固定(サーバーサイドで指定)されたランキング  */
export type G_BookRankingWithFixedTermItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/**  ブックス おすすめ商品  */
export type G_BookRecommendationItem = {
  /**  おすすめ商品  */
  series?: Maybe<G_BookSeriesSummary>;
  /**  i3トラッキングID  */
  trackingId: Scalars['ID'];
};

/**  ブックス 関連シリーズ  */
export type G_BookRelatedSeries = {
  relationType: G_BookSeriesRelationType;
  series: G_BookSeries;
};

/**  続きから読む ステータス  */
export enum G_BookResumeStatusType {
  /**  体力回復中  */
  Recovery = 'RECOVERY',
  /**  未読あり  */
  Unread = 'UNREAD',
  /**  ステータスなし  */
  None = 'NONE'
}

export type G_BookReviewInput = {
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  投稿対象のコンテンツID  */
  contentId: Scalars['ID'];
  /**  レビュアー名 (ニックネーム未設定の場合のみ必須)  */
  reviewerName?: Maybe<Scalars['String']>;
  /**  レビュータイトル  */
  title?: Maybe<Scalars['String']>;
  /**  レビュー値(星の数)  */
  point: Scalars['Int'];
  /**  ネタバレ有無  */
  hasSpoiler: Scalars['Boolean'];
  /**  投稿内容  */
  comment?: Maybe<Scalars['String']>;
};

/**  ブックスレビュー集計情報  */
export type G_BookReviewStats = {
  /**  レビューの平均点数  */
  averagePoint: Scalars['Float'];
  /**  レビュー者数  */
  reviewerCount: Scalars['Int'];
};

/**  ブックス 検索シリーズの情報  */
export type G_BookSearchConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookSearchEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
  /**  検索ファセット情報  */
  facet: G_BookSearchFacet;
};

export type G_BookSearchEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookSeriesSummary;
};

export type G_BookSearchFacet = {
  /**  作家  */
  author: Array<G_BookSearchFacetItem>;
  /**  キーワード  */
  keywords: Array<G_BookSearchFacetItem>;
  /**  掲載紙・レーベル  */
  label: Array<G_BookSearchFacetItem>;
  /**  出版社  */
  publisher: Array<G_BookSearchFacetItem>;
  /**  セール  */
  sale: Array<G_BookSearchFacetSale>;
  /**  連載体力情報  */
  stamina: Array<G_BookSearchFacetStaminaRental>;
  /**  フロア  */
  floor: Array<G_BookFloor>;
};

export type G_BookSearchFacetItem = {
  /**  対象文字列  */
  name: Scalars['String'];
  /**  対象作品数  */
  contentCount: Scalars['Int'];
};

/**  ブックス セール絞り込み  */
export enum G_BookSearchFacetSale {
  /**  1冊まるごと無料  */
  Free = 'FREE',
  /**  値引あり  */
  Discount = 'DISCOUNT',
  /**  ポイント還元あり  */
  Point = 'POINT',
  /**  セットキャンペーンあり  */
  Set = 'SET'
}

/**  ブックス 毎日¥0絞り込み  */
export enum G_BookSearchFacetStaminaRental {
  /**  対象作品  */
  Applicable = 'APPLICABLE'
}

/**  連載キャンペーン  */
export type G_BookSerializationCampaign = G_BookCampaign & {
  /**  キャンペーンID  */
  id: Scalars['Int'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  終了日時  */
  endAt: Scalars['DateTime'];
  /**  無料話数  */
  totalFreeEpisodes: Scalars['Int'];
  /**  毎日¥0話数  */
  totalStaminaRentalEpisodes: Scalars['Int'];
};

/**  連載の掲載周期  */
export enum G_BookSerializationCycle {
  /**  月曜連載  */
  Monday = 'MONDAY',
  /**  火曜連載  */
  Tuesday = 'TUESDAY',
  /**  水曜連載  */
  Wednesday = 'WEDNESDAY',
  /**  木曜連載  */
  Thursday = 'THURSDAY',
  /**  金曜連載  */
  Friday = 'FRIDAY',
  /**  土曜連載  */
  Saturday = 'SATURDAY',
  /**  日曜連載  */
  Sunday = 'SUNDAY'
}

/**  ブックス シリーズ情報  */
export type G_BookSeries = {
  /**  BookSeriesId  */
  id: Scalars['ID'];
  /**  シリーズのタイトル  */
  title: Scalars['String'];
  /**  シリーズの書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  新作であるか  */
  isNewWork: Scalars['Boolean'];
  /**  独占であるか  */
  isMonopoly: Scalars['Boolean'];
  /**  先行であるか  */
  isPreSale: Scalars['Boolean'];
  /**  予約であるか  */
  isPreOrder: Scalars['Boolean'];
  /**  完結しているか  */
  isCompleted: Scalars['Boolean'];
  /**  縦読みフラグ  */
  isToon: Scalars['Boolean'];
  /**  お気に入りしているかどうか  */
  hasBookmark: Scalars['Boolean'];
  /**
   * 関連シリーズ
   * 有料シリーズからは無料シリーズへ、無料シリーズからは有料シリーズへ紐付けが行われる
   */
  relatedSeries?: Maybe<G_BookRelatedSeries>;
  /**
   * ピックアップ巻(最大5件)
   * - 雑誌の場合
   * - 最新刊を先頭に降順で最大5件を返す
   * - 雑誌以外
   * - 閲覧履歴が存在する場合は、閲覧した巻を含む最新5件
   * - それ以外の場合は1巻から最大5件
   */
  pickupVolumes: Array<G_BookVolume>;
  /**
   * ピックアップ話(最大5件)
   * - 閲覧履歴が存在する場合は、閲覧した話を含む最新5件
   * - それ以外の場合は1話から最大5件
   */
  pickupEpisodes?: Maybe<Array<G_BookEpisode>>;
  /**  シリーズ(巻読み)概要  */
  volumesSummary?: Maybe<G_BookSeriesVolumesSummary>;
  /**  連載(話読み)概要  */
  episodesSummary?: Maybe<G_BookSeriesEpisodesSummary>;
  /**  シリーズ単位で集約されたキャンペーン情報  */
  campaign: G_BookAggregatedCampaignDetail;
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
  /**  休載コメント  */
  suspendedAnnounce?: Maybe<Scalars['String']>;
};

/**  連載(話読み)の概要  */
export type G_BookSeriesEpisodesSummary = {
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  新話を含んでいるか  */
  hasNewEpisode: Scalars['Boolean'];
  /**  休載中であるか  */
  isSuspended: Scalars['Boolean'];
  /**  毎日¥0対象作品であるか  */
  isStaminaRental: Scalars['Boolean'];
  /**  連載周期  */
  cycle?: Maybe<G_BookSerializationCycle>;
  /**  全話数  */
  numberOfStories: Scalars['Int'];
  /**  まとめてレンタル可能フラグ(シリーズ内にレンタル可能な作品が複数ある)  */
  canBulkRental: Scalars['Boolean'];
  /**  代表エピソード  */
  representativeEpisode: G_BookEpisode;
  /**  連載体力情報  */
  stamina?: Maybe<G_BookStamina>;
};

/**  ブックスシリーズピックアップ  */
export type G_BookSeriesPickup = {
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  シリーズ  */
  series?: Maybe<G_BookSeriesSummary>;
  /**  コンテンツID  */
  contentId?: Maybe<Scalars['ID']>;
  /**  出版形式  */
  publishFormat?: Maybe<G_BookPublishFormat>;
};

/**  ブックス シリーズリレーションタイプ  */
export enum G_BookSeriesRelationType {
  /**  無料シリーズから有料シリーズへのリレーション  */
  FreeToPaid = 'FREE_TO_PAID',
  /**  有料シリーズから無料シリーズへのリレーション  */
  PaidToFree = 'PAID_TO_FREE'
}

/**  ブックス シリーズ概要  */
export type G_BookSeriesSummary = G_Node & {
  /**  BookSeriesId  */
  id: Scalars['ID'];
  /**  タイトル  */
  title: Scalars['String'];
  /**  作家一覧  */
  authors: Array<G_BookMeta>;
  /**  書影  */
  thumbnail?: Maybe<Scalars['URI']>;
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  書影のコンテンツID */
  contentId?: Maybe<Scalars['ID']>;
  /**  連載代表書影  */
  episodeThumbnail?: Maybe<Scalars['URI']>;
  /**  連載代表カバーイメージ  */
  episodeCoverImage?: Maybe<Scalars['URI']>;
  /**  連載代表書影のコンテンツID  */
  episodeContentId?: Maybe<Scalars['ID']>;
  /**  連載代表のレーティング  */
  episodeRatingLevel?: Maybe<Scalars['Int']>;
  /**  単行本のレーティング  */
  volumeRatingLevel?: Maybe<Scalars['Int']>;
  /**  カテゴリー  */
  category: G_BookMeta;
  /**  縦読であるか  */
  isToon: Scalars['Boolean'];
  /**  毎日¥0であるか  */
  isStaminaRental: Scalars['Boolean'];
  /**  新巻を含んでいるか  */
  hasNewVolume: Scalars['Boolean'];
  /**  新話を含んでいるか  */
  hasNewEpisode: Scalars['Boolean'];
  /**  独占であるか  */
  isMonopoly: Scalars['Boolean'];
  /**  先行であるか  */
  isPreSale: Scalars['Boolean'];
  /**  予約であるか  */
  isPreOrder: Scalars['Boolean'];
  /**  連載体力情報  */
  stamina?: Maybe<G_BookStamina>;
  /**  キャンペーン概要 (各販売形式ごとのキャンペーン概要)  */
  campaign: G_BookAggregatedCampaignSummary;
  /**  レビュー集計情報  */
  reviewStats: G_BookReviewStats;
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
  /**  最小レーティングレベル  */
  minRatingLevel: Scalars['Int'];
};

/**  シリーズ(巻読み)情報  */
export type G_BookSeriesVolumesSummary = {
  /**  新巻を含んでいるか  */
  hasNewVolume: Scalars['Boolean'];
  /**  雑誌フラグ  */
  isMagazine: Scalars['Boolean'];
  /**  単品フラグ  */
  isSingle: Scalars['Boolean'];
  /**  全巻数  */
  numberOfVolumes: Scalars['Int'];
  /**  まとめてレンタル可能フラグ(シリーズ内にレンタル可能な作品が複数ある)  */
  canBulkRental: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewStats: G_BookReviewStats;
  /**  代表巻  */
  representativeVolume: G_BookVolume;
};

/**  シリーズに紐づく連載体力情報  */
export type G_BookStamina = {
  /**  残り閲覧可能話数(今読める残り話数)  */
  canBeReadNumber: Scalars['Int'];
  /**  最大閲覧可能話数(体力MAXで読める話数)  */
  maxReadNumber: Scalars['Int'];
  /**  体力回復するまでの秒数  */
  recoveryTimeSeconds?: Maybe<Scalars['Int']>;
};

/**  ブックスユーザー  */
export type G_BookUser = {
  /**  ユーザーID  */
  id: Scalars['ID'];
  /**  ブックス 未購入続刊リストを取得する  */
  continuingVolumes: Array<G_BookVolume>;
  /**  ブックス 「あなたへのおすすめ」作品リストを取得  */
  userBasedRecommendation: Array<G_BookRecommendationItem>;
  /**  ブックス 「この商品を買った人はこんな商品も買っています」作品リスト  */
  itemBasedRecommendation: Array<G_BookRecommendationItem>;
  /**  ブックスのお気に入りの作品を取得  */
  bookmarks: G_BookBookmarkConnection;
  /**  ブックスの閲覧履歴一覧を取得する  */
  browseHistories: G_BookBrowseHistoryConnection;
  /**  蔵書(購入済み書籍)を取得  */
  libraries: G_BookLibraryConnection;
};


/**  ブックスユーザー  */
export type G_BookUserItemBasedRecommendationArgs = {
  contentId: Scalars['ID'];
  displayLocation?: Maybe<G_BookItemBasedRecommendationDisplayLocation>;
};


/**  ブックスユーザー  */
export type G_BookUserBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<G_BookBookmarkOrder>;
};


/**  ブックスユーザー  */
export type G_BookUserBrowseHistoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  ブックスユーザー  */
export type G_BookUserLibrariesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  expired: Scalars['Boolean'];
  order: G_BookLibrarySortOrder;
};

/**  ブックス 単行本情報  */
export type G_BookVolume = G_Node & G_BookContent & {
  /**  BookContentId  */
  id: Scalars['ID'];
  /**  シリーズ  */
  series: G_BookMeta;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  作家一覧  */
  authors: Array<G_BookMeta>;
  /**  キーワード一覧  */
  keywords: Array<G_BookMeta>;
  /**  カテゴリー  */
  category: G_BookMeta;
  /**  書影  */
  thumbnail: Scalars['URI'];
  /**  カバーイメージ  */
  coverImage?: Maybe<Scalars['URI']>;
  /**  独占であるか  */
  isMonopoly: Scalars['Boolean'];
  /**  先行であるか  */
  isPreSale: Scalars['Boolean'];
  /**  縦読みフラグ  */
  isToon: Scalars['Boolean'];
  /**  作品概要  */
  description: Scalars['String'];
  /**  掲載紙・レーベル  */
  label: G_BookMeta;
  /**  出版社  */
  publisher: G_BookMeta;
  /**  告知  */
  notice: Array<Scalars['String']>;
  /**  ページ数  */
  pageNumber: Scalars['String'];
  /**  巻数  */
  number: Scalars['Int'];
  /**  既読フラグ(ログインユーザーのみ)  */
  isRead: Scalars['Boolean'];
  /**  最終閲覧フラグ(ログインユーザーのみ)  */
  isLastRead: Scalars['Boolean'];
  /**
   * 代表プロダクト
   * コンテンツ情報に必ずひとつセットされる、閲覧期限無期限(salesType=normal)のプロダクト
   */
  representativeProduct: G_BookVolumeProduct;
  /**  販売情報  */
  products: Array<G_BookVolumeProduct>;
  /**  レーティングレベル  */
  ratingLevel: Scalars['Int'];
  /**  プレミアム商品であるか  */
  isPremiumFree: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
};


/**  ブックス 単行本情報  */
export type G_BookVolumeReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/**  ブックス 単行本の視聴情報  */
export type G_BookVolumeBrowseFree = {
  /**  視聴URL  */
  browseUrl: Scalars['URI'];
  /**  終了日時  */
  endAt?: Maybe<Scalars['DateTime']>;
};

export type G_BookVolumeConnection = G_ForwardOnlyConnection & {
  edges: Array<G_BookVolumeEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_BookVolumeEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_BookVolume;
};

/**  ブックス 単行本販売情報  */
export type G_BookVolumeProduct = G_BookProduct & {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  販売ステータス  */
  saleStatus: G_BookProductSaleStatus;
  /**  無料ステータス  */
  freeStatus: G_BookVolumeProductFreeStatus;
  /**  無料ストリーミングURL  */
  freeStreamingUrl?: Maybe<Scalars['URI']>;
  /**  無料閲覧期限  */
  freeEndAt?: Maybe<Scalars['DateTime']>;
  /**  立ち読みURL  */
  sampleStreamingUrl?: Maybe<Scalars['URI']>;
  /**  ブックス販売種別(無期限/レンタル)  */
  salesType: G_BookProductSalesType;
  /**  配信形式  */
  distributionMethods: Array<G_BookProductDistributionMethod>;
  /**  提供プラットフォーム  */
  platforms: Array<G_BookPlatform>;
  /**  ユーザーが購入済みかどうか（購入可能かどうか）  */
  isPurchased: Scalars['Boolean'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**  定価(税込)  */
  fixedPrice: Scalars['Int'];
  /**  ポイント還元情報  */
  pointRefundDetail: G_PointRefundDetailByProduct;
  /**  適用された割引きキャンペーン  */
  appliedDiscountCampaign?: Maybe<G_BookDiscountCampaign>;
  /**  適用されたポイント還元キャンペーン  */
  appliedPointRefundCampaign?: Maybe<G_BookPointRefundCampaign>;
  /**  適用されたプレミアム会員限定ポイント還元キャンペーン  */
  appliedPremiumPointRefundCampaign?: Maybe<G_BookPremiumPointRefundCampaign>;
  /**  プレミアム会員限定ポイント還元キャンペーン  */
  premiumPointRefundCampaigns: Array<G_BookPremiumPointRefundCampaign>;
  /**  発売日  */
  releasedAt: Scalars['DateTime'];
  /**  公開日  */
  publishedAt: Scalars['DateTime'];
  /**  ファイル容量  */
  fileSize?: Maybe<Scalars['Float']>;
  /**  ファイル形式  */
  fileType?: Maybe<Scalars['String']>;
  /**  付録付きフラグ  */
  hasAppendix: Scalars['Boolean'];
  /**  閲覧情報  */
  browsingInfo?: Maybe<G_BookProductBrowsingInfo>;
  /**  新着か  */
  isNewItem: Scalars['Boolean'];
  /**  還元ポイント */
  issuancePoint: Scalars['Int'];
  /**  合計還元率  */
  totalPointRate: Scalars['Int'];
};

/**  ブックス 単行本商品無料ステータス  */
export enum G_BookVolumeProductFreeStatus {
  /**  有料  */
  Paid = 'PAID',
  /**  定価無料  */
  PriceFree = 'PRICE_FREE',
  /**  値引き無料  */
  DiscountFree = 'DISCOUNT_FREE',
  /**  関連商品無料  */
  RelationFree = 'RELATION_FREE',
  /**  プレミアム会員限定無料  */
  PremiumFree = 'PREMIUM_FREE'
}

/**  ブックス 単行本一覧の並び替え条件  */
export enum G_BookVolumeSortOrder {
  /**  最新刊から  */
  New = 'NEW',
  /**  最初から  */
  Old = 'OLD'
}

/**  ブックス 連載話商品形態  */
export enum G_BooksEpisodeProductType {
  /**  無料  */
  Free = 'FREE',
  /**  毎日￥0  */
  StaminaRental = 'STAMINA_RENTAL',
  /**  有料  */
  Paid = 'PAID'
}

/**  イベントタイプ  */
export enum G_BytePlusEventType {
  /**  作品のインプレッション  */
  Impression = 'IMPRESSION',
  /**  作品のクリック  */
  Click = 'CLICK',
  /**  お気に入り登録  */
  Favorite = 'FAVORITE',
  /**  検索  */
  Search = 'SEARCH',
  /**  詳細ページの表示  */
  StayDetailPage = 'STAY_DETAIL_PAGE'
}

/** 出演者 */
export type G_Cast = {
  /** @deprecated Use `Person.ID`. */
  id: Scalars['ID'];
  /**  役名  */
  castName: Scalars['String'];
  /**  出演者名  */
  actorName: Scalars['String'];
  /**  表示優先順位  */
  priority: Scalars['Int'];
  person: G_Person;
};

/**  カテゴリ・ジャンル  */
export type G_CategoryGenreInput = {
  /**  カテゴリID  */
  categoryId: Scalars['ID'];
  /**  ジャンルID  */
  genreId: Scalars['ID'];
  /**  シーズンID  */
  seasonId: Scalars['ID'];
};

/** チャプター情報(op/ed) */
export type G_Chapter = {
  /** オープニング情報 */
  op?: Maybe<G_ChapterRange>;
  /** エンディング情報 */
  ed?: Maybe<G_ChapterRange>;
  /** エンディングが終わった後、スキップ可能な区間の情報 */
  skippable?: Maybe<G_ChapterRange>;
};

/** チャプターの時間範囲情報 */
export type G_ChapterRange = {
  /** 開始位置(秒) */
  start: Scalars['Float'];
  /** 終了位置(秒) */
  end: Scalars['Float'];
};

export type G_ChargeTvCoinError = {
  code?: Maybe<G_ChargeTvCoinErrorCode>;
};

export enum G_ChargeTvCoinErrorCode {
  ErrorCodeInvalidReceipt = 'ERROR_CODE_INVALID_RECEIPT'
}

export type G_ChargeTvCoinForAndroidInput = {
  /**  Googleから取得した購入トークン  */
  purchaseToken: Scalars['String'];
  /**  課金アイテムID(SKU) 個々の購入可能アイテムに割り当てられる一意の識別子  */
  skuId: Scalars['String'];
  /**  アプリパッケージ名  */
  packageName: Scalars['String'];
  /**  アプリで発行されたorder id  */
  orderId: Scalars['String'];
};

export type G_ChargeTvCoinForAndroidPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  OpenAPIのトランザクション  */
  platformTransaction: G_PlatformTransaction;
  /**  エラー詳細  */
  error?: Maybe<G_ChargeTvCoinError>;
};

export type G_ChargeTvCoinForFireOsInput = {
  /**  Amazonから取得したレシートID  */
  receiptId: Scalars['String'];
  /**  AmazonアプリのユーザーID  */
  amazonUserId: Scalars['String'];
};

export type G_ChargeTvCoinForFireOsPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_ChargeTvCoinError>;
  /** OpenAPIのトランザクション */
  platformTransaction: G_PlatformTransaction;
};

export type G_ChargeTvCoinForIosInput = {
  /**  Appleから取得したbase64レシート  */
  base64Receipt: Scalars['String'];
};

export type G_ChargeTvCoinForIosPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**
   *  有効化したトランザクションID(App Storeで発行されたもの)
   * @deprecated Use appStoreTransactions.
   */
  transactionIds: Array<Scalars['String']>;
  /**  有効化したトランザクション  */
  appStoreTransactions: Array<G_AppStoreTransaction>;
  /**  OpenAPIのトランザクション  */
  platformTransactions: Array<G_PlatformTransaction>;
  /**  エラー詳細  */
  error?: Maybe<G_ChargeTvCoinError>;
};

/**  クライアント情報  */
export type G_Client = {
  /**  クライアントのIPアドレス  */
  ipAddress: Scalars['String'];
  /**  海外からのアクセスか  */
  isForeignAccess: Scalars['Boolean'];
};

/**  コメント  */
export type G_Comment = {
  /**  コメントID  */
  id: Scalars['ID'];
  /**  コメント内容  */
  body: Scalars['String'];
  /**  Hash化されたユーザーID  */
  hashedUserId: Scalars['String'];
  /**  コメント作成日時  */
  createdAt: Scalars['DateTime'];
  /**  絵文字などの特殊文字を含むか  */
  containsSpecialCharacter: Scalars['Boolean'];
};

export type G_CommentConnection = {
  edges: Array<G_CommentEdge>;
  pageInfo: G_PageInfo;
  /**  コメント一覧再取得の間隔(秒)  */
  commentRefreshIntervalSeconds: Scalars['Int'];
};

export type G_CommentEdge = {
  cursor: Scalars['String'];
  node: G_Comment;
};

export enum G_CommentInappropriateReason {
  /**  中傷 脅迫 */
  DefamationOrThreats = 'DEFAMATION_OR_THREATS',
  /**  プライバシー侵害  */
  PersonalOrRights = 'PERSONAL_OR_RIGHTS',
  /**  モラル違反  */
  Immorality = 'IMMORALITY',
  /**  スパム投稿  */
  CommercialOrSpam = 'COMMERCIAL_OR_SPAM',
  /**  その他  */
  OtherInappropriate = 'OTHER_INAPPROPRIATE'
}

/** cursor-based paginationのConnection */
export type G_Connection = {
  edges: Array<G_Edge>;
  pageInfo: G_PageInfo;
};

export type G_ConsumeBookStaminaInput = {
  /**  購入する商品ID情報  */
  products: Array<G_ConsumeBookStaminaProductInput>;
};

export type G_ConsumeBookStaminaPayload = G_Payload & {
  /**
   * 購入した商品ID情報
   * BookStoryのBookProduct.ID
   */
  productIds: Array<Scalars['ID']>;
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_ConsumeBookStaminaProductInput = {
  /**
   * 購入する商品ID情報
   * BookStoryのBookProduct.ID
   */
  productId: Scalars['ID'];
  /**
   * 購入するシリーズ情報
   * BookStoryが紐づくBookSeries.ID
   */
  seriesId: Scalars['ID'];
};

/**
 * ビーコンに連携されるコンテンツ詳細情報
 * https://confl.arms.dmm.com/pages/viewpage.action?pageId=1106165925
 */
export enum G_ContentTypeDetail {
  /** VODのSVODコンテンツ */
  VodSvod = 'VOD_SVOD',
  /** VODの無料コンテンツ */
  VodFree = 'VOD_FREE',
  /** VODの予告編・PV */
  VodPv = 'VOD_PV',
  /**  VODのESTコンテンツ  */
  VodPpvEst = 'VOD_PPV_EST',
  /**  VODのTVODコンテンツ  */
  VodPpvTvod = 'VOD_PPV_TVOD',
  /** 舞台等のライブ配信PPVコンテンツ */
  LivePpv = 'LIVE_PPV',
  /** スポット配信コンテンツ */
  LiveSpot = 'LIVE_SPOT',
  /** 放送のライブ配信 */
  BroadcastLive = 'BROADCAST_LIVE',
  /** 放送の追っかけ */
  BroadcastDvr = 'BROADCAST_DVR',
  /** 既存(newdmm)コンテンツ */
  Legacy = 'LEGACY'
}

export type G_ConversionTag = {
  /**  月額プランID  */
  id: G_SubscriptionPlanId;
  /**  デバイス  */
  device: G_Device;
  /**  成果タグ  */
  complete: Scalars['String'];
  /**  成果直前タグ  */
  confirm: Scalars['String'];
};


export type G_ConversionTagCompleteArgs = {
  orderId: Scalars['String'];
};

export type G_CreateDemographicInput = {
  /**  好きなカテゴリ・ジャンル (1〜3個選択)  */
  favoriteCategoryGenres: Array<G_CategoryGenreInput>;
  /**  生年月  */
  birthdate?: Maybe<G_BirthdateInput>;
  /**  性別  */
  gender?: Maybe<G_Gender>;
};

export type G_CreateDemographicPayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/** クレジットカード情報 */
export type G_CreditCard = {
  /**  クレジットカードが登録されているか  */
  isRegistered: Scalars['Boolean'];
  /**  クレジットカード番号の下四桁  */
  lastDigits?: Maybe<Scalars['String']>;
  /**  クレジットカードブランド  */
  brand?: Maybe<G_CreditCardBrand>;
};

/** クレジットカードブランド */
export enum G_CreditCardBrand {
  /**  Visa  */
  Visa = 'VISA',
  /**  Mastercard  */
  Master = 'MASTER',
  /**  JCB */
  Jcb = 'JCB',
  /**  American Express  */
  Amex = 'AMEX',
  /**  Diners Club  */
  Diners = 'DINERS',
  /**  その他  */
  Other = 'OTHER'
}



export type G_DeleteBookBookmarkInput = {
  /**  対象ブックス作品のシリーズID  */
  seriesId: Scalars['ID'];
};

export type G_DeleteBookBookmarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteBookBrowseHistoryInput = {
  /**  対象ブックス作品のシリーズID  */
  seriesId: Scalars['ID'];
};

export type G_DeleteBookBrowseHistoryPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteContinueWatchingListEntriesInput = {
  /**  シーズンID  */
  seasonIds: Array<Scalars['ID']>;
};

export type G_DeleteContinueWatchingListEntriesPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteFanzaPpvBookmarksInput = {
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  対象作品コンテンツID  */
  contentId: Scalars['ID'];
};

export type G_DeleteFanzaPpvBookmarksPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteFanzaSvodBookmarksInput = {
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  ショップオプション (ドリームチャンネル用)  */
  shopOption?: Maybe<Scalars['String']>;
  /**  対象作品コンテンツID  */
  contentIds: Array<Scalars['ID']>;
};

export type G_DeleteFanzaSvodPlayHistoriesInput = {
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  ショップオプション (ドリームチャンネル用)  */
  shopOption?: Maybe<Scalars['String']>;
  /**  対象作品コンテンツID  */
  contentIds: Array<Scalars['ID']>;
};

export type G_DeleteFanzaSvodPlayHistoryPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteProfileInput = {
  /**  プロフィールID  */
  profileId: Scalars['ID'];
};

export type G_DeleteProfilePayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_ProfileErrorCode>;
};

export type G_DeleteVideoBookmarksInput = {
  /**  対象作品のシーズンID  */
  seasonIds: Array<Scalars['ID']>;
};

export type G_DeleteVideoBookmarksPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_DeleteVideoPlayHistoriesInput = {
  /**  視聴履歴ID  */
  historyIds: Array<Scalars['ID']>;
};

export type G_DeleteVideoPlayHistoriesPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/**
 * ユーザーのデバイス種別
 * See https://confl.arms.dmm.com/x/SCLvQg
 */
export enum G_Device {
  /**  ブラウザ(PC)  */
  Browser = 'BROWSER',
  /**  モバイルブラウザ(iOS)  */
  BrowserMobileIos = 'BROWSER_MOBILE_IOS',
  /**  モバイルブラウザ(Android)  */
  BrowserMobileAndroid = 'BROWSER_MOBILE_ANDROID',
  /**  iPhone  */
  Iphone = 'IPHONE',
  /**  iPad  */
  Ipad = 'IPAD',
  /**  Android Mobile  */
  AndroidMobile = 'ANDROID_MOBILE',
  /**  Android TV  */
  AndroidTv = 'ANDROID_TV',
  /**  Fire TV  */
  FireTv = 'FIRE_TV',
  /**  HTML5 TV  */
  Html5Tv = 'HTML5_TV',
  /**  PS4  */
  Ps4 = 'PS4',
  /**  PS5  */
  Ps5 = 'PS5'
}

/**
 * 再生フィー計上対象のデバイス製造メーカー
 * See https://confl.arms.dmm.com/x/SCLvQg
 */
export enum G_DeviceManufacturer {
  /**  パナソニック  */
  Panasonic = 'PANASONIC',
  /**  東芝  */
  Toshiba = 'TOSHIBA',
  /**  シャープ  */
  Sharp = 'SHARP',
  /**  ハイセンス  */
  Hisense = 'HISENSE'
}

/** DMMポイント */
export type G_DmmPoint = {
  /**
   * サービス共通で利用できる、ユーザが購入したDMMポイント
   * (有償DMMポイント)
   */
  paidDmmPoint: Scalars['Int'];
  /**
   * サービス共通で利用できる、DMMが無料配布したDMMポイント
   * (無償DMMポイント)
   */
  sharedFreeDmmPoint: Scalars['Int'];
};

/** ダウンロード用ファイルの種類を管理 */
export enum G_DownloadType {
  /** dcv (DCV: PC向けダウンロードファイル) */
  Dcv = 'DCV',
  /** wsdcf (WebStreamDRM: VR / 現行スマホアプリ向けダウンロードファイル) */
  Wsdcf = 'WSDCF'
}

/** パート/エピソード毎のダウンロード出来るファイルの情報 */
export type G_DownloadableFile = {
  /** パート番号 */
  part: Scalars['Int'];
  /** サポートする画質一覧 */
  qualities: Array<G_Quality>;
};

/** ダウンロードファイル選択画面用データ */
export type G_DownloadableFileData = {
  /** パート数 */
  partCount?: Maybe<Scalars['Int']>;
  /**
   * ダウンロードするファイル情報
   * 複数入っている場合はパート作品想定
   */
  files: Array<G_DownloadableFile>;
};

export type G_DrmLevel = {
  /**
   *  DRMレベルがHDCPか
   * @deprecated Use hasRestrictedProtection
   */
  isHdcp: Scalars['Boolean'];
  /**  再生確認が必要なコンテンツ判定  */
  hasStrictProtection: Scalars['Boolean'];
};

/** cursor-based paginationのEdge */
export type G_Edge = {
  cursor: Scalars['String'];
  node: G_Node;
};

export enum G_ErrorCode {
  /**  未認証  */
  Unauthorized = 'UNAUTHORIZED',
  /**  プロフィール未選択  */
  ProfileUnspecified = 'PROFILE_UNSPECIFIED',
  /**  リソースが存在しない  */
  NotFound = 'NOT_FOUND',
  /**  リソースはすでに存在する  */
  AlreadyExists = 'ALREADY_EXISTS',
  /**  無効な引数が指定された  */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**  許可されていないオペレーション  */
  PermissionDenied = 'PERMISSION_DENIED',
  /**  ユーザーに割り当てられているリソース不足  */
  ResourceExhausted = 'RESOURCE_EXHAUSTED',
  /**  システム内部エラー  */
  InternalError = 'INTERNAL_ERROR',
  /**  リクエストキャンセル  */
  Canceled = 'CANCELED',
  /**  メンテナンス中  */
  Maintenance = 'MAINTENANCE'
}

export type G_EvaluateReviewInput = {
  /**  レビューID  */
  id: Scalars['ID'];
  /**  レビュアーID  */
  reviewerId: Scalars['ID'];
};

export type G_EvaluateReviewPayload = G_Payload & {
  /**
   *  評価が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  評価ステータス  */
  voteStatus?: Maybe<G_VoteStatus>;
};

/** 検索結果の絞り込みアイテム */
export type G_FacetItem = {
  name: Scalars['String'];
  value: Scalars['String'];
  count: Scalars['Int'];
};

export enum G_FailureCode {
  /** その他のエラー */
  Unspecified = 'UNSPECIFIED',
  /** アラート無し */
  NoAlertCode = 'NO_ALERT_CODE',
  /** クレジットカード会員情報が取得できなかった場合 */
  NotFoundCredit = 'NOT_FOUND_CREDIT',
  /** ステータスがsuspend（決済停止）の場合 */
  StatusSuspend = 'STATUS_SUSPEND',
  /** 有効期限が過ぎていた場合 */
  Expired = 'EXPIRED',
  /** カードブランドがmasterの場合 */
  BrandMaster = 'BRAND_MASTER',
  /** 残高不足の場合 */
  AmountShort = 'AMOUNT_SHORT'
}

/**
 * PSVRプレイヤー起動パラメータ
 * https://confl.arms.dmm.com/pages/viewpage.action?pageId=974843633
 */
export type G_FanzaAppStartParamsForPsvr = {
  /**  再生URL  */
  playUrl: Scalars['URI'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  ショップ名  */
  shop: Scalars['String'];
  /**  st品番  */
  productId: Scalars['String'];
  /**  購入品番  */
  parentProductId: Scalars['String'];
  /**  無期限購入判定  */
  isPast: Scalars['Boolean'];
  /**
   * 配信画質
   * Quality.nameと同等の値を返す
   */
  qualityGroup: Scalars['String'];
  /**  商品種類(基本的にmonthly or digital)  */
  type: Scalars['String'];
  /**  全パート  */
  allParts: Scalars['Int'];
  /**  視聴形式  */
  viewingType: Scalars['String'];
};

export type G_FanzaChannel = {
  /**  チャンネル名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**
   *  ショップオプション (ドリームチャンネル用)
   * @deprecated ドリームチャンネルの場合もshopNameに全て入ってくるため
   */
  shopOption?: Maybe<Scalars['String']>;
  /**  作品  */
  content: G_FanzaSvodContent;
  /**  作品検索  */
  search: G_FanzaSvodSearchResultConnection;
  /**  作品検索(offset)  */
  searchWithOffset: G_FanzaSvodSearchResultWithOffset;
  /**  お気に入り  */
  bookmarks: G_FanzaSvodContentConnection;
  /**  視聴履歴  */
  playHistories: G_FanzaSvodContentConnection;
  /**  u2iレコメンド  */
  userBasedRecommendations: Array<G_FanzaRecommendedContent>;
};


export type G_FanzaChannelContentArgs = {
  id: Scalars['ID'];
};


export type G_FanzaChannelSearchArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type G_FanzaChannelSearchWithOffsetArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type G_FanzaChannelBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type G_FanzaChannelPlayHistoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


export type G_FanzaChannelUserBasedRecommendationsArgs = {
  place: G_FanzaRecommendationPlaceTypes;
  limit: Scalars['Int'];
};

/**  FANZA作品  */
export type G_FanzaContent = {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  コンテンツタイプ  */
  contentType: G_FanzaContentType;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  ショップタイプ  */
  shopType: G_FanzaShopType;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  再生情報  */
  playInfo: G_FanzaContentPlayInfo;
  /**  視聴率グラフ  */
  heatMap?: Maybe<G_VideoHeatMap>;
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  サンプル画像  */
  samplePictures: Array<G_FanzaSamplePicture>;
  /**  サンプル動画  */
  sampleMovie?: Maybe<G_SampleMovie>;
  /**  女優  */
  actresses: Array<G_FanzaContentMeta>;
  /**  男優  */
  histrions: Array<G_FanzaContentMeta>;
  /**  監督  */
  directors: Array<G_FanzaContentMeta>;
  /**  メーカー  */
  maker?: Maybe<G_FanzaContentMeta>;
  /**  シリーズ  */
  series?: Maybe<G_FanzaContentMeta>;
  /**  レーベル  */
  label?: Maybe<G_FanzaContentMeta>;
  /**  ジャンル  */
  genres: Array<G_FanzaContentMeta>;
  /**  配信開始日  */
  startDeliveryAt: Scalars['DateTime'];
  /**  配信終了日  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  ブックマーク  */
  hasBookmark: Scalars['Boolean'];
  /**  i2iレコメンド  */
  itemBasedRecommendations: Array<G_FanzaRecommendedContent>;
};


/**  FANZA作品  */
export type G_FanzaContentPlayInfoArgs = {
  withResume?: Maybe<Scalars['Boolean']>;
  device?: Maybe<G_Device>;
};


/**  FANZA作品  */
export type G_FanzaContentHeatMapArgs = {
  part?: Maybe<Scalars['Int']>;
};


/**  FANZA作品  */
export type G_FanzaContentReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA作品  */
export type G_FanzaContentItemBasedRecommendationsArgs = {
  device: G_Device;
  shop: G_FanzaItemBasedRecommendationShopTypes;
  limit: Scalars['Int'];
};

/**  FANZA作品のメタデータ  */
export type G_FanzaContentMeta = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**  FANZA作品のパート  */
export type G_FanzaContentPart = G_Part & {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  パート番号  */
  number: Scalars['Int'];
  /**  パートの秒数  */
  duration: Scalars['Int'];
  /**  レジュームポイント(秒)  */
  resumePoint: Scalars['Int'];
  /**
   *  視聴率グラフ
   * @deprecated Use `FanzaContent.heatMap`.
   */
  heatMap?: Maybe<G_VideoHeatMap>;
};

/**  FANZA作品の再生情報  */
export type G_FanzaContentPlayInfo = {
  /**  コンテンツの最高画質  */
  highestQuality: Scalars['String'];
  /**  コンテンツの最高画質名  */
  highestQualityName: Scalars['String'];
  /**  コンテンツの秒数(複数パートがある場合は合計時間)  */
  duration: Scalars['Int'];
  /**  レジュームパート番号  */
  resumePartNumber: Scalars['Int'];
  /**  パート一覧  */
  parts: Array<G_FanzaContentPart>;
};

/**  FANZA作品概要  */
export type G_FanzaContentSummary = {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント。テレビデバイスでリストにも必要)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
};

/**  FANZAコンテンツタイプ  */
export enum G_FanzaContentType {
  /**  2D  */
  Vod_2D = 'VOD_2D',
  /**  VR  */
  VodVr = 'VOD_VR'
}

export enum G_FanzaItemBasedRecommendationShopTypes {
  /**  FANZA TV  */
  FanzaTv = 'FANZA_TV',
  /**  FANZA TV Plus */
  FanzaTvPlus = 'FANZA_TV_PLUS',
  /**  動画(videoa)  */
  Video = 'VIDEO',
  /**  素人(videoc)  */
  Amateur = 'AMATEUR',
  /**  アニメ(anime)  */
  Animation = 'ANIMATION',
  /**  成人映画(nikkatsu)  */
  Movie = 'MOVIE'
}

/**  FANZAお知らせ  */
export type G_FanzaNotification = G_Node & {
  /**  お知らせID  */
  id: Scalars['ID'];
  /**  お知らせタイトル  */
  title: Scalars['String'];
  /**  お知らせ本文  */
  body: Scalars['String'];
  /**  お知らせ詳細のURL  */
  url: Scalars['URI'];
  /**  公開日時  */
  startPublicAt: Scalars['DateTime'];
};

export type G_FanzaNotificationConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaNotificationEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_FanzaNotificationEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaNotification;
};

/**  FANZA動画お気に入り一覧  */
export type G_FanzaPpvBookmark = G_FanzaContentSummary & G_Node & {
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  定価(税込)  */
  price: Scalars['Int'];
  /**  販売定価(税込)  */
  salePrice: Scalars['Int'];
  /**  複数配信形式があるかどうか  */
  hasMultiplePrices: Scalars['Boolean'];
  /**  ゲーム機販売作品かどうか  */
  isSaleGameDevice: Scalars['Boolean'];
};


/**  FANZA動画お気に入り一覧  */
export type G_FanzaPpvBookmarkDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_FanzaPpvBookmarkConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaPpvBookmarkEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_FanzaPpvBookmarkEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaPpvBookmark;
};

export type G_FanzaPpvBookmarkError = {
  /**  エラーコード  */
  code?: Maybe<G_FanzaPpvBookmarkErrorCode>;
};

export enum G_FanzaPpvBookmarkErrorCode {
  /**  ブックマーク数超過  */
  UpperLimitOver = 'UPPER_LIMIT_OVER'
}

export type G_FanzaPpvBookmarksWithOffset = {
  total: Scalars['Int'];
  bookmarks: Array<G_FanzaPpvBookmark>;
};

/** FanzaPPVに適用されているキャンペーン */
export type G_FanzaPpvCampaign = {
  /**  キャンペーンID  */
  id: Scalars['ID'];
  /**  キャンペーン名  */
  name?: Maybe<Scalars['String']>;
  /**  終了日時  */
  endAt: Scalars['DateTime'];
};

/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContent = G_FanzaContent & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  コンテンツタイプ  */
  contentType: G_FanzaContentType;
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  ショップタイプ  */
  shopType: G_FanzaShopType;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  作品説明  */
  description: Scalars['String'];
  /**  補足情報  */
  notice?: Maybe<Scalars['String']>;
  /**  再生情報  */
  playInfo: G_FanzaContentPlayInfo;
  /**  視聴権利  */
  viewingRights: G_FanzaPpvViewingRights;
  /**  視聴率グラフ  */
  heatMap?: Maybe<G_VideoHeatMap>;
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  サンプル画像  */
  samplePictures: Array<G_FanzaSamplePicture>;
  /**  サンプル動画  */
  sampleMovie?: Maybe<G_SampleMovie>;
  /**  女優  */
  actresses: Array<G_FanzaContentMeta>;
  /**  男優  */
  histrions: Array<G_FanzaContentMeta>;
  /**  監督  */
  directors: Array<G_FanzaContentMeta>;
  /**  メーカー  */
  maker?: Maybe<G_FanzaContentMeta>;
  /**  シリーズ  */
  series?: Maybe<G_FanzaContentMeta>;
  /**  レーベル  */
  label?: Maybe<G_FanzaContentMeta>;
  /**  ジャンル  */
  genres: Array<G_FanzaContentMeta>;
  /**  商品情報  */
  products: Array<Maybe<G_FanzaPpvProduct>>;
  /**
   *  ゲーム機販売停止した商品も含む商品情報
   * @deprecated 内部利用のため
   */
  allProducts: Array<G_FanzaPpvProduct>;
  /**  配信開始日  */
  startDeliveryAt: Scalars['DateTime'];
  /**  配信終了日  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  ハート  */
  hasHeartMark: Scalars['Boolean'];
  /**  ブックマーク  */
  hasBookmark: Scalars['Boolean'];
  /**  i2iレコメンド  */
  itemBasedRecommendations: Array<G_FanzaRecommendedContent>;
  /**  価格サマリ  */
  priceSummary?: Maybe<G_FanzaPpvPriceSummary>;
  /**
   * PPV視聴期限
   * 複数のプロダクトを購入している場合は最も品質の高いプロダクトの視聴期限を返す
   * @deprecated Use `viewingRights.expiration`.
   */
  ppvExpiration?: Maybe<G_FanzaPpvExpiration>;
  /**
   *  ファイルID
   * @deprecated BFF内部利用
   */
  fileId: Scalars['ID'];
  /**  最高画質  */
  highestQuality: Scalars['String'];
  /**  PSVR専用アプリ起動パラメータ  */
  appStartParamsForPsvr: G_FanzaAppStartParamsForPsvr;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentPlayInfoArgs = {
  withResume?: Maybe<Scalars['Boolean']>;
  device?: Maybe<G_Device>;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentViewingRightsArgs = {
  device: G_PlayDevice;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentHeatMapArgs = {
  part?: Maybe<Scalars['Int']>;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentItemBasedRecommendationsArgs = {
  device: G_Device;
  shop: G_FanzaItemBasedRecommendationShopTypes;
  limit: Scalars['Int'];
};


/**  FANZA動画コンテンツ  */
export type G_FanzaPpvContentAppStartParamsForPsvrArgs = {
  part?: Maybe<Scalars['Int']>;
  quality?: Maybe<G_AppStartParamsForPsvrQuality>;
};

/**  FANZA動画検索結果  */
export type G_FanzaPpvContentSummary = G_FanzaContentSummary & G_Node & {
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  定価(税込)  */
  price: Scalars['Int'];
  /**  販売定価(税込)  */
  salePrice: Scalars['Int'];
  /**  複数配信形式があるかどうか  */
  hasMultiplePrices: Scalars['Boolean'];
};


/**  FANZA動画検索結果  */
export type G_FanzaPpvContentSummaryDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_FanzaPpvContentSummaryEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaPpvContentSummary;
};

/** 購入済みコンテンツの視聴期限 */
export type G_FanzaPpvExpiration = {
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  視聴期限タイプ  */
  expirationType: G_FanzaPpvExpirationType;
  /**  配信開始日時  */
  startDeliveryAt: Scalars['DateTime'];
  /**  視聴期限(無期限の場合はnull)  */
  viewingExpiration?: Maybe<Scalars['DateTime']>;
};

/** 視聴期限タイプ */
export enum G_FanzaPpvExpirationType {
  /**  無期限  */
  Est = 'EST',
  /**  レンタル  */
  Tvod = 'TVOD'
}

/**  マイライブラリ  */
export type G_FanzaPpvLibrary = {
  /**  すべてのマイリストグループ  */
  allMyListGroups: Array<Maybe<G_FanzaPpvMyListGroup>>;
  /**  動画 マイアイテム  */
  purchasedContents: G_FanzaPpvPurchasedContentConnection;
  /**  動画 マイアイテム(Offset Based Pagination)  */
  purchasedContentsWithOffset?: Maybe<G_FanzaPpvPurchasedContentWithOffset>;
};


/**  マイライブラリ  */
export type G_FanzaPpvLibraryPurchasedContentsArgs = {
  device: G_Device;
  groupId?: Maybe<Scalars['ID']>;
  withHeartMarkedOnly?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<G_FanzaContentType>;
  sort?: Maybe<G_FanzaPpvSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  マイライブラリ  */
export type G_FanzaPpvLibraryPurchasedContentsWithOffsetArgs = {
  device: G_Device;
  groupId?: Maybe<Scalars['ID']>;
  withHeartMarkedOnly?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<G_FanzaContentType>;
  sort?: Maybe<G_FanzaPpvSortKey>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/**  マイリストグループ  */
export type G_FanzaPpvMyListGroup = {
  /**  グループID  */
  id: Scalars['ID'];
  /**  グループ名  */
  name: Scalars['String'];
};

/**  FANZA動画支払い情報  */
export type G_FanzaPpvPaymentInfo = {
  /**  支払い方法  */
  paymentMethod: G_FanzaPpvPaymentMethod;
  /**  支払い金額  */
  amount: Scalars['Int'];
};

/**  FANZA動画支払い方法  */
export enum G_FanzaPpvPaymentMethod {
  /**  クレジットカード  */
  Credit = 'CREDIT',
  /**  DMMポイント  */
  DmmPoint = 'DMM_POINT'
}

export type G_FanzaPpvPlayHistoriesConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaPpvPlayHistoryEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

/**  FANZA動画PPV視聴履歴  */
export type G_FanzaPpvPlayHistory = G_FanzaContentSummary & G_Node & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  視聴期限切れフラグ  */
  isExpired: Scalars['Boolean'];
};


/**  FANZA動画PPV視聴履歴  */
export type G_FanzaPpvPlayHistoryDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_FanzaPpvPlayHistoryEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaPpvPlayHistory;
};

/** PPV参考価格 */
export type G_FanzaPpvPriceSummary = {
  /**  最低価格  */
  lowestPrice: Scalars['Int'];
  /**  最高価格  */
  highestPrice: Scalars['Int'];
  /**  キャンペーン適用後の最低価格  */
  discountedLowestPrice?: Maybe<Scalars['Int']>;
  /**  キャンペーン適用後の最高価格  */
  discountedHighestPrice?: Maybe<Scalars['Int']>;
  /**  キャンペーン情報  */
  campaign?: Maybe<G_FanzaPpvCampaign>;
};

/**  FANZA動画商品  */
export type G_FanzaPpvProduct = {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  配信形式名  */
  deliveryTypeName: Scalars['String'];
  /**  視聴期限(無期限/7日間)  */
  viewingExpire: Scalars['String'];
  /**  定価(税込)  */
  price: Scalars['Int'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**
   * 購入済みかどうか
   * 【参考】Digital_Api_Mylibrary.Call_getProductPurchased https://confl.arms.dmm.com/x/ojJDAw
   */
  isPurchased: Scalars['Boolean'];
  /**
   *  優先度
   * @deprecated 内部利用のため
   */
  priority: Scalars['Int'];
};

/**  FANZA動画 購入済み作品  */
export type G_FanzaPpvPurchasedContent = G_Node & {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  マイライブラリID  */
  myLibraryId: Scalars['Int'];
  /**  contentId  */
  contentId: Scalars['ID'];
  /**  ハートがついているか  */
  hasHeartMark: Scalars['Boolean'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  視聴期限  */
  viewingExpiresAt?: Maybe<Scalars['DateTime']>;
};

export type G_FanzaPpvPurchasedContentConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaPpvPurchasedContentEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  total: Scalars['Int'];
};

export type G_FanzaPpvPurchasedContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaPpvPurchasedContent;
};

export type G_FanzaPpvPurchasedContentWithOffset = {
  total: Scalars['Int'];
  /**  動画 マイアイテム  */
  purchasedContents: Array<G_FanzaPpvPurchasedContent>;
};

export type G_FanzaPpvSearchResultConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaPpvContentSummaryEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
  /**  totalの検索結果数  */
  total: Scalars['Int'];
  /**  絞り込み条件  */
  facet: G_FanzaSearchFacet;
};

export type G_FanzaPpvSearchResultWithOffset = {
  results: Array<G_FanzaPpvContentSummary>;
  /**  totalの検索結果数  */
  total: Scalars['Int'];
  /**  絞り込み条件  */
  facet: G_FanzaSearchFacet;
};

/**  FANZA動画ショップ  */
export enum G_FanzaPpvShop {
  /**  ビデオ  */
  Video = 'VIDEO',
  /**  素人  */
  Amateur = 'AMATEUR',
  /**  アニメ  */
  Animation = 'ANIMATION',
  /**  成人映画  */
  Movie = 'MOVIE'
}

/**  ショップでの絞り込みアイテム  */
export type G_FanzaPpvShopFacetItem = {
  name: Scalars['String'];
  value: G_FanzaPpvShop;
  count: Scalars['Int'];
};

/**  FANZA購入済みソート順  */
export enum G_FanzaPpvSortKey {
  /**  購入日昇順（古い順）  */
  PurchasedDateAsc = 'PURCHASED_DATE_ASC',
  /**  購入日降順（新しい順）  */
  PurchasedDateDesc = 'PURCHASED_DATE_DESC'
}

/**  FANZA動画検索ソート順  */
export enum G_FanzaPpvSortOder {
  /**  人気順  */
  Popular = 'POPULAR',
  /**  新着順  */
  NewestToOldest = 'NEWEST_TO_OLDEST',
  /**  売上げ本数順  */
  SalesHighestToLowest = 'SALES_HIGHEST_TO_LOWEST',
  /**  価格の安い順  */
  PriceLowestToHighest = 'PRICE_LOWEST_TO_HIGHEST'
}

/**  FANZA動画 視聴権利  */
export type G_FanzaPpvViewingRights = {
  /**  ストリーミング可能か  */
  isStreamable: Scalars['Boolean'];
  /**  視聴期限  */
  expiration?: Maybe<G_FanzaPpvExpiration>;
};

/**  FANZA月額プランの状態  */
export type G_FanzaPlanStatus = {
  /**  ステータス  */
  status: G_SubscriptionStatus;
  /**  サービス提供終了日  */
  provideEndDate?: Maybe<Scalars['DateTime']>;
  /**  次回契約更新日  */
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  /**  支払い方法  */
  paymentType?: Maybe<G_SubscriptionPaymentType>;
  /**  注文ID  */
  orderId?: Maybe<Scalars['String']>;
};

/**  レコメンド枠の設置場所  */
export enum G_FanzaRecommendationPlaceTypes {
  /**  ホーム(トップ)画面  */
  HomePage = 'HOME_PAGE',
  /**  詳細画面  */
  DetailPage = 'DETAIL_PAGE',
  /**  リスト画面  */
  ListPage = 'LIST_PAGE'
}

/**  FANZAおすすめ作品  */
export type G_FanzaRecommendedContent = G_FanzaContentSummary & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**
   * i3トラッキングID
   * See https://confl.arms.dmm.com/pages/viewpage.action?pageId=60719988
   */
  i3TrackingId: Scalars['String'];
  /**  定価(税込)  */
  price: Scalars['Int'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**  FANZA TV Plus限定ジャンル  */
  isFanzaTvPlusOnly: Scalars['Boolean'];
};

/**  サンプル画像  */
export type G_FanzaSamplePicture = {
  image: Scalars['URI'];
  imageLarge: Scalars['URI'];
};

/**  FANZA検索ファセット  */
export type G_FanzaSearchFacet = {
  /**  ジャンル  */
  genres: Array<G_FacetItem>;
  /**  メーカー  */
  makers: Array<G_FacetItem>;
  /**  シリーズ  */
  series: Array<G_FacetItem>;
  /**  女優  */
  actresses: Array<G_FacetItem>;
  /**  男優  */
  histrions: Array<G_FacetItem>;
  /**  レーベル  */
  labels: Array<G_FacetItem>;
  /**  ショップ  */
  shops: Array<G_FanzaPpvShopFacetItem>;
  /**  カテゴリ  */
  ppvShops: Array<G_FanzaPpvShopFacetItem>;
  /**  サービス(視聴プラン)  */
  viewingPlans: Array<G_FanzaTvViewingPlanFacetItem>;
};

/**  FANZAショップタイプ  */
export enum G_FanzaShopType {
  /**  FANZA動画  */
  Ppv = 'PPV',
  /**  FANZA月額  */
  Svod = 'SVOD',
  /**  FANZA TV  */
  FanzaTv = 'FANZA_TV'
}

/**  FANZA月額プラン  */
export enum G_FanzaSubscriptionPlan {
  /**  FANZA TV Plus  */
  FanzaTvPlus = 'FANZA_TV_PLUS'
}

/**  FANZA月額対応アプリ  */
export enum G_FanzaSvodApp {
  /**  iOSアプリ  */
  Ios = 'IOS',
  /**  Androidアプリ  */
  Android = 'ANDROID'
}

export type G_FanzaSvodBookmarkError = {
  /**  エラーコード  */
  code?: Maybe<G_FanzaSvodBookmarkErrorCode>;
};

export enum G_FanzaSvodBookmarkErrorCode {
  /**  ブックマーク数超過  */
  UpperLimitOver = 'UPPER_LIMIT_OVER'
}

export type G_FanzaSvodBookmarkInput = {
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  ショップオプション (ドリームチャンネル用)  */
  shopOption?: Maybe<Scalars['String']>;
  /**  対象作品コンテンツID  */
  contentId: Scalars['ID'];
};

export type G_FanzaSvodBookmarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_FanzaSvodBookmarkError>;
};

/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannel = G_FanzaChannel & {
  /**  チャンネル名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  チャンネル名  */
  shopName: Scalars['String'];
  /**
   *  ショップオプション (ドリームチャンネル用)
   * @deprecated ドリームチャンネルの場合もshopNameに全て入ってくるため
   */
  shopOption?: Maybe<Scalars['String']>;
  /**  ランキング  */
  rankings: G_FanzaSvodRankedContentConnection;
  /**  作品  */
  content: G_FanzaSvodContent;
  /**  作品検索  */
  search: G_FanzaSvodSearchResultConnection;
  /**  作品検索(offset)  */
  searchWithOffset: G_FanzaSvodSearchResultWithOffset;
  /**  お気に入り(ログインユーザーのみ)  */
  bookmarks: G_FanzaSvodContentConnection;
  /**  Offset版お気に入り(ログインユーザーのみ)  */
  bookmarksWithOffset: G_FanzaSvodContentsWithOffset;
  /**  視聴履歴(ログインユーザーのみ)  */
  playHistories: G_FanzaSvodContentConnection;
  /**  u2iレコメンド(ログインユーザーのみ)  */
  userBasedRecommendations: Array<G_FanzaRecommendedContent>;
  /**  FANZA月額ブックマークリスト 配信中商品を30件返す  */
  bookmarksWithPublicOnly: G_FanzaSvodContentConnection;
  /**  FANZA月額視聴履歴 配信中商品を30件返す  */
  playHistoriesWithPublicOnly: G_FanzaSvodContentConnection;
  /**  有効期限  */
  subscriptionExpiresAt: Scalars['DateTime'];
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelRankingsArgs = {
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  term: G_FanzaSvodRankingTerm;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelContentArgs = {
  id: Scalars['ID'];
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelSearchArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelSearchWithOffsetArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelBookmarksWithOffsetArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelPlayHistoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA月額チャンネル  */
export type G_FanzaSvodChannelUserBasedRecommendationsArgs = {
  place: G_FanzaRecommendationPlaceTypes;
  limit: Scalars['Int'];
};

/**  FANZA月額作品  */
export type G_FanzaSvodContent = G_FanzaContent & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  コンテンツタイプ  */
  contentType: G_FanzaContentType;
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  ショップ名(チャンネル名)  */
  shopName: Scalars['String'];
  /**
   *  ショップオプション (ドリームチャンネル用)
   * @deprecated ドリームチャンネルの場合もshopNameに全て入ってくるため
   */
  shopOption?: Maybe<Scalars['String']>;
  /**  ショップタイプ  */
  shopType: G_FanzaShopType;
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  再生情報  */
  playInfo: G_FanzaContentPlayInfo;
  /**  視聴権利  */
  viewingRights: G_FanzaViewingRights;
  /**  視聴率グラフ  */
  heatMap?: Maybe<G_VideoHeatMap>;
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  サンプル画像  */
  samplePictures: Array<G_FanzaSamplePicture>;
  /**  サンプル動画  */
  sampleMovie?: Maybe<G_SampleMovie>;
  /**  女優  */
  actresses: Array<G_FanzaContentMeta>;
  /**  男優  */
  histrions: Array<G_FanzaContentMeta>;
  /**  監督  */
  directors: Array<G_FanzaContentMeta>;
  /**  メーカー  */
  maker?: Maybe<G_FanzaContentMeta>;
  /**  シリーズ  */
  series?: Maybe<G_FanzaContentMeta>;
  /**  レーベル  */
  label?: Maybe<G_FanzaContentMeta>;
  /**  ジャンル  */
  genres: Array<G_FanzaContentMeta>;
  /**  配信開始日  */
  startDeliveryAt: Scalars['DateTime'];
  /**  配信終了日  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  PPV販売中フラグ  */
  isOnSale: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  ブックマーク(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /**  i2iレコメンド  */
  itemBasedRecommendations: Array<G_FanzaRecommendedContent>;
  /**  noindex対象のコンテンツかどうか  */
  noIndex: Scalars['Boolean'];
  /**  FANZA動画ショップ名  */
  ppvShopName?: Maybe<Scalars['String']>;
  /**
   *  ファイルID
   * @deprecated BFF内部利用
   */
  fileId: Scalars['ID'];
  /**  FANZA TV Plus限定作品フラグ  */
  isFanzaTvPlusOnly: Scalars['Boolean'];
  /**
   * アプリ起動スキーム
   * 未入会のチャンネルはNullが返る
   */
  appURLScheme?: Maybe<Array<G_VideoAppUrlScheme>>;
  /**  PSVR専用アプリ起動パラメータ  */
  appStartParamsForPsvr: G_FanzaAppStartParamsForPsvr;
  /**
   *  他事業部のContentID
   * @deprecated BFF内部利用
   */
  reviewContentIds: Array<Scalars['ID']>;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentPlayInfoArgs = {
  withResume?: Maybe<Scalars['Boolean']>;
  device?: Maybe<G_Device>;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentViewingRightsArgs = {
  device: G_PlayDevice;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentHeatMapArgs = {
  part?: Maybe<Scalars['Int']>;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentItemBasedRecommendationsArgs = {
  device: G_Device;
  shop: G_FanzaItemBasedRecommendationShopTypes;
  limit: Scalars['Int'];
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentAppUrlSchemeArgs = {
  app: G_FanzaSvodApp;
};


/**  FANZA月額作品  */
export type G_FanzaSvodContentAppStartParamsForPsvrArgs = {
  part?: Maybe<Scalars['Int']>;
  quality?: Maybe<G_AppStartParamsForPsvrQuality>;
};

export type G_FanzaSvodContentConnection = G_Connection & {
  edges: Array<G_FanzaSvodContentEdge>;
  pageInfo: G_PageInfo;
};

export type G_FanzaSvodContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaSvodContentSummary;
};

/**  FANZA月額作品概要  */
export type G_FanzaSvodContentSummary = G_FanzaContentSummary & G_Node & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**  配信開始日  */
  startDeliveryAt: Scalars['DateTime'];
  /**  配信終了日  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  FANZA TV Plus限定作品フラグ  */
  isFanzaTvPlusOnly: Scalars['Boolean'];
};


/**  FANZA月額作品概要  */
export type G_FanzaSvodContentSummaryDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_FanzaSvodContentsWithOffset = {
  total: Scalars['Int'];
  bookmarks: Array<G_FanzaSvodContentSummary>;
};

/**  FANZA月額ランキング作品  */
export type G_FanzaSvodRankedContent = G_Node & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  ランク  */
  rank: Scalars['Int'];
  /**  作品タイトル  */
  title: Scalars['String'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  パッケージ拡大画像  */
  packageLargeImage: Scalars['URI'];
  /**  作品説明(作品コメント)  */
  description: Scalars['String'];
  /**  レビュー平均点  */
  averageReviewPoint: Scalars['Float'];
  /**  配信開始日  */
  startDeliveryAt: Scalars['DateTime'];
  /**  配信終了日  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  FANZA TV Plus限定作品フラグ  */
  isFanzaTvPlusOnly: Scalars['Boolean'];
};


/**  FANZA月額ランキング作品  */
export type G_FanzaSvodRankedContentDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_FanzaSvodRankedContentConnection = G_ForwardOnlyConnection & {
  edges: Array<G_FanzaSvodRankedContentEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_FanzaSvodRankedContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_FanzaSvodRankedContent;
};

/**  FANZA月額のランキング集計期間  */
export enum G_FanzaSvodRankingTerm {
  /**  1時間  */
  Hourly = 'HOURLY',
  /**  1日  */
  Daily = 'DAILY',
  /**  1週間  */
  Weekly = 'WEEKLY',
  /**  1ヶ月  */
  Monthly = 'MONTHLY'
}

export type G_FanzaSvodSearchResultConnection = G_Connection & {
  edges: Array<G_FanzaSvodContentEdge>;
  pageInfo: G_PageInfo;
  /**  totalの検索結果数  */
  total: Scalars['Int'];
  /**  絞り込み条件  */
  facet: G_FanzaSearchFacet;
  /**  検索結果をnoindexの対象とするかどうか  */
  noIndex: Scalars['Boolean'];
};

export type G_FanzaSvodSearchResultWithOffset = {
  /**  検索結果  */
  results: Array<G_FanzaSvodContentSummary>;
  /**  totalの検索結果数  */
  total: Scalars['Int'];
  /**  絞り込み条件  */
  facet: G_FanzaSearchFacet;
  /**  検索結果をnoindexの対象とするかどうか  */
  noIndex: Scalars['Boolean'];
};

/**  FANZA月額検索のソート設定  */
export enum G_FanzaSvodSortKey {
  /**  人気順  */
  Popular = 'POPULAR',
  /**  新着順  */
  New = 'NEW',
  /**  配信終了日が近い順  */
  DeliveryEndingSoon = 'DELIVERY_ENDING_SOON',
  /**  公開予定日が近い順  */
  DeliveryUpcommingSoon = 'DELIVERY_UPCOMMING_SOON'
}

export type G_FanzaTvGenreGroup = {
  /**  ジャンルグループ名  */
  name: Scalars['String'];
  /**  ジャンル一覧  */
  genres: Array<G_FanzaTvGenre>;
};

/**
 * FANZA利用規約ID
 * See https://terms.dmm.com/
 */
export enum G_FanzaTermsId {
  /**  DMM会員規約  */
  Member = 'MEMBER',
  /**  個人情報保護に関して  */
  Privacy = 'PRIVACY',
  /**  資金決済法に基づく表示  */
  FundSettlement = 'FUND_SETTLEMENT',
  /**  特定商取引法に基づく表示  */
  Commerce = 'COMMERCE',
  /**  DMMポイント利用規約  */
  Dmmpoint = 'DMMPOINT',
  /**  デジタルコンテンツ利用規約  */
  DigitalService = 'DIGITAL_SERVICE',
  /**  特定商取引法に基づく表示（見放題chライト） */
  CommerceMonthlyPrimeDcm = 'COMMERCE_MONTHLY_PRIME_DCM',
  /**  レビュー利用規約  */
  ReviewService = 'REVIEW_SERVICE'
}

/**  FANZA TV  */
export type G_FanzaTv = G_FanzaChannel & {
  /**  チャンネル名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**
   *  ショップオプション (ドリームチャンネル用)
   * @deprecated ドリームチャンネルの場合もshopNameに全て入ってくるため
   */
  shopOption?: Maybe<Scalars['String']>;
  /**  お知らせ  */
  notification?: Maybe<G_FanzaNotification>;
  /**  ランキング  */
  rankings: G_FanzaSvodRankedContentConnection;
  /**  作品検索  */
  search: G_FanzaSvodSearchResultConnection;
  /**  作品検索  */
  searchWithOffset: G_FanzaSvodSearchResultWithOffset;
  /**  作品  */
  content: G_FanzaSvodContent;
  /**  お気に入り(ログインユーザーのみ)  */
  bookmarks: G_FanzaSvodContentConnection;
  /**  Offset版お気に入り(ログインユーザーのみ)  */
  bookmarksWithOffset: G_FanzaSvodContentsWithOffset;
  /**  視聴履歴(ログインユーザーのみ)  */
  playHistories: G_FanzaSvodContentConnection;
  /**  FANZATV ブックマークリスト 配信中商品を30件返す  */
  bookmarksWithPublicOnly: G_FanzaSvodContentConnection;
  /**  FANZATV 視聴履歴 配信中商品を30件返す  */
  playHistoriesWithPublicOnly: G_FanzaSvodContentConnection;
  /**  u2iレコメンド(ログインユーザーのみ)  */
  userBasedRecommendations: Array<G_FanzaRecommendedContent>;
  /**  ジャンル  */
  genres: G_FanzaTvGenres;
};


/**  FANZA TV  */
export type G_FanzaTvNotificationArgs = {
  device: G_Device;
};


/**  FANZA TV  */
export type G_FanzaTvRankingsArgs = {
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  term: G_FanzaSvodRankingTerm;
};


/**  FANZA TV  */
export type G_FanzaTvSearchArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  ppvShop?: Maybe<G_FanzaPpvShop>;
  viewingPlan?: Maybe<G_FanzaTvViewingPlan>;
  isForeign?: Maybe<Scalars['Boolean']>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV  */
export type G_FanzaTvSearchWithOffsetArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  ppvShop?: Maybe<G_FanzaPpvShop>;
  viewingPlan?: Maybe<G_FanzaTvViewingPlan>;
  isForeign?: Maybe<Scalars['Boolean']>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA TV  */
export type G_FanzaTvContentArgs = {
  id: Scalars['ID'];
  isForeign?: Maybe<Scalars['Boolean']>;
};


/**  FANZA TV  */
export type G_FanzaTvBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV  */
export type G_FanzaTvBookmarksWithOffsetArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA TV  */
export type G_FanzaTvPlayHistoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV  */
export type G_FanzaTvUserBasedRecommendationsArgs = {
  place: G_FanzaRecommendationPlaceTypes;
  limit: Scalars['Int'];
};

/** FANZA TV / FANZA TV Plus向けのジャンル */
export type G_FanzaTvGenre = {
  id: Scalars['ID'];
  /**  ジャンル名  */
  name: Scalars['String'];
  /**  URL埋め込み用のジャンル名  */
  encodedName: Scalars['String'];
  /**  FANZA TV Plus限定ジャンル  */
  isFanzaTvPlusOnly: Scalars['Boolean'];
};

/**  FANZA TV / FANZA TV Plusで使用されるジャンル  */
export type G_FanzaTvGenres = {
  /**  おすすめジャンル一覧  */
  pickUps: Array<G_FanzaTvGenre>;
  /**  ジャンルグループ一覧  */
  genreGroups: Array<G_FanzaTvGenreGroup>;
};

/**  FANZA TV Plus  */
export type G_FanzaTvPlus = G_FanzaChannel & {
  /**  チャンネル名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**
   *  ショップオプション (ドリームチャンネル用)
   * @deprecated ドリームチャンネルの場合もshopNameに全て入ってくるため
   */
  shopOption?: Maybe<Scalars['String']>;
  /**  お知らせ  */
  notification?: Maybe<G_FanzaNotification>;
  /**  ランキング  */
  rankings: G_FanzaSvodRankedContentConnection;
  /**  作品検索  */
  search: G_FanzaSvodSearchResultConnection;
  /**  作品検索  */
  searchWithOffset: G_FanzaSvodSearchResultWithOffset;
  /**  作品  */
  content: G_FanzaSvodContent;
  /**  お気に入り(ログインユーザーのみ)  */
  bookmarks: G_FanzaSvodContentConnection;
  /**  Offset版お気に入り(ログインユーザーのみ)  */
  bookmarksWithOffset: G_FanzaSvodContentsWithOffset;
  /**  視聴履歴(ログインユーザーのみ)  */
  playHistories: G_FanzaSvodContentConnection;
  /**  FANZATV Plus ブックマークリスト 配信中商品を30件返す  */
  bookmarksWithPublicOnly: G_FanzaSvodContentConnection;
  /**  FANZATV Plus 視聴履歴 配信中商品を30件返す  */
  playHistoriesWithPublicOnly: G_FanzaSvodContentConnection;
  /**  u2iレコメンド(ログインユーザーのみ)  */
  userBasedRecommendations: Array<G_FanzaRecommendedContent>;
  /**  ジャンル  */
  genres: G_FanzaTvGenres;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusNotificationArgs = {
  device: G_Device;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusRankingsArgs = {
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  term: G_FanzaSvodRankingTerm;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusSearchArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  ppvShop?: Maybe<G_FanzaPpvShop>;
  viewingPlan?: Maybe<G_FanzaTvViewingPlan>;
  isForeign?: Maybe<Scalars['Boolean']>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusSearchWithOffsetArgs = {
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  ppvShop?: Maybe<G_FanzaPpvShop>;
  viewingPlan?: Maybe<G_FanzaTvViewingPlan>;
  isForeign?: Maybe<Scalars['Boolean']>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaSvodSortKey>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusContentArgs = {
  id: Scalars['ID'];
  isForeign?: Maybe<Scalars['Boolean']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusBookmarksArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusBookmarksWithOffsetArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusPlayHistoriesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};


/**  FANZA TV Plus  */
export type G_FanzaTvPlusUserBasedRecommendationsArgs = {
  place: G_FanzaRecommendationPlaceTypes;
  limit: Scalars['Int'];
};

/**  FANZA TV Plusの月額支払い手段  */
export enum G_FanzaTvPlusPaymentType {
  /**  クレジットカード  */
  Credit = 'CREDIT',
  /**  DMMポイント  */
  DmmPoint = 'DMM_POINT'
}

/**  FANZA TV視聴プラン  */
export enum G_FanzaTvViewingPlan {
  /**  FANZA TV作品を視聴できるプラン  */
  FanzaTv = 'FANZA_TV',
  /**  FANZA TV Plus限定作品を視聴できるプラン  */
  FanzaTvPlus = 'FANZA_TV_PLUS'
}

/**  視聴プラン絞り込みアイテム  */
export type G_FanzaTvViewingPlanFacetItem = {
  name: Scalars['String'];
  value: G_FanzaTvViewingPlan;
  count: Scalars['Int'];
};

/**  FANZA TV 視聴権利  */
export type G_FanzaViewingRights = {
  /**  ストリーミング可能か  */
  isStreamable: Scalars['Boolean'];
};

/** forward only cursor-based paginationのConnection */
export type G_ForwardOnlyConnection = {
  edges: Array<G_Edge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_ForwardOnlyPageInfo = {
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
};

/** フリーアイテム */
export type G_FreeItem = G_UrlFreeItem | G_VideoFreeItem | G_VideoListFreeItem | G_VideoContentFreeItem | G_HomeFreeItem;

export type G_FreeItemConnection = {
  edges: Array<G_FreeItemEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_FreeItemEdge = {
  cursor: Scalars['String'];
  node: G_FreeItem;
};

export enum G_FreeItemType {
  /**  正方形  */
  Square = 'SQUARE',
  /**  横長  */
  Horizontal = 'HORIZONTAL'
}

/**  性別  */
export enum G_Gender {
  /**  男性  */
  Male = 'MALE',
  /**  女性  */
  Female = 'FEMALE',
  /**  その他  */
  Other = 'OTHER',
  /**  未回答  */
  NotAnswered = 'NOT_ANSWERED'
}

export enum G_Hdcp {
  /**  HDCP非対応  */
  None = 'NONE',
  /**  HDCP v1対応  */
  V1 = 'V1',
  /**  HDCP v2.2対応  */
  V2_2 = 'V2_2'
}

export type G_Health = {
  /** サービス名 */
  name: Scalars['String'];
  /** ステータスコード */
  status: Scalars['Int'];
  /** メッセージ */
  message: Scalars['String'];
  /** @deprecated spectaqlで生成するAPI仕様に出力されるようにするためのワークアラウンドで追加しています */
  videoSeason?: Maybe<G_VideoSeason>;
  /** @deprecated spectaqlで生成するAPI仕様に出力されるようにするためのワークアラウンドで追加しています */
  videoLegacySeason?: Maybe<G_VideoLegacySeason>;
  /** @deprecated spectaqlで生成するAPI仕様に出力されるようにするためのワークアラウンドで追加しています */
  videoStageSeason?: Maybe<G_VideoStageSeason>;
};

/** DMM TVホーム */
export type G_Home = {
  /**  ホームID  */
  id: Scalars['ID'];
  /**  タイトル(ビデオカテゴリトップの場合のみセットされる)  */
  title: Scalars['String'];
  /**  デバイス  */
  device: G_Device;
  /**  ページ種別  */
  type: G_HomeType;
  /**  ビデオサブページを全て返す  */
  allVideoSubPages: Array<G_Home>;
  /**  カテゴリID(カテゴリが紐づけられている場合のみ)  */
  categoryId?: Maybe<Scalars['ID']>;
  /**  関連づけられたジャンル(カテゴリが紐づけられている場合のみ)  */
  genres?: Maybe<Array<G_VideoGenre>>;
  /**  ヘッダー  */
  headerItems: Array<G_FreeItem>;
  /**  棚  */
  shelves: G_ShelfConnection;
  /**  お知らせ  */
  notification?: Maybe<G_Notification>;
  /**
   *  直近で視聴した作品のカテゴリ情報
   * @deprecated BFF内部利用
   */
  latestViewedCategories?: Maybe<Array<Maybe<G_LatestViewedCategories>>>;
  /**
   *  スポット配信作品かどうか
   * @deprecated BFF内部利用
   */
  isSpotLive: Scalars['Boolean'];
};


/** DMM TVホーム */
export type G_HomeHeaderItemsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** DMM TVホーム */
export type G_HomeShelvesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** DMM TVホームやビデオトップページへ遷移するフリーアイテム */
export type G_HomeFreeItem = {
  /**  フリーアイテムID  */
  id: Scalars['ID'];
  /**  画像  */
  image: Scalars['URI'];
  name: Scalars['String'];
  pageType: G_HomeType;
  homeId: Scalars['ID'];
  /** @deprecated BFF内部で計算済み */
  isHiddenForPremiumMember: Scalars['Boolean'];
};

/** テレビデバイスホーム設定 */
export type G_HomeSettings = {
  /**
   * 起動時の画面
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  initialScreen: G_InitialScreen;
  /**
   * プレビュー再生時に音声を流すかどうか
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  enablePreviewSound: Scalars['Boolean'];
};

/** ホームページの種類 */
export enum G_HomeType {
  /**  ホーム  */
  Home = 'HOME',
  /**  ビデオ  */
  VideoHome = 'VIDEO_HOME',
  /**  ビデオサブページ  */
  VideoSubPage = 'VIDEO_SUB_PAGE'
}

/**
 * テレビデバイス起動時のホーム画面設定
 * Html5TV/PS4/PS5/PSVR/PSVR2向け
 */
export enum G_InitialScreen {
  /**  ホーム  */
  DmmHome = 'DMM_HOME',
  /**  ビデオ  */
  DmmVideo = 'DMM_VIDEO',
  /**  DMMTV購入済み  */
  DmmPurchased = 'DMM_PURCHASED',
  /**  FANZA TV ※FANZA TV側でのみ設定可能  */
  FanzaTv = 'FANZA_TV',
  /**  FANZA購入済み ※FANZA TV側でのみ設定可能  */
  FanzaPurchased = 'FANZA_PURCHASED'
}

/** 使用されている言語と表示名の対応付け */
export type G_Language = {
  /** RFC5646 言語タグ (ja, en-US, ja-JP-x-1, etc...) */
  lang: Scalars['String'];
  /** 表示名(日本語/英語など) */
  displayName: Scalars['String'];
};

/**  直近で視聴した作品のカテゴリ情報  */
export type G_LatestViewedCategories = {
  /**  カテゴリID  */
  Id: Scalars['ID'];
  /**  優先度  */
  Priority: Scalars['Int'];
};

/**  メルマガID  */
export enum G_MailMagazineId {
  /**  FANZA総合版  */
  Fanza = 'FANZA',
  /**  FANZA動画配信版  */
  FanzaDigital = 'FANZA_DIGITAL'
}

export type G_MailMagazineSubscriptionStatus = {
  /**  メルマガID  */
  id: G_MailMagazineId;
  /**  購読しているか  */
  hasSubscribed: Scalars['Boolean'];
  /**
   * 購読チェックボックス用のラベル
   * e.g. DMM.com総合版メールマガジンを受信する
   */
  label: Scalars['String'];
};

/** メンテナンス情報 */
export type G_Maintenance = {
  /** タイトル */
  title: Scalars['String'];
  /** 説明 */
  description: Scalars['String'];
  /**
   * 開始予定日時
   * nilの場合、日時表示なし
   */
  startAt?: Maybe<Scalars['DateTime']>;
  /**
   * 終了予定日時
   * nilの場合、日時表示なしあるいは終了予定日時が未設定
   */
  endAt?: Maybe<Scalars['DateTime']>;
};

export type G_Mutation = {
  ping: Scalars['String'];
  /**  LOD/ROD作品のレジューム登録  */
  setAkb48ResumePoint: G_SetAkb48ResumePointPayload;
  /**  ブックス作品をお気に入りに追加する  */
  addBookBookmark?: Maybe<G_AddBookBookmarkPayload>;
  /**  ブックス作品をお気に入りから削除する  */
  deleteBookBookmark?: Maybe<G_DeleteBookBookmarkPayload>;
  /**  ブックス閲覧履歴を削除する  */
  deleteBookBrowseHistory?: Maybe<G_DeleteBookBrowseHistoryPayload>;
  /**  単行本を購入する  */
  purchaseBookVolume?: Maybe<G_PurchaseBookProductPayload>;
  /**  連載話を購入する  */
  purchaseBookEpisode?: Maybe<G_PurchaseBookProductPayload>;
  /**  連載話を毎日¥0で購入する  */
  consumeBookStamina: G_ConsumeBookStaminaPayload;
  /**  ブックス作品のレビューを投稿する  */
  postBookReview: G_PostReviewPayload;
  /**  ビデオのブックマークを追加する  */
  addVideoBookmark: G_AddVideoBookmarkPayload;
  /**  ビデオのブックマークを削除する  */
  deleteVideoBookmarks: G_DeleteVideoBookmarksPayload;
  /**  コメント投稿  */
  postComment: G_PostCommentPayload;
  /**  通報  */
  reportInappropriateComment: G_ReportInappropriateCommentPayload;
  /**  FANZA作品のレジューム登録  */
  setFanzaResumePoint: G_SetFanzaResumePointPayload;
  /**  FANZA動画作品を購入する  */
  purchaseFanzaPPVContent: G_PurchaseFanzaPpvContentPayload;
  /**  ハートマークを更新する  */
  updateFanzaPPVHeartMark: G_UpdateFanzaPpvHeartMarkPayload;
  /**  ハートマークを更新する(ContentID単位)  */
  updateFanzaPPVHeartMarkByContentID: G_UpdateFanzaPpvHeartMarkPayload;
  /**  FANZA動画作品をお気に入りに追加する  */
  addFanzaPPVBookmark: G_AddFanzaPpvBookmarkPayload;
  /**  FANZA動画作品をお気に入りから削除する  */
  deleteFanzaPPVBookmarks: G_DeleteFanzaPpvBookmarksPayload;
  /**  FANZA月額作品をお気に入りに追加する  */
  addFanzaSvodBookmark: G_FanzaSvodBookmarkPayload;
  /**  FANZA月額作品をお気に入りから削除する  */
  deleteFanzaSvodBookmarks: G_FanzaSvodBookmarkPayload;
  /**  FANZA月額作品の視聴履歴を削除する  */
  deleteFanzaSvodPlayHistories: G_DeleteFanzaSvodPlayHistoryPayload;
  /**  FANZA TV Plus入会  */
  subscribeFanzaTvPlus: G_SubscribeFanzaTvPlusPayload;
  /**  FANZA TV Plus退会  */
  unsubscribeFanzaTvPlus: G_UnsubscribeFanzaTvPlusPayload;
  /**  FANZA TV作品へのレビューを投稿する  */
  postFanzaReview: G_PostReviewPayload;
  /**  メルマガを購読する  */
  subscribeMailMagazine: G_SubscribeMailMagazinePayload;
  /**  プッシュ通知のトークン・通知設定の登録  */
  registerPushNotificationConfig: G_RegisterPushNotificationConfigPayload;
  /**  ビデオ作品のレビューを投稿する  */
  postVideoReview: G_PostReviewPayload;
  /**  レビューを評価する  */
  evaluateReview: G_EvaluateReviewPayload;
  /**  Amazon IAP入会  */
  subscribeForFireOS: G_SubscribeForFireOsPayload;
  /**  TVコインチャージ(iOS)  */
  chargeTvCoinForIOS: G_ChargeTvCoinForIosPayload;
  /**  TVコインチャージ(Android)  */
  chargeTvCoinForAndroid: G_ChargeTvCoinForAndroidPayload;
  /**  TVコインチャージ(FireOS)  */
  chargeTvCoinForFireOS: G_ChargeTvCoinForFireOsPayload;
  /**  プロフィールを追加する  */
  addProfile: G_AddProfilePayload;
  /**  プロフィールを選択する  */
  selectProfile: G_SelectProfilePayload;
  /**  プロフィールを編集する  */
  updateProfile: G_UpdateProfilePayload;
  /**  プロフィールを削除する  */
  deleteProfile: G_DeleteProfilePayload;
  /**  TVデバイスのホーム設定を編集する  */
  updateHomeSettings: G_UpdateHomeSettingsPayload;
  /**  VRデバイスのホーム設定を編集する  */
  updateVRHomeSettings: G_UpdateVrHomeSettingsPayload;
  /**  デモグラフィック情報登録  */
  createDemographic: G_CreateDemographicPayload;
  /**  視聴履歴を削除する  */
  deleteVideoPlayHistories: G_DeleteVideoPlayHistoriesPayload;
  /**  続きから見るリストから削除する  */
  deleteContinueWatchingListEntries: G_DeleteContinueWatchingListEntriesPayload;
  /**  BytePlusのユーザーイベントを送信  */
  sendBytePlusUserEvent: G_SendBytePlusUserEventPayload;
  /**  ビデオ作品を購入する  */
  purchaseVideo: G_PurchaseVideoPayload;
  /**
   * レジでビデオ作品を購入する
   * レジによる購入に必要なデータを登録し、レジのURLを生成して返却する
   */
  purchaseVideoByCashier: G_PurchaseVideoByCashierPayload;
  /**
   *  レジでワク割対象作品を購入する
   * @deprecated イベントワクワク割は2023/01/31で終了
   */
  purchaseWakuwariVideoByCashier: G_PurchaseWakuwariVideoByCashierPayload;
};


export type G_MutationSetAkb48ResumePointArgs = {
  input: G_SetAkb48ResumePointInput;
};


export type G_MutationAddBookBookmarkArgs = {
  input: G_AddBookBookmarkInput;
};


export type G_MutationDeleteBookBookmarkArgs = {
  input: G_DeleteBookBookmarkInput;
};


export type G_MutationDeleteBookBrowseHistoryArgs = {
  input: G_DeleteBookBrowseHistoryInput;
};


export type G_MutationPurchaseBookVolumeArgs = {
  input: G_PurchaseBookProductInput;
};


export type G_MutationPurchaseBookEpisodeArgs = {
  input: G_PurchaseBookProductInput;
};


export type G_MutationConsumeBookStaminaArgs = {
  input: G_ConsumeBookStaminaInput;
};


export type G_MutationPostBookReviewArgs = {
  input: G_PostReviewInput;
};


export type G_MutationAddVideoBookmarkArgs = {
  input: G_AddVideoBookmarkInput;
};


export type G_MutationDeleteVideoBookmarksArgs = {
  input: G_DeleteVideoBookmarksInput;
};


export type G_MutationPostCommentArgs = {
  input: G_PostCommentInput;
};


export type G_MutationReportInappropriateCommentArgs = {
  input: G_ReportInappropriateCommentInput;
};


export type G_MutationSetFanzaResumePointArgs = {
  input: G_SetFanzaResumePointInput;
};


export type G_MutationPurchaseFanzaPpvContentArgs = {
  input: G_PurchaseFanzaPpvContentInput;
};


export type G_MutationUpdateFanzaPpvHeartMarkArgs = {
  input: G_UpdateFanzaPpvHeartMarkInput;
};


export type G_MutationUpdateFanzaPpvHeartMarkByContentIdArgs = {
  input: G_UpdateFanzaPpvHeartMarkByContentIdInput;
};


export type G_MutationAddFanzaPpvBookmarkArgs = {
  input: G_AddFanzaPpvBookmarkInput;
};


export type G_MutationDeleteFanzaPpvBookmarksArgs = {
  inputs: Array<G_DeleteFanzaPpvBookmarksInput>;
};


export type G_MutationAddFanzaSvodBookmarkArgs = {
  input: G_FanzaSvodBookmarkInput;
};


export type G_MutationDeleteFanzaSvodBookmarksArgs = {
  input: G_DeleteFanzaSvodBookmarksInput;
};


export type G_MutationDeleteFanzaSvodPlayHistoriesArgs = {
  input: G_DeleteFanzaSvodPlayHistoriesInput;
};


export type G_MutationSubscribeFanzaTvPlusArgs = {
  input: G_SubscribeFanzaTvPlusInput;
};


export type G_MutationUnsubscribeFanzaTvPlusArgs = {
  input: G_UnsubscribeFanzaTvPlusInput;
};


export type G_MutationPostFanzaReviewArgs = {
  input: G_PostReviewInput;
};


export type G_MutationSubscribeMailMagazineArgs = {
  input: G_SubscribeMailMagazineInput;
};


export type G_MutationRegisterPushNotificationConfigArgs = {
  input: G_RegisterPushNotificationConfigInput;
};


export type G_MutationPostVideoReviewArgs = {
  input: G_VideoReviewInput;
};


export type G_MutationEvaluateReviewArgs = {
  input: G_EvaluateReviewInput;
};


export type G_MutationSubscribeForFireOsArgs = {
  input: G_SubscribeForFireOsInput;
};


export type G_MutationChargeTvCoinForIosArgs = {
  input: G_ChargeTvCoinForIosInput;
};


export type G_MutationChargeTvCoinForAndroidArgs = {
  input: G_ChargeTvCoinForAndroidInput;
};


export type G_MutationChargeTvCoinForFireOsArgs = {
  input: G_ChargeTvCoinForFireOsInput;
};


export type G_MutationAddProfileArgs = {
  input: G_AddProfileInput;
};


export type G_MutationSelectProfileArgs = {
  input: G_SelectProfileInput;
};


export type G_MutationUpdateProfileArgs = {
  input: G_UpdateProfileInput;
};


export type G_MutationDeleteProfileArgs = {
  input: G_DeleteProfileInput;
};


export type G_MutationUpdateHomeSettingsArgs = {
  input: G_UpdateHomeSettingsInput;
};


export type G_MutationUpdateVrHomeSettingsArgs = {
  input: G_UpdateVrHomeSettingsInput;
};


export type G_MutationCreateDemographicArgs = {
  input: G_CreateDemographicInput;
};


export type G_MutationDeleteVideoPlayHistoriesArgs = {
  input: G_DeleteVideoPlayHistoriesInput;
};


export type G_MutationDeleteContinueWatchingListEntriesArgs = {
  input: G_DeleteContinueWatchingListEntriesInput;
};


export type G_MutationSendBytePlusUserEventArgs = {
  input: G_SendBytePlusUserEventInput;
};


export type G_MutationPurchaseVideoArgs = {
  input: G_PurchaseVideoInput;
};


export type G_MutationPurchaseVideoByCashierArgs = {
  input: G_PurchaseVideoByCashierInput;
};


export type G_MutationPurchaseWakuwariVideoByCashierArgs = {
  input: G_PurchaseWakuwariVideoByCashierInput;
};

/** 次回配信エピソード */
export type G_NextDeliveryEpisode = {
  /**  配信前フラグ  */
  isBeforeDelivered: Scalars['Boolean'];
  /**  次回配信日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
};

export type G_Node = {
  id: Scalars['ID'];
};

/**  お知らせ  */
export type G_Notification = G_Node & {
  /**  お知らせID  */
  id: Scalars['ID'];
  /**  お知らせタイトル  */
  title: Scalars['String'];
  /**  お知らせ本文  */
  body: Scalars['String'];
  /**  お知らせ詳細のURL  */
  url: Scalars['URI'];
  /**  公開日時  */
  startPublicAt: Scalars['DateTime'];
};

export type G_NotificationConnection = G_ForwardOnlyConnection & {
  edges: Array<G_NotificationEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_NotificationEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_Notification;
};

/**  注文ステータス  */
export enum G_OrderStatus {
  /**  成功  */
  Success = 'SUCCESS',
  /**  失敗  */
  Failure = 'FAILURE',
  /**  処理中  */
  Processing = 'PROCESSING'
}

/** ページネーションのページ情報 */
export type G_PageInfo = {
  startCursor: Scalars['String'];
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

/**  パート  */
export type G_Part = {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  パート番号  */
  number: Scalars['Int'];
  /**  パートの秒数  */
  duration: Scalars['Int'];
  /**  レジュームポイント(秒)  */
  resumePoint: Scalars['Int'];
  /**  視聴率グラフ  */
  heatMap?: Maybe<G_VideoHeatMap>;
};

/**  ペイロード  */
export type G_Payload = {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_PaymentMethod = {
  /**  支払い手段  */
  type: G_PaymentType;
  /**  支払額・ポイント  */
  amount: Scalars['Int'];
};

/** 支払いステータス */
export type G_PaymentStatus = {
  /**  継続課金失敗かどうか  */
  isRenewalFailure: Scalars['Boolean'];
  /**  失敗コード  */
  failureCode: G_FailureCode;
  /**  失敗時のメッセージ  */
  message: Scalars['String'];
};

/**  支払い手段  */
export enum G_PaymentType {
  /**  クレジットカード  */
  Credit = 'CREDIT',
  /**  DMMポイント  */
  DmmPoint = 'DMM_POINT',
  /**  TVコイン  */
  TvCoin = 'TV_COIN'
}

/** 人物 */
export type G_Person = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** DMMプレミアム加入ステータス */
export type G_PlanStatus = {
  /**  現在のプラン  */
  servicePlan: G_ServicePlan;
  /**  会員ステータス  */
  status?: Maybe<G_SubscriptionStatus>;
  /**  サービス提供終了日  */
  provideEndDate?: Maybe<Scalars['DateTime']>;
  /**  次回契約更新日  */
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  /**  支払い方法  */
  paymentType?: Maybe<G_SubscriptionPaymentType>;
  /** ユーザーが支払い可能な状態かを確認する */
  paymentStatus: G_PaymentStatus;
};


/** DMMプレミアム加入ステータス */
export type G_PlanStatusPaymentStatusArgs = {
  id: G_SubscriptionPlanId;
};

/** OpenAPIのトランザクション */
export type G_PlatformTransaction = {
  /**  トランザクションID  */
  id: Scalars['String'];
  /**  注文ID  */
  orderId: Scalars['String'];
};

/**
 * 動画再生デバイス
 * See https://confl.arms.dmm.com/x/SCLvQg
 */
export enum G_PlayDevice {
  /**  ブラウザ(PC)  */
  Browser = 'BROWSER',
  /**  モバイルブラウザ(iOS)  */
  BrowserMobileIos = 'BROWSER_MOBILE_IOS',
  /**  モバイルブラウザ(Android)  */
  BrowserMobileAndroid = 'BROWSER_MOBILE_ANDROID',
  /**  iPhone  */
  Iphone = 'IPHONE',
  /**  iPad  */
  Ipad = 'IPAD',
  /**  Android Mobile  */
  AndroidMobile = 'ANDROID_MOBILE',
  /**  Android TV  */
  AndroidTv = 'ANDROID_TV',
  /**  Fire TV  */
  FireTv = 'FIRE_TV',
  /**  HTML5 TV  */
  Html5Tv = 'HTML5_TV',
  /**  PS4  */
  Ps4 = 'PS4',
  /**  PS5  */
  Ps5 = 'PS5',
  /**  Chromecast(iOS)  */
  ChromecastIos = 'CHROMECAST_IOS',
  /**  Chromecast(Android)  */
  ChromecastAndroid = 'CHROMECAST_ANDROID',
  /**  AirPlay(Apple TV)  */
  Airplay = 'AIRPLAY',
  /**  PlayStation VR */
  Psvr = 'PSVR',
  /**  PlayStation VR2 */
  Psvr2 = 'PSVR2',
  IosVr = 'IOS_VR',
  /**  Android VR  */
  AndroidVr = 'ANDROID_VR',
  /**  Gear VR */
  GearVr = 'GEAR_VR',
  /**  Xperia View  */
  XperiaView = 'XPERIA_VIEW'
}

/**  キャンペーンごとのポイント還元内訳  */
export type G_PointRefundDetailByCampaign = {
  /**  キャンペーン名  */
  campaignName: Scalars['String'];
  /**  還元ポイント  */
  refundPoint: Scalars['Int'];
};

/**  支払い方法によるポイント還元内訳  */
export type G_PointRefundDetailByPaymentMethod = {
  /**  支払い方法  */
  paymentMethod: G_PaymentType;
  /**  還元ポイント  */
  refundPoint: Scalars['Int'];
  /**  還元率(%)  */
  refundRate: Scalars['Int'];
  /**  後日還元かどうか  */
  isRefundLater: Scalars['Boolean'];
};

/**  商品ごとのポイント還元内訳  */
export type G_PointRefundDetailByProduct = {
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  商品ごとの還元ポイント合計  */
  totalRefundPoint: Scalars['Int'];
  /**  キャンペーン名  */
  campaignName: Scalars['String'];
  /**  キャンペーン還元ポイント  */
  campaignRefundPoint: Scalars['Int'];
  /**  キャンペーン還元率(%)  */
  campaignRefundRate: Scalars['Int'];
  /**  プレミアム還元ポイント  */
  premiumRefundPoint: Scalars['Int'];
  /**  プレミアム還元率(%)  */
  premiumRefundRate: Scalars['Int'];
};

/**  ポイント還元情報  */
export type G_PointRefundInfo = {
  /**  還元ポイントの合計値  */
  totalRefundPoint: Scalars['Int'];
  /**  プレミアム還元ポイントの合計値  */
  totalPremiumRefundPoint: Scalars['Int'];
  /**  キャンペーンごとのポイント還元内訳  */
  detailsByCampaign: Array<G_PointRefundDetailByCampaign>;
  /**  商品ごとのポイント還元内訳  */
  detailsByProduct: Array<G_PointRefundDetailByProduct>;
  /**  決済手段によるポイント還元内訳  */
  detailsByPaymentMethod: Array<G_PointRefundDetailByPaymentMethod>;
};

export type G_PostCommentInput = {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  コメント内容  */
  body: Scalars['String'];
  /**  デバイス  */
  device: G_Device;
};

export type G_PostCommentPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_PostReviewError = {
  /**  エラーコード  */
  code?: Maybe<G_PostReviewErrorCode>;
  /**  エラーが発生しているフィールド  */
  field?: Maybe<G_PostReviewErrorField>;
};

export enum G_PostReviewErrorCode {
  /**  不明なエラー  */
  Unspecified = 'UNSPECIFIED',
  /**  既にレビュー投稿済み  */
  AlreadyExists = 'ALREADY_EXISTS',
  /**  レビュータイトルが規定文字数の範囲外  */
  InvalidTitle = 'INVALID_TITLE',
  /**  投稿内容が規定文字数の範囲外  */
  InvalidComment = 'INVALID_COMMENT',
  /**  レビュアー名未登録 かつ レビュアー名が未設定  */
  NoReviewerName = 'NO_REVIEWER_NAME',
  /**  重複など何らかの理由でレビュアー名が利用不可  */
  UnavailableReviewerName = 'UNAVAILABLE_REVIEWER_NAME',
  /**  レビュアー名登録済み かつ レビュアー名が設定されている  */
  ReviewerNameIsRegistered = 'REVIEWER_NAME_IS_REGISTERED',
  /**  禁則文字が含まれているためレビュアー名が利用不可  */
  InvalidReviewerName = 'INVALID_REVIEWER_NAME',
  /**  内部エラー  */
  InternalError = 'INTERNAL_ERROR'
}

export enum G_PostReviewErrorField {
  /**  投稿対象のシーズンID  */
  SeasonId = 'SEASON_ID',
  /**  レビュータイトル  */
  Title = 'TITLE',
  /**  投稿内容  */
  Comment = 'COMMENT',
  /**  レビュアー名 (ニックネーム未設定の場合のみ必須)  */
  ReviewerName = 'REVIEWER_NAME'
}

export type G_PostReviewInput = {
  /**  ショップ名  */
  shopName: Scalars['String'];
  /**  投稿対象のコンテンツID  */
  contentId: Scalars['ID'];
  /**  レビュアー名 (ニックネーム未設定の場合のみ必須)  */
  reviewerName?: Maybe<Scalars['String']>;
  /**  レビュータイトル  */
  title?: Maybe<Scalars['String']>;
  /**  レビュー値(星の数)  */
  point: Scalars['Int'];
  /**  ネタバレ有無  */
  hasSpoiler: Scalars['Boolean'];
  /**  投稿内容  */
  comment?: Maybe<Scalars['String']>;
  /**  デバイス  */
  device: G_Device;
};

export type G_PostReviewPayload = G_Payload & {
  /**
   *  投稿が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_PostReviewError>;
};

export type G_PresetContentConnection = G_ForwardOnlyConnection & {
  edges: Array<G_PresetContentEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_PresetContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoContent;
};

export type G_PresetVideoConnection = {
  edges: Array<G_PresetVideoEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_PresetVideoEdge = {
  cursor: Scalars['String'];
  node: G_Video;
};

/** プロフィール情報 */
export type G_Profile = {
  /**  プロフィールID  */
  id: Scalars['ID'];
  /**  プロフィール名  */
  name: Scalars['String'];
  /**  プロフィールアイコン  */
  profileIcon: G_ProfileIcon;
  /**  親プロフィールかどうか  */
  isParent: Scalars['Boolean'];
  /**  視聴レーティング制限  */
  viewableRating: G_ViewableRating;
  /**  購入制限  */
  canPurchase: Scalars['Boolean'];
  /**  セキュリティーコード関連の設定  */
  securityCodeSettings: G_SecurityCodeSettings;
};

export enum G_ProfileErrorCode {
  /**  不明なエラー  */
  Unspecified = 'UNSPECIFIED',
  /**  削除対象の会員情報が存在しない  */
  UserNotFound = 'USER_NOT_FOUND',
  /**  削除対象のプロフィールが存在しない  */
  ProfileNotFound = 'PROFILE_NOT_FOUND',
  /**  削除対象のプロフィールが「無効」  */
  ProfileInactive = 'PROFILE_INACTIVE',
  /**  削除対象のプロフィールがデフォルトプロフィール  */
  DefaultProfileCannotDelete = 'DEFAULT_PROFILE_CANNOT_DELETE'
}

/** プロフィールアイコン */
export type G_ProfileIcon = {
  /**  プロフィールアイコンID  */
  id: Scalars['ID'];
  /**  プロフィールアイコンURL  */
  url: Scalars['URI'];
};

/**
 * コンテンツ保護機能とそれのデコード可能能力
 * データ組み立て方針: https://confl.arms.dmm.com/pages/viewpage.action?pageId=1157577370
 */
export type G_ProtectionCapability = {
  /**
   * SystemID
   * DASH-IFによって定められたコンテンツ保護に関する識別子(ID)
   */
  systemId: Scalars['ID'];
  /** ストリーミングフォーマット */
  format: G_StreamingFormat;
  /** 当該SystemIDにおけるオーディオに関するデコード能力 */
  audio: Array<G_AudioProtectionCapability>;
  /** 当該SystemIDにおけるビデオに関するデコード能力 */
  video: Array<G_VideoProtectionCapability>;
  /**  HDCPの対応有無(対応しているバージョン)  */
  hdcp?: Maybe<G_Hdcp>;
};

export type G_PurchaseBookProductInput = {
  /**
   * 購入する商品ID情報
   * BookContentのBookProduct.ID or BookStoryのBookProduct.ID
   */
  productIds: Array<Scalars['ID']>;
  /**  支払い方法  */
  paymentMethod: Array<G_PaymentMethod>;
  /** ユーザーのデバイス種別 */
  device: G_Device;
};

export type G_PurchaseBookProductPayload = G_Payload & {
  /**
   * 購入した商品ID情報
   * BookContentのBookProduct.ID or BookStoryのBookProduct.ID
   */
  productIds: Array<Scalars['ID']>;
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  OpenAPIで発行された購入ID  */
  orderId: Scalars['String'];
  /**  注文ステータス  */
  status: G_OrderStatus;
  /**  エラー詳細  */
  error?: Maybe<G_PurchaseErrorCode>;
};

export enum G_PurchaseErrorCode {
  /**  Internalエラー  */
  Internal = 'INTERNAL',
  /**  DMMTVで購入が利用できないデバイス  */
  InvalidDevice = 'INVALID_DEVICE',
  /**  支払い方法とデバイスが不一致  */
  InvalidPaytype = 'INVALID_PAYTYPE',
  /**  InvalidProductエラー  */
  InvalidProduct = 'INVALID_PRODUCT',
  /**  購入済み商品  */
  PurchaseAlreadyExists = 'PURCHASE_ALREADY_EXISTS',
  /**  price系エラー  */
  InvalidPrice = 'INVALID_PRICE',
  /**  不正購入判定：3Dセキュア認証が必要  */
  Need_3DSecure = 'NEED_3D_SECURE',
  /**  不正購入判定：カスタマーサポート部へ連絡するように求めてほしい  */
  RequestCustomerSupport = 'REQUEST_CUSTOMER_SUPPORT',
  /**  購入失敗エラー  */
  PurchaseFailed = 'PURCHASE_FAILED',
  /**  商品購入API：E220130 クレジットカードの有効期限切れ  */
  CreditExpired = 'CREDIT_EXPIRED',
  /**  商品購入API：E220140 クレジットカード未登録  */
  CreditUnregistered = 'CREDIT_UNREGISTERED',
  /**  クレジットカード系エラー  */
  CreditInvalidate = 'CREDIT_INVALIDATE',
  /**  商品購入API：E221020 DMMポイントの残高が不足  */
  DmmpointShortage = 'DMMPOINT_SHORTAGE',
  /**  商品購入API：E221025 TVコインの残高が不足  */
  TvcoinShortage = 'TVCOIN_SHORTAGE',
  /**  商品購入API: E221020 電子マネーの残高が不足  */
  EmoneyShortage = 'EMONEY_SHORTAGE',
  /**  許可されていないIPアドレス(=海外)での購入  */
  RestrictedIpAddress = 'RESTRICTED_IP_ADDRESS',
  /**  許可されていないプロフィールでの購入  */
  RestrictedProfile = 'RESTRICTED_PROFILE'
}

export type G_PurchaseFanzaPpvContentInput = {
  /**  デバイス  */
  device: G_Device;
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  支払い情報  */
  paymentInfo: Array<G_FanzaPpvPaymentInfo>;
};

export type G_PurchaseFanzaPpvContentPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  注文ID  */
  orderId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_PurchaseErrorCode>;
};

export type G_PurchaseVideoByCashierInput = {
  /**  デバイス  */
  device: G_Device;
  /**  購入する作品のプロダクトID  */
  productId: Scalars['ID'];
  /**  購入完了後に遷移するURL  */
  backUrl: Scalars['URI'];
};

export type G_PurchaseVideoByCashierPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  キャッシャー(レジ)のURL  */
  cashierUrl: Scalars['URI'];
  /**  エラー詳細  */
  error?: Maybe<G_PurchaseErrorCode>;
};

export type G_PurchaseVideoInput = {
  /**  デバイス  */
  device: G_Device;
  /**  購入する作品のプロダクトID  */
  productId: Scalars['ID'];
  /**  支払い方法  */
  paymentMethod: Array<G_PaymentMethod>;
};

export type G_PurchaseVideoPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  OpenAPIで発行された注文ID  */
  orderId: Scalars['String'];
  /**  注文ステータス  */
  status: G_OrderStatus;
  /**  エラー詳細  */
  error?: Maybe<G_PurchaseErrorCode>;
};

export type G_PurchaseWakuwariVideoByCashierInput = {
  /**  デバイス  */
  device: G_Device;
  /**  購入する作品のコンテンツID  */
  contentId: Scalars['ID'];
  /**  購入する作品のプロダクトID  */
  productId: Scalars['ID'];
  /**  購入完了後に遷移するURL  */
  backUrl: Scalars['URI'];
  /**  名前（名）  */
  givenName: Scalars['String'];
  /**  名前（姓）  */
  familyName: Scalars['String'];
  /**  メールアドレス  */
  mail: Scalars['String'];
};

export type G_PurchaseWakuwariVideoByCashierPayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  キャッシャー(レジ)のURL  */
  cashierUrl: Scalars['URI'];
};

/** 公演日別の購入済みコンテンツ */
export type G_PurchasedContentsByPerformanceDate = {
  /**  公演日  */
  performanceDate: Scalars['DateTime'];
  /**  コンテンツ  */
  contents: Array<G_VideoContent>;
};

/** 舞台購入済みコンテンツ */
export type G_PurchasedStageContents = {
  /**  全ての購入済みコンテンツ  */
  allPurchasedContents: Array<G_VideoContent>;
  /**  公演日別の購入済みコンテンツ  */
  purchasedContentsByPerformanceDate: Array<G_PurchasedContentsByPerformanceDate>;
};

/** 購入済みビデオ */
export type G_PurchasedVideo = G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**
   *  視聴期限
   * @deprecated 仕様変更のため
   */
  expiration: G_VideoPurchasedViewingExpiration;
  /**  購入済みのビデオ  */
  video: G_Video;
};

export type G_PurchasedVideoConnection = G_Connection & {
  edges: Array<G_PurchasedVideoEdge>;
  pageInfo: G_PageInfo;
};

export type G_PurchasedVideoEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_PurchasedVideo;
};

export enum G_PurchasedVideoSortKey {
  /**  購入日の古い順  */
  PurchasedDateAsc = 'PURCHASED_DATE_ASC',
  /**  購入日の新しい順  */
  PurchasedDateDesc = 'PURCHASED_DATE_DESC'
}

/** 品質情報識別子と表示名の対応付け */
export type G_Quality = {
  /**  品質識別子 (auto, sd, hd, 4k 等)  */
  name: Scalars['String'];
  /**  表示名 (AUTO, SD, HD(1080p) 等)  */
  displayName: Scalars['String'];
  /**  表示優先度  */
  displayPriority: Scalars['Int'];
};

export type G_Query = {
  /** ヘルスチェック */
  health: Array<G_Health>;
  /**  単行本 単一取得  */
  bookVolume: G_BookVolume;
  /**  単行本 一覧取得  */
  bookVolumes: G_BookVolumeConnection;
  /**  連載話 単一取得  */
  bookEpisode: G_BookEpisode;
  /**  連載話 一覧取得  */
  bookEpisodes: G_BookEpisodeConnection;
  /**  ブックスフロア一覧  */
  bookFloors: Array<G_BookFloor>;
  /**  ブックスホーム  */
  bookHome: G_BookHome;
  /**  ピックアップ作品  */
  bookPickups: Array<G_BookPickup>;
  /**  ブックスポイント還元内訳  */
  bookPointRefundInfo: G_PointRefundInfo;
  /**  ブックスのランキング全種類  */
  allBookRankings: Array<G_BookRanking>;
  /**  ブックスランキング  */
  bookRanking: G_BookRanking;
  searchBooks: G_BookSearchConnection;
  /**  ブックスのシリーズ情報取得  */
  bookSeries: G_BookSeries;
  /**  ブックスのシリーズ概要 (最近チェックした本を取得するための複数リクエスト)  */
  bookSeriesSummaries: Array<G_BookSeriesSummary>;
  /**  ブックスユーザー  */
  bookUser: G_BookUser;
  /**  クライアント  */
  client: G_Client;
  /**  コメント一覧取得  */
  comments: G_CommentConnection;
  /**  コメント総件数取得  */
  totalCommentCounts: Scalars['Int'];
  /**  FANZA動画検索  */
  searchFanzaPPVContents: G_FanzaPpvSearchResultConnection;
  /**  FANZA動画検索(Offset版)  */
  searchFanzaPPVContentsWithOffset: G_FanzaPpvSearchResultWithOffset;
  /**  FANZA動画コンテンツ  */
  fanzaPPVContent?: Maybe<G_FanzaPpvContent>;
  /**  還元ポイント  */
  fanzaPointRefundInfo: G_PointRefundInfo;
  /**  FANZA TV Plus  */
  fanzaTvPlus: G_FanzaTvPlus;
  /**  FANZA TV  */
  fanzaTV: G_FanzaTv;
  /** DMM TVホーム */
  home: G_Home;
  /** 棚取得(棚ID指定) */
  shelf: G_Shelf;
  /**
   * メンテナンス情報
   * nilの場合、実施中メンテナンスなし
   */
  maintenance?: Maybe<G_Maintenance>;
  /**  お知らせリスト  */
  notifications: G_NotificationConnection;
  /**  お知らせ  */
  notification?: Maybe<G_Notification>;
  /**  FANZAお知らせリスト  */
  fanzaNotifications: G_FanzaNotificationConnection;
  /**  FANZAお知らせ  */
  fanzaNotification?: Maybe<G_FanzaNotification>;
  /** DMM TVなコンテンツを再生する際に利用される */
  stream?: Maybe<G_Stream>;
  /** FANZA系/LOD,ROD系コンテンツを再生する際に利用される */
  streamLegacy?: Maybe<G_Stream>;
  /**
   * DMM TVなコンテンツのダウンロードURLを生成する (DCV / WebStreamDRMに対応)
   * 存在しない場合はnullを返す
   * この結果のURLをブラウザで開いくことでDownloadさせる
   */
  downloadFileUrl?: Maybe<Scalars['URI']>;
  /** 月額プラン */
  subscriptionPlan: G_SubscriptionPlan;
  /**
   * コンバージョンタグ
   * 2023/04/17時点ではFANZA TV Plusのコンバージョンタグのみを想定する
   */
  conversionTag: G_ConversionTag;
  /**  利用規約を取得  */
  terms: G_Terms;
  /**  FANZA利用規約を取得  */
  fanzaTerms: G_Terms;
  /**  TVコイン商品リスト  */
  tvCoinProducts: Array<G_TvCoinProduct>;
  /**  ログインユーザーの情報を取得する  */
  user: G_User;
  /**  プロフィール選択後のユーザ情報を取得する  */
  viewer: G_Viewer;
  /**
   *  おすすめのビデオ作品
   * @deprecated u2iRecommendedVideosに移行予定
   */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  u2iRecommendedVideos: G_RecommendedVideoConnection;
  /** ビデオを取得 */
  video: G_Video;
  /**  コピーライト一覧  */
  allVideoCopyrights: Array<Scalars['String']>;
  /**  好みのジャンル・カテゴリを選ぶ際の作品一覧を取得  */
  videosForDemographic: Array<G_VideoForDemographic>;
  /**  ビデオ作品キャンペーン  */
  videoCampaign?: Maybe<G_VideoCampaign>;
  /**  ビデオ作品キャンペーン一覧  */
  videoCampaigns: G_VideoCampaignConnection;
  /** ビデオコンテンツを取得 */
  videoContent: G_VideoContent;
  /** PPV商品を取得 */
  videoPpvProduct: G_VideoPpvProduct;
  /**  ビデオランキング  */
  videoRankings: G_VideoRankingConnection;
  /** ビデオを検索 */
  searchVideos: G_VideoSearchResultConnection;
  _service: G__Service;
};


export type G_QueryBookVolumeArgs = {
  id: Scalars['ID'];
};


export type G_QueryBookVolumesArgs = {
  seriesId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<G_BookVolumeSortOrder>;
};


export type G_QueryBookEpisodeArgs = {
  id: Scalars['ID'];
};


export type G_QueryBookEpisodesArgs = {
  seriesId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<G_BookEpisodeSortOrder>;
};


export type G_QueryBookPickupsArgs = {
  pickupType: G_BookPickupTypes;
};


export type G_QueryBookPointRefundInfoArgs = {
  publishFormat: G_BookPublishFormat;
  productIds: Array<Scalars['ID']>;
  paymentMethod: Array<G_PaymentMethod>;
};


export type G_QueryBookRankingArgs = {
  id: Scalars['ID'];
};


export type G_QuerySearchBooksArgs = {
  filter?: Maybe<G_BookFilterInput>;
  order?: Maybe<G_BookOrder>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QueryBookSeriesArgs = {
  seriesId: Scalars['ID'];
  contentId?: Maybe<Scalars['ID']>;
};


export type G_QueryBookSeriesSummariesArgs = {
  seriesId: Array<Scalars['ID']>;
};


export type G_QueryCommentsArgs = {
  contentId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


export type G_QueryTotalCommentCountsArgs = {
  contentId: Scalars['ID'];
};


export type G_QuerySearchFanzaPpvContentsArgs = {
  device: G_Device;
  shop?: Maybe<G_FanzaPpvShop>;
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  contentType?: Maybe<G_FanzaContentType>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaPpvSortOder>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QuerySearchFanzaPpvContentsWithOffsetArgs = {
  device: G_Device;
  shop?: Maybe<G_FanzaPpvShop>;
  keyword?: Maybe<Scalars['String']>;
  castIds?: Maybe<Array<Scalars['String']>>;
  genreIds?: Maybe<Array<Scalars['String']>>;
  makerIds?: Maybe<Array<Scalars['String']>>;
  seriesIds?: Maybe<Array<Scalars['String']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  contentType?: Maybe<G_FanzaContentType>;
  isChildNg?: Maybe<Scalars['Boolean']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<G_FanzaPpvSortOder>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type G_QueryFanzaPpvContentArgs = {
  shop: G_FanzaPpvShop;
  id: Scalars['ID'];
};


export type G_QueryFanzaPointRefundInfoArgs = {
  device: G_Device;
  paymentMethod: Array<G_PaymentMethod>;
  id: Scalars['ID'];
  shop: G_FanzaPpvShop;
};


export type G_QueryFanzaTvPlusArgs = {
  device: G_Device;
};


export type G_QueryFanzaTvArgs = {
  device: G_Device;
};


export type G_QueryHomeArgs = {
  device: G_Device;
  homeType: G_HomeType;
  id?: Maybe<Scalars['ID']>;
};


export type G_QueryShelfArgs = {
  id: Scalars['ID'];
  device: G_Device;
};


export type G_QueryNotificationsArgs = {
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type G_QueryFanzaNotificationsArgs = {
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QueryFanzaNotificationArgs = {
  id: Scalars['ID'];
};


export type G_QueryStreamArgs = {
  id: Scalars['ID'];
  part?: Maybe<Scalars['Int']>;
  protectionCapabilities: Array<G_ProtectionCapability>;
  audioChannelLayouts: Array<G_StreamingAudioChannelLayout>;
  device: G_PlayDevice;
  http?: Maybe<Scalars['Boolean']>;
  temporaryDownload?: Maybe<Scalars['Boolean']>;
};


export type G_QueryStreamLegacyArgs = {
  id: Scalars['ID'];
  part?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['ID']>;
  shopName: Scalars['String'];
  protectionCapabilities: Array<G_ProtectionCapability>;
  audioChannelLayouts: Array<G_StreamingAudioChannelLayout>;
  device: G_PlayDevice;
  deviceManufacturer?: Maybe<G_DeviceManufacturer>;
  http?: Maybe<Scalars['Boolean']>;
  temporaryDownload?: Maybe<Scalars['Boolean']>;
};


export type G_QueryDownloadFileUrlArgs = {
  id: Scalars['ID'];
  part?: Maybe<Scalars['Int']>;
  qualityName: Scalars['String'];
  fileType: G_DownloadType;
};


export type G_QuerySubscriptionPlanArgs = {
  id: G_SubscriptionPlanId;
};


export type G_QueryConversionTagArgs = {
  planId: G_SubscriptionPlanId;
  device: G_Device;
};


export type G_QueryTermsArgs = {
  device: G_Device;
  id: G_TermsId;
};


export type G_QueryFanzaTermsArgs = {
  device: G_Device;
  id: G_FanzaTermsId;
};


export type G_QueryTvCoinProductsArgs = {
  device: G_Device;
};


export type G_QueryRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  method: G_RecommendationMethod;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  searchQuery?: Maybe<Scalars['String']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};


export type G_QueryU2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  searchQuery?: Maybe<Scalars['String']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};


export type G_QueryVideoArgs = {
  id: Scalars['ID'];
};


export type G_QueryVideoCampaignArgs = {
  id: Scalars['ID'];
};


export type G_QueryVideoCampaignsArgs = {
  categoryId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QueryVideoContentArgs = {
  id: Scalars['ID'];
};


export type G_QueryVideoPpvProductArgs = {
  id: Scalars['ID'];
};


export type G_QueryVideoRankingsArgs = {
  device: G_Device;
  term: G_VideoRankingTerm;
  rankingType?: Maybe<G_VideoRankingType>;
  category?: Maybe<Scalars['ID']>;
  genre?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type G_QuerySearchVideosArgs = {
  device: G_Device;
  keyword?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Scalars['ID']>>;
  genres?: Maybe<Array<Scalars['ID']>>;
  casts?: Maybe<Array<Scalars['ID']>>;
  staffs?: Maybe<Array<Scalars['ID']>>;
  series?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  viewingTypes?: Maybe<Array<G_VideoViewingType>>;
  campaigns?: Maybe<Array<Scalars['ID']>>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

/** ユーザーイベントタイプ */
export enum G_RecommendationEventType {
  /**  home-page-view（トップページでの使用を想定）  */
  HomePageView = 'HOME_PAGE_VIEW',
  /**  detail-page-view（末端での使用を想定）  */
  DetailPageView = 'DETAIL_PAGE_VIEW',
  /**  purchase-complete（プレイヤーでの使用を想定）  */
  PurchaseComplete = 'PURCHASE_COMPLETE',
  /**  search（検索での使用を想定）  */
  Search = 'SEARCH',
  /**  category-page-view（作品一覧での使用を想定）  */
  CategoryPageView = 'CATEGORY_PAGE_VIEW'
}

/** レコメンデーションメソッド */
export enum G_RecommendationMethod {
  /**  関連商品の推薦  */
  RelatedItems = 'RELATED_ITEMS',
  /**  ユーザへの推薦  */
  UserBased = 'USER_BASED'
}

/** おすすめビデオ */
export type G_RecommendedVideo = {
  /**  シーズンID  */
  seasonId: Scalars['ID'];
  /**  おすすめビデオ  */
  video: G_Video;
};

export type G_RecommendedVideoConnection = G_Connection & {
  edges: Array<G_RecommendedVideoEdge>;
  /**  トラッキングID  */
  trackingId: Scalars['ID'];
  /**  テストID  */
  testId: Scalars['ID'];
  /**  リクエストID  */
  requestId: Scalars['ID'];
  /**  レコメンドエンジンのアルゴリズムID  */
  recInfo: Scalars['ID'];
  /** @deprecated スキーマ定義時のミスでページネーションではないにも関わらず定義してしまったので、deprecatedにする */
  pageInfo: G_PageInfo;
};

export type G_RecommendedVideoEdge = G_Edge & {
  /** @deprecated スキーマ定義時のミスでページネーションではないにも関わらず定義してしまったので、deprecatedにする */
  cursor: Scalars['String'];
  node: G_RecommendedVideoItem;
};

/** おすすめビデオ */
export type G_RecommendedVideoItem = G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  おすすめビデオ  */
  video: G_Video;
};

export type G_RegisterPushNotificationConfigInput = {
  /**
   * Firebase installation id
   *
   * See https://firebase.google.com/docs/projects/manage-installations#retrieve_client_identifiers
   */
  firebaseInstallationId: Scalars['String'];
  /**
   * Firebase messageのtoken
   *
   * See https://firebase.google.com/docs/cloud-messaging/manage-tokens
   */
  firebaseMessagingToken: Scalars['String'];
  /**  おすすめ情報の通知を受け取るか  */
  subscribePromotion: Scalars['Boolean'];
  /**  DMM TVの配信通知を受け取るか  */
  subscribeReminderProgramOrEpisode: Scalars['Boolean'];
  /**  DMMブックスの配信通知を受け取るか  */
  subscribeReminderBooksNewArrival: Scalars['Boolean'];
  /**  DMMブックスの毎日¥0スタミナ回復通知を受け取るか  */
  subscribeReminderBooksStaminaRecovered: Scalars['Boolean'];
};

export type G_RegisterPushNotificationConfigPayload = G_Payload & {
  /** @deprecated Payloadレスポンスの方針変更 */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/**  関連ブックス  */
export type G_RelatedBook = {
  /**  シリーズID  */
  seriesId: Scalars['ID'];
  /**  作品名  */
  title: Scalars['String'];
  /**  サムネイル画像  */
  thumbnail: Scalars['URI'];
  /**  ブックスサイトへのリンク  */
  url: Scalars['URI'];
};

/**  関連商品リンク  */
export type G_RelatedItemLink = {
  /**  バナー画像  */
  banner: Scalars['URI'];
  /**  商品へのリンク  */
  url: Scalars['URI'];
};

/**  関連商品  */
export type G_RelatedItems = {
  /**  DMM TV  */
  videos: Array<G_RelatedVideo>;
  /**  DMMブックス  */
  books: Array<G_RelatedBook>;
  /**  DMM通販  */
  mono?: Maybe<G_RelatedItemLink>;
  /**  DMMスクラッチ  */
  scratch?: Maybe<G_RelatedItemLink>;
  /**  DMMオンクレ  */
  onlineCrane?: Maybe<G_RelatedItemLink>;
};

/**  関連ビデオ  */
export type G_RelatedVideo = {
  /**  シーズンID  */
  seasonId: Scalars['ID'];
  /**  ビデオ詳細  */
  video: G_Video;
};

export type G_ReportInappropriateCommentInput = {
  /**  コメントID  */
  commentId: Scalars['ID'];
  /**  通報理由  */
  reason: G_CommentInappropriateReason;
};

export type G_ReportInappropriateCommentPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/**  作品レビューコメント情報  */
export type G_Review = G_Node & {
  /**  レビューID  */
  id: Scalars['ID'];
  /**  レビュアー名  */
  reviewerName: Scalars['String'];
  /**  レビュアーID  */
  reviewerId: Scalars['ID'];
  /**  レビュータイトル  */
  title?: Maybe<Scalars['String']>;
  /**  レビュー値(星の数)  */
  point: Scalars['Int'];
  /**  ネタバレ有無  */
  hasSpoiler: Scalars['Boolean'];
  /**  投稿内容  */
  comment?: Maybe<Scalars['String']>;
  /**  レビュー投稿日  */
  date: Scalars['Date'];
  /**  投稿評価人数  */
  postEvaluationCount: Scalars['Int'];
  /**  役に立ったと評価した人数  */
  helpfulVoteCount: Scalars['Int'];
  /**  レビュアーがレビュー対象作品を購入したかどうか  */
  isReviewerPurchased: Scalars['Boolean'];
};

export type G_ReviewConnection = G_Connection & {
  edges: Array<G_ReviewEdge>;
  pageInfo: G_PageInfo;
  total: Scalars['Int'];
};

export type G_ReviewEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_Review;
};

/**
 * レビューステータス
 * See https://confl.arms.dmm.com/pages/viewpage.action?pageId=1015657224
 */
export enum G_ReviewStatus {
  /**  投稿済み かつ 承認済み  */
  Published = 'PUBLISHED',
  /**  投稿済み だが 承認待ち  */
  Confirming = 'CONFIRMING',
  /**  指定コンテンツと相互リンク関係にあるコンテンツの方で既にレビュー投稿済み  */
  Relation = 'RELATION',
  /**  未投稿  */
  None = 'NONE'
}

/**  レビューサマリー  */
export type G_ReviewSummary = {
  /**  レビューの平均点数  */
  averagePoint: Scalars['Float'];
  /**  レビュー者数  */
  reviewerCount: Scalars['Int'];
  /**  レビューコメント数  */
  reviewCommentCount: Scalars['Int'];
};

export type G_Reviewer = {
  /**  reviewerId  */
  id?: Maybe<Scalars['ID']>;
  /**
   * ニックネーム
   * 動画/電書などDMM全体で共通で使用するニックネーム(親アカウントのみ持つ値)
   * この値がnullの場合、レビュー投稿は初回投稿とみなし、ニックネーム入力フォームが表示される
   * この値が存在する場合、ニックネームは入力済みとみなし入力フォームは非表示とする
   */
  nickname?: Maybe<Scalars['String']>;
  /**  ビデオ作品の投稿済みレビュー  */
  postedVideoReview: G_Review;
  /**  ビデオ作品のレビューステータス  */
  videoReviewStatus: G_ReviewStatus;
  /**  ブックス作品の投稿済みレビュー  */
  postedBookReview: G_Review;
  /**  ブックス作品のレビューステータス  */
  bookReviewStatus: G_ReviewStatus;
};


export type G_ReviewerPostedVideoReviewArgs = {
  seasonId: Scalars['ID'];
};


export type G_ReviewerVideoReviewStatusArgs = {
  seasonId: Scalars['ID'];
};


export type G_ReviewerPostedBookReviewArgs = {
  contentId: Scalars['ID'];
};


export type G_ReviewerBookReviewStatusArgs = {
  contentId: Scalars['ID'];
};

export enum G_Role {
  /**  ゲストでもアクセス可能だがログイン済み/プロフィール選択済みであればユーザーに関連する情報が返される  */
  All = 'ALL',
  /**  ログインユーザーのみアクセス可能  */
  User = 'USER',
  /**  プロフィール選択済みの場合のみアクセス可能  */
  Profile = 'PROFILE'
}

/** サンプル動画(サムネイルも追加予定) */
export type G_SampleMovie = {
  /** サンプル動画URL */
  url: Scalars['URI'];
  /** サンプル動画扉絵のURL */
  thumbnail?: Maybe<Scalars['URI']>;
};

/** セキュリティーコード関連の設定 */
export type G_SecurityCodeSettings = {
  /**  セキュリティーコードを設定しているかどうか  */
  hasSecurityCode: Scalars['Boolean'];
};

export type G_SelectProfileInput = {
  /**  ProfileID  */
  profileId: Scalars['ID'];
  /**  セキュリティコード  */
  securityCode?: Maybe<Scalars['String']>;
};

export type G_SelectProfilePayload = G_Payload & {
  /**
   *  プロフィール選択に成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  プロフィール情報(セキュリティコード不一致の場合はnull)  */
  profile?: Maybe<G_Profile>;
};

export type G_SendBytePlusUserEventInput = {
  /**  イベントタイプ  */
  eventType: G_BytePlusEventType;
  /**  イベント発生時のUNIXタイムスタンプ  */
  eventTimestamp: Scalars['Int'];
  /**  各種パラメータ(json)  */
  parameters: Scalars['String'];
};

export type G_SendBytePlusUserEventPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/** サービスの視聴プラン */
export enum G_ServicePlan {
  /**  フリープラン  */
  Free = 'FREE',
  /**  プレミアムプラン  */
  Premium = 'PREMIUM'
}

export type G_SetAkb48ResumePointInput = {
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  レジュームポイント(秒)  */
  resumePoint: Scalars['Int'];
};

export type G_SetAkb48ResumePointPayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_SetFanzaResumePointInput = {
  /**  利用デバイス  */
  device: G_Device;
  /**  ショップタイプ  */
  shopType: G_FanzaShopType;
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  パート番号  */
  partNumber: Scalars['Int'];
  /**  レジュームポイント(秒)  */
  resumePoint: Scalars['Int'];
};

export type G_SetFanzaResumePointPayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/** 棚 */
export type G_Shelf = G_ShelfOfContinueWatching | G_ShelfOfBookmarkedVideos | G_ShelfOfVideoRankings | G_ShelfOfRecommendedVideos | G_ShelfOfPresetVideos | G_ShelfOfPresetContents | G_ShelfOfFreeItems | G_ShelfOfPlayHistoryRecommendedVideos;

export type G_ShelfConnection = {
  edges: Array<G_ShelfEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_ShelfEdge = {
  cursor: Scalars['String'];
  node: G_Shelf;
};

export type G_ShelfInterface = {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
};

/** お気に入りビデオ棚 */
export type G_ShelfOfBookmarkedVideos = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  お気に入りビデオ  */
  bookmarkedVideos: G_VideoBookmarkConnection;
};


/** お気に入りビデオ棚 */
export type G_ShelfOfBookmarkedVideosBookmarkedVideosArgs = {
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** 続き気から見る棚 */
export type G_ShelfOfContinueWatching = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  カテゴリID  */
  categoryId?: Maybe<Scalars['ID']>;
  /**  続きから見る  */
  continueWatching: G_VideoContinueWatchingConnection;
};


/** 続き気から見る棚 */
export type G_ShelfOfContinueWatchingContinueWatchingArgs = {
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** フリーアイテム棚 */
export type G_ShelfOfFreeItems = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚タイトル  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  棚内の全てのフリーアイテム  */
  allFreeItems: Array<G_FreeItem>;
  /**  フリーアイテム  */
  freeItems: G_FreeItemConnection;
  /**  正方形/横長  */
  freeItemType: G_FreeItemType;
};


/** フリーアイテム棚 */
export type G_ShelfOfFreeItemsFreeItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type G_ShelfOfPlayHistoryRecommendedVideos = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  シーズンID  */
  seasonIds: Array<Scalars['ID']>;
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  GTMで送るためのTrackindId  */
  trackingId: Scalars['String'];
};


export type G_ShelfOfPlayHistoryRecommendedVideosRecommendedVideosArgs = {
  limit?: Maybe<Scalars['Int']>;
};

/** エピソード棚 */
export type G_ShelfOfPresetContents = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  棚に登録されているコンテンツID  */
  presetContentIds: Array<Scalars['ID']>;
  /**  コンテンツ  */
  presetContents: G_PresetContentConnection;
};


/** エピソード棚 */
export type G_ShelfOfPresetContentsPresetContentsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** ビデオ(シーズン)棚 */
export type G_ShelfOfPresetVideos = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  画像の種類  */
  imageType: G_VideoShelfImageType;
  /**  棚に登録されているシーズンID  */
  presetSeasonIds: Array<Scalars['ID']>;
  /**  ビデオ  */
  presetVideos: G_PresetVideoConnection;
};


/** ビデオ(シーズン)棚 */
export type G_ShelfOfPresetVideosPresetVideosArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** おすすめ(u2iレコメンド)ビデオ棚 */
export type G_ShelfOfRecommendedVideos = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**
   *  カテゴリID
   * @deprecated レコメンド棚のカテゴリ指定はローンチ時非対応
   */
  categoryId?: Maybe<Scalars['ID']>;
  /**  おすすめビデオ  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  u2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** おすすめ(u2iレコメンド)ビデオ棚 */
export type G_ShelfOfRecommendedVideosRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};


/** おすすめ(u2iレコメンド)ビデオ棚 */
export type G_ShelfOfRecommendedVideosU2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  searchQuery?: Maybe<Scalars['String']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

/** ビデオランキング棚 */
export type G_ShelfOfVideoRankings = G_Node & G_ShelfInterface & {
  /**  棚ID  */
  id: Scalars['ID'];
  /**  棚名  */
  name: Scalars['String'];
  /**  利用デバイス  */
  device: G_Device;
  /**  ランキング種別  */
  rankingType: G_VideoRankingType;
  /**  ランキング集計期間  */
  rankingTerm: G_VideoRankingTerm;
  /**  カテゴリID  */
  categoryId?: Maybe<Scalars['ID']>;
  /**  ジャンルID  */
  genreId?: Maybe<Scalars['ID']>;
  /**  ランキング  */
  videoRankings: G_VideoRankingConnection;
};


/** ビデオランキング棚 */
export type G_ShelfOfVideoRankingsVideoRankingsArgs = {
  contentType?: Maybe<G_VideoContentTypeFilter>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/** SNSシェア情報 */
export type G_SocialSharingInfo = {
  text: Scalars['String'];
  url: Scalars['URI'];
};

/** スタッフ */
export type G_Staff = {
  /** @deprecated Use `Person.ID`. */
  id: Scalars['ID'];
  /**  役職  */
  roleName: Scalars['String'];
  /**  スタッフ名  */
  staffName: Scalars['String'];
  /**  表示優先順位  */
  priority: Scalars['Int'];
  /**  人物  */
  person: G_Person;
};

/** 再生する動画情報 */
export type G_Stream = {
  /** sd/hd/4kなど */
  qualities: Array<G_Quality>;
  /** 字幕の種類(ソフトサブかハードサブ) */
  textRenditionType: G_TextRenditionType;
  /** 使用されている言語と表示名の対応付け */
  languages: Array<G_Language>;
  /** エンコードされた動画情報のリスト */
  videoRenditions: Array<G_VideoRendition>;
  /** 音声情報のリスト */
  audioRenditions: Array<G_AudioRendition>;
  /** 字幕情報のリスト */
  textRenditions: Array<G_TextRendition>;
  /** チャプター情報 */
  chapter?: Maybe<G_Chapter>;
  /** 再生されようとしている視聴権利とコンテンツの種類 */
  contentTypeDetail: G_ContentTypeDetail;
  /**
   * 最大再生可能日時
   * この日時に達したストリームキャッシュは、デバイスから削除されなければならない
   */
  streamCacheExpiration?: Maybe<Scalars['DateTime']>;
  /** 購入済みプロダクトID */
  purchasedProductId?: Maybe<Scalars['ID']>;
};

/** 利用できるオーディオチャンネルレイアウト */
export enum G_StreamingAudioChannelLayout {
  /** 2ch (L R) */
  Stereo = 'STEREO',
  /** 5.1ch (C L R Ls Rs Lfe)   */
  Mpeg_5_1D = 'MPEG_5_1_D'
}

/** ストリーミングにおける音声コーデック */
export enum G_StreamingAudioCodec {
  /** AAC */
  Aac = 'AAC',
  /** AC-3 */
  Ac_3 = 'AC_3'
}

/** ストリーミングフォーマット */
export enum G_StreamingFormat {
  Dash = 'DASH',
  Hls = 'HLS',
  Smooth = 'SMOOTH'
}

/** ストリーミング用URL */
export type G_StreamingUrl = {
  /**
   * SystemID
   * DASH-IFによって定められたコンテンツ保護に関する識別子(ID)
   */
  systemIds: Array<Scalars['ID']>;
  /** ビデオコーデック */
  videoCodec: G_StreamingVideoCodec;
  /** ストリーミングフォーマット */
  format: G_StreamingFormat;
  /**
   * 色空間
   * (8ならSDR, 10ならHDR)
   */
  bpc: Scalars['Int'];
  /** ストリームの最高画質時の総容量 (Bytes) (ABR内の最上位画質の容量が入る) */
  streamSize: Scalars['Float'];
  /** 再生URL (クライアントサイドフェイルオーバーを考慮) (優先度順) */
  urls: Array<Scalars['String']>;
  /**  HDCPの対応有無(対応しているバージョン)  */
  hdcp: G_Hdcp;
};

/** ストリーミングにおける映像コーデック */
export enum G_StreamingVideoCodec {
  /** AVC (H.264) */
  Avc = 'AVC',
  /** VP9 */
  Vp9 = 'VP9',
  /** HEVC (H.265) */
  Hevc = 'HEVC',
  /** AV1 */
  Av1 = 'AV1'
}

/**  月額入会エラー  */
export enum G_SubscribeError {
  /**  加入済み  */
  AlreadySubscribed = 'ALREADY_SUBSCRIBED',
  /**  クレジットカード未登録(支払い方法にクレジットカードを選択した場合のみ)  */
  CreditCardNotRegistered = 'CREDIT_CARD_NOT_REGISTERED',
  /**  購入処理に失敗  */
  FailedToPurchase = 'FAILED_TO_PURCHASE',
  /**  DMMプレミアム未加入  */
  PremiumNotSubscribed = 'PREMIUM_NOT_SUBSCRIBED',
  /**  加入処理中  */
  Processing = 'PROCESSING',
  /**  レシート不備  */
  InvalidReceipt = 'INVALID_RECEIPT',
  /**  レシート検証失敗  */
  ReceiptVerification = 'RECEIPT_VERIFICATION',
  /**  その他のエラー  */
  Internal = 'INTERNAL'
}

export type G_SubscribeFanzaTvPlusInput = {
  /**  デバイス  */
  device: G_Device;
  /**  支払い方法  */
  paymentType: G_FanzaTvPlusPaymentType;
};

export type G_SubscribeFanzaTvPlusPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_SubscribeError>;
  /**  サービス提供終了日(成功時のみ)  */
  provideEndDate?: Maybe<Scalars['DateTime']>;
  /**  次回契約更新日(成功時のみ)  */
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  /**  支払い方法(成功時のみ)  */
  paymentType?: Maybe<G_FanzaTvPlusPaymentType>;
  /**  注文ID  */
  orderId: Scalars['String'];
};

export type G_SubscribeForFireOsInput = {
  /**  月額プランID  */
  planId: G_SubscriptionPlanId;
  /**  レシートID  */
  receiptId: Scalars['ID'];
  /**  AmazonのユーザーID  */
  amazonUserId: Scalars['ID'];
};

export type G_SubscribeForFireOsPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  エラー詳細  */
  error?: Maybe<G_SubscribeError>;
  /**  サービス提供終了日(成功時のみ)  */
  provideEndDate?: Maybe<Scalars['DateTime']>;
  /**  次回契約更新日(成功時のみ)  */
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  /**  注文ID  */
  orderId: Scalars['String'];
};

export type G_SubscribeMailMagazineInput = {
  /**  購読するメルマガ  */
  ids: Array<G_MailMagazineId>;
};

export type G_SubscribeMailMagazinePayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/**  月額支払い方法  */
export enum G_SubscriptionPaymentType {
  /**  クレジットカード  */
  Credit = 'CREDIT',
  /**  DMMポイント  */
  DmmPoint = 'DMM_POINT',
  /**  ドコモキャリア決済  */
  Docomo = 'DOCOMO',
  /**  auキャリア決済  */
  Au = 'AU',
  /**  ソフトバンクキャリア決済  */
  Softbank = 'SOFTBANK',
  /**  Appleアプリ内課金  */
  Apple = 'APPLE',
  /**  Googleアプリ内課金  */
  Google = 'GOOGLE'
}

/** 月額プラン */
export type G_SubscriptionPlan = {
  /**  プラン名  */
  name: Scalars['String'];
  /**  価格(税込)  */
  price: Scalars['Int'];
  /**  価格(税抜)  */
  priceWithoutTax: Scalars['Int'];
  /**  税額  */
  tax: Scalars['Int'];
};

/** 月額プランID */
export enum G_SubscriptionPlanId {
  /**  DMMプレミアム  */
  DmmPremium = 'DMM_PREMIUM',
  /**  FANZA TV Plus */
  FanzaTvPlus = 'FANZA_TV_PLUS'
}

/**
 * 会員ステータス
 * https://confl.arms.dmm.com/pages/viewpage.action?pageId=1003802892
 */
export enum G_SubscriptionStatus {
  /**
   * 入会処理中
   * 入会処理中を表す
   */
  ProcessingSubscribe = 'PROCESSING_SUBSCRIBE',
  /**
   * 課金処理中
   * 課金処理中を表す
   */
  Processing = 'PROCESSING',
  /**
   * 無料トライアル
   * 無料トライアルとして加入している状態を表す
   */
  Trial = 'TRIAL',
  /**
   * 加入中（有料）
   * 加入している状態を表す
   */
  Subscribe = 'SUBSCRIBE',
  /**
   * 解約手続き中
   * 退会APIによって退会処理を行ったが、サービス提供終了日まではサービスが使える状態を表す
   */
  WaitingUnsubscribe = 'WAITING_UNSUBSCRIBE',
  /** 退会済または未入会 */
  Unsubscribe = 'UNSUBSCRIBE',
  /**
   * 処理の取消
   * 入会処理をキャンセルした状態を表すステータス
   * 主に処理中に障害が発生し、入会処理を中断した場合に設定するもの
   */
  Cancel = 'CANCEL'
}

/**  アンケートの回答  */
export type G_SurveyAnswer = {
  /**  質問番号  */
  Number: Scalars['Int'];
  /**  回答種別  */
  Type: G_SurveyAnswerType;
  /**  回答結果  */
  Answers: Array<Scalars['String']>;
};

/**  アンケート回答種別  */
export enum G_SurveyAnswerType {
  /**  単一選択の回答  */
  SingleChoice = 'SINGLE_CHOICE',
  /**  複数選択の回答  */
  MultipleChoice = 'MULTIPLE_CHOICE',
  /**  自由入力の回答  */
  FreeInput = 'FREE_INPUT'
}

/**  利用規約  */
export type G_Terms = {
  /**  規約ID  */
  id: Scalars['ID'];
  /**  規約名  */
  title: Scalars['String'];
  /**  規約内容  */
  body: Scalars['String'];
  /**  Hash化した規約内容  */
  hashedBody?: Maybe<Scalars['String']>;
};

/**
 * 利用規約ID
 * See https://terms.dmm.com/
 */
export enum G_TermsId {
  /**  DMMプレミアム規約 */
  Premium = 'PREMIUM',
  /**  プライバシーポリシー（プレミアム） */
  PrivacyPremium = 'PRIVACY_PREMIUM',
  /**  特商法表記 （プレミアム） */
  CommercePremium = 'COMMERCE_PREMIUM',
  /**  DMM TV規約  */
  Dmmtv = 'DMMTV',
  /**  プライバシーポリシー（TV） */
  PrivacyDmmtv = 'PRIVACY_DMMTV',
  /**  特商法表記 TV  */
  CommerceDmmtv = 'COMMERCE_DMMTV',
  /**  資金決済法に基づく表示(TV)  */
  FundSettlementDmmtv = 'FUND_SETTLEMENT_DMMTV',
  /**  DMM会員規約  */
  Member = 'MEMBER',
  /**  個人情報保護に関して  */
  Privacy = 'PRIVACY',
  /**  資金決済法に基づく表示  */
  FundSettlement = 'FUND_SETTLEMENT',
  /**  特定商取引法に基づく表示  */
  Commerce = 'COMMERCE',
  /**  DMMポイント利用規約  */
  Dmmpoint = 'DMMPOINT',
  /**  デジタルコンテンツ利用規約  */
  DigitalService = 'DIGITAL_SERVICE',
  /**  特定商取引法に基づく表示（見放題chライト） */
  CommerceMonthlyPrimeDcm = 'COMMERCE_MONTHLY_PRIME_DCM',
  /**  レビュー利用規約  */
  ReviewService = 'REVIEW_SERVICE',
  /**  コメント投稿利用規約  */
  CommentService = 'COMMENT_SERVICE',
  /**  グッズ付きPPVコンテンツ利用規約  */
  DmmtvGoodsExplanation = 'DMMTV_GOODS_EXPLANATION',
  /**  グッズ付きPPVコンテンツ利用規約  */
  DmmtvGoodsAnnouncement = 'DMMTV_GOODS_ANNOUNCEMENT'
}

export enum G_TextFormat {
  Plain = 'PLAIN',
  Html = 'HTML'
}

/** 字幕情報 */
export type G_TextRendition = {
  /** RFC5646 言語タグ (ja, en-US, ja-JP-x-1, etc...) */
  lang: Scalars['String'];
};

/** 字幕の付けられ方の種類 */
export enum G_TextRenditionType {
  /** ハードサブ */
  HardSub = 'HARD_SUB',
  /** ソフトサブ */
  SoftSub = 'SOFT_SUB',
  /** 字幕なし */
  None = 'NONE'
}

/**  TVコイン商品  */
export type G_TvCoinProduct = {
  /**  プロダクトID(SKU)  */
  id: Scalars['ID'];
  /**  発行コイン数  */
  coin: Scalars['Int'];
};


/** URLへ遷移するフリーアイテム */
export type G_UrlFreeItem = {
  /**  フリーアイテムID  */
  id: Scalars['ID'];
  /**  画像  */
  image: Scalars['URI'];
  name: Scalars['String'];
  url: Scalars['URI'];
  /** @deprecated BFF内部で計算済み */
  isHiddenForPremiumMember: Scalars['Boolean'];
};

/**  月額退会エラー  */
export enum G_UnsubscribeError {
  /**  退会済み(または未入会)  */
  AlreadyUnsubscribed = 'ALREADY_UNSUBSCRIBED',
  /**  入会手続き中  */
  SubscriptionInProcess = 'SUBSCRIPTION_IN_PROCESS',
  /**  退会手続き中  */
  UnsubscriptionInProcess = 'UNSUBSCRIPTION_IN_PROCESS',
  /**  その他のエラー  */
  Internal = 'INTERNAL'
}

export type G_UnsubscribeFanzaTvPlusInput = {
  /**  退会アンケート  */
  unsubscribeSurvey: Array<G_SurveyAnswer>;
};

export type G_UnsubscribeFanzaTvPlusPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  サービス提供終了日(成功時のみ)  */
  provideEndDate?: Maybe<Scalars['DateTime']>;
  /**  エラー詳細  */
  error?: Maybe<G_UnsubscribeError>;
};

export type G_UpdateFanzaPpvHeartMarkByContentIdInput = {
  /**  ショップ  */
  shop: G_FanzaPpvShop;
  /**  コンテンツID  */
  contentId: Scalars['ID'];
};

export type G_UpdateFanzaPpvHeartMarkInput = {
  /**  マイライブラリID  */
  myLibraryId: Scalars['Int'];
  /**  プロダクトID  */
  productId: Scalars['ID'];
};

export type G_UpdateFanzaPpvHeartMarkPayload = G_Payload & {
  /**
   *  処理が成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  ハートがついているか  */
  hasHeartMark: Scalars['Boolean'];
};

export type G_UpdateHomeSettingsInput = {
  /**
   * 起動時の画面
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  initialScreen?: Maybe<G_InitialScreen>;
  /**
   * プレビュー再生時に音声を流すかどうか
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  enablePreviewSound?: Maybe<Scalars['Boolean']>;
};

export type G_UpdateHomeSettingsPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

export type G_UpdateProfileInput = {
  /**  子のProfileID 親が子のプロフィールを編集する際に使用する  */
  profileId: Scalars['ID'];
  /**  プロフィール名  */
  name?: Maybe<Scalars['String']>;
  /**  プロフィールアイコンID  */
  profileIconId?: Maybe<Scalars['ID']>;
  /**  視聴レーティング制限  */
  viewableRating?: Maybe<G_ViewableRating>;
  /**  購入制限  */
  canPurchase?: Maybe<Scalars['Boolean']>;
  /**  セキュリティコード  */
  securityCode?: Maybe<Scalars['String']>;
  /**
   * 起動時の画面
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  initialScreen?: Maybe<G_InitialScreen>;
  /**
   * プレビュー再生時に音声を流すかどうか
   * 対象: TV APPデバイス（PS4/PS5/AmazonFireTV/AndroidTV/HTML5TV）
   */
  enablePreviewSound?: Maybe<Scalars['Boolean']>;
};

export type G_UpdateProfilePayload = G_Payload & {
  /**
   *  成功したかどうか
   * @deprecated Payloadレスポンスの方針変更
   */
  succeeded: Scalars['Boolean'];
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
  /**  プロフィール情報  */
  profile?: Maybe<G_Profile>;
};

export type G_UpdateVrHomeSettingsInput = {
  /**  VRデバイス(PSVR/PSVR2)起動時の画面  */
  initialScreen?: Maybe<G_VrInitialScreen>;
};

export type G_UpdateVrHomeSettingsPayload = G_Payload & {
  /**  ミューテーションID  */
  mutationId: Scalars['String'];
};

/** ログインユーザー */
export type G_User = {
  /**  userID  */
  id: Scalars['ID'];
  /**  プランの状態  */
  planStatus: G_PlanStatus;
  /**  メールアドレス  */
  mail: Scalars['String'];
  /**  プロフィール一覧  */
  profiles: Array<G_Profile>;
  /**  プロフィールアイコン一覧を取得する  */
  profileIcons: Array<G_ProfileIcon>;
  /**  プロフィール  */
  profile: G_Profile;
  /**  レビュワー  */
  reviewer: G_Reviewer;
  /**  レビュワー名が利用可能か  */
  isAvailableReviewerName: Scalars['Boolean'];
  /**  決済に関する情報(DMMポイント, TVコインの残高, クレジットカード情報など) */
  wallet: G_Wallet;
  /**  ハッシュ化されたユーザーID  */
  hashedId: Scalars['String'];
  /**
   * 初回購読可能か
   * 対象プランに初回購読可能な場合、trueを返す
   *
   * amazonUserId: Amazon IAPで入会するユーザーのID
   */
  isFirstSubscribe: Scalars['Boolean'];
  /**  アフィリエイトオーナーかどうか  */
  isAffiliateOwner: Scalars['Boolean'];
  /**  AKB48入会中チャンネルリスト  */
  akb48SubscribedChannels: Array<G_Akb48Channel>;
  /**  AKB48入会中チャンネル  */
  akb48SubscribedChannel?: Maybe<G_Akb48Channel>;
  /**  AKB48 LIVE!! ON DEMAND 購入済み作品リスト  */
  akb48LODPurchasedContents: G_Akb48PurchasedContentConnection;
  /**  AKB48 LIVE!! ON DEMAND 購入済み作品  */
  akb48LODPurchasedContent: G_Akb48Content;
  /**  FANZA月額プランの状態  */
  fanzaPlanStatus: G_FanzaPlanStatus;
  /**  FANZA動画初回購入クーポン獲得可否フラグ  */
  canAcquireFanzaPPVWelcomeCoupon: Scalars['Boolean'];
  /**  FANZA動画 マイライブラリ  */
  fanzaPPVLibrary: G_FanzaPpvLibrary;
  /**  FANZA動画 ブックマークリスト  */
  fanzaPPVBookmarks: G_FanzaPpvBookmarkConnection;
  /**  Offset版お気に入り(ログインユーザーのみ)  */
  fanzaPPVBookmarksWithOffset: G_FanzaPpvBookmarksWithOffset;
  /**  FANZA動画 購入済み視聴履歴  */
  fanzaPPVPlayHistories: G_FanzaPpvPlayHistoriesConnection;
  /**  FANZA動画条件付きブックマークリスト ゲーム機販売許諾あり商品30件返す  */
  fanzaPPVBookmarksWithSaleGameDevice: G_FanzaPpvBookmarkConnection;
  /**  入会中のFANZA月額チャンネル一覧  */
  fanzaSubscribedChannels: Array<G_FanzaSvodChannel>;
  /**  FANZA月額チャンネル  */
  fanzaSubscribedChannel?: Maybe<G_FanzaSvodChannel>;
  /**  メルマガ購読ステータス  */
  mailMagazineSubscriptionStatus: Array<G_MailMagazineSubscriptionStatus>;
};


/** ログインユーザー */
export type G_UserProfileArgs = {
  profileId: Scalars['ID'];
};


/** ログインユーザー */
export type G_UserIsAvailableReviewerNameArgs = {
  nickname: Scalars['String'];
};


/** ログインユーザー */
export type G_UserIsFirstSubscribeArgs = {
  planId: G_SubscriptionPlanId;
  amazonUserId?: Maybe<Scalars['String']>;
};


/** ログインユーザー */
export type G_UserAkb48SubscribedChannelArgs = {
  shopName: Scalars['String'];
};


/** ログインユーザー */
export type G_UserAkb48LodPurchasedContentsArgs = {
  device: G_Device;
  sort?: Maybe<G_Akb48PurchasedContentsSortOrder>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** ログインユーザー */
export type G_UserAkb48LodPurchasedContentArgs = {
  myLibraryId: Scalars['ID'];
};


/** ログインユーザー */
export type G_UserFanzaPlanStatusArgs = {
  plan: G_FanzaSubscriptionPlan;
  disableCache?: Maybe<Scalars['Boolean']>;
};


/** ログインユーザー */
export type G_UserFanzaPpvBookmarksArgs = {
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** ログインユーザー */
export type G_UserFanzaPpvBookmarksWithOffsetArgs = {
  device: G_Device;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** ログインユーザー */
export type G_UserFanzaPpvPlayHistoriesArgs = {
  device: G_Device;
  contentType?: Maybe<G_FanzaContentType>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** ログインユーザー */
export type G_UserFanzaPpvBookmarksWithSaleGameDeviceArgs = {
  device: G_Device;
};


/** ログインユーザー */
export type G_UserFanzaSubscribedChannelsArgs = {
  device: G_Device;
  contentType?: Maybe<G_FanzaContentType>;
};


/** ログインユーザー */
export type G_UserFanzaSubscribedChannelArgs = {
  device: G_Device;
  shopName: Scalars['String'];
  shopOption?: Maybe<Scalars['String']>;
};


/** ログインユーザー */
export type G_UserMailMagazineSubscriptionStatusArgs = {
  ids: Array<G_MailMagazineId>;
};

/** VRデバイスホーム設定 */
export type G_VrHomeSettings = {
  /**  VRデバイス(PSVR/PSVR2)起動時の画面  */
  initialScreen: G_VrInitialScreen;
};

/** VRデバイス(PSVR/PSVR2)起動時のホーム画面設定 */
export enum G_VrInitialScreen {
  /**  ホーム  */
  DmmHome = 'DMM_HOME',
  /**  ビデオ  */
  DmmVideo = 'DMM_VIDEO',
  /**  DMMTV購入済み  */
  DmmPurchased = 'DMM_PURCHASED',
  /**  FANZA TV ※FANZA TV側でのみ設定可能  */
  FanzaTv = 'FANZA_TV',
  /**  FANZA購入済み ※FANZA TV側でのみ設定可能  */
  FanzaPurchased = 'FANZA_PURCHASED'
}

/** ビデオ作品詳細 */
export type G_Video = {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  タイトルID  */
  titleId: Scalars['ID'];
  /**  作品名  */
  titleName: Scalars['String'];
  /**  作品名(ふりがな)  */
  titleNameRuby: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  シーズン名(ふりがな)  */
  seasonNameRuby: Scalars['String'];
  /**  見どころ  */
  highlight?: Maybe<Scalars['String']>;
  /**  説明  */
  description: Scalars['String'];
  /**  注釈  */
  notices?: Maybe<Array<Scalars['String']>>;
  /**  制作年  */
  productionYear?: Maybe<Scalars['Int']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  レーティング  */
  rating: G_VideoRating;
  /**  コピーライト  */
  copyright: Scalars['String'];
  /**  キャスト  */
  casts: Array<G_Cast>;
  /**  スタッフ  */
  staffs: Array<G_Staff>;
  /**  カテゴリ  */
  categories: Array<G_VideoCategory>;
  /**  ジャンル  */
  genres: Array<G_VideoGenre>;
  /**  ブックマークをしているか(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  作品詳細URL  */
  url: Scalars['URI'];
  /**  公開中フラグ  */
  isPublic: Scalars['Boolean'];
  /**
   * 販売中フラグ
   *
   * PPVのみ取り扱いがあるシーズンですべてのコンテンツが販売終了している場合にtrueを返す
   */
  isOnSale: Scalars['Boolean'];
  /** カスタムシーズンタグ */
  customTag?: Maybe<Scalars['String']>;
  /**  おすすめのビデオ作品  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  i2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** ビデオ作品詳細 */
export type G_VideoHighlightArgs = {
  format?: Maybe<G_TextFormat>;
};


/** ビデオ作品詳細 */
export type G_VideoDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/** ビデオ作品詳細 */
export type G_VideoNoticesArgs = {
  format?: Maybe<G_TextFormat>;
};


/** ビデオ作品詳細 */
export type G_VideoRelatedItemsArgs = {
  device: G_Device;
};


/** ビデオ作品詳細 */
export type G_VideoRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  categoryId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};


/** ビデオ作品詳細 */
export type G_VideoI2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

export enum G_VideoApp {
  /**  Widows VRアプリ  */
  WindowsVr = 'WINDOWS_VR',
  /**  iOS VRアプリ  */
  IosVr = 'IOS_VR',
  /**  Android VRアプリ  */
  AndroidVr = 'ANDROID_VR'
}

/**  動画アプリ起動スキーム  */
export type G_VideoAppUrlScheme = {
  /**  パート番号  */
  partNumber: Scalars['Int'];
  /**  URLスキーム  */
  url: Scalars['URI'];
};

/**  ブックマーク(ビデオ)  */
export type G_VideoBookmark = G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  お気に入り登録日時  */
  createdAt: Scalars['DateTime'];
  /**  ブックマークしたビデオ  */
  video: G_Video;
};

export type G_VideoBookmarkConnection = G_Connection & {
  edges: Array<G_VideoBookmarkEdge>;
  pageInfo: G_PageInfo;
};

export type G_VideoBookmarkEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoBookmark;
};

export type G_VideoCampaign = {
  /**  キャンペーンID  */
  id: Scalars['ID'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  キャンペーン終了日時  */
  endAt: Scalars['DateTime'];
  /**  プレミアム会員限定キャンペーンかどうか  */
  isLimitedPremium: Scalars['Boolean'];
  /**  キャンペーン対象作品  */
  videos: G_VideoSearchResultConnection;
};


export type G_VideoCampaignVideosArgs = {
  device: G_Device;
  categories?: Maybe<Array<Scalars['ID']>>;
  genres?: Maybe<Array<Scalars['ID']>>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

export type G_VideoCampaignConnection = {
  edges: Array<G_VideoCampaignEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_VideoCampaignEdge = {
  cursor: Scalars['String'];
  node: G_VideoCampaign;
};

/** カテゴリ */
export type G_VideoCategory = {
  id: Scalars['ID'];
  name: Scalars['String'];
  /**  カテゴリに紐づくジャンル  */
  genres: Array<G_VideoGenre>;
};

export type G_VideoConnection = {
  edges: Array<G_VideoEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

/** コンテンツ */
export type G_VideoContent = G_Node & {
  /**  コンテンツID  */
  id: Scalars['ID'];
  /**  表示優先順位  */
  priority: Scalars['Int'];
  /**  シーズンID  */
  seasonId: Scalars['ID'];
  /**
   *  ファイルID
   * @deprecated BFF内部で利用
   */
  fileId: Scalars['ID'];
  /**  エピソード種別  */
  episodeType: G_VideoEpisodeType;
  /**  コンテンツ種別(2D/VR)  */
  contentType: G_VideoContentType;
  /**  エピソード画像  */
  episodeImage: Scalars['URI'];
  /**  エピソードタイトル  */
  episodeTitle: Scalars['String'];
  /**  エピソードタイトルふりがな  */
  episodeTitleRuby: Scalars['String'];
  /**  エピソード詳細  */
  episodeDetail: Scalars['String'];
  /**  エピソード番号  */
  episodeNumber: Scalars['Int'];
  /**  エピソード番号表示名  */
  episodeNumberName?: Maybe<Scalars['String']>;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  SVOD商品  */
  svodProduct?: Maybe<G_VideoSvodProduct>;
  /**  PPV商品  */
  ppvProducts: Array<G_VideoPpvProduct>;
  /**  PPV参考価格  */
  priceSummary?: Maybe<G_VideoPriceSummary>;
  /**  無料商品  */
  freeProduct?: Maybe<G_VideoFreeProduct>;
  /**  視聴権利  */
  viewingRights: G_VideoViewingRights;
  /**  PPV視聴期限  */
  ppvExpiration?: Maybe<G_VideoPpvExpiration>;
  /**  コンテンツの許諾上の最高品質。許諾上の制限がない場合はnull  */
  highestQuality?: Maybe<Scalars['String']>;
  /**  再生情報  */
  playInfo: G_VideoPlayInfo;
  /**  視聴率グラフ  */
  heatMap?: Maybe<G_VideoHeatMap>;
  /**  サンプル動画  */
  sampleMovie: Scalars['URI'];
  /**  ライブ公演開始日時 (Live2Dのコンテンツタイプのみセットされる)  */
  startLivePerformanceAt?: Maybe<Scalars['DateTime']>;
  /**  ライブ公演終了日時 (Live2Dのコンテンツタイプのみセットされる)  */
  endLivePerformanceAt?: Maybe<Scalars['DateTime']>;
  /**
   *  イベントワクワク割り対象コンテンツかどうか
   * @deprecated イベントワクワク割は2023/01/31で終了
   */
  isWakuwari: Scalars['Boolean'];
  /**  コメント有効/無効フラグ  */
  isAllowComment: Scalars['Boolean'];
  /**  ダウンロード許諾フラグ  */
  isAllowDownload: Scalars['Boolean'];
  /**
   *  DRM Level
   * @deprecated 内部利用のため
   */
  drmLevelId: Scalars['Int'];
  /**  DRM  */
  drmLevel: G_DrmLevel;
  /**  PSVR専用アプリ起動パラメータ  */
  appStartParamsForPsvr: G_AppStartParamsForPsvr;
  /**
   *  ショップ名
   * @deprecated 内部利用のため
   */
  shopName?: Maybe<Scalars['String']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  ブックマークをしているか(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /** 次回エピソード(シーズン跨ぎ) */
  nextEpisode?: Maybe<G_VideoContent>;
};


/** コンテンツ */
export type G_VideoContentEpisodeDetailArgs = {
  format?: Maybe<G_TextFormat>;
};


/** コンテンツ */
export type G_VideoContentViewingRightsArgs = {
  device: G_PlayDevice;
};


/** コンテンツ */
export type G_VideoContentHeatMapArgs = {
  part?: Maybe<Scalars['Int']>;
};


/** コンテンツ */
export type G_VideoContentAppStartParamsForPsvrArgs = {
  part?: Maybe<Scalars['Int']>;
  quality?: Maybe<G_AppStartParamsForPsvrQuality>;
};

export type G_VideoContentConnection = G_Connection & {
  edges: Array<G_VideoContentEdge>;
  pageInfo: G_PageInfo;
  total: Scalars['Int'];
  allEpisodeNumbers: Array<Scalars['Int']>;
};

export type G_VideoContentEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoContent;
};

/** エピソードへ遷移するフリーアイテム */
export type G_VideoContentFreeItem = {
  /**  フリーアイテムID  */
  id: Scalars['ID'];
  /**  画像  */
  image: Scalars['URI'];
  name: Scalars['String'];
  contentId: Scalars['ID'];
  content: G_VideoContent;
  /** @deprecated BFF内部で計算済み */
  isHiddenForPremiumMember: Scalars['Boolean'];
};

/** コンテンツタイプ */
export enum G_VideoContentType {
  /**  2D  */
  Vod_2D = 'VOD_2D',
  /**  VR  */
  VodVr = 'VOD_VR',
  /**  Live 2D  */
  Live_2D = 'LIVE_2D',
  /**  Live VR  */
  LiveVr = 'LIVE_VR'
}

/** コンテンツタイプでの絞り込みアイテム */
export type G_VideoContentTypeFacetItem = {
  name: Scalars['String'];
  value: G_VideoContentTypeFilter;
  count: Scalars['Int'];
};

/** フィルター用のコンテンツタイプ */
export enum G_VideoContentTypeFilter {
  /**  2D  */
  Content_2D = 'CONTENT_2D',
  /**  VR  */
  ContentVr = 'CONTENT_VR'
}

/**  続きからみる  */
export type G_VideoContinueWatching = G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  コンテンツ */
  contentId: Scalars['ID'];
  /**  パート番号  */
  partNumber: Scalars['Int'];
  /**  レジュームポイント(秒)  */
  resumePoint: Scalars['Int'];
  /**  ビデオ  */
  video: G_Video;
  /**  コンテンツ  */
  content: G_VideoContent;
};

export type G_VideoContinueWatchingConnection = G_ForwardOnlyConnection & {
  edges: Array<G_VideoContinueWatchingEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_VideoContinueWatchingEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoContinueWatching;
};

/**  割引キャンペーン  */
export type G_VideoDiscountCampaign = G_VideoCampaign & {
  /**  キャンペーンID  */
  id: Scalars['ID'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  キャンペーン終了日時  */
  endAt: Scalars['DateTime'];
  /**  プレミアム会員限定キャンペーンかどうか  */
  isLimitedPremium: Scalars['Boolean'];
  /**  割引率  */
  rate: Scalars['Int'];
  /**  キャンペーン対象作品  */
  videos: G_VideoSearchResultConnection;
};


/**  割引キャンペーン  */
export type G_VideoDiscountCampaignVideosArgs = {
  device: G_Device;
  categories?: Maybe<Array<Scalars['ID']>>;
  genres?: Maybe<Array<Scalars['ID']>>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

/**  ダウンロードファイル選択画面用データ  */
export type G_VideoDownloadFile = {
  /**  品質  */
  quality: G_Quality;
  /**  ファイルサイズ（総容量） */
  totalFileSize: Scalars['Int'];
  /**  各パートのファイルサイズ  */
  parts: Array<G_VideoPartOfDownloadFile>;
};

export type G_VideoEdge = {
  cursor: Scalars['String'];
  node: G_Video;
};

/** エピソード種別 */
export enum G_VideoEpisodeType {
  /**  本編  */
  Main = 'MAIN',
  /**  予告編/PV  */
  Pv = 'PV',
  /**  特典映像  */
  Special = 'SPECIAL',
  /**  バンドル  */
  Bundle = 'BUNDLE'
}

/** ビデオ検索条件 */
export type G_VideoFilter = {
  /**  検索キーワード  */
  keyword?: Maybe<Scalars['String']>;
  /**  タイトル  */
  title?: Maybe<Scalars['ID']>;
  /**  カテゴリ  */
  categories?: Maybe<Array<Scalars['ID']>>;
  /**  ジャンル  */
  genres?: Maybe<Array<Scalars['ID']>>;
  /**  出演者  */
  casts?: Maybe<Array<Scalars['ID']>>;
  /**  スタッフ  */
  staffs?: Maybe<Array<Scalars['ID']>>;
  /**  シリーズ(グラビア、VRなど既存作品のみ)  */
  series?: Maybe<Scalars['ID']>;
  /**  コンテンツタイプ(2D/VR)  */
  contentType?: Maybe<G_VideoContentTypeFilter>;
  /**  視聴形式（全て/プレミアム/無料/有料） */
  viewingTypes?: Maybe<Array<G_VideoViewingType>>;
  /**  キャンペーン  */
  campaigns?: Maybe<Array<Scalars['ID']>>;
  /**  ソート  */
  sort?: Maybe<G_VideoSearchSortKey>;
};

/**  固定金額値引き  */
export type G_VideoFixedPriceDiscountCampaign = G_VideoCampaign & {
  /**  キャンペーンID  */
  id: Scalars['ID'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  キャンペーン終了日時  */
  endAt: Scalars['DateTime'];
  /**  プレミアム会員限定キャンペーンかどうか  */
  isLimitedPremium: Scalars['Boolean'];
  /**  値引き額  */
  amount: Scalars['Int'];
  /**  キャンペーン対象作品  */
  videos: G_VideoSearchResultConnection;
};


/**  固定金額値引き  */
export type G_VideoFixedPriceDiscountCampaignVideosArgs = {
  device: G_Device;
  categories?: Maybe<Array<Scalars['ID']>>;
  genres?: Maybe<Array<Scalars['ID']>>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

/**  舞台などの、購入日に関係なくこの日時までしか視聴できない視聴期限タイプ  */
export type G_VideoFixedViewingExpiration = {
  /**  視聴期限日時  */
  expiresAt: Scalars['DateTime'];
};

/** 好みのジャンル・カテゴリを選ぶ際の作品 */
export type G_VideoForDemographic = {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  カテゴリID  */
  categoryId: Scalars['ID'];
  /**  ジャンルID  */
  genreId: Scalars['ID'];
  /**  表示名  */
  displayName: Scalars['String'];
};

/** ビデオ作品詳細へ遷移するフリーアイテム */
export type G_VideoFreeItem = {
  /**  フリーアイテムID  */
  id: Scalars['ID'];
  /**  画像  */
  image: Scalars['URI'];
  name: Scalars['String'];
  seasonId: Scalars['ID'];
  video: G_Video;
  /** @deprecated BFF内部で計算済み */
  isHiddenForPremiumMember: Scalars['Boolean'];
};

/** 無料商品 */
export type G_VideoFreeProduct = G_VideoProduct & {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  配信開始日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信終了日時  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
};

/** ジャンル */
export type G_VideoGenre = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**  視聴率グラフ　 */
export type G_VideoHeatMap = {
  /**  タイムスタンプ  */
  timestamps: Array<Scalars['Int']>;
  /**  視聴率  */
  values: Array<Scalars['Int']>;
  /**  配列の要素数  */
  length: Scalars['Int'];
};

/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeason = G_Video & G_VideoSummary & G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  タイトルID  */
  titleId: Scalars['ID'];
  /**  作品名  */
  titleName: Scalars['String'];
  /**  作品名(ふりがな)  */
  titleNameRuby: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  シーズン名(ふりがな)  */
  seasonNameRuby: Scalars['String'];
  /**  見どころ  */
  highlight?: Maybe<Scalars['String']>;
  /**  作品の説明  */
  description: Scalars['String'];
  /**  注釈  */
  notices?: Maybe<Array<Scalars['String']>>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  拡大パッケージ画像  */
  packageLargeImage?: Maybe<Scalars['URI']>;
  /**  制作年  */
  productionYear?: Maybe<Scalars['Int']>;
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  レーティング  */
  rating: G_VideoRating;
  /**  コピーライト  */
  copyright: Scalars['String'];
  /**  サンプル画像  */
  samplePictures: Array<G_VideoSamplePicture>;
  /**  サンプル動画  */
  sampleMovie?: Maybe<G_SampleMovie>;
  /**  ブックマークをしているか(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  キャスト  */
  casts: Array<G_Cast>;
  /**  スタッフ  */
  staffs: Array<G_Staff>;
  /**  カテゴリ  */
  categories: Array<G_VideoCategory>;
  /**  ジャンル  */
  genres: Array<G_VideoGenre>;
  /**  シリーズ  */
  series?: Maybe<G_VideoSeries>;
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  コンテンツ  */
  content: G_VideoContent;
  /**
   * 続きから見る(ログインユーザーのみ)
   *
   * ※VR作品の「続きから見る」は試聴の有無に関わらずnullが返る
   */
  continueWatching?: Maybe<G_VideoContinueWatching>;
  /**  購入済みコンテンツ(ログインユーザーのみ)  */
  purchasedContents: G_VideoPurchasedContentConnection;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  作品詳細URL  */
  url: Scalars['URI'];
  /**  PPV参考価格  */
  priceSummary?: Maybe<G_VideoPriceSummary>;
  /**  公開中フラグ  */
  isPublic: Scalars['Boolean'];
  /**
   * 販売中フラグ
   *
   * PPVのみ取り扱いがあるシーズンですべてのコンテンツが販売終了している場合にtrueを返す
   */
  isOnSale: Scalars['Boolean'];
  /**  購入済みフラグ シーズン内に視聴期限内の購入済みPPVが1つ以上あればtrue  */
  isPurchased: Scalars['Boolean'];
  /** カスタムシーズンタグ */
  customTag?: Maybe<Scalars['String']>;
  /**  おすすめのビデオ作品  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  i2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonHighlightArgs = {
  format?: Maybe<G_TextFormat>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonNoticesArgs = {
  format?: Maybe<G_TextFormat>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonPurchasedContentsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonRelatedItemsArgs = {
  device: G_Device;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  categoryId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};


/** グラビア、VRなどの既存作品 */
export type G_VideoLegacySeasonI2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

/**  VRやグラビアなどの、購入日から一定日数視聴可能な視聴期限タイプ  */
export type G_VideoLegacyViewingExpiration = {
  /**  視聴期限日数（購入からN日間視聴可能、7（日）などが入る（グラビアなどの既存作品系））  */
  expireDay: Scalars['Int'];
};

/** ビデオ作品リストへ遷移するフリーアイテム */
export type G_VideoListFreeItem = {
  /**  フリーアイテムID  */
  id: Scalars['ID'];
  /**  画像  */
  image: Scalars['URI'];
  name: Scalars['String'];
  /**  リストの検索条件  */
  filter: G_VideoFilter;
  /** @deprecated BFF内部で計算済み */
  isHiddenForPremiumMember: Scalars['Boolean'];
};

/** 購入済みコンテンツの視聴期限 */
export type G_VideoPpvExpiration = {
  /**  視聴期限タイプ  */
  expirationType: G_VideoPpvExpirationType;
  /**  視聴開始期限  */
  viewingStartExpiration?: Maybe<Scalars['DateTime']>;
  /**  視聴期限  */
  viewingExpiration?: Maybe<Scalars['DateTime']>;
  /**  配信開始日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
};

/** 購入済みコンテンツの視聴期限タイプ */
export enum G_VideoPpvExpirationType {
  /**  無期限  */
  Est = 'EST',
  /**  初回視聴で決まる視聴期限  */
  TvodDynamicExpiration = 'TVOD_DYNAMIC_EXPIRATION',
  /**  購入時点で決まっている視聴期限  */
  TvodFixedExpiration = 'TVOD_FIXED_EXPIRATION'
}

/** PPV商品 */
export type G_VideoPpvProduct = G_VideoProduct & {
  /**  プロダクトID  */
  id: Scalars['ID'];
  /**  販売単位優先順位  */
  saleUnitPriority: Scalars['Int'];
  /**  コンテンツ単位優先順位  */
  contentPriority: Scalars['Int'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  コンテンツタイプ  */
  contentType: G_VideoContentType;
  /**  シーズンID  */
  seasonId: Scalars['ID'];
  /**  販売単位名  */
  saleUnitName: Scalars['String'];
  /**  エピソード名  */
  episodeTitle: Scalars['String'];
  /**  エピソード番号  */
  episodeNumber?: Maybe<Scalars['Int']>;
  /**  エピソード番号表示名  */
  episodeNumberName?: Maybe<Scalars['String']>;
  /**  エピソード種別  */
  episodeType: G_VideoEpisodeType;
  /**  価格  */
  price: G_VideoPpvProductPrice;
  /**  ポイント還元情報  */
  pointRefundInfo: G_PointRefundInfo;
  /**  販売タイプ  */
  saleType: G_VideoPpvSaleType;
  /**  予約販売  */
  isPreOrder: Scalars['Boolean'];
  /**  ストリーミング可能か  */
  isStreamable: Scalars['Boolean'];
  /**  ダウンロード可能か  */
  isDownloadable: Scalars['Boolean'];
  /**  視聴期限  */
  viewingExpiration?: Maybe<G_VideoViewingExpiration>;
  /**  販売開始日時  */
  startSaleAt?: Maybe<Scalars['DateTime']>;
  /**  販売開始日時  */
  endSaleAt?: Maybe<Scalars['DateTime']>;
  /**  販売中フラグ  */
  isOnSale: Scalars['Boolean'];
  /**  配信開始日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信終了日時  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  購入済みかどうか  */
  isPurchased: Scalars['Boolean'];
  /**  バンドル親商品かどうか  */
  isBundleParent: Scalars['Boolean'];
  /**  バンドル商品  */
  bundleProducts?: Maybe<Array<G_VideoPpvProduct>>;
  /**  グッズ付きPPV商品かどうか  */
  hasGoods: Scalars['Boolean'];
};


/** PPV商品 */
export type G_VideoPpvProductPointRefundInfoArgs = {
  device: G_Device;
  paymentMethod: Array<G_PaymentMethod>;
};

/**  PPV商品販売価格  */
export type G_VideoPpvProductPrice = {
  /**  プロダクトID  */
  productId: Scalars['ID'];
  /**  定価(税込)  */
  price: Scalars['Int'];
  /**  販売価格(税込)  */
  salePrice: Scalars['Int'];
  /**  適用されたキャンペーンID  */
  appliedCampaignId?: Maybe<Scalars['String']>;
  /**  適用されたキャンペーン名  */
  appliedCampaignName?: Maybe<Scalars['String']>;
  /**  プレミアム会員限定割引かどうか  */
  isLimitedPremium: Scalars['Boolean'];
};

/** PPV販売タイプ */
export enum G_VideoPpvSaleType {
  /**  TVOD  */
  Tvod = 'TVOD',
  /**  EST  */
  Est = 'EST'
}

/** パート */
export type G_VideoPart = G_Part & {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  コンテンツ種別(2D/VR)  */
  contentType: G_VideoContentType;
  /**  パート番号  */
  number: Scalars['Int'];
  /**  コンテンツの再生時間  */
  duration: Scalars['Int'];
  /**
   *  レジュームポイント(秒)
   * @deprecated Use `resume.point`.
   */
  resumePoint: Scalars['Int'];
  /**  レジューム情報  */
  resume: G_VideoResume;
  /**
   *  視聴率グラフ
   * @deprecated Use `VideoContent.heatMap`.
   */
  heatMap?: Maybe<G_VideoHeatMap>;
};

export type G_VideoPartOfDownloadFile = {
  /**  パート番号  */
  partNumber: Scalars['Int'];
  /**  ファイルサイズ  */
  fileSize: Scalars['Int'];
};

/**  視聴履歴  */
export type G_VideoPlayHistory = G_Node & {
  /**  視聴履歴ID  */
  id: Scalars['ID'];
  /**  シーズンID  */
  seasonId: Scalars['String'];
  /**  ビデオ(シーズン)  */
  video: G_Video;
  /**  コンテンツID  */
  contentId: Scalars['String'];
  /**  コンテンツ(エピソード)  */
  content: G_VideoContent;
  /**  視聴開始日時  */
  startedAt: Scalars['DateTime'];
};

export type G_VideoPlayHistoryConnection = G_ForwardOnlyConnection & {
  edges: Array<G_VideoPlayHistoryEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_VideoPlayHistoryEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoPlayHistory;
};

/** ビデオ再生情報 */
export type G_VideoPlayInfo = {
  /**  シーズンID  */
  seasonId: Scalars['ID'];
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  コンテンツ種別(2D/VR)  */
  contentType: G_VideoContentType;
  /**  品質情報タグ  */
  tags: Array<Scalars['String']>;
  /**  最高画質  */
  highestQuality: Scalars['String'];
  /**  最高Audioチャンネル数(5.1等)  */
  highestAudioChannelLayout: Scalars['String'];
  /**  音声情報 (日本語(2ch)、英語(2ch)、英語(5.1ch)など)  */
  audioRenditions: Array<Scalars['String']>;
  /**  字幕情報  */
  textRenditions: Array<Scalars['String']>;
  /**  字幕種類  */
  textRenditionType: G_TextRenditionType;
  /**  HDRサポート  */
  isSupportHDR: Scalars['Boolean'];
  /**  コンテンツの秒数(複数パートがある場合は合計時間)  */
  duration: Scalars['Int'];
  /**  レジュームパート番号  */
  resumePartNumber: Scalars['Int'];
  /**  パート  */
  parts: Array<G_VideoPart>;
};

/**  ポイント還元キャンペーン  */
export type G_VideoPointRefundCampaign = G_VideoCampaign & {
  /**  キャンペーンID  */
  id: Scalars['ID'];
  /**  キャンペーン名  */
  name: Scalars['String'];
  /**  キャンペーン終了日時  */
  endAt: Scalars['DateTime'];
  /**  プレミアム会員限定キャンペーンかどうか  */
  isLimitedPremium: Scalars['Boolean'];
  /**  ポイント還元率  */
  rate: Scalars['Int'];
  /**  キャンペーン対象作品  */
  videos: G_VideoSearchResultConnection;
};


/**  ポイント還元キャンペーン  */
export type G_VideoPointRefundCampaignVideosArgs = {
  device: G_Device;
  categories?: Maybe<Array<Scalars['ID']>>;
  genres?: Maybe<Array<Scalars['ID']>>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

/**  ブックマークしたPPV商品の値下げ情報  */
export type G_VideoPriceDropNotification = G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  値下げしたビデオ  */
  video: G_Video;
  /**  商品ID  */
  productId: Scalars['ID'];
  /**  商品  */
  product: G_VideoPpvProduct;
  /**  ブックマーク追加時の価格  */
  priceWhenAdded: Scalars['Int'];
  /**  現在の価格  */
  latestPrice: Scalars['Int'];
  /**  キャンペーンID  */
  campaignId?: Maybe<Scalars['ID']>;
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
};

export type G_VideoPriceDropNotificationConnection = G_ForwardOnlyConnection & {
  edges: Array<G_VideoPriceDropNotificationEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_VideoPriceDropNotificationEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoPriceDropNotification;
};

/** PPV参考価格 */
export type G_VideoPriceSummary = {
  /**  最低価格  */
  lowestPrice: Scalars['Int'];
  /**  最高価格  */
  highestPrice: Scalars['Int'];
  /**  キャンペーンID  */
  campaignId?: Maybe<Scalars['ID']>;
  /**  キャンペーン適用後の最低価格  */
  discountedLowestPrice?: Maybe<Scalars['Int']>;
  /**  キャンペーン適用後の最高価格  */
  discountedHighestPrice?: Maybe<Scalars['Int']>;
  /**  プレミアム会員限定割引かどうか  */
  isLimitedPremium: Scalars['Boolean'];
};

export type G_VideoProduct = {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  配信開始日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信終了日時  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
};

/** ビデオに関するデコード能力を示す */
export type G_VideoProtectionCapability = {
  /** ビデオコーデック */
  codec: G_StreamingVideoCodec;
  /** ハードウェアデコード可否 (TEE: Trusted Execution Environment への対応有無) */
  tee?: Maybe<Scalars['Boolean']>;
  /** ビット深度 (SDR: 8 / HDR: 10) */
  bpc: Scalars['Int'];
  /** 単位時間あたりにデコード可能なデータ量 (Width * Height * FPS で算出可能) */
  rate: Scalars['Float'];
  /** YUV444Pに対応しているか否か */
  yuv444p?: Maybe<Scalars['Boolean']>;
};

export type G_VideoPurchasedContentConnection = G_Connection & {
  edges: Array<G_VideoPurchasedContentEdge>;
  pageInfo: G_PageInfo;
  total: Scalars['Int'];
};

export type G_VideoPurchasedContentEdge = G_Edge & {
  cursor: Scalars['String'];
  contentID: Scalars['ID'];
  node: G_VideoContent;
};

/** 購入済み商品の視聴期限 */
export type G_VideoPurchasedViewingExpiration = {
  /**  視聴開始期限  */
  viewingStartExpiresAt?: Maybe<Scalars['DateTime']>;
  /**  視聴期限  */
  viewingExpiresAt?: Maybe<Scalars['DateTime']>;
  /**  視聴期限なし(EST)  */
  noExpiration: Scalars['Boolean'];
};

export type G_VideoRankingConnection = G_ForwardOnlyConnection & {
  edges: Array<G_VideoRankingEdge>;
  pageInfo: G_ForwardOnlyPageInfo;
};

export type G_VideoRankingEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoRankingItem;
};

/**  ビデオランキング  */
export type G_VideoRankingItem = G_Node & {
  id: Scalars['ID'];
  rank: Scalars['Int'];
  video: G_Video;
};

/**  ランキング集計期間  */
export enum G_VideoRankingTerm {
  /**  1時間  */
  Hourly = 'HOURLY',
  /**  1日  */
  Daily = 'DAILY',
  /**  1週間  */
  Weekly = 'WEEKLY',
  /**  1ヶ月  */
  Monthly = 'MONTHLY'
}

/**  ランキング種別  */
export enum G_VideoRankingType {
  /**  視聴数  */
  ViewCount = 'VIEW_COUNT',
  /**  売上  */
  Sales = 'SALES'
}

/** レーティング */
export type G_VideoRating = {
  category: G_VideoRatingCategory;
  name: Scalars['String'];
};

/** レーティング区分 */
export enum G_VideoRatingCategory {
  /**  レーティング無し  */
  Nr = 'NR',
  /**  全ての年齢層が鑑賞可能な区分  */
  G = 'G',
  /**  12歳未満（小学生以下）の鑑賞には、成人保護者の助言や指導が適当とされる区分	 */
  Pg12 = 'PG12',
  /**  15歳未満の入場・鑑賞を禁止する区分  */
  R15 = 'R15',
  /**  18歳未満の入場・鑑賞を禁止する区分（一般用） */
  R18 = 'R18',
  /**  18歳未満の入場・鑑賞を禁止する区分（グラビア用） */
  R18Gravure = 'R18_GRAVURE',
  /**  18歳未満の入場・鑑賞を禁止する区分（アダルト用） */
  R18Adult = 'R18_ADULT'
}

/** 関連するシーズン */
export type G_VideoRelatedSeason = {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  タイトル  */
  title: Scalars['String'];
  /**  ビデオ詳細  */
  video: G_Video;
};

/** エンコードされた動画情報 */
export type G_VideoRendition = {
  /**
   * RFC5646 言語タグ (空文字, ja, ja-JP)
   * (ハードサブの場合に使用されリリース当初は上記の3種類しか無い)
   */
  lang: Scalars['String'];
  /** SD/HD/4K/Auto */
  qualityName: Scalars['String'];
  /** 再生URL一覧 (HDR / SDR 間のフェイルオーバー等も考えて、複数渡せるようにしている) */
  streamingUrls: Array<G_StreamingUrl>;
};

/**  映画やアニメのレンタルなど、視聴開始までの期限と視聴開始後の期限が存在する視聴期限タイプ  */
export type G_VideoRentalViewingExpiration = {
  /**  視聴開始期限日数（購入からN日以内に視聴開始しなければいけない期限）  */
  startLimitDay: Scalars['Int'];
  /**  視聴期限時間（視聴開始してからの期限時間、48（時間）などが入る）  */
  expireHour: Scalars['Int'];
};

/**  レジューム情報  */
export type G_VideoResume = {
  /**  レジューム位置(秒)  */
  point: Scalars['Int'];
  /**  視聴完了フラグ（true:対象コンテンツを終了位置まで視聴済み、false:視聴途中）  */
  isCompleted: Scalars['Boolean'];
};

export type G_VideoReviewInput = {
  /**  投稿対象のシーズンID  */
  seasonId: Scalars['ID'];
  /**  レビュアー名 (ニックネーム未設定の場合のみ必須)  */
  reviewerName?: Maybe<Scalars['String']>;
  /**  レビュータイトル  */
  title?: Maybe<Scalars['String']>;
  /**  レビュー値(星の数)  */
  point: Scalars['Int'];
  /**  ネタバレ有無  */
  hasSpoiler: Scalars['Boolean'];
  /**  投稿内容  */
  comment?: Maybe<Scalars['String']>;
  /**  デバイス  */
  device: G_Device;
};

/** SVOD商品 */
export type G_VideoSvodProduct = G_VideoProduct & {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**  配信開始日時  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信終了日時  */
  endDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
};

/** サンプル画像 */
export type G_VideoSamplePicture = {
  image: Scalars['URI'];
  imageLarge: Scalars['URI'];
};

/** ビデオ検索ファセット */
export type G_VideoSearchFacet = {
  /**  タイトル  */
  titles: Array<G_FacetItem>;
  /**  カテゴリ  */
  categories: Array<G_FacetItem>;
  /**  ジャンル  */
  genres: Array<G_FacetItem>;
  /**  出演者  */
  casts: Array<G_FacetItem>;
  /**  スタッフ  */
  staffs: Array<G_FacetItem>;
  /**  シリーズ(グラビア、VRなど既存作品のみ)  */
  series: Array<G_FacetItem>;
  /**  キャンペーン  */
  campaigns: Array<G_FacetItem>;
  /**  2D/VR  */
  contentTypes: Array<G_VideoContentTypeFacetItem>;
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingTypeFacetItem>;
};

/** ビデオ検索結果 */
export type G_VideoSearchResult = G_VideoSummary & G_Node & {
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  作品名  */
  titleName: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  作品またはシーズンの説明  */
  description: Scalars['String'];
  /**  配信開始日  */
  startDeliveryAt?: Maybe<Scalars['DateTime']>;
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**
   *  キャンペーン中フラグ
   * @deprecated Use `isOnCampaign`
   */
  isOnSale: Scalars['Boolean'];
  /**  キャンペーン中フラグ  */
  isOnCampaign: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  最低価格(PPVのみ)  */
  lowestPrice?: Maybe<Scalars['Int']>;
  /**  最高価格(PPVで複数商品がある場合のみ)  */
  highestPrice?: Maybe<Scalars['Int']>;
  /**  キャンペーン適用後の最低価格(PPVでキャンペーン開催時のみ)  */
  discountedLowestPrice?: Maybe<Scalars['Int']>;
  /**  キャンペーン適用後の最高価格(PPV複数商品ありでキャンペーン開催時のみ)  */
  discountedHighestPrice?: Maybe<Scalars['Int']>;
  /**  レビュー平均点  */
  reviewAveragePoint: Scalars['Float'];
  /**  キービジュアル画像  */
  keyVisualImage?: Maybe<Scalars['URI']>;
  /**  キービジュアル(ロゴ無し)画像  */
  keyVisualWithoutLogoImage?: Maybe<Scalars['URI']>;
  /**  拡大パッケージ画像  */
  packageLargeImage?: Maybe<Scalars['URI']>;
  /**  カスタムシーズンタグ  */
  customTag?: Maybe<Scalars['String']>;
  /**  レーティング  */
  rating: G_VideoRatingCategory;
};


/** ビデオ検索結果 */
export type G_VideoSearchResultDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};

export type G_VideoSearchResultConnection = G_Connection & {
  edges: Array<G_VideoSearchResultEdge>;
  pageInfo: G_PageInfo;
  total: Scalars['Int'];
  facet: G_VideoSearchFacet;
};

export type G_VideoSearchResultEdge = G_Edge & {
  cursor: Scalars['String'];
  node: G_VideoSearchResult;
};

/** ビデオ検索で利用可能なソートキー */
export enum G_VideoSearchSortKey {
  /**  新着  */
  New = 'NEW',
  /**  ランキング  */
  Rank = 'RANK',
  /**  視聴数  */
  ViewCount = 'VIEW_COUNT',
  /**  売上  */
  Sales = 'SALES'
}

/** シーズン */
export type G_VideoSeason = G_Video & G_VideoSummary & G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  タイトルID  */
  titleId: Scalars['ID'];
  /**  作品名  */
  titleName: Scalars['String'];
  /**  作品名(ふりがな)  */
  titleNameRuby: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  シーズン名(ふりがな)  */
  seasonNameRuby: Scalars['String'];
  /**  見どころ  */
  highlight?: Maybe<Scalars['String']>;
  /**  シーズンの説明  */
  description: Scalars['String'];
  /**  注釈  */
  notices?: Maybe<Array<Scalars['String']>>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  レーティング  */
  rating: G_VideoRating;
  /**  コピーライト  */
  copyright: Scalars['String'];
  /**  制作年  */
  productionYear?: Maybe<Scalars['Int']>;
  /**  制作国  */
  productionCountry: Scalars['String'];
  /**  制作国での公開日  */
  releasedAt?: Maybe<Scalars['DateTime']>;
  /**  キービジュアル画像  */
  keyVisualImage?: Maybe<Scalars['URI']>;
  /**  キービジュアル(ロゴ無し)画像  */
  keyVisualWithoutLogoImage?: Maybe<Scalars['URI']>;
  /**  関連シーズン  */
  relatedSeasons: Array<G_VideoRelatedSeason>;
  /**  キャスト  */
  casts: Array<G_Cast>;
  /**  スタッフ  */
  staffs: Array<G_Staff>;
  /**  カテゴリ  */
  categories: Array<G_VideoCategory>;
  /**  ジャンル  */
  genres: Array<G_VideoGenre>;
  /**  ブックマークをしているか  */
  hasBookmark: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  エピソード  */
  episode: G_VideoContent;
  /**  エピソード一覧  */
  episodes: G_VideoContentConnection;
  /**
   *  次回更新予定のエピソード
   * @deprecated Use nextDeliveryEpisode
   */
  upcomingEpisode?: Maybe<G_VideoContent>;
  /** 次回配信エピソード */
  nextDeliveryEpisode: G_NextDeliveryEpisode;
  /**  続きから見る(ログインユーザーのみ)  */
  continueWatching?: Maybe<G_VideoContinueWatching>;
  /**  購入済みコンテンツ(ログインユーザーのみ)  */
  purchasedContents: G_VideoPurchasedContentConnection;
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  公開中フラグ  */
  isPublic: Scalars['Boolean'];
  /**
   * 販売中フラグ
   *
   * PPVのみ取り扱いがあるシーズンですべてのコンテンツが販売終了している場合にtrueを返す
   */
  isOnSale: Scalars['Boolean'];
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  作品詳細URL  */
  url: Scalars['URI'];
  /**  PPV参考価格  */
  priceSummary?: Maybe<G_VideoPriceSummary>;
  /**  購入済みフラグ シーズン内に視聴期限内の購入済みPPVが1つ以上あればtrue  */
  isPurchased: Scalars['Boolean'];
  /** カスタムシーズンタグ */
  customTag?: Maybe<Scalars['String']>;
  /**  おすすめのビデオ作品  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  i2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** シーズン */
export type G_VideoSeasonHighlightArgs = {
  format?: Maybe<G_TextFormat>;
};


/** シーズン */
export type G_VideoSeasonDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/** シーズン */
export type G_VideoSeasonNoticesArgs = {
  format?: Maybe<G_TextFormat>;
};


/** シーズン */
export type G_VideoSeasonReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** シーズン */
export type G_VideoSeasonEpisodeArgs = {
  id: Scalars['ID'];
};


/** シーズン */
export type G_VideoSeasonEpisodesArgs = {
  type?: Maybe<G_VideoEpisodeType>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Int']>;
};


/** シーズン */
export type G_VideoSeasonPurchasedContentsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


/** シーズン */
export type G_VideoSeasonRelatedItemsArgs = {
  device: G_Device;
};


/** シーズン */
export type G_VideoSeasonRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  categoryId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};


/** シーズン */
export type G_VideoSeasonI2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

/** シーズン種別 */
export enum G_VideoSeasonType {
  /**  単話  */
  SingleEpisode = 'SINGLE_EPISODE',
  /**  複数話　 */
  MultiEpisodes = 'MULTI_EPISODES',
  /**  既存の作品(グラビア・VRなど)  */
  Legacy = 'LEGACY',
  /**  舞台  */
  Stage = 'STAGE',
  /**  スポット配信  */
  SpotLive = 'SPOT_LIVE'
}

/** シリーズ */
export type G_VideoSeries = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** ビデオ(シーズン)棚で利用する画像の種類 */
export enum G_VideoShelfImageType {
  /**  パッケージ  */
  Package = 'PACKAGE',
  /**  キービジュアル(ロゴあり)  */
  KeyVisualWithLogo = 'KEY_VISUAL_WITH_LOGO',
  /**  キービジュアル(ロゴなし)  */
  KeyVisualWithoutLogo = 'KEY_VISUAL_WITHOUT_LOGO'
}

/** スポット配信作品 */
export type G_VideoSpotLiveSeason = G_Video & G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  タイトルID  */
  titleId: Scalars['ID'];
  /**  作品名  */
  titleName: Scalars['String'];
  /**  作品名(ふりがな)  */
  titleNameRuby: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  シーズン名(ふりがな)  */
  seasonNameRuby: Scalars['String'];
  /**  見どころ  */
  highlight?: Maybe<Scalars['String']>;
  /**  説明  */
  description: Scalars['String'];
  /**  注釈  */
  notices?: Maybe<Array<Scalars['String']>>;
  /**  制作年  */
  productionYear?: Maybe<Scalars['Int']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  キービジュアル画像  */
  keyVisualImage?: Maybe<Scalars['URI']>;
  /**  キービジュアル(ロゴ無し)画像  */
  keyVisualWithoutLogoImage?: Maybe<Scalars['URI']>;
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  レーティング  */
  rating: G_VideoRating;
  /**  コピーライト  */
  copyright: Scalars['String'];
  /**  キャスト  */
  casts: Array<G_Cast>;
  /**  スタッフ  */
  staffs: Array<G_Staff>;
  /**  カテゴリ  */
  categories: Array<G_VideoCategory>;
  /**  ジャンル  */
  genres: Array<G_VideoGenre>;
  /**  ブックマークをしているか(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /**  エピソード  */
  episode: G_VideoContent;
  /**  エピソード一覧  */
  episodes: G_VideoContentConnection;
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  作品詳細URL  */
  url: Scalars['URI'];
  /**  公開中フラグ  */
  isPublic: Scalars['Boolean'];
  /**
   * 販売中フラグ
   *
   * PPVのみ取り扱いがあるシーズンですべてのコンテンツが販売終了している場合にtrueを返す
   */
  isOnSale: Scalars['Boolean'];
  /** カスタムシーズンタグ */
  customTag?: Maybe<Scalars['String']>;
  /**  おすすめのビデオ作品  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  i2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonHighlightArgs = {
  format?: Maybe<G_TextFormat>;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonNoticesArgs = {
  format?: Maybe<G_TextFormat>;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonEpisodeArgs = {
  id: Scalars['ID'];
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonEpisodesArgs = {
  type?: Maybe<G_VideoEpisodeType>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Int']>;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonRelatedItemsArgs = {
  device: G_Device;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
  categoryId?: Maybe<Scalars['ID']>;
};


/** スポット配信作品 */
export type G_VideoSpotLiveSeasonI2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

/**  ライブ公演  */
export type G_VideoStagePerformance = {
  /**  公演日  */
  performanceDate: Scalars['DateTime'];
  /**  コンテンツ  */
  contents: Array<G_VideoContent>;
};

/** 舞台ライブ作品 */
export type G_VideoStageSeason = G_Video & G_VideoSummary & G_Node & {
  /**  シーズンID  */
  id: Scalars['ID'];
  /**  シーズン種別  */
  seasonType: G_VideoSeasonType;
  /**  タイトルID  */
  titleId: Scalars['ID'];
  /**  作品名  */
  titleName: Scalars['String'];
  /**  作品名(ふりがな)  */
  titleNameRuby: Scalars['String'];
  /**  シーズン名  */
  seasonName: Scalars['String'];
  /**  シーズン名(ふりがな)  */
  seasonNameRuby: Scalars['String'];
  /**  見どころ  */
  highlight?: Maybe<Scalars['String']>;
  /**  説明  */
  description: Scalars['String'];
  /**  注釈  */
  notices?: Maybe<Array<Scalars['String']>>;
  /**  制作年  */
  productionYear?: Maybe<Scalars['Int']>;
  /**  配信中フラグ  */
  isBeingDelivered: Scalars['Boolean'];
  /**  パッケージ画像  */
  packageImage: Scalars['URI'];
  /**  キービジュアル画像  */
  keyVisualImage?: Maybe<Scalars['URI']>;
  /**  キービジュアル(ロゴ無し)画像  */
  keyVisualWithoutLogoImage?: Maybe<Scalars['URI']>;
  /**  新着フラグ  */
  isNewArrival: Scalars['Boolean'];
  /**  独占配信フラグ  */
  isExclusive: Scalars['Boolean'];
  /**  視聴形式  */
  viewingTypes: Array<G_VideoViewingType>;
  /**  レーティング  */
  rating: G_VideoRating;
  /**  コピーライト  */
  copyright: Scalars['String'];
  /**  キャスト  */
  casts: Array<G_Cast>;
  /**  スタッフ  */
  staffs: Array<G_Staff>;
  /**  カテゴリ  */
  categories: Array<G_VideoCategory>;
  /**  ジャンル  */
  genres: Array<G_VideoGenre>;
  /**  シリーズ  */
  series?: Maybe<G_VideoSeries>;
  /**  購入済みコンテンツ(ログインユーザーのみ)  */
  purchasedContents: G_VideoPurchasedContentConnection;
  /**  舞台購入済みコンテンツ(ログインユーザーのみ)  */
  purchasedStageContents?: Maybe<G_PurchasedStageContents>;
  /**  ブックマークをしているか(ログインユーザーのみ)  */
  hasBookmark: Scalars['Boolean'];
  /**  レビュー集計情報  */
  reviewSummary: G_ReviewSummary;
  /**  レビュー  */
  reviews: G_ReviewConnection;
  /**  キャンペーン  */
  campaign?: Maybe<G_VideoCampaign>;
  /**  公開開始日時  */
  startPublicAt: Scalars['DateTime'];
  /**  公開終了日時  */
  endPublicAt?: Maybe<Scalars['DateTime']>;
  /**  全ての公演  */
  allPerformances: Array<G_VideoStagePerformance>;
  /**  公演  */
  performance: G_VideoStagePerformance;
  /**  関連商品  */
  relatedItems: G_RelatedItems;
  /**  作品詳細URL  */
  url: Scalars['URI'];
  /**  PPV参考価格  */
  priceSummary?: Maybe<G_VideoPriceSummary>;
  /**  公開中フラグ  */
  isPublic: Scalars['Boolean'];
  /**
   * 販売中フラグ
   *
   * PPVのみ取り扱いがあるシーズンですべてのコンテンツが販売終了している場合にtrueを返す
   */
  isOnSale: Scalars['Boolean'];
  /**  購入済みフラグ シーズン内に視聴期限内の購入済みPPVが1つ以上あればtrue  */
  isPurchased: Scalars['Boolean'];
  /** カスタムシーズンタグ */
  customTag?: Maybe<Scalars['String']>;
  /**  おすすめのビデオ作品  */
  recommendedVideos: Array<G_RecommendedVideo>;
  /**  おすすめのビデオ作品  */
  i2iRecommendedVideos: G_RecommendedVideoConnection;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonHighlightArgs = {
  format?: Maybe<G_TextFormat>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonDescriptionArgs = {
  format?: Maybe<G_TextFormat>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonNoticesArgs = {
  format?: Maybe<G_TextFormat>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonPurchasedContentsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonReviewsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonPerformanceArgs = {
  performanceDate: Scalars['DateTime'];
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonRelatedItemsArgs = {
  device: G_Device;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  categoryId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};


/** 舞台ライブ作品 */
export type G_VideoStageSeasonI2iRecommendedVideosArgs = {
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
};

/** ビデオ作品概要 */
export type G_VideoSummary = {
  id: Scalars['ID'];
  seasonType: G_VideoSeasonType;
  titleName: Scalars['String'];
  seasonName: Scalars['String'];
  description: Scalars['String'];
  packageImage: Scalars['URI'];
  isNewArrival: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  viewingTypes: Array<G_VideoViewingType>;
};

/**  視聴期限  */
export type G_VideoViewingExpiration = G_VideoRentalViewingExpiration | G_VideoLegacyViewingExpiration | G_VideoFixedViewingExpiration;

/**  視聴権利  */
export type G_VideoViewingRights = {
  /**  コンテンツID  */
  contentId: Scalars['ID'];
  /**
   *  ファイルID
   * @deprecated BFF内部で利用
   */
  fileId: Scalars['ID'];
  /**  再生デバイス  */
  device: G_PlayDevice;
  /**  コンテンツ種別(2D/VR)  */
  contentType: G_VideoContentType;
  /**  ストリーミング可能か  */
  isStreamable: Scalars['Boolean'];
  /**  ダウンロード可能か  */
  isDownloadable: Scalars['Boolean'];
  /**
   *  ダウンロード可能な品質グループリスト
   * @deprecated Field no longer supported
   */
  downloadableQualityGroups?: Maybe<Array<Scalars['String']>>;
  /**  品質毎のダウンロードファイル情報  */
  downloadableFiles?: Maybe<Array<G_VideoDownloadFile>>;
  /**  アプリ起動スキーム  */
  appURLSchemes?: Maybe<Array<G_VideoAppUrlScheme>>;
};


/**  視聴権利  */
export type G_VideoViewingRightsAppUrlSchemesArgs = {
  app: G_VideoApp;
};

/** 視聴形式 */
export enum G_VideoViewingType {
  /**  プレミアム  */
  Premium = 'PREMIUM',
  /**  有料  */
  Ppv = 'PPV',
  /**  無料  */
  Free = 'FREE'
}

/** 視聴形式の絞り込みアイテム */
export type G_VideoViewingTypeFacetItem = {
  name: Scalars['String'];
  value: G_VideoViewingType;
  count: Scalars['Int'];
};

/** プロフィールごとの視聴レーティング制限 */
export enum G_ViewableRating {
  /** 一般作品まで視聴可能 */
  G = 'G',
  /** PG12まで視聴可能 */
  Pg12 = 'PG12',
  /** R15まで視聴可能 */
  R15 = 'R15',
  /** アダルトとグラビア以外のR18まで視聴可能 */
  R18Restrict = 'R18_RESTRICT',
  /** R18まで視聴可能 */
  R18 = 'R18'
}

/** プロフィール選択後のユーザ情報 */
export type G_Viewer = {
  /**  プロフィール  */
  profile: G_Profile;
  /**  テレビデバイスホーム設定  */
  homeSettings: G_HomeSettings;
  /**  VRデバイスホーム設定  */
  vrHomeSettings: G_VrHomeSettings;
  /**  デモグラフィック情報があるか  */
  hasDemographic: Scalars['Boolean'];
  /**  ブックマーク(ビデオ)  */
  videoBookmarks: G_VideoBookmarkConnection;
  /**  ブックマークしたビデオの値下げ通知  */
  videoPriceDropNotifications: G_VideoPriceDropNotificationConnection;
  /**  視聴履歴  */
  videoPlayHistories: G_VideoPlayHistoryConnection;
  /**  続きから見る  */
  continueWatchingList: G_VideoContinueWatchingConnection;
  /**  購入済みビデオ  */
  purchasedVideos: G_PurchasedVideoConnection;
};


/** プロフィール選択後のユーザ情報 */
export type G_ViewerVideoBookmarksArgs = {
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


/** プロフィール選択後のユーザ情報 */
export type G_ViewerVideoPriceDropNotificationsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** プロフィール選択後のユーザ情報 */
export type G_ViewerVideoPlayHistoriesArgs = {
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** プロフィール選択後のユーザ情報 */
export type G_ViewerContinueWatchingListArgs = {
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


/** プロフィール選択後のユーザ情報 */
export type G_ViewerPurchasedVideosArgs = {
  device: G_Device;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  ratingLimit?: Maybe<G_VideoRatingCategory>;
  sort?: Maybe<G_PurchasedVideoSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};

/** 評価ステータス */
export enum G_VoteStatus {
  /**  成功  */
  Success = 'SUCCESS',
  /**  既に評価済み  */
  Voted = 'VOTED',
  /**  レビュー投稿者とレビュー評価者が同じ  */
  SameReviewer = 'SAME_REVIEWER'
}

/** DMMポイント, TVコインの残高 */
export type G_Wallet = {
  /**
   * サービス共通で利用できる、ユーザが購入したDMMポイント
   * (有償 & 無償DMMポイント)
   */
  dmmPoint: G_DmmPoint;
  /**  TVコイン  */
  tvCoin: Scalars['Int'];
  /**  クレジットカード情報  */
  creditCard: G_CreditCard;
};


/** DMMポイント, TVコインの残高 */
export type G_WalletTvCoinArgs = {
  device: G_Device;
};



export type G__Service = {
  sdl?: Maybe<Scalars['String']>;
};

export type G_FetchAllVideoCopyrightsQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchAllVideoCopyrightsQuery = Pick<G_Query, 'allVideoCopyrights'>;

export type G_FetchClientQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchClientQuery = { client: Pick<G_Client, 'isForeignAccess'> };

export type G_GetCommentsQueryVariables = Exact<{
  contentId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
}>;


export type G_GetCommentsQuery = { comments: (
    Pick<G_CommentConnection, 'commentRefreshIntervalSeconds'>
    & { edges: Array<(
      Pick<G_CommentEdge, 'cursor'>
      & { node: Pick<G_Comment, 'hashedUserId' | 'id' | 'body' | 'createdAt'> }
    )>, pageInfo: Pick<G_PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'> }
  ) };

export type G_PostCommentMutationVariables = Exact<{
  input: G_PostCommentInput;
}>;


export type G_PostCommentMutation = { postComment: Pick<G_PostCommentPayload, 'mutationId'> };

export type G_ReportInappropriateCommentMutationVariables = Exact<{
  input: G_ReportInappropriateCommentInput;
}>;


export type G_ReportInappropriateCommentMutation = { reportInappropriateComment: Pick<G_ReportInappropriateCommentPayload, 'mutationId'> };

export type G_AddVideoBookmarkMutationVariables = Exact<{
  input: G_AddVideoBookmarkInput;
}>;


export type G_AddVideoBookmarkMutation = { addVideoBookmark: Pick<G_AddVideoBookmarkPayload, 'mutationId'> };

export type G_DeleteVideoBookmarksMutationVariables = Exact<{
  input: G_DeleteVideoBookmarksInput;
}>;


export type G_DeleteVideoBookmarksMutation = { deleteVideoBookmarks: Pick<G_DeleteVideoBookmarksPayload, 'mutationId'> };

export type G_GetVideoByMiniDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  playDevice: G_PlayDevice;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetVideoByMiniDetailQuery = { video: (
    { __typename: 'VideoLegacySeason' }
    & MakeOptional<Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'viewingTypes' | 'seasonType' | 'isBeingDelivered' | 'isPublic' | 'hasBookmark'>, 'hasBookmark'>
    & { sampleMovie?: Maybe<Pick<G_SampleMovie, 'url'>>, continueWatching?: Maybe<(
      Pick<G_VideoContinueWatching, 'id' | 'contentId' | 'resumePoint' | 'partNumber'>
      & { content: (
        Pick<G_VideoContent, 'id' | 'contentType' | 'episodeTitle' | 'episodeNumberName' | 'episodeImage'>
        & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
          Pick<G_VideoPpvProduct, 'id' | 'contentId'>
          & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
        )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, playInfo?: Maybe<(
          Pick<G_VideoPlayInfo, 'duration'>
          & { parts: Array<Pick<G_VideoPart, 'number' | 'contentId' | 'resumePoint' | 'duration'>> }
        )> }
      ) }
    )>, content: (
      Pick<G_VideoContent, 'id' | 'episodeTitle' | 'episodeNumberName' | 'contentType'>
      & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, playInfo?: Maybe<(
        Pick<G_VideoPlayInfo, 'duration'>
        & { parts: Array<Pick<G_VideoPart, 'contentId' | 'resumePoint' | 'number'>> }
      )>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
        Pick<G_VideoPpvProduct, 'id' | 'contentId'>
        & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
      )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'> }
    ) }
  ) | (
    { __typename: 'VideoSeason' }
    & MakeOptional<Pick<G_VideoSeason, 'id' | 'titleName' | 'viewingTypes' | 'seasonType' | 'isBeingDelivered' | 'isPublic' | 'hasBookmark'>, 'hasBookmark'>
    & { continueWatching?: Maybe<(
      Pick<G_VideoContinueWatching, 'id' | 'contentId' | 'resumePoint'>
      & { content: (
        Pick<G_VideoContent, 'id' | 'contentType' | 'episodeTitle' | 'episodeNumberName' | 'episodeImage'>
        & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
          Pick<G_VideoPpvProduct, 'id' | 'contentId'>
          & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
        )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, playInfo?: Maybe<(
          Pick<G_VideoPlayInfo, 'duration'>
          & { parts: Array<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint'>> }
        )> }
      ) }
    )>, mainEpisodes: { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'contentType' | 'episodeTitle' | 'episodeNumberName'>
          & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
            Pick<G_VideoPpvProduct, 'id' | 'contentId'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'> }
        ) }> }, pvEpisodes: { edges: Array<{ node: Pick<G_VideoContent, 'id' | 'sampleMovie'> }> } }
  ) | (
    { __typename: 'VideoSpotLiveSeason' }
    & MakeOptional<Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'viewingTypes' | 'seasonType' | 'isBeingDelivered' | 'isPublic' | 'hasBookmark'>, 'hasBookmark'>
    & { mainEpisodes: { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'contentType' | 'episodeNumberName' | 'episodeTitle'>
          & { ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
            Pick<G_VideoPpvProduct, 'id' | 'contentId'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
        ) }> }, pvEpisodes: { edges: Array<{ node: Pick<G_VideoContent, 'id' | 'sampleMovie'> }> } }
  ) | (
    { __typename: 'VideoStageSeason' }
    & MakeOptional<Pick<G_VideoStageSeason, 'id' | 'titleName' | 'viewingTypes' | 'seasonType' | 'isBeingDelivered' | 'isPublic' | 'hasBookmark'>, 'hasBookmark'>
  ) };

export type G_FetchDownloadFileUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  part?: Maybe<Scalars['Int']>;
  qualityName: Scalars['String'];
  fileType: G_DownloadType;
}>;


export type G_FetchDownloadFileUrlQuery = Pick<G_Query, 'downloadFileUrl'>;

export type G_FetchHomeQueryVariables = Exact<{
  device: G_Device;
  homeType: G_HomeType;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  visitorId: Scalars['ID'];
  eventType: G_RecommendationEventType;
}>;


export type G_FetchHomeQuery = { home: (
    Pick<G_Home, 'id' | 'title' | 'device' | 'type' | 'categoryId'>
    & { genres?: Maybe<Array<Pick<G_VideoGenre, 'id' | 'name'>>>, notification?: Maybe<Pick<G_Notification, 'id' | 'title'>>, allVideoSubPages: Array<Pick<G_Home, 'id' | 'title'>>, headerItems: Array<(
      { __typename: 'URLFreeItem' }
      & Pick<G_UrlFreeItem, 'id' | 'image' | 'name' | 'url' | 'isHiddenForPremiumMember'>
    ) | (
      { __typename: 'VideoFreeItem' }
      & Pick<G_VideoFreeItem, 'id' | 'image' | 'name' | 'seasonId' | 'isHiddenForPremiumMember'>
      & { video: (
        { __typename: 'VideoLegacySeason' }
        & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoSeason' }
        & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoSpotLiveSeason' }
        & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoStageSeason' }
        & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) }
    ) | (
      { __typename: 'VideoListFreeItem' }
      & Pick<G_VideoListFreeItem, 'id' | 'name' | 'image' | 'isHiddenForPremiumMember'>
      & { filter: Pick<G_VideoFilter, 'keyword' | 'title' | 'categories' | 'genres' | 'casts' | 'staffs' | 'series' | 'contentType' | 'viewingTypes' | 'campaigns' | 'sort'> }
    ) | (
      { __typename: 'VideoContentFreeItem' }
      & Pick<G_VideoContentFreeItem, 'id' | 'image' | 'name' | 'isHiddenForPremiumMember'>
      & { content: (
        Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeDetail' | 'episodeImage'>
        & { svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<Pick<G_VideoPpvProduct, 'id'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
      ) }
    ) | (
      { __typename: 'HomeFreeItem' }
      & Pick<G_HomeFreeItem, 'id' | 'homeId' | 'name' | 'image' | 'pageType' | 'isHiddenForPremiumMember'>
    )>, shelves: { edges: Array<{ node: (
          { __typename: 'ShelfOfContinueWatching' }
          & Pick<G_ShelfOfContinueWatching, 'id'>
          & { continueWatching: { edges: Array<{ node: (
                { __typename: 'VideoContinueWatching' }
                & Pick<G_VideoContinueWatching, 'id' | 'contentId' | 'partNumber'>
                & { video: (
                  { __typename: 'VideoLegacySeason' }
                  & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'isNewArrival' | 'customTag' | 'isExclusive' | 'seasonType'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSeason' }
                  & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'isNewArrival' | 'customTag' | 'isExclusive' | 'seasonType'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSpotLiveSeason' }
                  & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'isNewArrival' | 'customTag' | 'isExclusive' | 'seasonType'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoStageSeason' }
                  & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'isNewArrival' | 'customTag' | 'isExclusive' | 'seasonType'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ), content: (
                  Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeImage' | 'episodeTitle' | 'episodeNumber' | 'episodeDetail' | 'episodeNumberName'>
                  & { playInfo: (
                    Pick<G_VideoPlayInfo, 'contentId' | 'resumePartNumber'>
                    & { parts: Array<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint' | 'number'>> }
                  ) }
                ) }
              ) }> } }
        ) | (
          { __typename: 'ShelfOfBookmarkedVideos' }
          & Pick<G_ShelfOfBookmarkedVideos, 'id' | 'device'>
          & { bookmarkedVideos: { edges: Array<{ node: (
                Pick<G_VideoBookmark, 'id'>
                & { video: (
                  { __typename: 'VideoLegacySeason' }
                  & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive' | 'customTag'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoSeason' }
                  & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive' | 'customTag'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoSpotLiveSeason' }
                  & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive' | 'customTag'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoStageSeason' }
                  & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive' | 'customTag'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) }
              ) }> } }
        ) | (
          { __typename: 'ShelfOfVideoRankings' }
          & Pick<G_ShelfOfVideoRankings, 'id' | 'device'>
          & { videoRankings: { edges: Array<{ node: (
                Pick<G_VideoRankingItem, 'id' | 'rank'>
                & { video: (
                  { __typename: 'VideoLegacySeason' }
                  & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSeason' }
                  & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSpotLiveSeason' }
                  & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoStageSeason' }
                  & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) }
              ) }> } }
        ) | (
          { __typename: 'ShelfOfRecommendedVideos' }
          & Pick<G_ShelfOfRecommendedVideos, 'id' | 'device'>
          & { u2iRecommendedVideos: (
            Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
            & { edges: Array<{ node: (
                Pick<G_RecommendedVideoItem, 'id'>
                & { video: (
                  { __typename: 'VideoLegacySeason' }
                  & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoSeason' }
                  & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoSpotLiveSeason' }
                  & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) | (
                  { __typename: 'VideoStageSeason' }
                  & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
                ) }
              ) }> }
          ) }
        ) | (
          { __typename: 'ShelfOfPresetVideos' }
          & Pick<G_ShelfOfPresetVideos, 'id' | 'device' | 'imageType' | 'name'>
          & { presetVideos: { edges: Array<{ node: (
                { __typename: 'VideoLegacySeason' }
                & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
              ) | (
                { __typename: 'VideoSeason' }
                & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
              ) | (
                { __typename: 'VideoSpotLiveSeason' }
                & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
              ) | (
                { __typename: 'VideoStageSeason' }
                & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
              ) }> } }
        ) | (
          { __typename: 'ShelfOfPresetContents' }
          & Pick<G_ShelfOfPresetContents, 'id' | 'name'>
          & { presetContents: { edges: Array<{ node: Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName' | 'episodeImage'> }> } }
        ) | (
          { __typename: 'ShelfOfFreeItems' }
          & Pick<G_ShelfOfFreeItems, 'id' | 'name' | 'freeItemType'>
          & { freeItems: { edges: Array<(
              Pick<G_FreeItemEdge, 'cursor'>
              & { node: (
                { __typename: 'URLFreeItem' }
                & Pick<G_UrlFreeItem, 'id' | 'image' | 'name' | 'url' | 'isHiddenForPremiumMember'>
              ) | (
                { __typename: 'VideoFreeItem' }
                & Pick<G_VideoFreeItem, 'id' | 'image' | 'name' | 'seasonId' | 'isHiddenForPremiumMember'>
                & { video: (
                  { __typename: 'VideoLegacySeason' }
                  & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSeason' }
                  & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoSpotLiveSeason' }
                  & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) | (
                  { __typename: 'VideoStageSeason' }
                  & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
                  & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
                ) }
              ) | (
                { __typename: 'VideoListFreeItem' }
                & Pick<G_VideoListFreeItem, 'id' | 'name' | 'image' | 'isHiddenForPremiumMember'>
                & { filter: Pick<G_VideoFilter, 'keyword' | 'title' | 'categories' | 'genres' | 'casts' | 'staffs' | 'series' | 'contentType' | 'viewingTypes' | 'campaigns' | 'sort'> }
              ) | (
                { __typename: 'VideoContentFreeItem' }
                & Pick<G_VideoContentFreeItem, 'id' | 'image' | 'name' | 'isHiddenForPremiumMember'>
                & { content: (
                  Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeDetail' | 'episodeImage'>
                  & { svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<Pick<G_VideoPpvProduct, 'id'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
                ) }
              ) | (
                { __typename: 'HomeFreeItem' }
                & Pick<G_HomeFreeItem, 'id' | 'homeId' | 'name' | 'image' | 'pageType' | 'isHiddenForPremiumMember'>
              ) }
            )>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'hasNextPage' | 'endCursor'> } }
        ) }>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'hasNextPage' | 'endCursor'> } }
  ) };

export type G_FetchMaintenanceQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchMaintenanceQuery = { maintenance?: Maybe<Pick<G_Maintenance, 'title' | 'description' | 'startAt' | 'endAt'>> };

export type G_FetchNotificationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type G_FetchNotificationQuery = { notification?: Maybe<Pick<G_Notification, 'id' | 'title' | 'body' | 'startPublicAt'>> };

export type G_FetchNotificationsQueryVariables = Exact<{
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchNotificationsQuery = { notifications: { edges: Array<(
      Pick<G_NotificationEdge, 'cursor'>
      & { node: Pick<G_Notification, 'id' | 'title' | 'body' | 'startPublicAt'> }
    )>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'endCursor' | 'hasNextPage'> } };

export type G_PostEvaluateReviewMutationVariables = Exact<{
  input: G_EvaluateReviewInput;
}>;


export type G_PostEvaluateReviewMutation = { evaluateReview: Pick<G_EvaluateReviewPayload, 'mutationId' | 'voteStatus'> };

export type G_PostVideoReviewMutationVariables = Exact<{
  input: G_VideoReviewInput;
}>;


export type G_PostVideoReviewMutation = { postVideoReview: (
    Pick<G_PostReviewPayload, 'mutationId'>
    & { error?: Maybe<Pick<G_PostReviewError, 'code'>> }
  ) };

export type G_PostPurchaseVideoByCashierMutationVariables = Exact<{
  input: G_PurchaseVideoByCashierInput;
}>;


export type G_PostPurchaseVideoByCashierMutation = { purchaseVideoByCashier: Pick<G_PurchaseVideoByCashierPayload, 'cashierUrl' | 'mutationId'> };

export type G_PostPurchaseWakuwariVideoByCashierMutationVariables = Exact<{
  input: G_PurchaseWakuwariVideoByCashierInput;
}>;


export type G_PostPurchaseWakuwariVideoByCashierMutation = { purchaseWakuwariVideoByCashier: Pick<G_PurchaseWakuwariVideoByCashierPayload, 'mutationId' | 'cashierUrl'> };

export type G_GetVideoQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  contentId: Scalars['ID'];
  device: G_Device;
  playDevice: G_PlayDevice;
  isLoggedIn: Scalars['Boolean'];
  isContentId: Scalars['Boolean'];
}>;


export type G_GetVideoQuery = { video: (
    { __typename: 'VideoLegacySeason' }
    & MakeOptional<Pick<G_VideoLegacySeason, 'packageLargeImage' | 'id' | 'seasonType' | 'hasBookmark' | 'titleName' | 'seasonName' | 'highlight' | 'description' | 'notices' | 'packageImage' | 'productionYear' | 'isNewArrival' | 'customTag' | 'isPublic' | 'isExclusive' | 'isBeingDelivered' | 'viewingTypes' | 'url' | 'startPublicAt' | 'copyright'>, 'hasBookmark'>
    & { metaDescription: G_VideoLegacySeason['description'] }
    & { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, sampleMovie?: Maybe<Pick<G_SampleMovie, 'url' | 'thumbnail'>>, samplePictures: Array<Pick<G_VideoSamplePicture, 'image' | 'imageLarge'>>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>>, continueWatching?: Maybe<(
      Pick<G_VideoContinueWatching, 'partNumber' | 'resumePoint' | 'contentId'>
      & { content: { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, playInfo: { parts: Array<Pick<G_VideoPart, 'contentId'>> }, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> } }
    )>, content: (
      Pick<G_VideoContent, 'id' | 'contentType'>
      & { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, viewingRights: (
        Pick<G_VideoViewingRights, 'isStreamable' | 'isDownloadable'>
        & { downloadableFiles?: Maybe<Array<(
          Pick<G_VideoDownloadFile, 'totalFileSize'>
          & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
        )>>, windowsURLSchemes?: Maybe<Array<Pick<G_VideoAppUrlScheme, 'partNumber' | 'url'>>>, iosURLSchemes?: Maybe<Array<Pick<G_VideoAppUrlScheme, 'partNumber' | 'url'>>>, androidURLSchemes?: Maybe<Array<Pick<G_VideoAppUrlScheme, 'partNumber' | 'url'>>> }
      ), playInfo: (
        Pick<G_VideoPlayInfo, 'duration' | 'audioRenditions' | 'textRenditions' | 'highestQuality' | 'isSupportHDR' | 'highestAudioChannelLayout'>
        & { parts: Array<Pick<G_VideoPart, 'contentId' | 'number'>> }
      ), ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
        MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
        & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
      )>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'startDeliveryAt'>>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
    ), series?: Maybe<Pick<G_VideoSeries, 'id' | 'name'>>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, rating: Pick<G_VideoRating, 'category'>, casts: Array<(
      Pick<G_Cast, 'castName' | 'actorName'>
      & { person: Pick<G_Person, 'id'> }
    )>, staffs: Array<(
      Pick<G_Staff, 'roleName' | 'staffName'>
      & { person: Pick<G_Person, 'id'> }
    )>, categories: Array<Pick<G_VideoCategory, 'name' | 'id'>>, genres: Array<Pick<G_VideoGenre, 'name' | 'id'>>, relatedItems: { videos: Array<(
        Pick<G_RelatedVideo, 'seasonId'>
        & { video: (
          Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) }
      )>, books: Array<Pick<G_RelatedBook, 'seriesId' | 'title' | 'thumbnail' | 'url'>>, mono?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, scratch?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, onlineCrane?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>> } }
  ) | (
    { __typename: 'VideoSeason' }
    & MakeOptional<Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonType' | 'hasBookmark' | 'titleName' | 'seasonName' | 'highlight' | 'description' | 'notices' | 'packageImage' | 'productionYear' | 'isNewArrival' | 'customTag' | 'isPublic' | 'isExclusive' | 'isBeingDelivered' | 'viewingTypes' | 'url' | 'startPublicAt' | 'copyright'>, 'hasBookmark'>
    & { metaDescription: G_VideoSeason['description'] }
    & { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, relatedSeasons: Array<Pick<G_VideoRelatedSeason, 'id' | 'title'>>, nextDeliveryEpisode: Pick<G_NextDeliveryEpisode, 'isBeforeDelivered' | 'startDeliveryAt'>, continueWatching?: Maybe<(
      Pick<G_VideoContinueWatching, 'id' | 'resumePoint' | 'contentId'>
      & { content: (
        Pick<G_VideoContent, 'episodeImage' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName'>
        & { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, ppvProducts: Array<(
          MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
          & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
        )>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'startDeliveryAt'>> }
      ) }
    )>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>>, episode?: Maybe<(
      Pick<G_VideoContent, 'id' | 'episodeTitle' | 'episodeImage' | 'episodeNumber' | 'episodeNumberName' | 'episodeDetail'>
      & { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, playInfo: (
        MakeOptional<Pick<G_VideoPlayInfo, 'highestQuality' | 'isSupportHDR' | 'highestAudioChannelLayout' | 'duration' | 'audioRenditions' | 'textRenditions' | 'resumePartNumber'>, 'resumePartNumber'>
        & { parts: Array<MakeOptional<Pick<G_VideoPart, 'contentId' | 'number' | 'duration' | 'resumePoint'>, 'resumePoint'>> }
      ), viewingRights: Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
        MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
        & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
      )>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'startDeliveryAt'>>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
    )>, episodes: (
      Pick<G_VideoContentConnection, 'total'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'sampleMovie' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName'>
          & { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, playInfo: (
            MakeOptional<Pick<G_VideoPlayInfo, 'highestQuality' | 'isSupportHDR' | 'highestAudioChannelLayout' | 'duration' | 'audioRenditions' | 'textRenditions' | 'resumePartNumber'>, 'resumePartNumber'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'number' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: (
            Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>
            & { downloadableFiles?: Maybe<Array<(
              Pick<G_VideoDownloadFile, 'totalFileSize'>
              & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
            )>> }
          ), ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
            MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'startDeliveryAt'>>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
        ) }> }
    ), purchasedContents?: Maybe<(
      Pick<G_VideoPurchasedContentConnection, 'total'>
      & { edges: Array<{ node: Pick<G_VideoContent, 'id'> }> }
    )>, specialEpisode: Pick<G_VideoContentConnection, 'total'>, pvEpisode: (
      Pick<G_VideoContentConnection, 'total'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'sampleMovie'>
          & { playInfo: Pick<G_VideoPlayInfo, 'duration'> }
        ) }> }
    ), campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, rating: Pick<G_VideoRating, 'category'>, casts: Array<(
      Pick<G_Cast, 'castName' | 'actorName'>
      & { person: Pick<G_Person, 'id'> }
    )>, staffs: Array<(
      Pick<G_Staff, 'roleName' | 'staffName'>
      & { person: Pick<G_Person, 'id'> }
    )>, categories: Array<Pick<G_VideoCategory, 'name' | 'id'>>, genres: Array<Pick<G_VideoGenre, 'name' | 'id'>>, relatedItems: { videos: Array<(
        Pick<G_RelatedVideo, 'seasonId'>
        & { video: (
          Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) }
      )>, books: Array<Pick<G_RelatedBook, 'seriesId' | 'title' | 'thumbnail' | 'url'>>, mono?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, scratch?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, onlineCrane?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>> } }
  ) | (
    { __typename: 'VideoSpotLiveSeason' }
    & MakeOptional<Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonType' | 'hasBookmark' | 'titleName' | 'seasonName' | 'highlight' | 'description' | 'notices' | 'packageImage' | 'productionYear' | 'isNewArrival' | 'customTag' | 'isPublic' | 'isExclusive' | 'isBeingDelivered' | 'viewingTypes' | 'url' | 'startPublicAt' | 'copyright'>, 'hasBookmark'>
    & { metaDescription: G_VideoSpotLiveSeason['description'] }
    & { episodes: { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName'>
          & { drmLevel: Pick<G_DrmLevel, 'hasStrictProtection'>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
            MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'startDeliveryAt'>>, playInfo: Pick<G_VideoPlayInfo, 'audioRenditions' | 'textRenditions' | 'duration' | 'highestQuality' | 'isSupportHDR' | 'highestAudioChannelLayout'>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
        ) }> }, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, rating: Pick<G_VideoRating, 'category'>, casts: Array<(
      Pick<G_Cast, 'castName' | 'actorName'>
      & { person: Pick<G_Person, 'id'> }
    )>, staffs: Array<(
      Pick<G_Staff, 'roleName' | 'staffName'>
      & { person: Pick<G_Person, 'id'> }
    )>, categories: Array<Pick<G_VideoCategory, 'name' | 'id'>>, genres: Array<Pick<G_VideoGenre, 'name' | 'id'>>, relatedItems: { videos: Array<(
        Pick<G_RelatedVideo, 'seasonId'>
        & { video: (
          Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) }
      )>, books: Array<Pick<G_RelatedBook, 'seriesId' | 'title' | 'thumbnail' | 'url'>>, mono?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, scratch?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, onlineCrane?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>> } }
  ) | (
    { __typename: 'VideoStageSeason' }
    & MakeOptional<Pick<G_VideoStageSeason, 'id' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonType' | 'hasBookmark' | 'titleName' | 'seasonName' | 'highlight' | 'description' | 'notices' | 'packageImage' | 'productionYear' | 'isNewArrival' | 'customTag' | 'isPublic' | 'isExclusive' | 'isBeingDelivered' | 'viewingTypes' | 'url' | 'startPublicAt' | 'copyright'>, 'hasBookmark'>
    & { metaDescription: G_VideoStageSeason['description'] }
    & { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>>, allPerformances: Array<(
      Pick<G_VideoStagePerformance, 'performanceDate'>
      & { contents: Array<(
        Pick<G_VideoContent, 'id' | 'episodeTitle' | 'priority' | 'startLivePerformanceAt'>
        & { ppvProducts: Array<(
          MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
          & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
        )>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'isLimitedPremium'>> }
      )> }
    )>, purchasedContents?: Maybe<(
      Pick<G_VideoPurchasedContentConnection, 'total'>
      & { edges: Array<{ node: Pick<G_VideoContent, 'id'> }> }
    )>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, rating: Pick<G_VideoRating, 'category'>, casts: Array<(
      Pick<G_Cast, 'castName' | 'actorName'>
      & { person: Pick<G_Person, 'id'> }
    )>, staffs: Array<(
      Pick<G_Staff, 'roleName' | 'staffName'>
      & { person: Pick<G_Person, 'id'> }
    )>, categories: Array<Pick<G_VideoCategory, 'name' | 'id'>>, genres: Array<Pick<G_VideoGenre, 'name' | 'id'>>, relatedItems: { videos: Array<(
        Pick<G_RelatedVideo, 'seasonId'>
        & { video: (
          Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) | (
          Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { rating: Pick<G_VideoRating, 'category'> }
        ) }
      )>, books: Array<Pick<G_RelatedBook, 'seriesId' | 'title' | 'thumbnail' | 'url'>>, mono?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, scratch?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>>, onlineCrane?: Maybe<Pick<G_RelatedItemLink, 'banner' | 'url'>> } }
  ) };

export type G_GetVideoMainEpisodeQueryVariables = Exact<{
  id: Scalars['ID'];
  device: G_PlayDevice;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Int']>;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetVideoMainEpisodeQuery = { video: { episodes: (
      Pick<G_VideoContentConnection, 'total' | 'allEpisodeNumbers'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeType' | 'episodeImage' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName'>
          & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'isLimitedPremium' | 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice'>>, playInfo: (
            Pick<G_VideoPlayInfo, 'contentId' | 'duration'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'contentId' | 'number' | 'duration' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: (
            Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>
            & { downloadableFiles?: Maybe<Array<(
              Pick<G_VideoDownloadFile, 'totalFileSize'>
              & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
            )>> }
          ), svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'isBeingDelivered' | 'contentId'>>, ppvProducts: Array<(
            MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'isBeingDelivered' | 'contentId'>>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>> }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> }
    ) } };

export type G_GetVideoPurchasedEpisodeQueryVariables = Exact<{
  id: Scalars['ID'];
  device: G_PlayDevice;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetVideoPurchasedEpisodeQuery = { video?: Maybe<{ purchasedContents: (
      Pick<G_VideoPurchasedContentConnection, 'total'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeType' | 'episodeImage' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName' | 'contentType'>
          & { playInfo: (
            Pick<G_VideoPlayInfo, 'contentId' | 'duration'>
            & { parts: Array<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint'>> }
          ), viewingRights: (
            Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>
            & { downloadableFiles?: Maybe<Array<(
              Pick<G_VideoDownloadFile, 'totalFileSize'>
              & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
            )>> }
          ), ppvProducts: Array<(
            MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>> }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> }
    ) } | (
    Pick<G_VideoStageSeason, 'id'>
    & { purchasedContents: (
      Pick<G_VideoPurchasedContentConnection, 'total'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeType' | 'episodeImage' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName' | 'contentType'>
          & { playInfo: (
            Pick<G_VideoPlayInfo, 'contentId' | 'duration'>
            & { parts: Array<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint'>> }
          ), viewingRights: (
            Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>
            & { downloadableFiles?: Maybe<Array<(
              Pick<G_VideoDownloadFile, 'totalFileSize'>
              & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
            )>> }
          ), ppvProducts: Array<(
            MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'isOnSale' | 'isBeingDelivered' | 'isBundleParent' | 'isPurchased'>, 'isPurchased'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'viewingExpiration' | 'viewingStartExpiration' | 'startDeliveryAt'>> }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> }
    ) }
  )> };

export type G_GetVideoPvEpisodeQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Int']>;
}>;


export type G_GetVideoPvEpisodeQuery = { video: { episodes: (
      Pick<G_VideoContentConnection, 'total' | 'allEpisodeNumbers'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'episodeType' | 'episodeImage' | 'episodeTitle' | 'episodeDetail'>
          & { playInfo: Pick<G_VideoPlayInfo, 'duration'> }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> }
    ) } };

export type G_GetVideoSpecialEpisodeQueryVariables = Exact<{
  id: Scalars['ID'];
  device: G_PlayDevice;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Int']>;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetVideoSpecialEpisodeQuery = { video: { episodes: (
      Pick<G_VideoContentConnection, 'total' | 'allEpisodeNumbers'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeType' | 'episodeImage' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName'>
          & { playInfo: (
            Pick<G_VideoPlayInfo, 'contentId' | 'duration'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: (
            Pick<G_VideoViewingRights, 'isDownloadable' | 'isStreamable'>
            & { downloadableFiles?: Maybe<Array<(
              Pick<G_VideoDownloadFile, 'totalFileSize'>
              & { quality: Pick<G_Quality, 'name' | 'displayName' | 'displayPriority'>, parts: Array<Pick<G_VideoPartOfDownloadFile, 'partNumber' | 'fileSize'>> }
            )>> }
          ) }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> }
    ) } };

export type G_GetVideoReviewsQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_GetVideoReviewsQuery = { video: { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, reviews: (
      Pick<G_ReviewConnection, 'total'>
      & { edges: Array<{ node: Pick<G_Review, 'id' | 'reviewerName' | 'reviewerId' | 'title' | 'point' | 'hasSpoiler' | 'comment' | 'date' | 'isReviewerPurchased' | 'helpfulVoteCount'> }>, pageInfo: Pick<G_PageInfo, 'hasNextPage' | 'endCursor'> }
    ) } | { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, reviews: (
      Pick<G_ReviewConnection, 'total'>
      & { edges: Array<{ node: Pick<G_Review, 'id' | 'reviewerName' | 'reviewerId' | 'title' | 'point' | 'hasSpoiler' | 'comment' | 'date' | 'isReviewerPurchased' | 'helpfulVoteCount'> }>, pageInfo: Pick<G_PageInfo, 'hasNextPage' | 'endCursor'> }
    ) } | (
    Pick<G_VideoStageSeason, 'id'>
    & { reviewSummary: Pick<G_ReviewSummary, 'averagePoint' | 'reviewerCount' | 'reviewCommentCount'>, reviews: (
      Pick<G_ReviewConnection, 'total'>
      & { edges: Array<{ node: Pick<G_Review, 'id' | 'reviewerName' | 'reviewerId' | 'title' | 'point' | 'hasSpoiler' | 'comment' | 'date' | 'isReviewerPurchased' | 'helpfulVoteCount'> }>, pageInfo: Pick<G_PageInfo, 'hasNextPage' | 'endCursor'> }
    ) }
  ) };

export type G_GetRecommendedVideoQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type G_GetRecommendedVideoQuery = { video: { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
            & { rating: Pick<G_VideoRating, 'category'> }
          ) }
        ) }> }
    ) } };

export type G_GetVideoPurchaseModalDataQueryVariables = Exact<{
  seasonId: Scalars['ID'];
}>;


export type G_GetVideoPurchaseModalDataQuery = { video: (
    Pick<G_VideoLegacySeason, 'titleName' | 'seasonName' | 'seasonType'>
    & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>> }
  ) | (
    Pick<G_VideoSeason, 'titleName' | 'seasonName' | 'seasonType'>
    & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>> }
  ) | (
    Pick<G_VideoSpotLiveSeason, 'titleName' | 'seasonName' | 'seasonType'>
    & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>> }
  ) | (
    Pick<G_VideoStageSeason, 'titleName' | 'seasonName' | 'seasonType'>
    & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>> }
  ) };

export type G_FetchRecommendedVideosQueryVariables = Exact<{
  visitorId: Scalars['ID'];
  device: G_Device;
  eventType: G_RecommendationEventType;
  categoryId?: Maybe<Scalars['ID']>;
  searchQuery?: Maybe<Scalars['String']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type G_FetchRecommendedVideosQuery = { u2iRecommendedVideos: (
    Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
    & { edges: Array<{ node: (
        Pick<G_RecommendedVideoItem, 'id'>
        & { video: (
          { __typename: 'VideoLegacySeason' }
          & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoSeason' }
          & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoSpotLiveSeason' }
          & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoStageSeason' }
          & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) }
      ) }> }
  ) };

export type G_VideoSearchResultConnectionFragment = (
  Pick<G_VideoSearchResultConnection, 'total'>
  & { edges: Array<{ node: (
      { __typename: 'VideoSearchResult' }
      & Pick<G_VideoSearchResult, 'id' | 'titleName' | 'seasonName' | 'packageImage' | 'packageLargeImage' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'description' | 'lowestPrice' | 'highestPrice' | 'seasonType' | 'discountedLowestPrice' | 'discountedHighestPrice' | 'isNewArrival' | 'isExclusive' | 'isOnSale' | 'customTag' | 'reviewAveragePoint' | 'rating'>
    ) }>, pageInfo: Pick<G_PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>, facet: { titles: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, categories: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, genres: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, casts: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, staffs: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, series: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, campaigns: Array<Pick<G_FacetItem, 'name' | 'value' | 'count'>>, contentTypes: Array<Pick<G_VideoContentTypeFacetItem, 'name' | 'value' | 'count'>>, viewingTypes: Array<Pick<G_VideoViewingTypeFacetItem, 'name' | 'value' | 'count'>> } }
);

export type G_FetchSearchVideosQueryVariables = Exact<{
  device: G_Device;
  keyword?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  genres?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  casts?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  staffs?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  series?: Maybe<Scalars['ID']>;
  contentType?: Maybe<G_VideoContentTypeFilter>;
  viewingTypes?: Maybe<Array<G_VideoViewingType> | G_VideoViewingType>;
  campaigns?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  sort?: Maybe<G_VideoSearchSortKey>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchSearchVideosQuery = { searchVideos: G_VideoSearchResultConnectionFragment };

export type G_FetchShelfQueryVariables = Exact<{
  id: Scalars['ID'];
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchShelfQuery = { shelf: (
    { __typename: 'ShelfOfPresetVideos' }
    & Pick<G_ShelfOfPresetVideos, 'id' | 'device' | 'imageType' | 'name'>
    & { presetVideos: { pageInfo: Pick<G_ForwardOnlyPageInfo, 'endCursor' | 'hasNextPage'>, edges: Array<{ node: (
          { __typename: 'VideoLegacySeason' }
          & Pick<G_VideoLegacySeason, 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoSeason' }
          & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoSpotLiveSeason' }
          & Pick<G_VideoSpotLiveSeason, 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) | (
          { __typename: 'VideoStageSeason' }
          & Pick<G_VideoStageSeason, 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>>, rating: Pick<G_VideoRating, 'category'> }
        ) }> } }
  ) };

export type G_AddUserProfileMutationVariables = Exact<{
  input: G_AddProfileInput;
}>;


export type G_AddUserProfileMutation = { addProfile: Pick<G_AddProfilePayload, 'mutationId'> };

export type G_UpdateUserProfileMutationVariables = Exact<{
  input: G_UpdateProfileInput;
}>;


export type G_UpdateUserProfileMutation = { updateProfile: Pick<G_UpdateProfilePayload, 'mutationId'> };

export type G_DeleteUserProfileMutationVariables = Exact<{
  input: G_DeleteProfileInput;
}>;


export type G_DeleteUserProfileMutation = { deleteProfile: Pick<G_DeleteProfilePayload, 'mutationId'> };

export type G_FetchUserQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchUserQuery = { user: (
    Pick<G_User, 'id' | 'mail' | 'hashedId' | 'isFirstSubscribe' | 'isAffiliateOwner'>
    & { planStatus: (
      Pick<G_PlanStatus, 'servicePlan' | 'status' | 'nextBillingDate' | 'paymentType'>
      & { paymentStatus: Pick<G_PaymentStatus, 'isRenewalFailure' | 'failureCode' | 'message'> }
    ), profiles: Array<(
      Pick<G_Profile, 'id' | 'isParent' | 'name' | 'viewableRating'>
      & { profileIcon: Pick<G_ProfileIcon, 'id' | 'url'>, securityCodeSettings: Pick<G_SecurityCodeSettings, 'hasSecurityCode'> }
    )>, wallet: { dmmPoint: Pick<G_DmmPoint, 'paidDmmPoint' | 'sharedFreeDmmPoint'> }, fanzaPlanStatus: Pick<G_FanzaPlanStatus, 'status'> }
  ) };

export type G_FetchUserProfileQueryVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type G_FetchUserProfileQuery = { user: (
    Pick<G_User, 'id'>
    & { profile: (
      Pick<G_Profile, 'id' | 'name' | 'isParent' | 'viewableRating'>
      & { securityCodeSettings: Pick<G_SecurityCodeSettings, 'hasSecurityCode'>, profileIcon: Pick<G_ProfileIcon, 'id' | 'url'> }
    ), profileIcons: Array<Pick<G_ProfileIcon, 'id' | 'url'>> }
  ) };

export type G_FetchUserReviewInfoQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_FetchUserReviewInfoQuery = { user?: Maybe<(
    Pick<G_User, 'id' | 'mail'>
    & { reviewer: Pick<G_Reviewer, 'id' | 'nickname' | 'videoReviewStatus'> }
  )> };

export type G_FetchUserPostedVideoReviewInfoQueryVariables = Exact<{
  seasonId: Scalars['ID'];
}>;


export type G_FetchUserPostedVideoReviewInfoQuery = { user: (
    Pick<G_User, 'id'>
    & { reviewer: (
      Pick<G_Reviewer, 'id'>
      & { postedVideoReview: Pick<G_Review, 'id' | 'title' | 'point' | 'hasSpoiler' | 'comment'> }
    ) }
  ) };

export type G_FetchVideoContentQueryVariables = Exact<{
  id: Scalars['ID'];
  playDevice: G_PlayDevice;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_FetchVideoContentQuery = { videoContent: (
    MakeOptional<Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeNumberName' | 'episodeImage' | 'episodeTitle' | 'contentType' | 'isWakuwari' | 'isAllowComment' | 'hasBookmark'>, 'hasBookmark'>
    & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, ppvExpiration?: Maybe<Pick<G_VideoPpvExpiration, 'expirationType' | 'startDeliveryAt'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<(
      MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'seasonId' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName' | 'contentPriority' | 'saleUnitPriority' | 'contentType' | 'saleUnitName' | 'saleType' | 'isPreOrder' | 'isStreamable' | 'isDownloadable' | 'isBundleParent' | 'isOnSale' | 'isPurchased' | 'startDeliveryAt' | 'endDeliveryAt'>, 'isPurchased'>
      & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, price: Pick<G_VideoPpvProductPrice, 'productId' | 'price' | 'salePrice' | 'isLimitedPremium'>, viewingExpiration?: Maybe<Pick<G_VideoRentalViewingExpiration, 'startLimitDay' | 'expireHour'> | Pick<G_VideoLegacyViewingExpiration, 'expireDay'> | Pick<G_VideoFixedViewingExpiration, 'expiresAt'>>, bundleProducts?: Maybe<Array<(
        MakeOptional<Pick<G_VideoPpvProduct, 'id' | 'contentId' | 'seasonId' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName' | 'contentPriority' | 'saleUnitPriority' | 'contentType' | 'saleUnitName' | 'saleType' | 'isPreOrder' | 'isStreamable' | 'isDownloadable' | 'isBundleParent' | 'isOnSale' | 'isPurchased' | 'startDeliveryAt' | 'endDeliveryAt'>, 'isPurchased'>
        & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt' | 'isLimitedPremium'>>, price: Pick<G_VideoPpvProductPrice, 'productId' | 'price' | 'salePrice' | 'isLimitedPremium'>, viewingExpiration?: Maybe<Pick<G_VideoRentalViewingExpiration, 'startLimitDay' | 'expireHour'> | Pick<G_VideoLegacyViewingExpiration, 'expireDay'> | Pick<G_VideoFixedViewingExpiration, 'expiresAt'>> }
      )>> }
    )>, viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, playInfo?: Maybe<(
      Pick<G_VideoPlayInfo, 'duration' | 'resumePartNumber'>
      & { parts: Array<Pick<G_VideoPart, 'duration' | 'contentId' | 'resumePoint' | 'number'>> }
    )> }
  ) };

export type G_VideoRankingConnectionFragment = { edges: Array<{ node: (
      Pick<G_VideoRankingItem, 'id' | 'rank'>
      & { video: (
        { __typename: 'VideoLegacySeason' }
        & Pick<G_VideoLegacySeason, 'packageLargeImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'customTag' | 'isNewArrival' | 'isExclusive'>
        & { reviewSummary: Pick<G_ReviewSummary, 'averagePoint'>, rating: Pick<G_VideoRating, 'category'> }
      ) | (
        { __typename: 'VideoSeason' }
        & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'customTag' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'> }
      ) | (
        { __typename: 'VideoSpotLiveSeason' }
        & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'customTag' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'> }
      ) | (
        { __typename: 'VideoStageSeason' }
        & Pick<G_VideoStageSeason, 'id' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'customTag' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'> }
      ) }
    ) }>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'endCursor' | 'hasNextPage'> };

export type G_FetchVideoRankingsQueryVariables = Exact<{
  device: G_Device;
  term: G_VideoRankingTerm;
  rankingType?: Maybe<G_VideoRankingType>;
  category?: Maybe<Scalars['ID']>;
  genre?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchVideoRankingsQuery = { videoRankings: G_VideoRankingConnectionFragment };

export type G_CreateDemographicMutationVariables = Exact<{
  input: G_CreateDemographicInput;
}>;


export type G_CreateDemographicMutation = { createDemographic: Pick<G_CreateDemographicPayload, 'succeeded' | 'mutationId'> };

export type G_FetchVideosForDemographicQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchVideosForDemographicQuery = { videosForDemographic: Array<Pick<G_VideoForDemographic, 'id' | 'packageImage' | 'categoryId' | 'genreId' | 'displayName'>> };

export type G_DeleteViewerVideoBookmarksOnMyBookmarkMutationVariables = Exact<{
  input: G_DeleteVideoBookmarksInput;
}>;


export type G_DeleteViewerVideoBookmarksOnMyBookmarkMutation = { deleteVideoBookmarks: Pick<G_DeleteVideoBookmarksPayload, 'mutationId'> };

export type G_DeleteViewerVideoPlayHistoriesMutationVariables = Exact<{
  input: G_DeleteVideoPlayHistoriesInput;
}>;


export type G_DeleteViewerVideoPlayHistoriesMutation = { deleteVideoPlayHistories: Pick<G_DeleteVideoPlayHistoriesPayload, 'mutationId'> };

export type G_FetchViewerVideoPriceDropNotificationsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchViewerVideoPriceDropNotificationsQuery = { viewer: { videoPriceDropNotifications: { edges: Array<(
        Pick<G_VideoPriceDropNotificationEdge, 'cursor'>
        & { node: (
          Pick<G_VideoPriceDropNotification, 'id' | 'campaignId' | 'priceWhenAdded' | 'latestPrice'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName'>
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName'>
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName'>
          ) }
        ) }
      )>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'endCursor' | 'hasNextPage'> } } };

export type G_FetchViewerVideoBookmarksQueryVariables = Exact<{
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchViewerVideoBookmarksQuery = { viewer: { videoBookmarks: { edges: Array<{ node: (
          { __typename: 'VideoBookmark' }
          & Pick<G_VideoBookmark, 'id' | 'createdAt'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'packageLargeImage' | 'id' | 'seasonType' | 'titleName' | 'seasonName' | 'hasBookmark' | 'packageImage' | 'description' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'viewingTypes'>
            & { purchasedContents: Pick<G_VideoPurchasedContentConnection, 'total'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt'>> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonType' | 'titleName' | 'seasonName' | 'hasBookmark' | 'packageImage' | 'description' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'viewingTypes'>
            & { purchasedContents: Pick<G_VideoPurchasedContentConnection, 'total'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt'>> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'seasonType' | 'titleName' | 'seasonName' | 'hasBookmark' | 'packageImage' | 'description' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'viewingTypes'>
            & { campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt'>> }
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonType' | 'titleName' | 'seasonName' | 'hasBookmark' | 'packageImage' | 'description' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'viewingTypes'>
            & { allPerformances: Array<{ contents: Array<(
                Pick<G_VideoContent, 'id'>
                & { ppvProducts: Array<(
                  Pick<G_VideoPpvProduct, 'id'>
                  & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
                )> }
              )> }>, purchasedContents: Pick<G_VideoPurchasedContentConnection, 'total'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'name' | 'endAt'>> }
          ) }
        ) }>, pageInfo: Pick<G_PageInfo, 'endCursor' | 'hasNextPage'> } } };

export type G_FetchViewerPurchasedVideosQueryVariables = Exact<{
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  sort?: Maybe<G_PurchasedVideoSortKey>;
}>;


export type G_FetchViewerPurchasedVideosQuery = { viewer: { purchasedVideos: { edges: Array<{ node: (
          { __typename: 'PurchasedVideo' }
          & Pick<G_PurchasedVideo, 'id'>
          & { expiration: Pick<G_VideoPurchasedViewingExpiration, 'viewingStartExpiresAt' | 'viewingExpiresAt' | 'noExpiration'>, video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'packageLargeImage' | 'id' | 'description' | 'packageImage' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark'>
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'description' | 'packageImage' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark'>
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'description' | 'packageImage' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'keyVisualWithoutLogoImage' | 'keyVisualImage' | 'description' | 'packageImage' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark'>
          ) }
        ) }>, pageInfo: Pick<G_PageInfo, 'hasNextPage' | 'endCursor'> } } };

export type G_FetchViewerVideoPlayHistoriesQueryVariables = Exact<{
  device: G_Device;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type G_FetchViewerVideoPlayHistoriesQuery = { viewer: { videoPlayHistories: { edges: Array<{ node: (
          { __typename: 'VideoPlayHistory' }
          & Pick<G_VideoPlayHistory, 'id' | 'seasonId' | 'contentId'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark' | 'packageImage' | 'description' | 'viewingTypes' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark' | 'packageImage' | 'description' | 'viewingTypes' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark' | 'packageImage' | 'description' | 'viewingTypes' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'hasBookmark' | 'packageImage' | 'description' | 'viewingTypes' | 'isNewArrival' | 'customTag' | 'isExclusive'>
          ), content: (
            Pick<G_VideoContent, 'id' | 'episodeTitle' | 'episodeDetail' | 'episodeNumberName' | 'episodeImage'>
            & { playInfo: (
              Pick<G_VideoPlayInfo, 'contentId' | 'resumePartNumber'>
              & { parts: Array<Pick<G_VideoPart, 'contentId' | 'duration' | 'resumePoint' | 'number'>> }
            ) }
          ) }
        ) }>, pageInfo: Pick<G_ForwardOnlyPageInfo, 'hasNextPage' | 'endCursor'> } } };

export type G_FetchViewerHasDemographicQueryVariables = Exact<{ [key: string]: never; }>;


export type G_FetchViewerHasDemographicQuery = { viewer: Pick<G_Viewer, 'hasDemographic'> };

export type G_GetPlaybackVideoContentQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  contentId: Scalars['ID'];
}>;


export type G_GetPlaybackVideoContentQuery = { video: (
    { __typename: 'VideoLegacySeason' }
    & Pick<G_VideoLegacySeason, 'titleName' | 'packageLargeImage' | 'seasonType' | 'packageImage'>
    & { sampleMovie?: Maybe<Pick<G_SampleMovie, 'url' | 'thumbnail'>> }
  ) | (
    { __typename: 'VideoSeason' }
    & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonType' | 'packageImage'>
    & { episode: Pick<G_VideoContent, 'episodeTitle' | 'episodeImage'> }
  ) | (
    { __typename: 'VideoSpotLiveSeason' }
    & Pick<G_VideoSpotLiveSeason, 'titleName' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonType' | 'packageImage'>
  ) | (
    { __typename: 'VideoStageSeason' }
    & Pick<G_VideoStageSeason, 'id' | 'titleName' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'seasonType' | 'packageImage'>
  ) };

export type G_GetPlaybackEpisodeQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  contentId: Scalars['ID'];
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetPlaybackEpisodeQuery = { video: (
    { __typename: 'VideoLegacySeason' }
    & Pick<G_VideoLegacySeason, 'id'>
  ) | (
    { __typename: 'VideoSeason' }
    & Pick<G_VideoSeason, 'id'>
    & { episode: Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeNumber' | 'episodeNumberName' | 'episodeImage'>, purchasedContents?: Maybe<{ edges: Array<{ node: Pick<G_VideoContent, 'id' | 'seasonId'> }> }> }
  ) | (
    { __typename: 'VideoSpotLiveSeason' }
    & Pick<G_VideoSpotLiveSeason, 'id'>
  ) | (
    { __typename: 'VideoStageSeason' }
    & Pick<G_VideoStageSeason, 'id'>
  ) };

export type G_GetPlaybackCurrentEpisodeQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  cursor: Scalars['Int'];
  playDevice: G_PlayDevice;
  isLoggedIn: Scalars['Boolean'];
}>;


export type G_GetPlaybackCurrentEpisodeQuery = { video: { currentEpisode: (
      Pick<G_VideoContentConnection, 'total'>
      & { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeNumberName' | 'episodeTitle' | 'episodeImage'>
          & { freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
            Pick<G_VideoPpvProduct, 'id' | 'isOnSale'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, playInfo: (
            Pick<G_VideoPlayInfo, 'duration'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'duration' | 'number' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: Pick<G_VideoViewingRights, 'isStreamable'> }
        ) }> }
    ) } };

export type G_GetPlaybackBeforeAndAfterEpisodesQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  cursor: Scalars['Int'];
  playDevice: G_PlayDevice;
  isLoggedIn: Scalars['Boolean'];
  isIncludeBefore: Scalars['Boolean'];
  isIncludeAfter: Scalars['Boolean'];
}>;


export type G_GetPlaybackBeforeAndAfterEpisodesQuery = { video: { beforeEpisodes: Maybe<{ edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeNumberName' | 'episodeTitle' | 'episodeImage'>
          & { freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
            Pick<G_VideoPpvProduct, 'id' | 'isOnSale'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, playInfo: (
            Pick<G_VideoPlayInfo, 'duration'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'duration' | 'number' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: Pick<G_VideoViewingRights, 'isStreamable'> }
        ) }> }>, afterEpisodes: Maybe<{ edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeNumberName' | 'episodeTitle' | 'episodeImage'>
          & { playInfo: (
            Pick<G_VideoPlayInfo, 'duration'>
            & { parts: Array<MakeOptional<Pick<G_VideoPart, 'duration' | 'number' | 'resumePoint'>, 'resumePoint'>> }
          ), viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, ppvProducts: Array<(
            Pick<G_VideoPpvProduct, 'id' | 'isOnSale'>
            & { price: Pick<G_VideoPpvProductPrice, 'price' | 'salePrice'> }
          )>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
        ) }> }> } };

export type G_GetPlaybackNextEpisodeQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  after?: Maybe<Scalars['Int']>;
  playDevice: G_PlayDevice;
}>;


export type G_GetPlaybackNextEpisodeQuery = { video: { nextEpisode: { edges: Array<{ node: (
          Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeNumberName' | 'episodeImage'>
          & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
        ) }> } } };

export type G_GetPlaybackVideoLiveQueryVariables = Exact<{
  seasonId: Scalars['ID'];
}>;


export type G_GetPlaybackVideoLiveQuery = { video: Pick<G_VideoLegacySeason, 'seasonType' | 'seasonName'> | Pick<G_VideoSeason, 'seasonType' | 'seasonName'> | Pick<G_VideoSpotLiveSeason, 'seasonType' | 'seasonName'> | Pick<G_VideoStageSeason, 'id' | 'keyVisualImage' | 'seasonType' | 'seasonName'> };

export type G_GetStreamQueryVariables = Exact<{
  id: Scalars['ID'];
  part?: Maybe<Scalars['Int']>;
  protectionCapabilities: Array<G_ProtectionCapability> | G_ProtectionCapability;
  audioChannelLayouts: Array<G_StreamingAudioChannelLayout> | G_StreamingAudioChannelLayout;
  device: G_PlayDevice;
  http?: Maybe<Scalars['Boolean']>;
  temporaryDownload?: Maybe<Scalars['Boolean']>;
}>;


export type G_GetStreamQuery = { stream?: Maybe<(
    Pick<G_Stream, 'contentTypeDetail' | 'purchasedProductId' | 'textRenditionType'>
    & { qualities: Array<Pick<G_Quality, 'name' | 'displayName'>>, languages: Array<Pick<G_Language, 'lang' | 'displayName'>>, videoRenditions: Array<(
      Pick<G_VideoRendition, 'lang' | 'qualityName'>
      & { streamingUrls: Array<Pick<G_StreamingUrl, 'systemIds' | 'videoCodec' | 'format' | 'bpc' | 'streamSize' | 'urls' | 'hdcp'>> }
    )>, audioRenditions: Array<Pick<G_AudioRendition, 'lang' | 'audioChannels' | 'audioChannelLayout'>>, textRenditions: Array<Pick<G_TextRendition, 'lang'>>, chapter?: Maybe<{ op?: Maybe<Pick<G_ChapterRange, 'start' | 'end'>>, ed?: Maybe<Pick<G_ChapterRange, 'start' | 'end'>>, skippable?: Maybe<Pick<G_ChapterRange, 'start' | 'end'>> }> }
  )> };

export type G_GetRecommendedVideosQueryVariables = Exact<{
  seasonId: Scalars['ID'];
  visitorId: Scalars['ID'];
  device: G_Device;
  categoryId?: Maybe<Scalars['ID']>;
  playDevice: G_PlayDevice;
  eventType: G_RecommendationEventType;
  limit: Scalars['Int'];
  isLoggedIn: Scalars['Boolean'];
  contentType?: Maybe<G_VideoContentTypeFilter>;
}>;


export type G_GetRecommendedVideosQuery = { video: { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'packageImage' | 'packageLargeImage' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { content: (
              Pick<G_VideoContent, 'id' | 'episodeTitle'>
              & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
            ), continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'packageImage' | 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { episodes: { edges: Array<{ node: (
                  Pick<G_VideoContent, 'id'>
                  & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
                ) }> }, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'packageImage' | 'packageLargeImage' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { content: (
              Pick<G_VideoContent, 'id' | 'episodeTitle'>
              & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
            ), continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'packageImage' | 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { episodes: { edges: Array<{ node: (
                  Pick<G_VideoContent, 'id'>
                  & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
                ) }> }, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'packageImage' | 'packageLargeImage' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { content: (
              Pick<G_VideoContent, 'id' | 'episodeTitle'>
              & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
            ), continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'packageImage' | 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { episodes: { edges: Array<{ node: (
                  Pick<G_VideoContent, 'id'>
                  & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
                ) }> }, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) }
        ) }> }
    ) } | { i2iRecommendedVideos: (
      Pick<G_RecommendedVideoConnection, 'trackingId' | 'testId' | 'requestId'>
      & { edges: Array<{ node: (
          Pick<G_RecommendedVideoItem, 'id'>
          & { video: (
            { __typename: 'VideoLegacySeason' }
            & Pick<G_VideoLegacySeason, 'id' | 'packageImage' | 'packageLargeImage' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { content: (
              Pick<G_VideoContent, 'id' | 'episodeTitle'>
              & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
            ), continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }>, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) | (
            { __typename: 'VideoSeason' }
            & Pick<G_VideoSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'packageImage' | 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { episodes: { edges: Array<{ node: (
                  Pick<G_VideoContent, 'id'>
                  & { viewingRights: Pick<G_VideoViewingRights, 'isStreamable'>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>>, svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>> }
                ) }> }, priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>>, continueWatching?: Maybe<{ content: { playInfo: (
                  Pick<G_VideoPlayInfo, 'contentId'>
                  & { parts: Array<Pick<G_VideoPart, 'number' | 'resumePoint' | 'duration'>> }
                ) } }> }
          ) | (
            { __typename: 'VideoSpotLiveSeason' }
            & Pick<G_VideoSpotLiveSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
          ) | (
            { __typename: 'VideoStageSeason' }
            & Pick<G_VideoStageSeason, 'id' | 'isExclusive' | 'isNewArrival' | 'customTag' | 'titleName' | 'seasonName'>
            & { priceSummary?: Maybe<Pick<G_VideoPriceSummary, 'lowestPrice' | 'discountedLowestPrice' | 'highestPrice' | 'isLimitedPremium'>> }
          ) }
        ) }> }
    ) } };

export type G_GetGravureTopQueryVariables = Exact<{
  device: G_Device;
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type G_GetGravureTopQuery = { topHeader: (
    Pick<G_Home, 'title' | 'categoryId'>
    & { headerItems: Array<(
      { __typename: 'URLFreeItem' }
      & Pick<G_UrlFreeItem, 'id' | 'image' | 'name' | 'url' | 'isHiddenForPremiumMember'>
    ) | (
      { __typename: 'VideoFreeItem' }
      & Pick<G_VideoFreeItem, 'id' | 'image' | 'name' | 'seasonId' | 'isHiddenForPremiumMember'>
      & { video: (
        { __typename: 'VideoLegacySeason' }
        & Pick<G_VideoLegacySeason, 'isBeingDelivered' | 'startPublicAt' | 'packageLargeImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoSeason' }
        & Pick<G_VideoSeason, 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoSpotLiveSeason' }
        & Pick<G_VideoSpotLiveSeason, 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'id' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) | (
        { __typename: 'VideoStageSeason' }
        & Pick<G_VideoStageSeason, 'id' | 'isBeingDelivered' | 'startPublicAt' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'viewingTypes' | 'seasonName' | 'titleName' | 'description' | 'packageImage' | 'seasonType' | 'isNewArrival' | 'isExclusive'>
        & { rating: Pick<G_VideoRating, 'category'>, campaign?: Maybe<Pick<G_VideoDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'endAt'> | Pick<G_VideoPointRefundCampaign, 'id' | 'endAt'>> }
      ) }
    ) | (
      { __typename: 'VideoListFreeItem' }
      & Pick<G_VideoListFreeItem, 'id' | 'name' | 'image' | 'isHiddenForPremiumMember'>
      & { filter: Pick<G_VideoFilter, 'keyword' | 'title' | 'categories' | 'genres' | 'casts' | 'staffs' | 'series' | 'contentType' | 'viewingTypes' | 'campaigns' | 'sort'> }
    ) | (
      { __typename: 'VideoContentFreeItem' }
      & Pick<G_VideoContentFreeItem, 'id' | 'image' | 'name' | 'isHiddenForPremiumMember'>
      & { content: (
        Pick<G_VideoContent, 'id' | 'seasonId' | 'episodeTitle' | 'episodeDetail' | 'episodeImage'>
        & { svodProduct?: Maybe<Pick<G_VideoSvodProduct, 'contentId'>>, ppvProducts: Array<Pick<G_VideoPpvProduct, 'id'>>, freeProduct?: Maybe<Pick<G_VideoFreeProduct, 'contentId'>> }
      ) }
    ) | (
      { __typename: 'HomeFreeItem' }
      & Pick<G_HomeFreeItem, 'id' | 'homeId' | 'name' | 'image' | 'pageType' | 'isHiddenForPremiumMember'>
    )>, genres?: Maybe<Array<Pick<G_VideoGenre, 'id' | 'name'>>> }
  ), allUURanking: G_VideoRankingConnectionFragment, videoCampaigns: { edges: Array<{ node: (
        Pick<G_VideoDiscountCampaign, 'id' | 'name'>
        & { videos: { edges: Array<{ node: (
              { __typename: 'VideoSearchResult' }
              & Pick<G_VideoSearchResult, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'packageImage' | 'packageLargeImage' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'description' | 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'discountedHighestPrice' | 'isNewArrival' | 'isExclusive' | 'isOnSale' | 'viewingTypes'>
            ) }> } }
      ) | (
        Pick<G_VideoFixedPriceDiscountCampaign, 'id' | 'name'>
        & { videos: { edges: Array<{ node: (
              { __typename: 'VideoSearchResult' }
              & Pick<G_VideoSearchResult, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'packageImage' | 'packageLargeImage' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'description' | 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'discountedHighestPrice' | 'isNewArrival' | 'isExclusive' | 'isOnSale' | 'viewingTypes'>
            ) }> } }
      ) | (
        Pick<G_VideoPointRefundCampaign, 'id' | 'name'>
        & { videos: { edges: Array<{ node: (
              { __typename: 'VideoSearchResult' }
              & Pick<G_VideoSearchResult, 'id' | 'titleName' | 'seasonName' | 'seasonType' | 'packageImage' | 'packageLargeImage' | 'keyVisualImage' | 'keyVisualWithoutLogoImage' | 'description' | 'lowestPrice' | 'highestPrice' | 'discountedLowestPrice' | 'discountedHighestPrice' | 'isNewArrival' | 'isExclusive' | 'isOnSale' | 'viewingTypes'>
            ) }> } }
      ) }> }, allByPopularity: G_VideoSearchResultConnectionFragment, newPPVTakeShobo: G_VideoSearchResultConnectionFragment, newPPVLineCommunication: G_VideoSearchResultConnectionFragment, newPPVExclusive: G_VideoSearchResultConnectionFragment, newPPVEnetFrontier: G_VideoSearchResultConnectionFragment, newPPVFantastica: G_VideoSearchResultConnectionFragment, allPPVNewArrival: G_VideoSearchResultConnectionFragment, exclusiveAndPopularity: G_VideoSearchResultConnectionFragment, bigBreastsByPopularity: G_VideoSearchResultConnectionFragment, imageVideoByPopularity: G_VideoSearchResultConnectionFragment, vrByPopularity: G_VideoSearchResultConnectionFragment, allNewSVODUnlimited: G_VideoSearchResultConnectionFragment, exclusiveAndPopularityUnlimited: G_VideoSearchResultConnectionFragment, bigBreastsByPopularityUnlimited: G_VideoSearchResultConnectionFragment, imageVideoByPopularityUnlimited: G_VideoSearchResultConnectionFragment, vrByPopularityUnlimited: G_VideoSearchResultConnectionFragment };

export type G_DeleteContinueWatchingListMutationVariables = Exact<{
  input: G_DeleteContinueWatchingListEntriesInput;
}>;


export type G_DeleteContinueWatchingListMutation = { deleteContinueWatchingListEntries: Pick<G_DeleteContinueWatchingListEntriesPayload, 'mutationId'> };

export const VideoSearchResultConnectionFragmentDoc = gql`
    fragment VideoSearchResultConnection on VideoSearchResultConnection {
  edges {
    node {
      __typename
      id
      titleName
      seasonName
      packageImage
      packageLargeImage
      keyVisualImage
      keyVisualWithoutLogoImage
      description
      lowestPrice
      highestPrice
      seasonType
      discountedLowestPrice
      discountedHighestPrice
      isNewArrival
      isExclusive
      isOnSale
      customTag
      reviewAveragePoint
      rating
    }
  }
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
  total
  facet {
    titles {
      name
      value
      count
    }
    categories {
      name
      value
      count
    }
    genres {
      name
      value
      count
    }
    casts {
      name
      value
      count
    }
    staffs {
      name
      value
      count
    }
    series {
      name
      value
      count
    }
    campaigns {
      name
      value
      count
    }
    contentTypes {
      name
      value
      count
    }
    viewingTypes {
      name
      value
      count
    }
  }
}
    `;
export const VideoRankingConnectionFragmentDoc = gql`
    fragment VideoRankingConnection on VideoRankingConnection {
  edges {
    node {
      id
      rank
      video {
        __typename
        id
        seasonName
        titleName
        description
        packageImage
        customTag
        isNewArrival
        isExclusive
        rating {
          category
        }
        ... on VideoSeason {
          keyVisualImage
          keyVisualWithoutLogoImage
        }
        ... on VideoLegacySeason {
          packageLargeImage
          reviewSummary {
            averagePoint
          }
        }
        ... on VideoStageSeason {
          id
          keyVisualImage
          keyVisualWithoutLogoImage
        }
        ... on VideoSpotLiveSeason {
          keyVisualImage
          keyVisualWithoutLogoImage
        }
      }
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
}
    `;
export const FetchAllVideoCopyrightsDocument = gql`
    query FetchAllVideoCopyrights {
  allVideoCopyrights
}
    `;

/**
 * __useFetchAllVideoCopyrightsQuery__
 *
 * To run a query within a React component, call `useFetchAllVideoCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllVideoCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllVideoCopyrightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllVideoCopyrightsQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchAllVideoCopyrightsQuery, G_FetchAllVideoCopyrightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchAllVideoCopyrightsQuery, G_FetchAllVideoCopyrightsQueryVariables>(FetchAllVideoCopyrightsDocument, options);
      }
export function useFetchAllVideoCopyrightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchAllVideoCopyrightsQuery, G_FetchAllVideoCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchAllVideoCopyrightsQuery, G_FetchAllVideoCopyrightsQueryVariables>(FetchAllVideoCopyrightsDocument, options);
        }
export type FetchAllVideoCopyrightsQueryHookResult = ReturnType<typeof useFetchAllVideoCopyrightsQuery>;
export type FetchAllVideoCopyrightsLazyQueryHookResult = ReturnType<typeof useFetchAllVideoCopyrightsLazyQuery>;
export type FetchAllVideoCopyrightsQueryResult = Apollo.QueryResult<G_FetchAllVideoCopyrightsQuery, G_FetchAllVideoCopyrightsQueryVariables>;
export const FetchClientDocument = gql`
    query FetchClient {
  client {
    isForeignAccess
  }
}
    `;

/**
 * __useFetchClientQuery__
 *
 * To run a query within a React component, call `useFetchClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchClientQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchClientQuery, G_FetchClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchClientQuery, G_FetchClientQueryVariables>(FetchClientDocument, options);
      }
export function useFetchClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchClientQuery, G_FetchClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchClientQuery, G_FetchClientQueryVariables>(FetchClientDocument, options);
        }
export type FetchClientQueryHookResult = ReturnType<typeof useFetchClientQuery>;
export type FetchClientLazyQueryHookResult = ReturnType<typeof useFetchClientLazyQuery>;
export type FetchClientQueryResult = Apollo.QueryResult<G_FetchClientQuery, G_FetchClientQueryVariables>;
export const GetCommentsDocument = gql`
    query GetComments($contentId: ID!, $first: Int, $after: String, $last: Int, $before: String) {
  comments(
    contentId: $contentId
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      cursor
      node {
        hashedUserId
        id
        body
        createdAt
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    commentRefreshIntervalSeconds
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<G_GetCommentsQuery, G_GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetCommentsQuery, G_GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetCommentsQuery, G_GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetCommentsQuery, G_GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<G_GetCommentsQuery, G_GetCommentsQueryVariables>;
export const PostCommentDocument = gql`
    mutation PostComment($input: PostCommentInput!) {
  postComment(input: $input) {
    mutationId
  }
}
    `;
export type G_PostCommentMutationFn = Apollo.MutationFunction<G_PostCommentMutation, G_PostCommentMutationVariables>;

/**
 * __usePostCommentMutation__
 *
 * To run a mutation, you first call `usePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCommentMutation, { data, loading, error }] = usePostCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<G_PostCommentMutation, G_PostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_PostCommentMutation, G_PostCommentMutationVariables>(PostCommentDocument, options);
      }
export type PostCommentMutationHookResult = ReturnType<typeof usePostCommentMutation>;
export type PostCommentMutationResult = Apollo.MutationResult<G_PostCommentMutation>;
export type PostCommentMutationOptions = Apollo.BaseMutationOptions<G_PostCommentMutation, G_PostCommentMutationVariables>;
export const ReportInappropriateCommentDocument = gql`
    mutation reportInappropriateComment($input: ReportInappropriateCommentInput!) {
  reportInappropriateComment(input: $input) {
    mutationId
  }
}
    `;
export type G_ReportInappropriateCommentMutationFn = Apollo.MutationFunction<G_ReportInappropriateCommentMutation, G_ReportInappropriateCommentMutationVariables>;

/**
 * __useReportInappropriateCommentMutation__
 *
 * To run a mutation, you first call `useReportInappropriateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportInappropriateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportInappropriateCommentMutation, { data, loading, error }] = useReportInappropriateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportInappropriateCommentMutation(baseOptions?: Apollo.MutationHookOptions<G_ReportInappropriateCommentMutation, G_ReportInappropriateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_ReportInappropriateCommentMutation, G_ReportInappropriateCommentMutationVariables>(ReportInappropriateCommentDocument, options);
      }
export type ReportInappropriateCommentMutationHookResult = ReturnType<typeof useReportInappropriateCommentMutation>;
export type ReportInappropriateCommentMutationResult = Apollo.MutationResult<G_ReportInappropriateCommentMutation>;
export type ReportInappropriateCommentMutationOptions = Apollo.BaseMutationOptions<G_ReportInappropriateCommentMutation, G_ReportInappropriateCommentMutationVariables>;
export const AddVideoBookmarkDocument = gql`
    mutation AddVideoBookmark($input: AddVideoBookmarkInput!) {
  addVideoBookmark(input: $input) {
    mutationId
  }
}
    `;
export type G_AddVideoBookmarkMutationFn = Apollo.MutationFunction<G_AddVideoBookmarkMutation, G_AddVideoBookmarkMutationVariables>;

/**
 * __useAddVideoBookmarkMutation__
 *
 * To run a mutation, you first call `useAddVideoBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVideoBookmarkMutation, { data, loading, error }] = useAddVideoBookmarkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVideoBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<G_AddVideoBookmarkMutation, G_AddVideoBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_AddVideoBookmarkMutation, G_AddVideoBookmarkMutationVariables>(AddVideoBookmarkDocument, options);
      }
export type AddVideoBookmarkMutationHookResult = ReturnType<typeof useAddVideoBookmarkMutation>;
export type AddVideoBookmarkMutationResult = Apollo.MutationResult<G_AddVideoBookmarkMutation>;
export type AddVideoBookmarkMutationOptions = Apollo.BaseMutationOptions<G_AddVideoBookmarkMutation, G_AddVideoBookmarkMutationVariables>;
export const DeleteVideoBookmarksDocument = gql`
    mutation DeleteVideoBookmarks($input: DeleteVideoBookmarksInput!) {
  deleteVideoBookmarks(input: $input) {
    mutationId
  }
}
    `;
export type G_DeleteVideoBookmarksMutationFn = Apollo.MutationFunction<G_DeleteVideoBookmarksMutation, G_DeleteVideoBookmarksMutationVariables>;

/**
 * __useDeleteVideoBookmarksMutation__
 *
 * To run a mutation, you first call `useDeleteVideoBookmarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoBookmarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoBookmarksMutation, { data, loading, error }] = useDeleteVideoBookmarksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVideoBookmarksMutation(baseOptions?: Apollo.MutationHookOptions<G_DeleteVideoBookmarksMutation, G_DeleteVideoBookmarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_DeleteVideoBookmarksMutation, G_DeleteVideoBookmarksMutationVariables>(DeleteVideoBookmarksDocument, options);
      }
export type DeleteVideoBookmarksMutationHookResult = ReturnType<typeof useDeleteVideoBookmarksMutation>;
export type DeleteVideoBookmarksMutationResult = Apollo.MutationResult<G_DeleteVideoBookmarksMutation>;
export type DeleteVideoBookmarksMutationOptions = Apollo.BaseMutationOptions<G_DeleteVideoBookmarksMutation, G_DeleteVideoBookmarksMutationVariables>;
export const GetVideoByMiniDetailDocument = gql`
    query GetVideoByMiniDetail($id: ID!, $playDevice: PlayDevice!, $isLoggedIn: Boolean!) {
  video(id: $id) {
    __typename
    id
    titleName
    viewingTypes
    seasonType
    isBeingDelivered
    isPublic
    hasBookmark @include(if: $isLoggedIn)
    ... on VideoSeason {
      continueWatching @include(if: $isLoggedIn) {
        id
        contentId
        resumePoint
        content {
          id
          contentType
          episodeTitle
          episodeNumberName
          episodeImage
          priceSummary {
            lowestPrice
            discountedLowestPrice
            highestPrice
            isLimitedPremium
          }
          ppvExpiration @include(if: $isLoggedIn) {
            expirationType
            startDeliveryAt
          }
          freeProduct {
            contentId
          }
          svodProduct {
            contentId
          }
          ppvProducts {
            id
            contentId
            price {
              price
              salePrice
            }
          }
          viewingRights(device: $playDevice) {
            isStreamable
          }
          playInfo @include(if: $isLoggedIn) {
            duration
            parts {
              contentId
              duration
              resumePoint
            }
          }
          priceSummary {
            lowestPrice
            highestPrice
            discountedLowestPrice
            isLimitedPremium
          }
        }
      }
      mainEpisodes: episodes(first: 1, type: MAIN) {
        edges {
          node {
            id
            seasonId
            contentType
            episodeTitle
            episodeNumberName
            priceSummary {
              lowestPrice
              highestPrice
              discountedLowestPrice
              isLimitedPremium
            }
            ppvExpiration @include(if: $isLoggedIn) {
              expirationType
              startDeliveryAt
            }
            freeProduct {
              contentId
            }
            svodProduct {
              contentId
            }
            ppvProducts {
              id
              contentId
              price {
                price
                salePrice
              }
            }
            viewingRights(device: $playDevice) {
              isStreamable
            }
          }
        }
      }
      pvEpisodes: episodes(first: 1, type: PV) {
        edges {
          node {
            id
            sampleMovie
          }
        }
      }
    }
    ... on VideoLegacySeason {
      sampleMovie {
        url
      }
      continueWatching @include(if: $isLoggedIn) {
        id
        contentId
        resumePoint
        partNumber
        content {
          id
          contentType
          episodeTitle
          episodeNumberName
          episodeImage
          priceSummary {
            lowestPrice
            discountedLowestPrice
            highestPrice
            isLimitedPremium
          }
          ppvExpiration @include(if: $isLoggedIn) {
            expirationType
            startDeliveryAt
          }
          freeProduct {
            contentId
          }
          svodProduct {
            contentId
          }
          ppvProducts {
            id
            contentId
            price {
              price
              salePrice
            }
          }
          viewingRights(device: $playDevice) {
            isStreamable
          }
          playInfo @include(if: $isLoggedIn) {
            duration
            parts {
              number
              contentId
              resumePoint
              duration
            }
          }
          priceSummary {
            lowestPrice
            highestPrice
            discountedLowestPrice
            isLimitedPremium
          }
        }
      }
      content {
        id
        episodeTitle
        episodeNumberName
        contentType
        priceSummary {
          lowestPrice
          discountedLowestPrice
          highestPrice
          isLimitedPremium
        }
        playInfo @include(if: $isLoggedIn) {
          duration
          parts {
            contentId
            resumePoint
            number
          }
        }
        ppvExpiration @include(if: $isLoggedIn) {
          expirationType
          startDeliveryAt
        }
        freeProduct {
          contentId
        }
        svodProduct {
          contentId
        }
        ppvProducts {
          id
          contentId
          price {
            price
            salePrice
          }
        }
        viewingRights(device: $playDevice) {
          isStreamable
        }
        priceSummary {
          lowestPrice
          highestPrice
          discountedLowestPrice
          isLimitedPremium
        }
      }
    }
    ... on VideoSpotLiveSeason {
      mainEpisodes: episodes(first: 1, type: MAIN) {
        edges {
          node {
            id
            contentType
            episodeNumberName
            episodeTitle
            ppvExpiration @include(if: $isLoggedIn) {
              expirationType
              startDeliveryAt
            }
            freeProduct {
              contentId
            }
            svodProduct {
              contentId
            }
            ppvProducts {
              id
              contentId
              price {
                price
                salePrice
              }
            }
            viewingRights(device: $playDevice) {
              isStreamable
            }
            priceSummary {
              lowestPrice
              highestPrice
              discountedLowestPrice
              isLimitedPremium
            }
          }
        }
      }
      pvEpisodes: episodes(first: 1, type: PV) {
        edges {
          node {
            id
            sampleMovie
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetVideoByMiniDetailQuery__
 *
 * To run a query within a React component, call `useGetVideoByMiniDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoByMiniDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoByMiniDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      playDevice: // value for 'playDevice'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetVideoByMiniDetailQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoByMiniDetailQuery, G_GetVideoByMiniDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoByMiniDetailQuery, G_GetVideoByMiniDetailQueryVariables>(GetVideoByMiniDetailDocument, options);
      }
export function useGetVideoByMiniDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoByMiniDetailQuery, G_GetVideoByMiniDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoByMiniDetailQuery, G_GetVideoByMiniDetailQueryVariables>(GetVideoByMiniDetailDocument, options);
        }
export type GetVideoByMiniDetailQueryHookResult = ReturnType<typeof useGetVideoByMiniDetailQuery>;
export type GetVideoByMiniDetailLazyQueryHookResult = ReturnType<typeof useGetVideoByMiniDetailLazyQuery>;
export type GetVideoByMiniDetailQueryResult = Apollo.QueryResult<G_GetVideoByMiniDetailQuery, G_GetVideoByMiniDetailQueryVariables>;
export const FetchDownloadFileUrlDocument = gql`
    query FetchDownloadFileUrl($id: ID!, $part: Int, $qualityName: String!, $fileType: DownloadType!) {
  downloadFileUrl(
    id: $id
    part: $part
    qualityName: $qualityName
    fileType: $fileType
  )
}
    `;

/**
 * __useFetchDownloadFileUrlQuery__
 *
 * To run a query within a React component, call `useFetchDownloadFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDownloadFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDownloadFileUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      part: // value for 'part'
 *      qualityName: // value for 'qualityName'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useFetchDownloadFileUrlQuery(baseOptions: Apollo.QueryHookOptions<G_FetchDownloadFileUrlQuery, G_FetchDownloadFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchDownloadFileUrlQuery, G_FetchDownloadFileUrlQueryVariables>(FetchDownloadFileUrlDocument, options);
      }
export function useFetchDownloadFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchDownloadFileUrlQuery, G_FetchDownloadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchDownloadFileUrlQuery, G_FetchDownloadFileUrlQueryVariables>(FetchDownloadFileUrlDocument, options);
        }
export type FetchDownloadFileUrlQueryHookResult = ReturnType<typeof useFetchDownloadFileUrlQuery>;
export type FetchDownloadFileUrlLazyQueryHookResult = ReturnType<typeof useFetchDownloadFileUrlLazyQuery>;
export type FetchDownloadFileUrlQueryResult = Apollo.QueryResult<G_FetchDownloadFileUrlQuery, G_FetchDownloadFileUrlQueryVariables>;
export const FetchHomeDocument = gql`
    query FetchHome($device: Device!, $homeType: HomeType!, $first: Int!, $after: String, $id: ID, $visitorId: ID!, $eventType: RecommendationEventType!) {
  home(device: $device, homeType: $homeType, id: $id) {
    id
    title
    device
    type
    categoryId
    genres {
      id
      name
    }
    notification {
      id
      title
    }
    allVideoSubPages {
      id
      title
    }
    headerItems {
      __typename
      ... on VideoFreeItem {
        __typename
        id
        image
        name
        seasonId
        isHiddenForPremiumMember
        video {
          __typename
          id
          viewingTypes
          seasonName
          titleName
          description
          rating {
            category
          }
          packageImage
          seasonType
          isNewArrival
          customTag
          isExclusive
          campaign {
            id
            endAt
          }
          ... on VideoSeason {
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoStageSeason {
            id
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoLegacySeason {
            __typename
            isBeingDelivered
            startPublicAt
            packageLargeImage
          }
          ... on VideoSpotLiveSeason {
            __typename
            keyVisualImage
            keyVisualWithoutLogoImage
          }
        }
      }
      ... on VideoListFreeItem {
        __typename
        id
        name
        image
        isHiddenForPremiumMember
        filter {
          keyword
          title
          categories
          genres
          casts
          staffs
          series
          contentType
          viewingTypes
          campaigns
          sort
        }
      }
      ... on VideoContentFreeItem {
        __typename
        id
        image
        name
        isHiddenForPremiumMember
        content {
          id
          seasonId
          episodeTitle
          episodeDetail
          episodeImage
          svodProduct {
            contentId
          }
          ppvProducts {
            id
          }
          freeProduct {
            contentId
          }
        }
      }
      ... on HomeFreeItem {
        __typename
        id
        homeId
        name
        image
        pageType
        isHiddenForPremiumMember
      }
      ... on URLFreeItem {
        __typename
        id
        image
        name
        url
        isHiddenForPremiumMember
      }
    }
    shelves(first: $first, after: $after) {
      edges {
        node {
          ... on ShelfOfContinueWatching {
            __typename
            id
            continueWatching(first: 30) {
              edges {
                node {
                  __typename
                  id
                  contentId
                  partNumber
                  video {
                    __typename
                    id
                    isNewArrival
                    customTag
                    isExclusive
                    seasonType
                    campaign {
                      id
                      endAt
                    }
                    ... on VideoSeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoStageSeason {
                      id
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoLegacySeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      packageLargeImage
                    }
                    ... on VideoSpotLiveSeason {
                      __typename
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                  }
                  content {
                    id
                    seasonId
                    episodeImage
                    episodeTitle
                    episodeNumber
                    episodeDetail
                    episodeNumberName
                    playInfo {
                      contentId
                      parts {
                        contentId
                        duration
                        resumePoint
                        number
                      }
                      resumePartNumber
                    }
                  }
                }
              }
            }
          }
          ... on ShelfOfVideoRankings {
            __typename
            id
            device
            videoRankings(first: 30) {
              edges {
                node {
                  id
                  rank
                  video {
                    __typename
                    id
                    rating {
                      category
                    }
                    viewingTypes
                    seasonName
                    titleName
                    description
                    packageImage
                    seasonType
                    isNewArrival
                    customTag
                    isExclusive
                    campaign {
                      id
                      endAt
                    }
                    rating {
                      category
                    }
                    ... on VideoSeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoStageSeason {
                      id
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoLegacySeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      packageLargeImage
                    }
                    ... on VideoSpotLiveSeason {
                      __typename
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                  }
                }
              }
            }
          }
          ... on ShelfOfBookmarkedVideos {
            __typename
            id
            device
            bookmarkedVideos(contentType: CONTENT_2D) {
              edges {
                node {
                  id
                  video {
                    __typename
                    id
                    viewingTypes
                    seasonName
                    titleName
                    description
                    packageImage
                    seasonType
                    isNewArrival
                    isExclusive
                    customTag
                    campaign {
                      id
                      endAt
                    }
                    rating {
                      category
                    }
                    ... on VideoSeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoStageSeason {
                      id
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoLegacySeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      packageLargeImage
                    }
                    ... on VideoSpotLiveSeason {
                      __typename
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                  }
                }
              }
            }
          }
          ... on ShelfOfPresetVideos {
            __typename
            id
            device
            imageType
            name
            presetVideos {
              edges {
                node {
                  __typename
                  id
                  seasonName
                  titleName
                  description
                  packageImage
                  seasonType
                  isNewArrival
                  customTag
                  isExclusive
                  campaign {
                    id
                    endAt
                  }
                  rating {
                    category
                  }
                  ... on VideoSeason {
                    __typename
                    isBeingDelivered
                    startPublicAt
                    keyVisualImage
                    keyVisualWithoutLogoImage
                  }
                  ... on VideoStageSeason {
                    id
                    __typename
                    isBeingDelivered
                    startPublicAt
                    keyVisualImage
                    keyVisualWithoutLogoImage
                  }
                  ... on VideoLegacySeason {
                    __typename
                    isBeingDelivered
                    startPublicAt
                    packageLargeImage
                  }
                  ... on VideoSpotLiveSeason {
                    __typename
                    keyVisualImage
                    keyVisualWithoutLogoImage
                  }
                }
              }
            }
          }
          ... on ShelfOfPresetContents {
            __typename
            id
            name
            presetContents {
              edges {
                node {
                  id
                  seasonId
                  episodeTitle
                  episodeDetail
                  episodeNumberName
                  episodeImage
                }
              }
            }
          }
          ... on ShelfOfRecommendedVideos {
            __typename
            id
            device
            u2iRecommendedVideos(visitorId: $visitorId, eventType: $eventType) {
              trackingId
              testId
              requestId
              edges {
                node {
                  id
                  video {
                    __typename
                    id
                    seasonName
                    titleName
                    description
                    packageImage
                    seasonType
                    isNewArrival
                    customTag
                    isExclusive
                    campaign {
                      id
                      endAt
                    }
                    rating {
                      category
                    }
                    ... on VideoSeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoStageSeason {
                      id
                      __typename
                      isBeingDelivered
                      startPublicAt
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                    ... on VideoLegacySeason {
                      __typename
                      isBeingDelivered
                      startPublicAt
                      packageLargeImage
                    }
                    ... on VideoSpotLiveSeason {
                      __typename
                      keyVisualImage
                      keyVisualWithoutLogoImage
                    }
                  }
                }
              }
            }
          }
          ... on ShelfOfFreeItems {
            __typename
            id
            name
            freeItemType
            freeItems {
              edges {
                cursor
                node {
                  ... on VideoFreeItem {
                    __typename
                    id
                    image
                    name
                    seasonId
                    isHiddenForPremiumMember
                    video {
                      __typename
                      id
                      viewingTypes
                      seasonName
                      titleName
                      description
                      packageImage
                      rating {
                        category
                      }
                      seasonType
                      isNewArrival
                      customTag
                      isExclusive
                      campaign {
                        id
                        endAt
                      }
                      ... on VideoSeason {
                        __typename
                        isBeingDelivered
                        startPublicAt
                        keyVisualImage
                        keyVisualWithoutLogoImage
                      }
                      ... on VideoStageSeason {
                        id
                        __typename
                        isBeingDelivered
                        startPublicAt
                        keyVisualImage
                        keyVisualWithoutLogoImage
                      }
                      ... on VideoLegacySeason {
                        __typename
                        isBeingDelivered
                        startPublicAt
                        packageLargeImage
                      }
                      ... on VideoSpotLiveSeason {
                        __typename
                        keyVisualImage
                        keyVisualWithoutLogoImage
                      }
                    }
                  }
                  ... on VideoListFreeItem {
                    __typename
                    id
                    name
                    image
                    isHiddenForPremiumMember
                    filter {
                      keyword
                      title
                      categories
                      genres
                      casts
                      staffs
                      series
                      contentType
                      viewingTypes
                      campaigns
                      sort
                    }
                  }
                  ... on VideoContentFreeItem {
                    __typename
                    id
                    image
                    name
                    isHiddenForPremiumMember
                    content {
                      id
                      seasonId
                      episodeTitle
                      episodeDetail
                      episodeImage
                      svodProduct {
                        contentId
                      }
                      ppvProducts {
                        id
                      }
                      freeProduct {
                        contentId
                      }
                    }
                  }
                  ... on HomeFreeItem {
                    __typename
                    id
                    homeId
                    name
                    image
                    pageType
                    isHiddenForPremiumMember
                  }
                  ... on URLFreeItem {
                    __typename
                    id
                    image
                    name
                    url
                    isHiddenForPremiumMember
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFetchHomeQuery__
 *
 * To run a query within a React component, call `useFetchHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHomeQuery({
 *   variables: {
 *      device: // value for 'device'
 *      homeType: // value for 'homeType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      id: // value for 'id'
 *      visitorId: // value for 'visitorId'
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useFetchHomeQuery(baseOptions: Apollo.QueryHookOptions<G_FetchHomeQuery, G_FetchHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchHomeQuery, G_FetchHomeQueryVariables>(FetchHomeDocument, options);
      }
export function useFetchHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchHomeQuery, G_FetchHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchHomeQuery, G_FetchHomeQueryVariables>(FetchHomeDocument, options);
        }
export type FetchHomeQueryHookResult = ReturnType<typeof useFetchHomeQuery>;
export type FetchHomeLazyQueryHookResult = ReturnType<typeof useFetchHomeLazyQuery>;
export type FetchHomeQueryResult = Apollo.QueryResult<G_FetchHomeQuery, G_FetchHomeQueryVariables>;
export const FetchMaintenanceDocument = gql`
    query FetchMaintenance {
  maintenance {
    title
    description
    startAt
    endAt
  }
}
    `;

/**
 * __useFetchMaintenanceQuery__
 *
 * To run a query within a React component, call `useFetchMaintenanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMaintenanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMaintenanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMaintenanceQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchMaintenanceQuery, G_FetchMaintenanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchMaintenanceQuery, G_FetchMaintenanceQueryVariables>(FetchMaintenanceDocument, options);
      }
export function useFetchMaintenanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchMaintenanceQuery, G_FetchMaintenanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchMaintenanceQuery, G_FetchMaintenanceQueryVariables>(FetchMaintenanceDocument, options);
        }
export type FetchMaintenanceQueryHookResult = ReturnType<typeof useFetchMaintenanceQuery>;
export type FetchMaintenanceLazyQueryHookResult = ReturnType<typeof useFetchMaintenanceLazyQuery>;
export type FetchMaintenanceQueryResult = Apollo.QueryResult<G_FetchMaintenanceQuery, G_FetchMaintenanceQueryVariables>;
export const FetchNotificationDocument = gql`
    query FetchNotification($id: ID!) {
  notification(id: $id) {
    id
    title
    body
    startPublicAt
  }
}
    `;

/**
 * __useFetchNotificationQuery__
 *
 * To run a query within a React component, call `useFetchNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchNotificationQuery(baseOptions: Apollo.QueryHookOptions<G_FetchNotificationQuery, G_FetchNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchNotificationQuery, G_FetchNotificationQueryVariables>(FetchNotificationDocument, options);
      }
export function useFetchNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchNotificationQuery, G_FetchNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchNotificationQuery, G_FetchNotificationQueryVariables>(FetchNotificationDocument, options);
        }
export type FetchNotificationQueryHookResult = ReturnType<typeof useFetchNotificationQuery>;
export type FetchNotificationLazyQueryHookResult = ReturnType<typeof useFetchNotificationLazyQuery>;
export type FetchNotificationQueryResult = Apollo.QueryResult<G_FetchNotificationQuery, G_FetchNotificationQueryVariables>;
export const FetchNotificationsDocument = gql`
    query FetchNotifications($device: Device!, $first: Int, $after: String) {
  notifications(device: $device, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        title
        body
        startPublicAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationsQuery({
 *   variables: {
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchNotificationsQuery(baseOptions: Apollo.QueryHookOptions<G_FetchNotificationsQuery, G_FetchNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchNotificationsQuery, G_FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
      }
export function useFetchNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchNotificationsQuery, G_FetchNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchNotificationsQuery, G_FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
        }
export type FetchNotificationsQueryHookResult = ReturnType<typeof useFetchNotificationsQuery>;
export type FetchNotificationsLazyQueryHookResult = ReturnType<typeof useFetchNotificationsLazyQuery>;
export type FetchNotificationsQueryResult = Apollo.QueryResult<G_FetchNotificationsQuery, G_FetchNotificationsQueryVariables>;
export const PostEvaluateReviewDocument = gql`
    mutation PostEvaluateReview($input: EvaluateReviewInput!) {
  evaluateReview(input: $input) {
    mutationId
    voteStatus
  }
}
    `;
export type G_PostEvaluateReviewMutationFn = Apollo.MutationFunction<G_PostEvaluateReviewMutation, G_PostEvaluateReviewMutationVariables>;

/**
 * __usePostEvaluateReviewMutation__
 *
 * To run a mutation, you first call `usePostEvaluateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostEvaluateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postEvaluateReviewMutation, { data, loading, error }] = usePostEvaluateReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostEvaluateReviewMutation(baseOptions?: Apollo.MutationHookOptions<G_PostEvaluateReviewMutation, G_PostEvaluateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_PostEvaluateReviewMutation, G_PostEvaluateReviewMutationVariables>(PostEvaluateReviewDocument, options);
      }
export type PostEvaluateReviewMutationHookResult = ReturnType<typeof usePostEvaluateReviewMutation>;
export type PostEvaluateReviewMutationResult = Apollo.MutationResult<G_PostEvaluateReviewMutation>;
export type PostEvaluateReviewMutationOptions = Apollo.BaseMutationOptions<G_PostEvaluateReviewMutation, G_PostEvaluateReviewMutationVariables>;
export const PostVideoReviewDocument = gql`
    mutation PostVideoReview($input: VideoReviewInput!) {
  postVideoReview(input: $input) {
    mutationId
    error {
      code
    }
  }
}
    `;
export type G_PostVideoReviewMutationFn = Apollo.MutationFunction<G_PostVideoReviewMutation, G_PostVideoReviewMutationVariables>;

/**
 * __usePostVideoReviewMutation__
 *
 * To run a mutation, you first call `usePostVideoReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostVideoReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postVideoReviewMutation, { data, loading, error }] = usePostVideoReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostVideoReviewMutation(baseOptions?: Apollo.MutationHookOptions<G_PostVideoReviewMutation, G_PostVideoReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_PostVideoReviewMutation, G_PostVideoReviewMutationVariables>(PostVideoReviewDocument, options);
      }
export type PostVideoReviewMutationHookResult = ReturnType<typeof usePostVideoReviewMutation>;
export type PostVideoReviewMutationResult = Apollo.MutationResult<G_PostVideoReviewMutation>;
export type PostVideoReviewMutationOptions = Apollo.BaseMutationOptions<G_PostVideoReviewMutation, G_PostVideoReviewMutationVariables>;
export const PostPurchaseVideoByCashierDocument = gql`
    mutation PostPurchaseVideoByCashier($input: PurchaseVideoByCashierInput!) {
  purchaseVideoByCashier(input: $input) {
    cashierUrl
    mutationId
  }
}
    `;
export type G_PostPurchaseVideoByCashierMutationFn = Apollo.MutationFunction<G_PostPurchaseVideoByCashierMutation, G_PostPurchaseVideoByCashierMutationVariables>;

/**
 * __usePostPurchaseVideoByCashierMutation__
 *
 * To run a mutation, you first call `usePostPurchaseVideoByCashierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostPurchaseVideoByCashierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postPurchaseVideoByCashierMutation, { data, loading, error }] = usePostPurchaseVideoByCashierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostPurchaseVideoByCashierMutation(baseOptions?: Apollo.MutationHookOptions<G_PostPurchaseVideoByCashierMutation, G_PostPurchaseVideoByCashierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_PostPurchaseVideoByCashierMutation, G_PostPurchaseVideoByCashierMutationVariables>(PostPurchaseVideoByCashierDocument, options);
      }
export type PostPurchaseVideoByCashierMutationHookResult = ReturnType<typeof usePostPurchaseVideoByCashierMutation>;
export type PostPurchaseVideoByCashierMutationResult = Apollo.MutationResult<G_PostPurchaseVideoByCashierMutation>;
export type PostPurchaseVideoByCashierMutationOptions = Apollo.BaseMutationOptions<G_PostPurchaseVideoByCashierMutation, G_PostPurchaseVideoByCashierMutationVariables>;
export const PostPurchaseWakuwariVideoByCashierDocument = gql`
    mutation PostPurchaseWakuwariVideoByCashier($input: PurchaseWakuwariVideoByCashierInput!) {
  purchaseWakuwariVideoByCashier(input: $input) {
    mutationId
    cashierUrl
  }
}
    `;
export type G_PostPurchaseWakuwariVideoByCashierMutationFn = Apollo.MutationFunction<G_PostPurchaseWakuwariVideoByCashierMutation, G_PostPurchaseWakuwariVideoByCashierMutationVariables>;

/**
 * __usePostPurchaseWakuwariVideoByCashierMutation__
 *
 * To run a mutation, you first call `usePostPurchaseWakuwariVideoByCashierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostPurchaseWakuwariVideoByCashierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postPurchaseWakuwariVideoByCashierMutation, { data, loading, error }] = usePostPurchaseWakuwariVideoByCashierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostPurchaseWakuwariVideoByCashierMutation(baseOptions?: Apollo.MutationHookOptions<G_PostPurchaseWakuwariVideoByCashierMutation, G_PostPurchaseWakuwariVideoByCashierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_PostPurchaseWakuwariVideoByCashierMutation, G_PostPurchaseWakuwariVideoByCashierMutationVariables>(PostPurchaseWakuwariVideoByCashierDocument, options);
      }
export type PostPurchaseWakuwariVideoByCashierMutationHookResult = ReturnType<typeof usePostPurchaseWakuwariVideoByCashierMutation>;
export type PostPurchaseWakuwariVideoByCashierMutationResult = Apollo.MutationResult<G_PostPurchaseWakuwariVideoByCashierMutation>;
export type PostPurchaseWakuwariVideoByCashierMutationOptions = Apollo.BaseMutationOptions<G_PostPurchaseWakuwariVideoByCashierMutation, G_PostPurchaseWakuwariVideoByCashierMutationVariables>;
export const GetVideoDocument = gql`
    query GetVideo($seasonId: ID!, $contentId: ID!, $device: Device!, $playDevice: PlayDevice!, $isLoggedIn: Boolean!, $isContentId: Boolean!) {
  video(id: $seasonId) {
    id
    seasonType
    hasBookmark @include(if: $isLoggedIn)
    titleName
    seasonName
    highlight(format: HTML)
    description(format: HTML)
    notices(format: HTML)
    packageImage
    productionYear
    isNewArrival
    customTag
    isPublic
    isExclusive
    isBeingDelivered
    viewingTypes
    url
    startPublicAt
    campaign {
      id
      name
      endAt
      isLimitedPremium
    }
    rating {
      category
    }
    casts {
      castName
      actorName
      person {
        id
      }
    }
    staffs {
      roleName
      staffName
      person {
        id
      }
    }
    categories {
      name
      id
    }
    genres {
      name
      id
    }
    copyright
    relatedItems(device: $device) {
      videos {
        seasonId
        video {
          id
          titleName
          packageImage
          isNewArrival
          customTag
          isExclusive
          rating {
            category
          }
        }
      }
      books {
        seriesId
        title
        thumbnail
        url
      }
      mono {
        banner
        url
      }
      scratch {
        banner
        url
      }
      onlineCrane {
        banner
        url
      }
    }
    ... on VideoSeason {
      __typename
      metaDescription: description(format: PLAIN)
      keyVisualImage
      keyVisualWithoutLogoImage
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      relatedSeasons {
        id
        title
      }
      nextDeliveryEpisode {
        isBeforeDelivered
        startDeliveryAt
      }
      continueWatching @include(if: $isLoggedIn) {
        id
        resumePoint
        contentId
        content {
          episodeImage
          drmLevel {
            hasStrictProtection
          }
          episodeTitle
          episodeNumber
          episodeNumberName
          freeProduct {
            contentId
          }
          viewingRights(device: $playDevice) {
            isStreamable
          }
          ppvProducts {
            id
            contentId
            isOnSale
            isBeingDelivered
            isBundleParent
            isPurchased @include(if: $isLoggedIn)
            price {
              price
              salePrice
            }
          }
          svodProduct {
            startDeliveryAt
          }
        }
      }
      priceSummary {
        lowestPrice
        highestPrice
        discountedLowestPrice
        isLimitedPremium
      }
      episode(id: $contentId) @include(if: $isContentId) {
        id
        episodeTitle
        episodeImage
        episodeNumber
        episodeNumberName
        episodeDetail
        drmLevel {
          hasStrictProtection
        }
        playInfo {
          highestQuality
          isSupportHDR
          highestAudioChannelLayout
          duration
          audioRenditions
          textRenditions
          resumePartNumber @include(if: $isLoggedIn)
          parts {
            contentId
            number
            duration
            resumePoint @include(if: $isLoggedIn)
          }
        }
        viewingRights(device: $playDevice) {
          isDownloadable
          isStreamable
        }
        ppvExpiration @include(if: $isLoggedIn) {
          expirationType
          viewingExpiration
          viewingStartExpiration
          startDeliveryAt
        }
        freeProduct {
          contentId
        }
        ppvProducts {
          id
          contentId
          isOnSale
          isBeingDelivered
          isBundleParent
          isPurchased @include(if: $isLoggedIn)
          price {
            price
            salePrice
          }
        }
        svodProduct {
          startDeliveryAt
        }
        priceSummary {
          lowestPrice
          highestPrice
          discountedLowestPrice
          isLimitedPremium
        }
      }
      episodes(type: MAIN, first: 1) {
        edges {
          node {
            id
            sampleMovie
            episodeTitle
            episodeNumber
            episodeNumberName
            drmLevel {
              hasStrictProtection
            }
            playInfo {
              highestQuality
              isSupportHDR
              highestAudioChannelLayout
              duration
              audioRenditions
              textRenditions
              resumePartNumber @include(if: $isLoggedIn)
              parts {
                number
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $playDevice) {
              isDownloadable
              isStreamable
              downloadableFiles @include(if: $isLoggedIn) {
                quality {
                  name
                  displayName
                  displayPriority
                }
                totalFileSize
                parts {
                  partNumber
                  fileSize
                }
              }
            }
            ppvExpiration @include(if: $isLoggedIn) {
              expirationType
              viewingExpiration
              viewingStartExpiration
              startDeliveryAt
            }
            freeProduct {
              contentId
            }
            ppvProducts {
              id
              contentId
              isOnSale
              isBeingDelivered
              isBundleParent
              isPurchased @include(if: $isLoggedIn)
              price {
                price
                salePrice
              }
            }
            svodProduct {
              startDeliveryAt
            }
            priceSummary {
              lowestPrice
              highestPrice
              discountedLowestPrice
              isLimitedPremium
            }
          }
        }
        total
      }
      purchasedContents(first: 1) @include(if: $isLoggedIn) {
        edges {
          node {
            id
          }
        }
        total
      }
      specialEpisode: episodes(type: SPECIAL, first: 1) {
        total
      }
      pvEpisode: episodes(type: PV, first: 1) {
        edges {
          node {
            id
            sampleMovie
            playInfo {
              duration
            }
          }
        }
        total
      }
    }
    ... on VideoLegacySeason {
      __typename
      metaDescription: description(format: PLAIN)
      packageLargeImage
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      sampleMovie {
        url
        thumbnail
      }
      samplePictures {
        image
        imageLarge
      }
      sampleMovie {
        url
        thumbnail
      }
      reviewSummary {
        averagePoint
      }
      priceSummary {
        lowestPrice
        highestPrice
        discountedLowestPrice
        isLimitedPremium
      }
      continueWatching @include(if: $isLoggedIn) {
        partNumber
        resumePoint
        contentId
        content {
          drmLevel {
            hasStrictProtection
          }
          playInfo {
            parts {
              contentId
            }
          }
          viewingRights(device: $playDevice) {
            isStreamable
          }
          freeProduct {
            contentId
          }
        }
      }
      content {
        id
        contentType
        drmLevel {
          hasStrictProtection
        }
        viewingRights(device: $playDevice) {
          isStreamable
          isDownloadable
          downloadableFiles @include(if: $isLoggedIn) {
            quality {
              name
              displayName
              displayPriority
            }
            totalFileSize
            parts {
              partNumber
              fileSize
            }
          }
          windowsURLSchemes: appURLSchemes(app: WINDOWS_VR) @include(if: $isLoggedIn) {
            partNumber
            url
          }
          iosURLSchemes: appURLSchemes(app: IOS_VR) @include(if: $isLoggedIn) {
            partNumber
            url
          }
          androidURLSchemes: appURLSchemes(app: ANDROID_VR) @include(if: $isLoggedIn) {
            partNumber
            url
          }
        }
        playInfo {
          duration
          audioRenditions
          textRenditions
          highestQuality
          isSupportHDR
          highestAudioChannelLayout
          parts {
            contentId
            number
          }
        }
        ppvExpiration @include(if: $isLoggedIn) {
          expirationType
          viewingExpiration
          viewingStartExpiration
          startDeliveryAt
        }
        freeProduct {
          contentId
        }
        ppvProducts {
          id
          contentId
          isOnSale
          isBeingDelivered
          isBundleParent
          isPurchased @include(if: $isLoggedIn)
          price {
            price
            salePrice
          }
        }
        svodProduct {
          startDeliveryAt
        }
        priceSummary {
          lowestPrice
          highestPrice
          discountedLowestPrice
          isLimitedPremium
        }
      }
      series {
        id
        name
      }
    }
    ... on VideoStageSeason {
      id
      __typename
      metaDescription: description(format: PLAIN)
      keyVisualImage
      keyVisualWithoutLogoImage
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      priceSummary {
        lowestPrice
        highestPrice
        discountedLowestPrice
        isLimitedPremium
      }
      allPerformances {
        performanceDate
        contents {
          id
          episodeTitle
          priority
          startLivePerformanceAt
          ppvProducts {
            id
            contentId
            isOnSale
            isBeingDelivered
            isBundleParent
            isPurchased @include(if: $isLoggedIn)
            price {
              price
              salePrice
            }
          }
          priceSummary {
            lowestPrice
            highestPrice
            discountedLowestPrice
            isLimitedPremium
          }
        }
      }
      purchasedContents(first: 1) @include(if: $isLoggedIn) {
        edges {
          node {
            id
          }
        }
        total
      }
    }
    ... on VideoSpotLiveSeason {
      __typename
      metaDescription: description(format: PLAIN)
      keyVisualImage
      keyVisualWithoutLogoImage
      episodes(type: MAIN, first: 1) {
        edges {
          node {
            drmLevel {
              hasStrictProtection
            }
            id
            episodeTitle
            episodeNumber
            episodeNumberName
            viewingRights(device: $playDevice) {
              isStreamable
            }
            ppvExpiration @include(if: $isLoggedIn) {
              expirationType
              viewingExpiration
              viewingStartExpiration
              startDeliveryAt
            }
            freeProduct {
              contentId
            }
            ppvProducts {
              id
              contentId
              isOnSale
              isBeingDelivered
              isBundleParent
              isPurchased @include(if: $isLoggedIn)
              price {
                price
                salePrice
              }
            }
            svodProduct {
              startDeliveryAt
            }
            playInfo {
              audioRenditions
              textRenditions
              duration
              highestQuality
              isSupportHDR
              highestAudioChannelLayout
            }
            priceSummary {
              lowestPrice
              highestPrice
              discountedLowestPrice
              isLimitedPremium
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetVideoQuery__
 *
 * To run a query within a React component, call `useGetVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      contentId: // value for 'contentId'
 *      device: // value for 'device'
 *      playDevice: // value for 'playDevice'
 *      isLoggedIn: // value for 'isLoggedIn'
 *      isContentId: // value for 'isContentId'
 *   },
 * });
 */
export function useGetVideoQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoQuery, G_GetVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoQuery, G_GetVideoQueryVariables>(GetVideoDocument, options);
      }
export function useGetVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoQuery, G_GetVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoQuery, G_GetVideoQueryVariables>(GetVideoDocument, options);
        }
export type GetVideoQueryHookResult = ReturnType<typeof useGetVideoQuery>;
export type GetVideoLazyQueryHookResult = ReturnType<typeof useGetVideoLazyQuery>;
export type GetVideoQueryResult = Apollo.QueryResult<G_GetVideoQuery, G_GetVideoQueryVariables>;
export const GetVideoMainEpisodeDocument = gql`
    query GetVideoMainEpisode($id: ID!, $device: PlayDevice!, $first: Int, $after: Int, $last: Int, $before: Int, $isLoggedIn: Boolean!) {
  video(id: $id) {
    ... on VideoSeason {
      episodes(type: MAIN, first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            id
            seasonId
            episodeType
            episodeImage
            episodeTitle
            episodeDetail
            episodeNumberName
            priceSummary {
              isLimitedPremium
              lowestPrice
              highestPrice
              discountedLowestPrice
            }
            playInfo {
              contentId
              duration
              parts {
                contentId
                number
                duration
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $device) {
              isDownloadable
              isStreamable
              downloadableFiles @include(if: $isLoggedIn) {
                quality {
                  name
                  displayName
                  displayPriority
                }
                totalFileSize
                parts {
                  partNumber
                  fileSize
                }
              }
            }
            svodProduct {
              isBeingDelivered
              contentId
            }
            ppvProducts {
              id
              contentId
              isOnSale
              isBeingDelivered
              isBundleParent
              isPurchased @include(if: $isLoggedIn)
              price {
                price
                salePrice
              }
            }
            freeProduct {
              isBeingDelivered
              contentId
            }
            ppvExpiration @include(if: $isLoggedIn) {
              expirationType
              viewingExpiration
              viewingStartExpiration
              startDeliveryAt
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        total
        allEpisodeNumbers
      }
    }
  }
}
    `;

/**
 * __useGetVideoMainEpisodeQuery__
 *
 * To run a query within a React component, call `useGetVideoMainEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoMainEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoMainEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetVideoMainEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoMainEpisodeQuery, G_GetVideoMainEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoMainEpisodeQuery, G_GetVideoMainEpisodeQueryVariables>(GetVideoMainEpisodeDocument, options);
      }
export function useGetVideoMainEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoMainEpisodeQuery, G_GetVideoMainEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoMainEpisodeQuery, G_GetVideoMainEpisodeQueryVariables>(GetVideoMainEpisodeDocument, options);
        }
export type GetVideoMainEpisodeQueryHookResult = ReturnType<typeof useGetVideoMainEpisodeQuery>;
export type GetVideoMainEpisodeLazyQueryHookResult = ReturnType<typeof useGetVideoMainEpisodeLazyQuery>;
export type GetVideoMainEpisodeQueryResult = Apollo.QueryResult<G_GetVideoMainEpisodeQuery, G_GetVideoMainEpisodeQueryVariables>;
export const GetVideoPurchasedEpisodeDocument = gql`
    query GetVideoPurchasedEpisode($id: ID!, $device: PlayDevice!, $first: Int, $after: String, $isLoggedIn: Boolean!) {
  video(id: $id) @include(if: $isLoggedIn) {
    ... on VideoSeason {
      purchasedContents(first: $first, after: $after) {
        edges {
          node {
            id
            seasonId
            episodeType
            episodeImage
            episodeTitle
            episodeDetail
            episodeNumberName
            contentType
            playInfo {
              contentId
              duration
              parts {
                contentId
                duration
                resumePoint
              }
            }
            viewingRights(device: $device) {
              isDownloadable
              isStreamable
              downloadableFiles @include(if: $isLoggedIn) {
                quality {
                  name
                  displayName
                  displayPriority
                }
                totalFileSize
                parts {
                  partNumber
                  fileSize
                }
              }
            }
            ppvProducts {
              id
              contentId
              isOnSale
              isBeingDelivered
              isBundleParent
              isPurchased @include(if: $isLoggedIn)
              price {
                price
                salePrice
              }
            }
            ppvExpiration {
              expirationType
              viewingExpiration
              viewingStartExpiration
              startDeliveryAt
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        total
      }
    }
    ... on VideoStageSeason {
      id
      purchasedContents(first: $first, after: $after) {
        edges {
          node {
            id
            seasonId
            episodeType
            episodeImage
            episodeTitle
            episodeDetail
            episodeNumberName
            contentType
            playInfo {
              contentId
              duration
              parts {
                contentId
                duration
                resumePoint
              }
            }
            viewingRights(device: $device) {
              isDownloadable
              isStreamable
              downloadableFiles @include(if: $isLoggedIn) {
                quality {
                  name
                  displayName
                  displayPriority
                }
                totalFileSize
                parts {
                  partNumber
                  fileSize
                }
              }
            }
            ppvProducts {
              id
              contentId
              isOnSale
              isBeingDelivered
              isBundleParent
              isPurchased @include(if: $isLoggedIn)
              price {
                price
                salePrice
              }
            }
            ppvExpiration {
              expirationType
              viewingExpiration
              viewingStartExpiration
              startDeliveryAt
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        total
      }
    }
  }
}
    `;

/**
 * __useGetVideoPurchasedEpisodeQuery__
 *
 * To run a query within a React component, call `useGetVideoPurchasedEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoPurchasedEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoPurchasedEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetVideoPurchasedEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoPurchasedEpisodeQuery, G_GetVideoPurchasedEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoPurchasedEpisodeQuery, G_GetVideoPurchasedEpisodeQueryVariables>(GetVideoPurchasedEpisodeDocument, options);
      }
export function useGetVideoPurchasedEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoPurchasedEpisodeQuery, G_GetVideoPurchasedEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoPurchasedEpisodeQuery, G_GetVideoPurchasedEpisodeQueryVariables>(GetVideoPurchasedEpisodeDocument, options);
        }
export type GetVideoPurchasedEpisodeQueryHookResult = ReturnType<typeof useGetVideoPurchasedEpisodeQuery>;
export type GetVideoPurchasedEpisodeLazyQueryHookResult = ReturnType<typeof useGetVideoPurchasedEpisodeLazyQuery>;
export type GetVideoPurchasedEpisodeQueryResult = Apollo.QueryResult<G_GetVideoPurchasedEpisodeQuery, G_GetVideoPurchasedEpisodeQueryVariables>;
export const GetVideoPvEpisodeDocument = gql`
    query GetVideoPvEpisode($id: ID!, $first: Int, $after: Int, $last: Int, $before: Int) {
  video(id: $id) {
    ... on VideoSeason {
      episodes(type: PV, first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            id
            episodeType
            episodeImage
            episodeTitle
            episodeDetail
            playInfo {
              duration
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        total
        allEpisodeNumbers
      }
    }
  }
}
    `;

/**
 * __useGetVideoPvEpisodeQuery__
 *
 * To run a query within a React component, call `useGetVideoPvEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoPvEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoPvEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetVideoPvEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoPvEpisodeQuery, G_GetVideoPvEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoPvEpisodeQuery, G_GetVideoPvEpisodeQueryVariables>(GetVideoPvEpisodeDocument, options);
      }
export function useGetVideoPvEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoPvEpisodeQuery, G_GetVideoPvEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoPvEpisodeQuery, G_GetVideoPvEpisodeQueryVariables>(GetVideoPvEpisodeDocument, options);
        }
export type GetVideoPvEpisodeQueryHookResult = ReturnType<typeof useGetVideoPvEpisodeQuery>;
export type GetVideoPvEpisodeLazyQueryHookResult = ReturnType<typeof useGetVideoPvEpisodeLazyQuery>;
export type GetVideoPvEpisodeQueryResult = Apollo.QueryResult<G_GetVideoPvEpisodeQuery, G_GetVideoPvEpisodeQueryVariables>;
export const GetVideoSpecialEpisodeDocument = gql`
    query GetVideoSpecialEpisode($id: ID!, $device: PlayDevice!, $first: Int, $after: Int, $last: Int, $before: Int, $isLoggedIn: Boolean!) {
  video(id: $id) {
    ... on VideoSeason {
      episodes(
        type: SPECIAL
        first: $first
        after: $after
        last: $last
        before: $before
      ) {
        edges {
          node {
            id
            seasonId
            episodeType
            episodeImage
            episodeTitle
            episodeDetail
            episodeNumberName
            playInfo {
              contentId
              duration
              parts {
                contentId
                duration
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $device) {
              isDownloadable
              isStreamable
              downloadableFiles @include(if: $isLoggedIn) {
                quality {
                  name
                  displayName
                  displayPriority
                }
                totalFileSize
                parts {
                  partNumber
                  fileSize
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        total
        allEpisodeNumbers
      }
    }
  }
}
    `;

/**
 * __useGetVideoSpecialEpisodeQuery__
 *
 * To run a query within a React component, call `useGetVideoSpecialEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoSpecialEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoSpecialEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetVideoSpecialEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoSpecialEpisodeQuery, G_GetVideoSpecialEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoSpecialEpisodeQuery, G_GetVideoSpecialEpisodeQueryVariables>(GetVideoSpecialEpisodeDocument, options);
      }
export function useGetVideoSpecialEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoSpecialEpisodeQuery, G_GetVideoSpecialEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoSpecialEpisodeQuery, G_GetVideoSpecialEpisodeQueryVariables>(GetVideoSpecialEpisodeDocument, options);
        }
export type GetVideoSpecialEpisodeQueryHookResult = ReturnType<typeof useGetVideoSpecialEpisodeQuery>;
export type GetVideoSpecialEpisodeLazyQueryHookResult = ReturnType<typeof useGetVideoSpecialEpisodeLazyQuery>;
export type GetVideoSpecialEpisodeQueryResult = Apollo.QueryResult<G_GetVideoSpecialEpisodeQuery, G_GetVideoSpecialEpisodeQueryVariables>;
export const GetVideoReviewsDocument = gql`
    query GetVideoReviews($id: ID!, $first: Int, $after: String) {
  video(id: $id) {
    ... on VideoSeason {
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      reviews(first: $first, after: $after) {
        edges {
          node {
            id
            reviewerName
            reviewerId
            title
            point
            hasSpoiler
            comment
            date
            isReviewerPurchased
            helpfulVoteCount
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        total
      }
    }
    ... on VideoStageSeason {
      id
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      reviews(first: $first, after: $after) {
        edges {
          node {
            id
            reviewerName
            reviewerId
            title
            point
            hasSpoiler
            comment
            date
            isReviewerPurchased
            helpfulVoteCount
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        total
      }
    }
    ... on VideoLegacySeason {
      reviewSummary {
        averagePoint
        reviewerCount
        reviewCommentCount
      }
      reviews(first: $first, after: $after) {
        edges {
          node {
            id
            reviewerName
            reviewerId
            title
            point
            hasSpoiler
            comment
            date
            isReviewerPurchased
            helpfulVoteCount
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        total
      }
    }
  }
}
    `;

/**
 * __useGetVideoReviewsQuery__
 *
 * To run a query within a React component, call `useGetVideoReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetVideoReviewsQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoReviewsQuery, G_GetVideoReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoReviewsQuery, G_GetVideoReviewsQueryVariables>(GetVideoReviewsDocument, options);
      }
export function useGetVideoReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoReviewsQuery, G_GetVideoReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoReviewsQuery, G_GetVideoReviewsQueryVariables>(GetVideoReviewsDocument, options);
        }
export type GetVideoReviewsQueryHookResult = ReturnType<typeof useGetVideoReviewsQuery>;
export type GetVideoReviewsLazyQueryHookResult = ReturnType<typeof useGetVideoReviewsLazyQuery>;
export type GetVideoReviewsQueryResult = Apollo.QueryResult<G_GetVideoReviewsQuery, G_GetVideoReviewsQueryVariables>;
export const GetRecommendedVideoDocument = gql`
    query GetRecommendedVideo($seasonId: ID!, $visitorId: ID!, $device: Device!, $eventType: RecommendationEventType!, $categoryId: ID, $contentType: VideoContentTypeFilter, $limit: Int) {
  video(id: $seasonId) {
    i2iRecommendedVideos(
      visitorId: $visitorId
      device: $device
      eventType: $eventType
      categoryId: $categoryId
      contentType: $contentType
      limit: $limit
    ) {
      edges {
        node {
          id
          video {
            __typename
            id
            titleName
            packageImage
            seasonType
            isNewArrival
            customTag
            isExclusive
            rating {
              category
            }
          }
        }
      }
      trackingId
      testId
      requestId
    }
  }
}
    `;

/**
 * __useGetRecommendedVideoQuery__
 *
 * To run a query within a React component, call `useGetRecommendedVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedVideoQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      visitorId: // value for 'visitorId'
 *      device: // value for 'device'
 *      eventType: // value for 'eventType'
 *      categoryId: // value for 'categoryId'
 *      contentType: // value for 'contentType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRecommendedVideoQuery(baseOptions: Apollo.QueryHookOptions<G_GetRecommendedVideoQuery, G_GetRecommendedVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetRecommendedVideoQuery, G_GetRecommendedVideoQueryVariables>(GetRecommendedVideoDocument, options);
      }
export function useGetRecommendedVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetRecommendedVideoQuery, G_GetRecommendedVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetRecommendedVideoQuery, G_GetRecommendedVideoQueryVariables>(GetRecommendedVideoDocument, options);
        }
export type GetRecommendedVideoQueryHookResult = ReturnType<typeof useGetRecommendedVideoQuery>;
export type GetRecommendedVideoLazyQueryHookResult = ReturnType<typeof useGetRecommendedVideoLazyQuery>;
export type GetRecommendedVideoQueryResult = Apollo.QueryResult<G_GetRecommendedVideoQuery, G_GetRecommendedVideoQueryVariables>;
export const GetVideoPurchaseModalDataDocument = gql`
    query GetVideoPurchaseModalData($seasonId: ID!) {
  video(id: $seasonId) {
    titleName
    seasonName
    seasonType
    campaign {
      id
      name
      endAt
      isLimitedPremium
    }
  }
}
    `;

/**
 * __useGetVideoPurchaseModalDataQuery__
 *
 * To run a query within a React component, call `useGetVideoPurchaseModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoPurchaseModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoPurchaseModalDataQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetVideoPurchaseModalDataQuery(baseOptions: Apollo.QueryHookOptions<G_GetVideoPurchaseModalDataQuery, G_GetVideoPurchaseModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetVideoPurchaseModalDataQuery, G_GetVideoPurchaseModalDataQueryVariables>(GetVideoPurchaseModalDataDocument, options);
      }
export function useGetVideoPurchaseModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetVideoPurchaseModalDataQuery, G_GetVideoPurchaseModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetVideoPurchaseModalDataQuery, G_GetVideoPurchaseModalDataQueryVariables>(GetVideoPurchaseModalDataDocument, options);
        }
export type GetVideoPurchaseModalDataQueryHookResult = ReturnType<typeof useGetVideoPurchaseModalDataQuery>;
export type GetVideoPurchaseModalDataLazyQueryHookResult = ReturnType<typeof useGetVideoPurchaseModalDataLazyQuery>;
export type GetVideoPurchaseModalDataQueryResult = Apollo.QueryResult<G_GetVideoPurchaseModalDataQuery, G_GetVideoPurchaseModalDataQueryVariables>;
export const FetchRecommendedVideosDocument = gql`
    query FetchRecommendedVideos($visitorId: ID!, $device: Device!, $eventType: RecommendationEventType!, $categoryId: ID, $searchQuery: String, $contentType: VideoContentTypeFilter, $limit: Int) {
  u2iRecommendedVideos(
    visitorId: $visitorId
    device: $device
    eventType: $eventType
    categoryId: $categoryId
    searchQuery: $searchQuery
    contentType: $contentType
    limit: $limit
  ) {
    trackingId
    testId
    requestId
    edges {
      node {
        id
        video {
          __typename
          id
          viewingTypes
          seasonName
          titleName
          description
          packageImage
          seasonType
          isNewArrival
          customTag
          isExclusive
          campaign {
            id
            endAt
          }
          rating {
            category
          }
          ... on VideoSeason {
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoStageSeason {
            id
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoLegacySeason {
            __typename
            isBeingDelivered
            startPublicAt
            packageLargeImage
          }
          ... on VideoSpotLiveSeason {
            __typename
            keyVisualImage
            keyVisualWithoutLogoImage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchRecommendedVideosQuery__
 *
 * To run a query within a React component, call `useFetchRecommendedVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecommendedVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecommendedVideosQuery({
 *   variables: {
 *      visitorId: // value for 'visitorId'
 *      device: // value for 'device'
 *      eventType: // value for 'eventType'
 *      categoryId: // value for 'categoryId'
 *      searchQuery: // value for 'searchQuery'
 *      contentType: // value for 'contentType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchRecommendedVideosQuery(baseOptions: Apollo.QueryHookOptions<G_FetchRecommendedVideosQuery, G_FetchRecommendedVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchRecommendedVideosQuery, G_FetchRecommendedVideosQueryVariables>(FetchRecommendedVideosDocument, options);
      }
export function useFetchRecommendedVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchRecommendedVideosQuery, G_FetchRecommendedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchRecommendedVideosQuery, G_FetchRecommendedVideosQueryVariables>(FetchRecommendedVideosDocument, options);
        }
export type FetchRecommendedVideosQueryHookResult = ReturnType<typeof useFetchRecommendedVideosQuery>;
export type FetchRecommendedVideosLazyQueryHookResult = ReturnType<typeof useFetchRecommendedVideosLazyQuery>;
export type FetchRecommendedVideosQueryResult = Apollo.QueryResult<G_FetchRecommendedVideosQuery, G_FetchRecommendedVideosQueryVariables>;
export const FetchSearchVideosDocument = gql`
    query FetchSearchVideos($device: Device!, $keyword: String, $title: ID, $categories: [ID!], $genres: [ID!], $casts: [ID!], $staffs: [ID!], $series: ID, $contentType: VideoContentTypeFilter, $viewingTypes: [VideoViewingType!], $campaigns: [ID!], $sort: VideoSearchSortKey, $first: Int, $last: Int, $before: String, $after: String) {
  searchVideos(
    device: $device
    keyword: $keyword
    title: $title
    categories: $categories
    genres: $genres
    casts: $casts
    staffs: $staffs
    series: $series
    contentType: $contentType
    viewingTypes: $viewingTypes
    campaigns: $campaigns
    sort: $sort
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    ...VideoSearchResultConnection
  }
}
    ${VideoSearchResultConnectionFragmentDoc}`;

/**
 * __useFetchSearchVideosQuery__
 *
 * To run a query within a React component, call `useFetchSearchVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSearchVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSearchVideosQuery({
 *   variables: {
 *      device: // value for 'device'
 *      keyword: // value for 'keyword'
 *      title: // value for 'title'
 *      categories: // value for 'categories'
 *      genres: // value for 'genres'
 *      casts: // value for 'casts'
 *      staffs: // value for 'staffs'
 *      series: // value for 'series'
 *      contentType: // value for 'contentType'
 *      viewingTypes: // value for 'viewingTypes'
 *      campaigns: // value for 'campaigns'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchSearchVideosQuery(baseOptions: Apollo.QueryHookOptions<G_FetchSearchVideosQuery, G_FetchSearchVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchSearchVideosQuery, G_FetchSearchVideosQueryVariables>(FetchSearchVideosDocument, options);
      }
export function useFetchSearchVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchSearchVideosQuery, G_FetchSearchVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchSearchVideosQuery, G_FetchSearchVideosQueryVariables>(FetchSearchVideosDocument, options);
        }
export type FetchSearchVideosQueryHookResult = ReturnType<typeof useFetchSearchVideosQuery>;
export type FetchSearchVideosLazyQueryHookResult = ReturnType<typeof useFetchSearchVideosLazyQuery>;
export type FetchSearchVideosQueryResult = Apollo.QueryResult<G_FetchSearchVideosQuery, G_FetchSearchVideosQueryVariables>;
export const FetchShelfDocument = gql`
    query FetchShelf($id: ID!, $device: Device!, $first: Int, $after: String) {
  shelf(device: $device, id: $id) {
    ... on ShelfOfPresetVideos {
      __typename
      id
      device
      imageType
      name
      presetVideos(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            __typename
            id
            seasonName
            titleName
            description
            packageImage
            seasonType
            isNewArrival
            customTag
            isExclusive
            campaign {
              id
              endAt
            }
            rating {
              category
            }
            ... on VideoSeason {
              __typename
              keyVisualImage
              keyVisualWithoutLogoImage
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchShelfQuery__
 *
 * To run a query within a React component, call `useFetchShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShelfQuery({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchShelfQuery(baseOptions: Apollo.QueryHookOptions<G_FetchShelfQuery, G_FetchShelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchShelfQuery, G_FetchShelfQueryVariables>(FetchShelfDocument, options);
      }
export function useFetchShelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchShelfQuery, G_FetchShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchShelfQuery, G_FetchShelfQueryVariables>(FetchShelfDocument, options);
        }
export type FetchShelfQueryHookResult = ReturnType<typeof useFetchShelfQuery>;
export type FetchShelfLazyQueryHookResult = ReturnType<typeof useFetchShelfLazyQuery>;
export type FetchShelfQueryResult = Apollo.QueryResult<G_FetchShelfQuery, G_FetchShelfQueryVariables>;
export const AddUserProfileDocument = gql`
    mutation AddUserProfile($input: AddProfileInput!) {
  addProfile(input: $input) {
    mutationId
  }
}
    `;
export type G_AddUserProfileMutationFn = Apollo.MutationFunction<G_AddUserProfileMutation, G_AddUserProfileMutationVariables>;

/**
 * __useAddUserProfileMutation__
 *
 * To run a mutation, you first call `useAddUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserProfileMutation, { data, loading, error }] = useAddUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<G_AddUserProfileMutation, G_AddUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_AddUserProfileMutation, G_AddUserProfileMutationVariables>(AddUserProfileDocument, options);
      }
export type AddUserProfileMutationHookResult = ReturnType<typeof useAddUserProfileMutation>;
export type AddUserProfileMutationResult = Apollo.MutationResult<G_AddUserProfileMutation>;
export type AddUserProfileMutationOptions = Apollo.BaseMutationOptions<G_AddUserProfileMutation, G_AddUserProfileMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    mutationId
  }
}
    `;
export type G_UpdateUserProfileMutationFn = Apollo.MutationFunction<G_UpdateUserProfileMutation, G_UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<G_UpdateUserProfileMutation, G_UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_UpdateUserProfileMutation, G_UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<G_UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<G_UpdateUserProfileMutation, G_UpdateUserProfileMutationVariables>;
export const DeleteUserProfileDocument = gql`
    mutation DeleteUserProfile($input: DeleteProfileInput!) {
  deleteProfile(input: $input) {
    mutationId
  }
}
    `;
export type G_DeleteUserProfileMutationFn = Apollo.MutationFunction<G_DeleteUserProfileMutation, G_DeleteUserProfileMutationVariables>;

/**
 * __useDeleteUserProfileMutation__
 *
 * To run a mutation, you first call `useDeleteUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserProfileMutation, { data, loading, error }] = useDeleteUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<G_DeleteUserProfileMutation, G_DeleteUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_DeleteUserProfileMutation, G_DeleteUserProfileMutationVariables>(DeleteUserProfileDocument, options);
      }
export type DeleteUserProfileMutationHookResult = ReturnType<typeof useDeleteUserProfileMutation>;
export type DeleteUserProfileMutationResult = Apollo.MutationResult<G_DeleteUserProfileMutation>;
export type DeleteUserProfileMutationOptions = Apollo.BaseMutationOptions<G_DeleteUserProfileMutation, G_DeleteUserProfileMutationVariables>;
export const FetchUserDocument = gql`
    query FetchUser {
  user {
    id
    mail
    hashedId
    isFirstSubscribe(planId: DMM_PREMIUM)
    isAffiliateOwner
    planStatus {
      servicePlan
      status
      nextBillingDate
      paymentType
      paymentStatus(id: DMM_PREMIUM) {
        isRenewalFailure
        failureCode
        message
      }
    }
    profiles {
      id
      isParent
      name
      viewableRating
      profileIcon {
        id
        url
      }
      securityCodeSettings {
        hasSecurityCode
      }
    }
    wallet {
      dmmPoint {
        paidDmmPoint
        sharedFreeDmmPoint
      }
    }
    fanzaPlanStatus(plan: FANZA_TV_PLUS) {
      status
    }
  }
}
    `;

/**
 * __useFetchUserQuery__
 *
 * To run a query within a React component, call `useFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUserQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchUserQuery, G_FetchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchUserQuery, G_FetchUserQueryVariables>(FetchUserDocument, options);
      }
export function useFetchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchUserQuery, G_FetchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchUserQuery, G_FetchUserQueryVariables>(FetchUserDocument, options);
        }
export type FetchUserQueryHookResult = ReturnType<typeof useFetchUserQuery>;
export type FetchUserLazyQueryHookResult = ReturnType<typeof useFetchUserLazyQuery>;
export type FetchUserQueryResult = Apollo.QueryResult<G_FetchUserQuery, G_FetchUserQueryVariables>;
export const FetchUserProfileDocument = gql`
    query FetchUserProfile($profileId: ID!) {
  user {
    id
    profile(profileId: $profileId) {
      id
      name
      isParent
      viewableRating
      securityCodeSettings {
        hasSecurityCode
      }
      profileIcon {
        id
        url
      }
    }
    profileIcons {
      id
      url
    }
  }
}
    `;

/**
 * __useFetchUserProfileQuery__
 *
 * To run a query within a React component, call `useFetchUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useFetchUserProfileQuery(baseOptions: Apollo.QueryHookOptions<G_FetchUserProfileQuery, G_FetchUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchUserProfileQuery, G_FetchUserProfileQueryVariables>(FetchUserProfileDocument, options);
      }
export function useFetchUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchUserProfileQuery, G_FetchUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchUserProfileQuery, G_FetchUserProfileQueryVariables>(FetchUserProfileDocument, options);
        }
export type FetchUserProfileQueryHookResult = ReturnType<typeof useFetchUserProfileQuery>;
export type FetchUserProfileLazyQueryHookResult = ReturnType<typeof useFetchUserProfileLazyQuery>;
export type FetchUserProfileQueryResult = Apollo.QueryResult<G_FetchUserProfileQuery, G_FetchUserProfileQueryVariables>;
export const FetchUserReviewInfoDocument = gql`
    query FetchUserReviewInfo($seasonId: ID!, $isLoggedIn: Boolean!) {
  user @include(if: $isLoggedIn) {
    id
    mail
    reviewer {
      id
      nickname
      videoReviewStatus(seasonId: $seasonId)
    }
  }
}
    `;

/**
 * __useFetchUserReviewInfoQuery__
 *
 * To run a query within a React component, call `useFetchUserReviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserReviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserReviewInfoQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useFetchUserReviewInfoQuery(baseOptions: Apollo.QueryHookOptions<G_FetchUserReviewInfoQuery, G_FetchUserReviewInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchUserReviewInfoQuery, G_FetchUserReviewInfoQueryVariables>(FetchUserReviewInfoDocument, options);
      }
export function useFetchUserReviewInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchUserReviewInfoQuery, G_FetchUserReviewInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchUserReviewInfoQuery, G_FetchUserReviewInfoQueryVariables>(FetchUserReviewInfoDocument, options);
        }
export type FetchUserReviewInfoQueryHookResult = ReturnType<typeof useFetchUserReviewInfoQuery>;
export type FetchUserReviewInfoLazyQueryHookResult = ReturnType<typeof useFetchUserReviewInfoLazyQuery>;
export type FetchUserReviewInfoQueryResult = Apollo.QueryResult<G_FetchUserReviewInfoQuery, G_FetchUserReviewInfoQueryVariables>;
export const FetchUserPostedVideoReviewInfoDocument = gql`
    query FetchUserPostedVideoReviewInfo($seasonId: ID!) {
  user {
    id
    reviewer {
      id
      postedVideoReview(seasonId: $seasonId) {
        id
        title
        point
        hasSpoiler
        comment
      }
    }
  }
}
    `;

/**
 * __useFetchUserPostedVideoReviewInfoQuery__
 *
 * To run a query within a React component, call `useFetchUserPostedVideoReviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserPostedVideoReviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserPostedVideoReviewInfoQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useFetchUserPostedVideoReviewInfoQuery(baseOptions: Apollo.QueryHookOptions<G_FetchUserPostedVideoReviewInfoQuery, G_FetchUserPostedVideoReviewInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchUserPostedVideoReviewInfoQuery, G_FetchUserPostedVideoReviewInfoQueryVariables>(FetchUserPostedVideoReviewInfoDocument, options);
      }
export function useFetchUserPostedVideoReviewInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchUserPostedVideoReviewInfoQuery, G_FetchUserPostedVideoReviewInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchUserPostedVideoReviewInfoQuery, G_FetchUserPostedVideoReviewInfoQueryVariables>(FetchUserPostedVideoReviewInfoDocument, options);
        }
export type FetchUserPostedVideoReviewInfoQueryHookResult = ReturnType<typeof useFetchUserPostedVideoReviewInfoQuery>;
export type FetchUserPostedVideoReviewInfoLazyQueryHookResult = ReturnType<typeof useFetchUserPostedVideoReviewInfoLazyQuery>;
export type FetchUserPostedVideoReviewInfoQueryResult = Apollo.QueryResult<G_FetchUserPostedVideoReviewInfoQuery, G_FetchUserPostedVideoReviewInfoQueryVariables>;
export const FetchVideoContentDocument = gql`
    query FetchVideoContent($id: ID!, $playDevice: PlayDevice!, $isLoggedIn: Boolean!) {
  videoContent(id: $id) {
    id
    seasonId
    episodeNumberName
    episodeImage
    episodeTitle
    contentType
    isWakuwari
    isAllowComment
    priceSummary {
      lowestPrice
      discountedLowestPrice
      highestPrice
      isLimitedPremium
    }
    ppvExpiration @include(if: $isLoggedIn) {
      expirationType
      startDeliveryAt
    }
    freeProduct {
      contentId
    }
    svodProduct {
      contentId
    }
    ppvProducts {
      id
      contentId
      seasonId
      episodeTitle
      episodeNumber
      episodeNumberName
      contentPriority
      saleUnitPriority
      contentType
      saleUnitName
      saleType
      isPreOrder
      isStreamable
      isDownloadable
      isBundleParent
      isOnSale
      isPurchased @include(if: $isLoggedIn)
      startDeliveryAt
      endDeliveryAt
      campaign {
        id
        name
        endAt
        isLimitedPremium
      }
      price {
        productId
        price
        salePrice
        isLimitedPremium
      }
      viewingExpiration {
        ... on VideoLegacyViewingExpiration {
          expireDay
        }
        ... on VideoRentalViewingExpiration {
          startLimitDay
          expireHour
        }
        ... on VideoFixedViewingExpiration {
          expiresAt
        }
      }
      bundleProducts {
        id
        contentId
        seasonId
        episodeTitle
        episodeNumber
        episodeNumberName
        contentPriority
        saleUnitPriority
        contentType
        saleUnitName
        saleType
        isPreOrder
        isStreamable
        isDownloadable
        isBundleParent
        isOnSale
        isPurchased @include(if: $isLoggedIn)
        startDeliveryAt
        endDeliveryAt
        campaign {
          id
          name
          endAt
          isLimitedPremium
        }
        price {
          productId
          price
          salePrice
          isLimitedPremium
        }
        viewingExpiration {
          ... on VideoLegacyViewingExpiration {
            expireDay
          }
          ... on VideoRentalViewingExpiration {
            startLimitDay
            expireHour
          }
          ... on VideoFixedViewingExpiration {
            expiresAt
          }
        }
      }
    }
    ppvExpiration @include(if: $isLoggedIn) {
      expirationType
    }
    viewingRights(device: $playDevice) {
      isStreamable
    }
    playInfo @include(if: $isLoggedIn) {
      duration
      resumePartNumber
      parts {
        duration
        contentId
        resumePoint
        number
      }
    }
    hasBookmark @include(if: $isLoggedIn)
  }
}
    `;

/**
 * __useFetchVideoContentQuery__
 *
 * To run a query within a React component, call `useFetchVideoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVideoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVideoContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      playDevice: // value for 'playDevice'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useFetchVideoContentQuery(baseOptions: Apollo.QueryHookOptions<G_FetchVideoContentQuery, G_FetchVideoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchVideoContentQuery, G_FetchVideoContentQueryVariables>(FetchVideoContentDocument, options);
      }
export function useFetchVideoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchVideoContentQuery, G_FetchVideoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchVideoContentQuery, G_FetchVideoContentQueryVariables>(FetchVideoContentDocument, options);
        }
export type FetchVideoContentQueryHookResult = ReturnType<typeof useFetchVideoContentQuery>;
export type FetchVideoContentLazyQueryHookResult = ReturnType<typeof useFetchVideoContentLazyQuery>;
export type FetchVideoContentQueryResult = Apollo.QueryResult<G_FetchVideoContentQuery, G_FetchVideoContentQueryVariables>;
export const FetchVideoRankingsDocument = gql`
    query FetchVideoRankings($device: Device!, $term: VideoRankingTerm!, $rankingType: VideoRankingType, $category: ID, $genre: ID, $first: Int, $after: String) {
  videoRankings(
    device: $device
    term: $term
    rankingType: $rankingType
    category: $category
    genre: $genre
    first: $first
    after: $after
  ) {
    ...VideoRankingConnection
  }
}
    ${VideoRankingConnectionFragmentDoc}`;

/**
 * __useFetchVideoRankingsQuery__
 *
 * To run a query within a React component, call `useFetchVideoRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVideoRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVideoRankingsQuery({
 *   variables: {
 *      device: // value for 'device'
 *      term: // value for 'term'
 *      rankingType: // value for 'rankingType'
 *      category: // value for 'category'
 *      genre: // value for 'genre'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchVideoRankingsQuery(baseOptions: Apollo.QueryHookOptions<G_FetchVideoRankingsQuery, G_FetchVideoRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchVideoRankingsQuery, G_FetchVideoRankingsQueryVariables>(FetchVideoRankingsDocument, options);
      }
export function useFetchVideoRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchVideoRankingsQuery, G_FetchVideoRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchVideoRankingsQuery, G_FetchVideoRankingsQueryVariables>(FetchVideoRankingsDocument, options);
        }
export type FetchVideoRankingsQueryHookResult = ReturnType<typeof useFetchVideoRankingsQuery>;
export type FetchVideoRankingsLazyQueryHookResult = ReturnType<typeof useFetchVideoRankingsLazyQuery>;
export type FetchVideoRankingsQueryResult = Apollo.QueryResult<G_FetchVideoRankingsQuery, G_FetchVideoRankingsQueryVariables>;
export const CreateDemographicDocument = gql`
    mutation CreateDemographic($input: CreateDemographicInput!) {
  createDemographic(input: $input) {
    succeeded
    mutationId
  }
}
    `;
export type G_CreateDemographicMutationFn = Apollo.MutationFunction<G_CreateDemographicMutation, G_CreateDemographicMutationVariables>;

/**
 * __useCreateDemographicMutation__
 *
 * To run a mutation, you first call `useCreateDemographicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemographicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemographicMutation, { data, loading, error }] = useCreateDemographicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDemographicMutation(baseOptions?: Apollo.MutationHookOptions<G_CreateDemographicMutation, G_CreateDemographicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_CreateDemographicMutation, G_CreateDemographicMutationVariables>(CreateDemographicDocument, options);
      }
export type CreateDemographicMutationHookResult = ReturnType<typeof useCreateDemographicMutation>;
export type CreateDemographicMutationResult = Apollo.MutationResult<G_CreateDemographicMutation>;
export type CreateDemographicMutationOptions = Apollo.BaseMutationOptions<G_CreateDemographicMutation, G_CreateDemographicMutationVariables>;
export const FetchVideosForDemographicDocument = gql`
    query FetchVideosForDemographic {
  videosForDemographic {
    id
    packageImage
    categoryId
    genreId
    displayName
  }
}
    `;

/**
 * __useFetchVideosForDemographicQuery__
 *
 * To run a query within a React component, call `useFetchVideosForDemographicQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVideosForDemographicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVideosForDemographicQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchVideosForDemographicQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchVideosForDemographicQuery, G_FetchVideosForDemographicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchVideosForDemographicQuery, G_FetchVideosForDemographicQueryVariables>(FetchVideosForDemographicDocument, options);
      }
export function useFetchVideosForDemographicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchVideosForDemographicQuery, G_FetchVideosForDemographicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchVideosForDemographicQuery, G_FetchVideosForDemographicQueryVariables>(FetchVideosForDemographicDocument, options);
        }
export type FetchVideosForDemographicQueryHookResult = ReturnType<typeof useFetchVideosForDemographicQuery>;
export type FetchVideosForDemographicLazyQueryHookResult = ReturnType<typeof useFetchVideosForDemographicLazyQuery>;
export type FetchVideosForDemographicQueryResult = Apollo.QueryResult<G_FetchVideosForDemographicQuery, G_FetchVideosForDemographicQueryVariables>;
export const DeleteViewerVideoBookmarksOnMyBookmarkDocument = gql`
    mutation DeleteViewerVideoBookmarksOnMyBookmark($input: DeleteVideoBookmarksInput!) {
  deleteVideoBookmarks(input: $input) {
    mutationId
  }
}
    `;
export type G_DeleteViewerVideoBookmarksOnMyBookmarkMutationFn = Apollo.MutationFunction<G_DeleteViewerVideoBookmarksOnMyBookmarkMutation, G_DeleteViewerVideoBookmarksOnMyBookmarkMutationVariables>;

/**
 * __useDeleteViewerVideoBookmarksOnMyBookmarkMutation__
 *
 * To run a mutation, you first call `useDeleteViewerVideoBookmarksOnMyBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewerVideoBookmarksOnMyBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewerVideoBookmarksOnMyBookmarkMutation, { data, loading, error }] = useDeleteViewerVideoBookmarksOnMyBookmarkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteViewerVideoBookmarksOnMyBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<G_DeleteViewerVideoBookmarksOnMyBookmarkMutation, G_DeleteViewerVideoBookmarksOnMyBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_DeleteViewerVideoBookmarksOnMyBookmarkMutation, G_DeleteViewerVideoBookmarksOnMyBookmarkMutationVariables>(DeleteViewerVideoBookmarksOnMyBookmarkDocument, options);
      }
export type DeleteViewerVideoBookmarksOnMyBookmarkMutationHookResult = ReturnType<typeof useDeleteViewerVideoBookmarksOnMyBookmarkMutation>;
export type DeleteViewerVideoBookmarksOnMyBookmarkMutationResult = Apollo.MutationResult<G_DeleteViewerVideoBookmarksOnMyBookmarkMutation>;
export type DeleteViewerVideoBookmarksOnMyBookmarkMutationOptions = Apollo.BaseMutationOptions<G_DeleteViewerVideoBookmarksOnMyBookmarkMutation, G_DeleteViewerVideoBookmarksOnMyBookmarkMutationVariables>;
export const DeleteViewerVideoPlayHistoriesDocument = gql`
    mutation DeleteViewerVideoPlayHistories($input: DeleteVideoPlayHistoriesInput!) {
  deleteVideoPlayHistories(input: $input) {
    mutationId
  }
}
    `;
export type G_DeleteViewerVideoPlayHistoriesMutationFn = Apollo.MutationFunction<G_DeleteViewerVideoPlayHistoriesMutation, G_DeleteViewerVideoPlayHistoriesMutationVariables>;

/**
 * __useDeleteViewerVideoPlayHistoriesMutation__
 *
 * To run a mutation, you first call `useDeleteViewerVideoPlayHistoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewerVideoPlayHistoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewerVideoPlayHistoriesMutation, { data, loading, error }] = useDeleteViewerVideoPlayHistoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteViewerVideoPlayHistoriesMutation(baseOptions?: Apollo.MutationHookOptions<G_DeleteViewerVideoPlayHistoriesMutation, G_DeleteViewerVideoPlayHistoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_DeleteViewerVideoPlayHistoriesMutation, G_DeleteViewerVideoPlayHistoriesMutationVariables>(DeleteViewerVideoPlayHistoriesDocument, options);
      }
export type DeleteViewerVideoPlayHistoriesMutationHookResult = ReturnType<typeof useDeleteViewerVideoPlayHistoriesMutation>;
export type DeleteViewerVideoPlayHistoriesMutationResult = Apollo.MutationResult<G_DeleteViewerVideoPlayHistoriesMutation>;
export type DeleteViewerVideoPlayHistoriesMutationOptions = Apollo.BaseMutationOptions<G_DeleteViewerVideoPlayHistoriesMutation, G_DeleteViewerVideoPlayHistoriesMutationVariables>;
export const FetchViewerVideoPriceDropNotificationsDocument = gql`
    query FetchViewerVideoPriceDropNotifications($first: Int, $after: String) {
  viewer {
    videoPriceDropNotifications(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          campaignId
          priceWhenAdded
          latestPrice
          video {
            id
            __typename
            titleName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useFetchViewerVideoPriceDropNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchViewerVideoPriceDropNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerVideoPriceDropNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchViewerVideoPriceDropNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchViewerVideoPriceDropNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchViewerVideoPriceDropNotificationsQuery, G_FetchViewerVideoPriceDropNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchViewerVideoPriceDropNotificationsQuery, G_FetchViewerVideoPriceDropNotificationsQueryVariables>(FetchViewerVideoPriceDropNotificationsDocument, options);
      }
export function useFetchViewerVideoPriceDropNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchViewerVideoPriceDropNotificationsQuery, G_FetchViewerVideoPriceDropNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchViewerVideoPriceDropNotificationsQuery, G_FetchViewerVideoPriceDropNotificationsQueryVariables>(FetchViewerVideoPriceDropNotificationsDocument, options);
        }
export type FetchViewerVideoPriceDropNotificationsQueryHookResult = ReturnType<typeof useFetchViewerVideoPriceDropNotificationsQuery>;
export type FetchViewerVideoPriceDropNotificationsLazyQueryHookResult = ReturnType<typeof useFetchViewerVideoPriceDropNotificationsLazyQuery>;
export type FetchViewerVideoPriceDropNotificationsQueryResult = Apollo.QueryResult<G_FetchViewerVideoPriceDropNotificationsQuery, G_FetchViewerVideoPriceDropNotificationsQueryVariables>;
export const FetchViewerVideoBookmarksDocument = gql`
    query FetchViewerVideoBookmarks($device: Device!, $first: Int, $after: String) {
  viewer {
    videoBookmarks(device: $device, first: $first, after: $after) {
      edges {
        node {
          __typename
          id
          createdAt
          video {
            __typename
            id
            seasonType
            titleName
            seasonName
            hasBookmark
            packageImage
            description
            isExclusive
            isNewArrival
            customTag
            packageImage
            viewingTypes
            campaign {
              id
              name
              endAt
            }
            ... on VideoSeason {
              keyVisualImage
              keyVisualWithoutLogoImage
              purchasedContents(first: 1) {
                total
              }
            }
            ... on VideoStageSeason {
              id
              keyVisualImage
              keyVisualWithoutLogoImage
              allPerformances {
                contents {
                  id
                  ppvProducts {
                    id
                    price {
                      price
                      salePrice
                    }
                  }
                }
              }
              purchasedContents(first: 1) {
                total
              }
            }
            ... on VideoLegacySeason {
              packageLargeImage
              purchasedContents(first: 1) {
                total
              }
            }
            ... on VideoSpotLiveSeason {
              keyVisualImage
              keyVisualWithoutLogoImage
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useFetchViewerVideoBookmarksQuery__
 *
 * To run a query within a React component, call `useFetchViewerVideoBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerVideoBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchViewerVideoBookmarksQuery({
 *   variables: {
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchViewerVideoBookmarksQuery(baseOptions: Apollo.QueryHookOptions<G_FetchViewerVideoBookmarksQuery, G_FetchViewerVideoBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchViewerVideoBookmarksQuery, G_FetchViewerVideoBookmarksQueryVariables>(FetchViewerVideoBookmarksDocument, options);
      }
export function useFetchViewerVideoBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchViewerVideoBookmarksQuery, G_FetchViewerVideoBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchViewerVideoBookmarksQuery, G_FetchViewerVideoBookmarksQueryVariables>(FetchViewerVideoBookmarksDocument, options);
        }
export type FetchViewerVideoBookmarksQueryHookResult = ReturnType<typeof useFetchViewerVideoBookmarksQuery>;
export type FetchViewerVideoBookmarksLazyQueryHookResult = ReturnType<typeof useFetchViewerVideoBookmarksLazyQuery>;
export type FetchViewerVideoBookmarksQueryResult = Apollo.QueryResult<G_FetchViewerVideoBookmarksQuery, G_FetchViewerVideoBookmarksQueryVariables>;
export const FetchViewerPurchasedVideosDocument = gql`
    query FetchViewerPurchasedVideos($device: Device!, $first: Int, $after: String, $sort: PurchasedVideoSortKey) {
  viewer {
    purchasedVideos(device: $device, first: $first, after: $after, sort: $sort) {
      edges {
        node {
          __typename
          id
          expiration {
            viewingStartExpiresAt
            viewingExpiresAt
            noExpiration
          }
          video {
            __typename
            id
            description
            packageImage
            titleName
            seasonName
            seasonType
            hasBookmark
            ... on VideoSeason {
              keyVisualImage
              keyVisualWithoutLogoImage
            }
            ... on VideoStageSeason {
              id
              keyVisualWithoutLogoImage
              keyVisualImage
            }
            ... on VideoLegacySeason {
              packageLargeImage
            }
            ... on VideoSpotLiveSeason {
              keyVisualImage
              keyVisualWithoutLogoImage
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFetchViewerPurchasedVideosQuery__
 *
 * To run a query within a React component, call `useFetchViewerPurchasedVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerPurchasedVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchViewerPurchasedVideosQuery({
 *   variables: {
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchViewerPurchasedVideosQuery(baseOptions: Apollo.QueryHookOptions<G_FetchViewerPurchasedVideosQuery, G_FetchViewerPurchasedVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchViewerPurchasedVideosQuery, G_FetchViewerPurchasedVideosQueryVariables>(FetchViewerPurchasedVideosDocument, options);
      }
export function useFetchViewerPurchasedVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchViewerPurchasedVideosQuery, G_FetchViewerPurchasedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchViewerPurchasedVideosQuery, G_FetchViewerPurchasedVideosQueryVariables>(FetchViewerPurchasedVideosDocument, options);
        }
export type FetchViewerPurchasedVideosQueryHookResult = ReturnType<typeof useFetchViewerPurchasedVideosQuery>;
export type FetchViewerPurchasedVideosLazyQueryHookResult = ReturnType<typeof useFetchViewerPurchasedVideosLazyQuery>;
export type FetchViewerPurchasedVideosQueryResult = Apollo.QueryResult<G_FetchViewerPurchasedVideosQuery, G_FetchViewerPurchasedVideosQueryVariables>;
export const FetchViewerVideoPlayHistoriesDocument = gql`
    query FetchViewerVideoPlayHistories($device: Device!, $first: Int, $after: String) {
  viewer {
    videoPlayHistories(device: $device, first: $first, after: $after) {
      edges {
        node {
          __typename
          id
          seasonId
          contentId
          video {
            __typename
            id
            titleName
            seasonName
            seasonType
            hasBookmark
            packageImage
            description
            viewingTypes
            isNewArrival
            customTag
            isExclusive
          }
          content {
            id
            episodeTitle
            episodeDetail
            episodeNumberName
            episodeImage
            playInfo {
              contentId
              parts {
                contentId
                duration
                resumePoint
                number
              }
              resumePartNumber
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFetchViewerVideoPlayHistoriesQuery__
 *
 * To run a query within a React component, call `useFetchViewerVideoPlayHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerVideoPlayHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchViewerVideoPlayHistoriesQuery({
 *   variables: {
 *      device: // value for 'device'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchViewerVideoPlayHistoriesQuery(baseOptions: Apollo.QueryHookOptions<G_FetchViewerVideoPlayHistoriesQuery, G_FetchViewerVideoPlayHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchViewerVideoPlayHistoriesQuery, G_FetchViewerVideoPlayHistoriesQueryVariables>(FetchViewerVideoPlayHistoriesDocument, options);
      }
export function useFetchViewerVideoPlayHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchViewerVideoPlayHistoriesQuery, G_FetchViewerVideoPlayHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchViewerVideoPlayHistoriesQuery, G_FetchViewerVideoPlayHistoriesQueryVariables>(FetchViewerVideoPlayHistoriesDocument, options);
        }
export type FetchViewerVideoPlayHistoriesQueryHookResult = ReturnType<typeof useFetchViewerVideoPlayHistoriesQuery>;
export type FetchViewerVideoPlayHistoriesLazyQueryHookResult = ReturnType<typeof useFetchViewerVideoPlayHistoriesLazyQuery>;
export type FetchViewerVideoPlayHistoriesQueryResult = Apollo.QueryResult<G_FetchViewerVideoPlayHistoriesQuery, G_FetchViewerVideoPlayHistoriesQueryVariables>;
export const FetchViewerHasDemographicDocument = gql`
    query FetchViewerHasDemographic {
  viewer {
    hasDemographic
  }
}
    `;

/**
 * __useFetchViewerHasDemographicQuery__
 *
 * To run a query within a React component, call `useFetchViewerHasDemographicQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerHasDemographicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchViewerHasDemographicQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchViewerHasDemographicQuery(baseOptions?: Apollo.QueryHookOptions<G_FetchViewerHasDemographicQuery, G_FetchViewerHasDemographicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_FetchViewerHasDemographicQuery, G_FetchViewerHasDemographicQueryVariables>(FetchViewerHasDemographicDocument, options);
      }
export function useFetchViewerHasDemographicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_FetchViewerHasDemographicQuery, G_FetchViewerHasDemographicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_FetchViewerHasDemographicQuery, G_FetchViewerHasDemographicQueryVariables>(FetchViewerHasDemographicDocument, options);
        }
export type FetchViewerHasDemographicQueryHookResult = ReturnType<typeof useFetchViewerHasDemographicQuery>;
export type FetchViewerHasDemographicLazyQueryHookResult = ReturnType<typeof useFetchViewerHasDemographicLazyQuery>;
export type FetchViewerHasDemographicQueryResult = Apollo.QueryResult<G_FetchViewerHasDemographicQuery, G_FetchViewerHasDemographicQueryVariables>;
export const GetPlaybackVideoContentDocument = gql`
    query GetPlaybackVideoContent($seasonId: ID!, $contentId: ID!) {
  video(id: $seasonId) {
    __typename
    seasonType
    packageImage
    ... on VideoSeason {
      episode(id: $contentId) {
        episodeTitle
        episodeImage
      }
      keyVisualImage
      keyVisualWithoutLogoImage
    }
    ... on VideoStageSeason {
      id
      titleName
      keyVisualImage
      keyVisualWithoutLogoImage
    }
    ... on VideoLegacySeason {
      titleName
      sampleMovie {
        url
        thumbnail
      }
      packageLargeImage
    }
    ... on VideoSpotLiveSeason {
      titleName
      keyVisualImage
      keyVisualWithoutLogoImage
    }
  }
}
    `;

/**
 * __useGetPlaybackVideoContentQuery__
 *
 * To run a query within a React component, call `useGetPlaybackVideoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackVideoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackVideoContentQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetPlaybackVideoContentQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackVideoContentQuery, G_GetPlaybackVideoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackVideoContentQuery, G_GetPlaybackVideoContentQueryVariables>(GetPlaybackVideoContentDocument, options);
      }
export function useGetPlaybackVideoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackVideoContentQuery, G_GetPlaybackVideoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackVideoContentQuery, G_GetPlaybackVideoContentQueryVariables>(GetPlaybackVideoContentDocument, options);
        }
export type GetPlaybackVideoContentQueryHookResult = ReturnType<typeof useGetPlaybackVideoContentQuery>;
export type GetPlaybackVideoContentLazyQueryHookResult = ReturnType<typeof useGetPlaybackVideoContentLazyQuery>;
export type GetPlaybackVideoContentQueryResult = Apollo.QueryResult<G_GetPlaybackVideoContentQuery, G_GetPlaybackVideoContentQueryVariables>;
export const GetPlaybackEpisodeDocument = gql`
    query GetPlaybackEpisode($seasonId: ID!, $contentId: ID!, $isLoggedIn: Boolean!) {
  video(id: $seasonId) {
    __typename
    id
    ... on VideoSeason {
      episode(id: $contentId) {
        id
        seasonId
        episodeTitle
        episodeNumber
        episodeNumberName
        episodeImage
      }
      purchasedContents @include(if: $isLoggedIn) {
        edges {
          node {
            id
            seasonId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlaybackEpisodeQuery__
 *
 * To run a query within a React component, call `useGetPlaybackEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackEpisodeQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      contentId: // value for 'contentId'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetPlaybackEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackEpisodeQuery, G_GetPlaybackEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackEpisodeQuery, G_GetPlaybackEpisodeQueryVariables>(GetPlaybackEpisodeDocument, options);
      }
export function useGetPlaybackEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackEpisodeQuery, G_GetPlaybackEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackEpisodeQuery, G_GetPlaybackEpisodeQueryVariables>(GetPlaybackEpisodeDocument, options);
        }
export type GetPlaybackEpisodeQueryHookResult = ReturnType<typeof useGetPlaybackEpisodeQuery>;
export type GetPlaybackEpisodeLazyQueryHookResult = ReturnType<typeof useGetPlaybackEpisodeLazyQuery>;
export type GetPlaybackEpisodeQueryResult = Apollo.QueryResult<G_GetPlaybackEpisodeQuery, G_GetPlaybackEpisodeQueryVariables>;
export const GetPlaybackCurrentEpisodeDocument = gql`
    query GetPlaybackCurrentEpisode($seasonId: ID!, $cursor: Int!, $playDevice: PlayDevice!, $isLoggedIn: Boolean!) {
  video(id: $seasonId) {
    ... on VideoSeason {
      currentEpisode: episodes(first: 1, after: $cursor) {
        edges {
          node {
            id
            seasonId
            episodeNumberName
            episodeTitle
            episodeImage
            freeProduct {
              contentId
            }
            ppvProducts {
              id
              isOnSale
              price {
                price
                salePrice
              }
            }
            priceSummary {
              lowestPrice
              discountedLowestPrice
              highestPrice
              isLimitedPremium
            }
            svodProduct {
              contentId
            }
            playInfo {
              duration
              parts {
                duration
                number
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $playDevice) {
              isStreamable
            }
          }
        }
        total
      }
    }
  }
}
    `;

/**
 * __useGetPlaybackCurrentEpisodeQuery__
 *
 * To run a query within a React component, call `useGetPlaybackCurrentEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackCurrentEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackCurrentEpisodeQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      cursor: // value for 'cursor'
 *      playDevice: // value for 'playDevice'
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useGetPlaybackCurrentEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackCurrentEpisodeQuery, G_GetPlaybackCurrentEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackCurrentEpisodeQuery, G_GetPlaybackCurrentEpisodeQueryVariables>(GetPlaybackCurrentEpisodeDocument, options);
      }
export function useGetPlaybackCurrentEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackCurrentEpisodeQuery, G_GetPlaybackCurrentEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackCurrentEpisodeQuery, G_GetPlaybackCurrentEpisodeQueryVariables>(GetPlaybackCurrentEpisodeDocument, options);
        }
export type GetPlaybackCurrentEpisodeQueryHookResult = ReturnType<typeof useGetPlaybackCurrentEpisodeQuery>;
export type GetPlaybackCurrentEpisodeLazyQueryHookResult = ReturnType<typeof useGetPlaybackCurrentEpisodeLazyQuery>;
export type GetPlaybackCurrentEpisodeQueryResult = Apollo.QueryResult<G_GetPlaybackCurrentEpisodeQuery, G_GetPlaybackCurrentEpisodeQueryVariables>;
export const GetPlaybackBeforeAndAfterEpisodesDocument = gql`
    query GetPlaybackBeforeAndAfterEpisodes($seasonId: ID!, $cursor: Int!, $playDevice: PlayDevice!, $isLoggedIn: Boolean!, $isIncludeBefore: Boolean!, $isIncludeAfter: Boolean!) {
  video(id: $seasonId) {
    ... on VideoSeason {
      beforeEpisodes: episodes(last: 15, before: $cursor) @include(if: $isIncludeBefore) {
        edges {
          node {
            id
            seasonId
            episodeNumberName
            episodeTitle
            episodeImage
            freeProduct {
              contentId
            }
            ppvProducts {
              id
              isOnSale
              price {
                price
                salePrice
              }
            }
            priceSummary {
              lowestPrice
              discountedLowestPrice
              highestPrice
              isLimitedPremium
            }
            svodProduct {
              contentId
            }
            playInfo {
              duration
              parts {
                duration
                number
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $playDevice) {
              isStreamable
            }
          }
        }
      }
      afterEpisodes: episodes(first: 15, after: $cursor) @include(if: $isIncludeAfter) {
        edges {
          node {
            playInfo {
              duration
              parts {
                duration
                number
                resumePoint @include(if: $isLoggedIn)
              }
            }
            viewingRights(device: $playDevice) {
              isStreamable
            }
            id
            seasonId
            episodeNumberName
            episodeTitle
            episodeImage
            freeProduct {
              contentId
            }
            ppvProducts {
              id
              isOnSale
              price {
                price
                salePrice
              }
            }
            priceSummary {
              lowestPrice
              discountedLowestPrice
              highestPrice
              isLimitedPremium
            }
            svodProduct {
              contentId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlaybackBeforeAndAfterEpisodesQuery__
 *
 * To run a query within a React component, call `useGetPlaybackBeforeAndAfterEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackBeforeAndAfterEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackBeforeAndAfterEpisodesQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      cursor: // value for 'cursor'
 *      playDevice: // value for 'playDevice'
 *      isLoggedIn: // value for 'isLoggedIn'
 *      isIncludeBefore: // value for 'isIncludeBefore'
 *      isIncludeAfter: // value for 'isIncludeAfter'
 *   },
 * });
 */
export function useGetPlaybackBeforeAndAfterEpisodesQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackBeforeAndAfterEpisodesQuery, G_GetPlaybackBeforeAndAfterEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackBeforeAndAfterEpisodesQuery, G_GetPlaybackBeforeAndAfterEpisodesQueryVariables>(GetPlaybackBeforeAndAfterEpisodesDocument, options);
      }
export function useGetPlaybackBeforeAndAfterEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackBeforeAndAfterEpisodesQuery, G_GetPlaybackBeforeAndAfterEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackBeforeAndAfterEpisodesQuery, G_GetPlaybackBeforeAndAfterEpisodesQueryVariables>(GetPlaybackBeforeAndAfterEpisodesDocument, options);
        }
export type GetPlaybackBeforeAndAfterEpisodesQueryHookResult = ReturnType<typeof useGetPlaybackBeforeAndAfterEpisodesQuery>;
export type GetPlaybackBeforeAndAfterEpisodesLazyQueryHookResult = ReturnType<typeof useGetPlaybackBeforeAndAfterEpisodesLazyQuery>;
export type GetPlaybackBeforeAndAfterEpisodesQueryResult = Apollo.QueryResult<G_GetPlaybackBeforeAndAfterEpisodesQuery, G_GetPlaybackBeforeAndAfterEpisodesQueryVariables>;
export const GetPlaybackNextEpisodeDocument = gql`
    query GetPlaybackNextEpisode($seasonId: ID!, $after: Int, $playDevice: PlayDevice!) {
  video(id: $seasonId) {
    ... on VideoSeason {
      nextEpisode: episodes(after: $after, first: 1) {
        edges {
          node {
            id
            seasonId
            episodeTitle
            episodeNumberName
            episodeImage
            viewingRights(device: $playDevice) {
              isStreamable
            }
            svodProduct {
              contentId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlaybackNextEpisodeQuery__
 *
 * To run a query within a React component, call `useGetPlaybackNextEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackNextEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackNextEpisodeQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      after: // value for 'after'
 *      playDevice: // value for 'playDevice'
 *   },
 * });
 */
export function useGetPlaybackNextEpisodeQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackNextEpisodeQuery, G_GetPlaybackNextEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackNextEpisodeQuery, G_GetPlaybackNextEpisodeQueryVariables>(GetPlaybackNextEpisodeDocument, options);
      }
export function useGetPlaybackNextEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackNextEpisodeQuery, G_GetPlaybackNextEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackNextEpisodeQuery, G_GetPlaybackNextEpisodeQueryVariables>(GetPlaybackNextEpisodeDocument, options);
        }
export type GetPlaybackNextEpisodeQueryHookResult = ReturnType<typeof useGetPlaybackNextEpisodeQuery>;
export type GetPlaybackNextEpisodeLazyQueryHookResult = ReturnType<typeof useGetPlaybackNextEpisodeLazyQuery>;
export type GetPlaybackNextEpisodeQueryResult = Apollo.QueryResult<G_GetPlaybackNextEpisodeQuery, G_GetPlaybackNextEpisodeQueryVariables>;
export const GetPlaybackVideoLiveDocument = gql`
    query GetPlaybackVideoLive($seasonId: ID!) {
  video(id: $seasonId) {
    seasonType
    seasonName
    ... on VideoStageSeason {
      id
      keyVisualImage
    }
  }
}
    `;

/**
 * __useGetPlaybackVideoLiveQuery__
 *
 * To run a query within a React component, call `useGetPlaybackVideoLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybackVideoLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybackVideoLiveQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetPlaybackVideoLiveQuery(baseOptions: Apollo.QueryHookOptions<G_GetPlaybackVideoLiveQuery, G_GetPlaybackVideoLiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetPlaybackVideoLiveQuery, G_GetPlaybackVideoLiveQueryVariables>(GetPlaybackVideoLiveDocument, options);
      }
export function useGetPlaybackVideoLiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetPlaybackVideoLiveQuery, G_GetPlaybackVideoLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetPlaybackVideoLiveQuery, G_GetPlaybackVideoLiveQueryVariables>(GetPlaybackVideoLiveDocument, options);
        }
export type GetPlaybackVideoLiveQueryHookResult = ReturnType<typeof useGetPlaybackVideoLiveQuery>;
export type GetPlaybackVideoLiveLazyQueryHookResult = ReturnType<typeof useGetPlaybackVideoLiveLazyQuery>;
export type GetPlaybackVideoLiveQueryResult = Apollo.QueryResult<G_GetPlaybackVideoLiveQuery, G_GetPlaybackVideoLiveQueryVariables>;
export const GetStreamDocument = gql`
    query GetStream($id: ID!, $part: Int, $protectionCapabilities: [ProtectionCapability!]!, $audioChannelLayouts: [StreamingAudioChannelLayout!]!, $device: PlayDevice!, $http: Boolean, $temporaryDownload: Boolean) {
  stream(
    id: $id
    part: $part
    protectionCapabilities: $protectionCapabilities
    audioChannelLayouts: $audioChannelLayouts
    device: $device
    http: $http
    temporaryDownload: $temporaryDownload
  ) {
    contentTypeDetail
    purchasedProductId
    qualities {
      name
      displayName
    }
    textRenditionType
    languages {
      lang
      displayName
    }
    videoRenditions {
      lang
      qualityName
      streamingUrls {
        systemIds
        videoCodec
        format
        bpc
        streamSize
        urls
        hdcp
      }
    }
    audioRenditions {
      lang
      audioChannels
      audioChannelLayout
    }
    textRenditions {
      lang
    }
    chapter {
      op {
        start
        end
      }
      ed {
        start
        end
      }
      skippable {
        start
        end
      }
    }
  }
}
    `;

/**
 * __useGetStreamQuery__
 *
 * To run a query within a React component, call `useGetStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      part: // value for 'part'
 *      protectionCapabilities: // value for 'protectionCapabilities'
 *      audioChannelLayouts: // value for 'audioChannelLayouts'
 *      device: // value for 'device'
 *      http: // value for 'http'
 *      temporaryDownload: // value for 'temporaryDownload'
 *   },
 * });
 */
export function useGetStreamQuery(baseOptions: Apollo.QueryHookOptions<G_GetStreamQuery, G_GetStreamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetStreamQuery, G_GetStreamQueryVariables>(GetStreamDocument, options);
      }
export function useGetStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetStreamQuery, G_GetStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetStreamQuery, G_GetStreamQueryVariables>(GetStreamDocument, options);
        }
export type GetStreamQueryHookResult = ReturnType<typeof useGetStreamQuery>;
export type GetStreamLazyQueryHookResult = ReturnType<typeof useGetStreamLazyQuery>;
export type GetStreamQueryResult = Apollo.QueryResult<G_GetStreamQuery, G_GetStreamQueryVariables>;
export const GetRecommendedVideosDocument = gql`
    query GetRecommendedVideos($seasonId: ID!, $visitorId: ID!, $device: Device!, $categoryId: ID, $playDevice: PlayDevice!, $eventType: RecommendationEventType!, $limit: Int!, $isLoggedIn: Boolean!, $contentType: VideoContentTypeFilter) {
  video(id: $seasonId) {
    i2iRecommendedVideos(
      visitorId: $visitorId
      device: $device
      eventType: $eventType
      categoryId: $categoryId
      contentType: $contentType
      limit: $limit
    ) {
      edges {
        node {
          id
          video {
            __typename
            id
            isExclusive
            isNewArrival
            customTag
            titleName
            seasonName
            ... on VideoLegacySeason {
              id
              packageImage
              packageLargeImage
              content {
                id
                episodeTitle
                viewingRights(device: $playDevice) {
                  isStreamable
                }
                svodProduct {
                  contentId
                }
                freeProduct {
                  contentId
                }
              }
              content {
                freeProduct {
                  contentId
                }
                svodProduct {
                  contentId
                }
              }
              continueWatching @include(if: $isLoggedIn) {
                content {
                  playInfo {
                    contentId
                    parts {
                      number
                      resumePoint
                      duration
                    }
                  }
                }
              }
              priceSummary {
                lowestPrice
                discountedLowestPrice
                highestPrice
                isLimitedPremium
              }
            }
            ... on VideoSeason {
              episodes(first: 1) {
                edges {
                  node {
                    id
                    viewingRights(device: $playDevice) {
                      isStreamable
                    }
                    freeProduct {
                      contentId
                    }
                    svodProduct {
                      contentId
                    }
                  }
                }
              }
              priceSummary {
                lowestPrice
                discountedLowestPrice
                highestPrice
                isLimitedPremium
              }
              keyVisualImage
              keyVisualWithoutLogoImage
              packageImage
              continueWatching @include(if: $isLoggedIn) {
                content {
                  playInfo {
                    contentId
                    parts {
                      number
                      resumePoint
                      duration
                    }
                  }
                }
              }
            }
            ... on VideoStageSeason {
              id
              priceSummary {
                lowestPrice
                discountedLowestPrice
                highestPrice
                isLimitedPremium
              }
            }
          }
        }
      }
      trackingId
      testId
      requestId
    }
  }
}
    `;

/**
 * __useGetRecommendedVideosQuery__
 *
 * To run a query within a React component, call `useGetRecommendedVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedVideosQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      visitorId: // value for 'visitorId'
 *      device: // value for 'device'
 *      categoryId: // value for 'categoryId'
 *      playDevice: // value for 'playDevice'
 *      eventType: // value for 'eventType'
 *      limit: // value for 'limit'
 *      isLoggedIn: // value for 'isLoggedIn'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGetRecommendedVideosQuery(baseOptions: Apollo.QueryHookOptions<G_GetRecommendedVideosQuery, G_GetRecommendedVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetRecommendedVideosQuery, G_GetRecommendedVideosQueryVariables>(GetRecommendedVideosDocument, options);
      }
export function useGetRecommendedVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetRecommendedVideosQuery, G_GetRecommendedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetRecommendedVideosQuery, G_GetRecommendedVideosQueryVariables>(GetRecommendedVideosDocument, options);
        }
export type GetRecommendedVideosQueryHookResult = ReturnType<typeof useGetRecommendedVideosQuery>;
export type GetRecommendedVideosLazyQueryHookResult = ReturnType<typeof useGetRecommendedVideosLazyQuery>;
export type GetRecommendedVideosQueryResult = Apollo.QueryResult<G_GetRecommendedVideosQuery, G_GetRecommendedVideosQueryVariables>;
export const GetGravureTopDocument = gql`
    query GetGravureTop($device: Device!, $id: ID!, $first: Int = 30, $categoryId: ID = "23") {
  topHeader: home(device: $device, homeType: VIDEO_SUB_PAGE, id: $id) {
    headerItems {
      __typename
      ... on VideoFreeItem {
        __typename
        id
        image
        name
        seasonId
        isHiddenForPremiumMember
        video {
          __typename
          id
          viewingTypes
          seasonName
          titleName
          description
          rating {
            category
          }
          packageImage
          seasonType
          isNewArrival
          isExclusive
          campaign {
            id
            endAt
          }
          ... on VideoSeason {
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoStageSeason {
            id
            __typename
            isBeingDelivered
            startPublicAt
            keyVisualImage
            keyVisualWithoutLogoImage
          }
          ... on VideoLegacySeason {
            __typename
            isBeingDelivered
            startPublicAt
            packageLargeImage
          }
          ... on VideoSpotLiveSeason {
            __typename
            keyVisualImage
            keyVisualWithoutLogoImage
          }
        }
      }
      ... on VideoListFreeItem {
        __typename
        id
        name
        image
        isHiddenForPremiumMember
        filter {
          keyword
          title
          categories
          genres
          casts
          staffs
          series
          contentType
          viewingTypes
          campaigns
          sort
        }
      }
      ... on VideoContentFreeItem {
        __typename
        id
        image
        name
        isHiddenForPremiumMember
        content {
          id
          seasonId
          episodeTitle
          episodeDetail
          episodeImage
          svodProduct {
            contentId
          }
          ppvProducts {
            id
          }
          freeProduct {
            contentId
          }
        }
      }
      ... on HomeFreeItem {
        __typename
        id
        homeId
        name
        image
        pageType
        isHiddenForPremiumMember
      }
      ... on URLFreeItem {
        __typename
        id
        image
        name
        url
        isHiddenForPremiumMember
      }
    }
    title
    categoryId
    genres {
      id
      name
    }
  }
  allUURanking: videoRankings(
    device: $device
    term: DAILY
    first: $first
    category: $categoryId
    rankingType: VIEW_COUNT
  ) {
    ...VideoRankingConnection
  }
  videoCampaigns(categoryId: $categoryId) {
    edges {
      node {
        ... on VideoCampaign {
          id
          name
          videos(device: $device, categories: [$categoryId], sort: RANK) {
            edges {
              node {
                __typename
                id
                titleName
                seasonName
                seasonType
                packageImage
                packageLargeImage
                keyVisualImage
                keyVisualWithoutLogoImage
                description
                lowestPrice
                highestPrice
                discountedLowestPrice
                discountedHighestPrice
                isNewArrival
                isExclusive
                isOnSale
                viewingTypes
              }
            }
          }
        }
        ... on VideoDiscountCampaign {
          id
          name
          videos(device: $device, categories: [$categoryId], sort: RANK) {
            edges {
              node {
                __typename
                id
                titleName
                seasonName
                seasonType
                packageImage
                packageLargeImage
                keyVisualImage
                keyVisualWithoutLogoImage
                description
                lowestPrice
                highestPrice
                discountedLowestPrice
                discountedHighestPrice
                isNewArrival
                isExclusive
                isOnSale
                viewingTypes
              }
            }
          }
        }
        ... on VideoPointRefundCampaign {
          id
          name
          videos(device: $device, categories: [$categoryId], sort: RANK) {
            edges {
              node {
                __typename
                id
                titleName
                seasonName
                seasonType
                packageImage
                packageLargeImage
                keyVisualImage
                keyVisualWithoutLogoImage
                description
                lowestPrice
                highestPrice
                discountedLowestPrice
                discountedHighestPrice
                isNewArrival
                isExclusive
                isOnSale
                viewingTypes
              }
            }
          }
        }
        ... on VideoFixedPriceDiscountCampaign {
          id
          name
          videos(device: $device, categories: [$categoryId], sort: RANK) {
            edges {
              node {
                __typename
                id
                titleName
                seasonName
                seasonType
                packageImage
                packageLargeImage
                keyVisualImage
                keyVisualWithoutLogoImage
                description
                lowestPrice
                highestPrice
                discountedLowestPrice
                discountedHighestPrice
                isNewArrival
                isExclusive
                isOnSale
                viewingTypes
              }
            }
          }
        }
      }
    }
  }
  allByPopularity: searchVideos(
    device: $device
    categories: [$categoryId]
    first: $first
    sort: RANK
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  newPPVTakeShobo: searchVideos(
    device: $device
    categories: [$categoryId]
    staffs: ["maker_60101"]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  newPPVLineCommunication: searchVideos(
    device: $device
    categories: [$categoryId]
    staffs: ["maker_60091"]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  newPPVExclusive: searchVideos(
    device: $device
    categories: [$categoryId]
    staffs: ["maker_3255"]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  newPPVEnetFrontier: searchVideos(
    device: $device
    categories: [$categoryId]
    staffs: ["maker_60041"]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  newPPVFantastica: searchVideos(
    device: $device
    categories: [$categoryId]
    staffs: ["maker_66447"]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  allPPVNewArrival: searchVideos(
    device: $device
    categories: [$categoryId]
    first: $first
    sort: NEW
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  exclusiveAndPopularity: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["6548"]
    first: $first
    sort: RANK
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  bigBreastsByPopularity: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["66313"]
    first: $first
    sort: RANK
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  imageVideoByPopularity: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["6014"]
    first: $first
    sort: RANK
    viewingTypes: [PPV]
  ) {
    ...VideoSearchResultConnection
  }
  vrByPopularity: searchVideos(
    device: $device
    categories: [$categoryId]
    first: $first
    sort: RANK
    viewingTypes: [PPV]
    contentType: CONTENT_VR
  ) {
    ...VideoSearchResultConnection
  }
  allNewSVODUnlimited: searchVideos(
    device: $device
    categories: [$categoryId]
    first: $first
    sort: NEW
    viewingTypes: [PREMIUM]
  ) {
    ...VideoSearchResultConnection
  }
  exclusiveAndPopularityUnlimited: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["6548"]
    first: $first
    sort: RANK
    viewingTypes: [PREMIUM]
  ) {
    ...VideoSearchResultConnection
  }
  bigBreastsByPopularityUnlimited: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["66313"]
    first: $first
    sort: RANK
    viewingTypes: [PREMIUM]
  ) {
    ...VideoSearchResultConnection
  }
  imageVideoByPopularityUnlimited: searchVideos(
    device: $device
    categories: [$categoryId]
    genres: ["6014"]
    first: $first
    sort: RANK
    viewingTypes: [PREMIUM]
  ) {
    ...VideoSearchResultConnection
  }
  vrByPopularityUnlimited: searchVideos(
    device: $device
    categories: [$categoryId]
    first: $first
    sort: RANK
    viewingTypes: [PREMIUM]
    contentType: CONTENT_VR
  ) {
    ...VideoSearchResultConnection
  }
}
    ${VideoRankingConnectionFragmentDoc}
${VideoSearchResultConnectionFragmentDoc}`;

/**
 * __useGetGravureTopQuery__
 *
 * To run a query within a React component, call `useGetGravureTopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGravureTopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGravureTopQuery({
 *   variables: {
 *      device: // value for 'device'
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetGravureTopQuery(baseOptions: Apollo.QueryHookOptions<G_GetGravureTopQuery, G_GetGravureTopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G_GetGravureTopQuery, G_GetGravureTopQueryVariables>(GetGravureTopDocument, options);
      }
export function useGetGravureTopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G_GetGravureTopQuery, G_GetGravureTopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G_GetGravureTopQuery, G_GetGravureTopQueryVariables>(GetGravureTopDocument, options);
        }
export type GetGravureTopQueryHookResult = ReturnType<typeof useGetGravureTopQuery>;
export type GetGravureTopLazyQueryHookResult = ReturnType<typeof useGetGravureTopLazyQuery>;
export type GetGravureTopQueryResult = Apollo.QueryResult<G_GetGravureTopQuery, G_GetGravureTopQueryVariables>;
export const DeleteContinueWatchingListDocument = gql`
    mutation DeleteContinueWatchingList($input: DeleteContinueWatchingListEntriesInput!) {
  deleteContinueWatchingListEntries(input: $input) {
    mutationId
  }
}
    `;
export type G_DeleteContinueWatchingListMutationFn = Apollo.MutationFunction<G_DeleteContinueWatchingListMutation, G_DeleteContinueWatchingListMutationVariables>;

/**
 * __useDeleteContinueWatchingListMutation__
 *
 * To run a mutation, you first call `useDeleteContinueWatchingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContinueWatchingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContinueWatchingListMutation, { data, loading, error }] = useDeleteContinueWatchingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContinueWatchingListMutation(baseOptions?: Apollo.MutationHookOptions<G_DeleteContinueWatchingListMutation, G_DeleteContinueWatchingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<G_DeleteContinueWatchingListMutation, G_DeleteContinueWatchingListMutationVariables>(DeleteContinueWatchingListDocument, options);
      }
export type DeleteContinueWatchingListMutationHookResult = ReturnType<typeof useDeleteContinueWatchingListMutation>;
export type DeleteContinueWatchingListMutationResult = Apollo.MutationResult<G_DeleteContinueWatchingListMutation>;
export type DeleteContinueWatchingListMutationOptions = Apollo.BaseMutationOptions<G_DeleteContinueWatchingListMutation, G_DeleteContinueWatchingListMutationVariables>;